//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import {settings} from "@/main"
import _ from "underscore";
import Loader from "@/features/shared/components/Loader";
import {authService, profileIdStorageKey} from "@/AuthService";
import {cultureService} from "@/CultureService";
import toasts from "@/components/Toasts";
export class ClientBase {
    private loader = new Loader();
    private handleNotFound = true;

    getBaseUrl(defaultUrl: string, baseUrl?: string) {
        return settings.misApiBaseUrl;
    }

    setLoader(loader:Loader){
        this.loader = loader;
        return this;
    }

    ignoreNotFound(){
        this.handleNotFound = false;
        return this;
    }

    protected transformOptions(options: RequestInit) : Promise<RequestInit> {
        this.loader.startLoading();

        const headers = new Headers(options.headers);
        if (authService?.isLoggedIn) {
            headers.set("Authorization", authService.getAuthorizationHeaderValue());

            const profileId = sessionStorage.getItem(profileIdStorageKey);
            if (profileId)
                headers.set(profileIdStorageKey, profileId);
        }

        headers.set("Accept-Language", cultureService.currentCulture)

        options.headers = headers;
        try {
            return Promise.resolve(options);
        } catch (e) {
            this.loader.endLoading();
            throw e;
        }
    }

    protected transformResult(url: string, response: Response, handleResponse: (response: Response) => any) {
        this.loader.endLoading();

        if (response.status == 404) {
            if (!this.handleNotFound)
                return Promise.reject(response);
        }

        return handleResponse(response);
    }
}

export class SwedbankClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    swedbankBanklinkReturn(applicationId: string, requirementId: string, vK_SERVICE: string | undefined, vK_VERSION: string | undefined, vK_SND_ID: string | undefined, vK_REC_ID: string | undefined, vK_STAMP: string | undefined, vK_T_NO: string | null | undefined, vK_AMOUNT: string | undefined, vK_CURR: string | undefined, vK_REC_ACC: string | undefined, vK_REC_NAME: string | undefined, vK_SND_ACC: string | undefined, vK_SND_NAME: string | null | undefined, vK_REF: string | undefined, vK_MSG: string | null | undefined, vK_T_DATETIME: string | undefined, vK_MAC: string | undefined, vK_ENCODING: string | undefined, vK_LANG: string | null | undefined, vK_AUTO: string | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/payments/swedbank-banklink-return/{applicationId}/{requirementId}";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        if (requirementId === undefined || requirementId === null)
            throw new Error("The parameter 'requirementId' must be defined.");
        url_ = url_.replace("{requirementId}", encodeURIComponent("" + requirementId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (vK_SERVICE === null || vK_SERVICE === undefined)
            throw new Error("The parameter 'vK_SERVICE' cannot be null.");
        else
            content_.append("VK_SERVICE", vK_SERVICE.toString());
        if (vK_VERSION === null || vK_VERSION === undefined)
            throw new Error("The parameter 'vK_VERSION' cannot be null.");
        else
            content_.append("VK_VERSION", vK_VERSION.toString());
        if (vK_SND_ID === null || vK_SND_ID === undefined)
            throw new Error("The parameter 'vK_SND_ID' cannot be null.");
        else
            content_.append("VK_SND_ID", vK_SND_ID.toString());
        if (vK_REC_ID === null || vK_REC_ID === undefined)
            throw new Error("The parameter 'vK_REC_ID' cannot be null.");
        else
            content_.append("VK_REC_ID", vK_REC_ID.toString());
        if (vK_STAMP === null || vK_STAMP === undefined)
            throw new Error("The parameter 'vK_STAMP' cannot be null.");
        else
            content_.append("VK_STAMP", vK_STAMP.toString());
        if (vK_T_NO !== null && vK_T_NO !== undefined)
            content_.append("VK_T_NO", vK_T_NO.toString());
        if (vK_AMOUNT === null || vK_AMOUNT === undefined)
            throw new Error("The parameter 'vK_AMOUNT' cannot be null.");
        else
            content_.append("VK_AMOUNT", vK_AMOUNT.toString());
        if (vK_CURR === null || vK_CURR === undefined)
            throw new Error("The parameter 'vK_CURR' cannot be null.");
        else
            content_.append("VK_CURR", vK_CURR.toString());
        if (vK_REC_ACC === null || vK_REC_ACC === undefined)
            throw new Error("The parameter 'vK_REC_ACC' cannot be null.");
        else
            content_.append("VK_REC_ACC", vK_REC_ACC.toString());
        if (vK_REC_NAME === null || vK_REC_NAME === undefined)
            throw new Error("The parameter 'vK_REC_NAME' cannot be null.");
        else
            content_.append("VK_REC_NAME", vK_REC_NAME.toString());
        if (vK_SND_ACC === null || vK_SND_ACC === undefined)
            throw new Error("The parameter 'vK_SND_ACC' cannot be null.");
        else
            content_.append("VK_SND_ACC", vK_SND_ACC.toString());
        if (vK_SND_NAME !== null && vK_SND_NAME !== undefined)
            content_.append("VK_SND_NAME", vK_SND_NAME.toString());
        if (vK_REF === null || vK_REF === undefined)
            throw new Error("The parameter 'vK_REF' cannot be null.");
        else
            content_.append("VK_REF", vK_REF.toString());
        if (vK_MSG !== null && vK_MSG !== undefined)
            content_.append("VK_MSG", vK_MSG.toString());
        if (vK_T_DATETIME === null || vK_T_DATETIME === undefined)
            throw new Error("The parameter 'vK_T_DATETIME' cannot be null.");
        else
            content_.append("VK_T_DATETIME", vK_T_DATETIME.toString());
        if (vK_MAC === null || vK_MAC === undefined)
            throw new Error("The parameter 'vK_MAC' cannot be null.");
        else
            content_.append("VK_MAC", vK_MAC.toString());
        if (vK_ENCODING === null || vK_ENCODING === undefined)
            throw new Error("The parameter 'vK_ENCODING' cannot be null.");
        else
            content_.append("VK_ENCODING", vK_ENCODING.toString());
        if (vK_LANG !== null && vK_LANG !== undefined)
            content_.append("VK_LANG", vK_LANG.toString());
        if (vK_AUTO === null || vK_AUTO === undefined)
            throw new Error("The parameter 'vK_AUTO' cannot be null.");
        else
            content_.append("VK_AUTO", vK_AUTO.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSwedbankBanklinkReturn(_response));
        });
    }

    protected processSwedbankBanklinkReturn(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    swedbankBanklinkCancel(applicationId: string, requirementId: string, vK_SERVICE: string | undefined, vK_VERSION: string | undefined, vK_SND_ID: string | undefined, vK_REC_ID: string | undefined, vK_STAMP: string | undefined, vK_REF: string | undefined, vK_MSG: string | null | undefined, vK_MAC: string | undefined, vK_ENCODING: string | undefined, vK_LANG: string | null | undefined, vK_AUTO: string | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/payments/swedbank-banklink-cancel/{applicationId}/{requirementId}";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        if (requirementId === undefined || requirementId === null)
            throw new Error("The parameter 'requirementId' must be defined.");
        url_ = url_.replace("{requirementId}", encodeURIComponent("" + requirementId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (vK_SERVICE === null || vK_SERVICE === undefined)
            throw new Error("The parameter 'vK_SERVICE' cannot be null.");
        else
            content_.append("VK_SERVICE", vK_SERVICE.toString());
        if (vK_VERSION === null || vK_VERSION === undefined)
            throw new Error("The parameter 'vK_VERSION' cannot be null.");
        else
            content_.append("VK_VERSION", vK_VERSION.toString());
        if (vK_SND_ID === null || vK_SND_ID === undefined)
            throw new Error("The parameter 'vK_SND_ID' cannot be null.");
        else
            content_.append("VK_SND_ID", vK_SND_ID.toString());
        if (vK_REC_ID === null || vK_REC_ID === undefined)
            throw new Error("The parameter 'vK_REC_ID' cannot be null.");
        else
            content_.append("VK_REC_ID", vK_REC_ID.toString());
        if (vK_STAMP === null || vK_STAMP === undefined)
            throw new Error("The parameter 'vK_STAMP' cannot be null.");
        else
            content_.append("VK_STAMP", vK_STAMP.toString());
        if (vK_REF === null || vK_REF === undefined)
            throw new Error("The parameter 'vK_REF' cannot be null.");
        else
            content_.append("VK_REF", vK_REF.toString());
        if (vK_MSG !== null && vK_MSG !== undefined)
            content_.append("VK_MSG", vK_MSG.toString());
        if (vK_MAC === null || vK_MAC === undefined)
            throw new Error("The parameter 'vK_MAC' cannot be null.");
        else
            content_.append("VK_MAC", vK_MAC.toString());
        if (vK_ENCODING === null || vK_ENCODING === undefined)
            throw new Error("The parameter 'vK_ENCODING' cannot be null.");
        else
            content_.append("VK_ENCODING", vK_ENCODING.toString());
        if (vK_LANG !== null && vK_LANG !== undefined)
            content_.append("VK_LANG", vK_LANG.toString());
        if (vK_AUTO === null || vK_AUTO === undefined)
            throw new Error("The parameter 'vK_AUTO' cannot be null.");
        else
            content_.append("VK_AUTO", vK_AUTO.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSwedbankBanklinkCancel(_response));
        });
    }

    protected processSwedbankBanklinkCancel(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class UsersClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    userInfo(): Promise<AnonymousUserInfoResponse> {
        let url_ = this.baseUrl + "/users/user-info";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUserInfo(_response));
        });
    }

    protected processUserInfo(response: Response): Promise<AnonymousUserInfoResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AnonymousUserInfoResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AnonymousUserInfoResponse>(null as any);
    }

    availableProfiles(): Promise<AvailableProfileModel[]> {
        let url_ = this.baseUrl + "/users/available-profiles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAvailableProfiles(_response));
        });
    }

    protected processAvailableProfiles(response: Response): Promise<AvailableProfileModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AvailableProfileModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AvailableProfileModel[]>(null as any);
    }

    availableActions(): Promise<UserActions> {
        let url_ = this.baseUrl + "/users/available-actions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAvailableActions(_response));
        });
    }

    protected processAvailableActions(response: Response): Promise<UserActions> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserActions.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserActions>(null as any);
    }

    confirmData(): Promise<ConfirmDataResponse> {
        let url_ = this.baseUrl + "/users/confirm-data";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processConfirmData(_response));
        });
    }

    protected processConfirmData(response: Response): Promise<ConfirmDataResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConfirmDataResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ConfirmDataResponse>(null as any);
    }
}

export class SystemOperationsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    execute(command: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/admin/SystemOperations/execute?";
        if (command === null)
            throw new Error("The parameter 'command' cannot be null.");
        else if (command !== undefined)
            url_ += "command=" + encodeURIComponent("" + command) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExecute(_response));
        });
    }

    protected processExecute(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class SysAdminSpecialitiesClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    all(searchTerm: string | null | undefined): Promise<SpecialityLightModel[]> {
        let url_ = this.baseUrl + "/admin/SysAdminSpecialities?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAll(_response));
        });
    }

    protected processAll(response: Response): Promise<SpecialityLightModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SpecialityLightModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SpecialityLightModel[]>(null as any);
    }

    upsert(request: UpsertSpecialityRequest): Promise<void> {
        let url_ = this.baseUrl + "/admin/SysAdminSpecialities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpsert(_response));
        });
    }

    protected processUpsert(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    search(sort: SysAdminSpecialitiesSortField | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, searchTerm: string | null | undefined): Promise<PagedResultOfSpecialityLightModel> {
        let url_ = this.baseUrl + "/admin/SysAdminSpecialities/search?";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearch(_response));
        });
    }

    protected processSearch(response: Response): Promise<PagedResultOfSpecialityLightModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfSpecialityLightModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfSpecialityLightModel>(null as any);
    }

    details(id: string): Promise<SpecialityDetailsModel> {
        let url_ = this.baseUrl + "/admin/SysAdminSpecialities/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDetails(_response));
        });
    }

    protected processDetails(response: Response): Promise<SpecialityDetailsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SpecialityDetailsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SpecialityDetailsModel>(null as any);
    }

    educations(): Promise<EducationModel[]> {
        let url_ = this.baseUrl + "/admin/SysAdminSpecialities/educations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEducations(_response));
        });
    }

    protected processEducations(response: Response): Promise<EducationModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EducationModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EducationModel[]>(null as any);
    }
}

export class SysAdminShipsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    search(sort: SysAdminShipsSortField | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, searchTerm: string | null | undefined): Promise<PagedResultOfShipLightModel> {
        let url_ = this.baseUrl + "/admin/SysAdminShips/search?";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearch(_response));
        });
    }

    protected processSearch(response: Response): Promise<PagedResultOfShipLightModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfShipLightModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfShipLightModel>(null as any);
    }

    add(request: AddOrUpdateShipRequest): Promise<void> {
        let url_ = this.baseUrl + "/admin/SysAdminShips";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAdd(_response));
        });
    }

    protected processAdd(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    update(id: string, request: AddOrUpdateShipRequest): Promise<void> {
        let url_ = this.baseUrl + "/admin/SysAdminShips/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    details(id: string): Promise<ShipDetailsModel> {
        let url_ = this.baseUrl + "/admin/SysAdminShips/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDetails(_response));
        });
    }

    protected processDetails(response: Response): Promise<ShipDetailsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShipDetailsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShipDetailsModel>(null as any);
    }

    activate(id: string): Promise<void> {
        let url_ = this.baseUrl + "/admin/SysAdminShips/{id}/activate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processActivate(_response));
        });
    }

    protected processActivate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deactivate(id: string): Promise<void> {
        let url_ = this.baseUrl + "/admin/SysAdminShips/{id}/deactivate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeactivate(_response));
        });
    }

    protected processDeactivate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class SysAdminShipTypesClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    search(sort: SysAdminShipTypesSortField | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, searchTerm: string | null | undefined): Promise<ShipTypeLightModel[]> {
        let url_ = this.baseUrl + "/admin/SysAdminShipTypes/search?";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearch(_response));
        });
    }

    protected processSearch(response: Response): Promise<ShipTypeLightModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShipTypeLightModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShipTypeLightModel[]>(null as any);
    }

    add(request: AddOrUpdateShipTypeRequest): Promise<void> {
        let url_ = this.baseUrl + "/admin/SysAdminShipTypes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAdd(_response));
        });
    }

    protected processAdd(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    update(id: string, request: AddOrUpdateShipTypeRequest): Promise<void> {
        let url_ = this.baseUrl + "/admin/SysAdminShipTypes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    details(id: string): Promise<ShipTypeDetailsModel> {
        let url_ = this.baseUrl + "/admin/SysAdminShipTypes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDetails(_response));
        });
    }

    protected processDetails(response: Response): Promise<ShipTypeDetailsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShipTypeDetailsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShipTypeDetailsModel>(null as any);
    }

    activate(id: string): Promise<void> {
        let url_ = this.baseUrl + "/admin/SysAdminShipTypes/{id}/activate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processActivate(_response));
        });
    }

    protected processActivate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deactivate(id: string): Promise<void> {
        let url_ = this.baseUrl + "/admin/SysAdminShipTypes/{id}/deactivate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeactivate(_response));
        });
    }

    protected processDeactivate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class SysAdminRestrictionsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    all(searchTerm: string | null | undefined): Promise<RestrictionLightModel[]> {
        let url_ = this.baseUrl + "/admin/SysAdminRestrictions?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAll(_response));
        });
    }

    protected processAll(response: Response): Promise<RestrictionLightModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RestrictionLightModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RestrictionLightModel[]>(null as any);
    }

    upsert(request: UpsertRestrictionRequest): Promise<void> {
        let url_ = this.baseUrl + "/admin/SysAdminRestrictions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpsert(_response));
        });
    }

    protected processUpsert(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    details(id: string): Promise<RestrictionDetailsModel> {
        let url_ = this.baseUrl + "/admin/SysAdminRestrictions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDetails(_response));
        });
    }

    protected processDetails(response: Response): Promise<RestrictionDetailsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RestrictionDetailsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RestrictionDetailsModel>(null as any);
    }
}

export class SysAdminPrintBackgroundTemplatesClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    search(sort: SysAdminPrintBackgroundTemplatesSortField | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, searchTerm: string | null | undefined): Promise<PagedResultOfPrintBackgroundTemplateModel> {
        let url_ = this.baseUrl + "/admin/sys/print-background-templates/search?";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearch(_response));
        });
    }

    protected processSearch(response: Response): Promise<PagedResultOfPrintBackgroundTemplateModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfPrintBackgroundTemplateModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfPrintBackgroundTemplateModel>(null as any);
    }

    details(id: string): Promise<PrintBackgroundTemplateDetailsModel> {
        let url_ = this.baseUrl + "/admin/sys/print-background-templates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDetails(_response));
        });
    }

    protected processDetails(response: Response): Promise<PrintBackgroundTemplateDetailsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrintBackgroundTemplateDetailsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrintBackgroundTemplateDetailsModel>(null as any);
    }

    delete(id: string): Promise<void> {
        let url_ = this.baseUrl + "/admin/sys/print-background-templates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    upsert(model: UpsertPrintBackgroundTemplateRequest): Promise<void> {
        let url_ = this.baseUrl + "/admin/sys/print-background-templates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpsert(_response));
        });
    }

    protected processUpsert(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    downloadFile(id: string): Promise<PrintBackgroundTemplateDownloadUrls> {
        let url_ = this.baseUrl + "/{id}/files";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadFile(_response));
        });
    }

    protected processDownloadFile(response: Response): Promise<PrintBackgroundTemplateDownloadUrls> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrintBackgroundTemplateDownloadUrls.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrintBackgroundTemplateDownloadUrls>(null as any);
    }

    options(): Promise<PrintBackgroundOption[]> {
        let url_ = this.baseUrl + "/admin/sys/print-background-templates/options";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processOptions(_response));
        });
    }

    protected processOptions(response: Response): Promise<PrintBackgroundOption[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PrintBackgroundOption.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrintBackgroundOption[]>(null as any);
    }
}

export class SysAdminPositionsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    all(searchTerm: string | null | undefined): Promise<PositionLightModel[]> {
        let url_ = this.baseUrl + "/admin/SysAdminPositions?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAll(_response));
        });
    }

    protected processAll(response: Response): Promise<PositionLightModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PositionLightModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PositionLightModel[]>(null as any);
    }

    upsert(request: UpsertPositionRequest): Promise<void> {
        let url_ = this.baseUrl + "/admin/SysAdminPositions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpsert(_response));
        });
    }

    protected processUpsert(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    details(id: string): Promise<PositionDetailsModel> {
        let url_ = this.baseUrl + "/admin/SysAdminPositions/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDetails(_response));
        });
    }

    protected processDetails(response: Response): Promise<PositionDetailsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PositionDetailsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PositionDetailsModel>(null as any);
    }
}

export class SysAdminOrganizationsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    list(): Promise<OrganizationLightModel[]> {
        let url_ = this.baseUrl + "/admin/SysAdminOrganizations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<OrganizationLightModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationLightModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationLightModel[]>(null as any);
    }

    upsert(request: UpsertOrganizationRequest): Promise<void> {
        let url_ = this.baseUrl + "/admin/SysAdminOrganizations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpsert(_response));
        });
    }

    protected processUpsert(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    details(id: string): Promise<OrganizationDetailsModel> {
        let url_ = this.baseUrl + "/admin/SysAdminOrganizations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDetails(_response));
        });
    }

    protected processDetails(response: Response): Promise<OrganizationDetailsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationDetailsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationDetailsModel>(null as any);
    }

    updateRoles(model: UpdateOrganizationRolesModel, id: string): Promise<Ok> {
        let url_ = this.baseUrl + "/admin/SysAdminOrganizations/{id}/roles";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateRoles(_response));
        });
    }

    protected processUpdateRoles(response: Response): Promise<Ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Ok>(null as any);
    }

    roles(id: string): Promise<RoleModel[]> {
        let url_ = this.baseUrl + "/admin/SysAdminOrganizations/roles/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRoles(_response));
        });
    }

    protected processRoles(response: Response): Promise<RoleModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoleModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleModel[]>(null as any);
    }

    organizationTypes(): Promise<OrganizationTypeModel[]> {
        let url_ = this.baseUrl + "/admin/SysAdminOrganizations/organization-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processOrganizationTypes(_response));
        });
    }

    protected processOrganizationTypes(response: Response): Promise<OrganizationTypeModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationTypeModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationTypeModel[]>(null as any);
    }

    updateFromArireg(id: string): Promise<Ok> {
        let url_ = this.baseUrl + "/admin/SysAdminOrganizations/{id}/update-from-xroad";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateFromArireg(_response));
        });
    }

    protected processUpdateFromArireg(response: Response): Promise<Ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Ok>(null as any);
    }
}

export class SysAdminMedicalPractitionersClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    list(): Promise<MedicalPractitionerViewModel[]> {
        let url_ = this.baseUrl + "/admin/SysAdminMedicalPractitioners";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<MedicalPractitionerViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MedicalPractitionerViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MedicalPractitionerViewModel[]>(null as any);
    }

    upsert(request: UpsertMedicalPractitionerRequest): Promise<MedicalPractitionerId> {
        let url_ = this.baseUrl + "/admin/SysAdminMedicalPractitioners";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpsert(_response));
        });
    }

    protected processUpsert(response: Response): Promise<MedicalPractitionerId> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalPractitionerId.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MedicalPractitionerId>(null as any);
    }

    get(id: string): Promise<MedicalPractitionerViewModel> {
        let url_ = this.baseUrl + "/admin/SysAdminMedicalPractitioners/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<MedicalPractitionerViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalPractitionerViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MedicalPractitionerViewModel>(null as any);
    }

    organizationOptions(): Promise<OrganizationModel[]> {
        let url_ = this.baseUrl + "/admin/SysAdminMedicalPractitioners/organization-options";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processOrganizationOptions(_response));
        });
    }

    protected processOrganizationOptions(response: Response): Promise<OrganizationModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationModel[]>(null as any);
    }
}

export class SysAdminHeaderNotificationClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    item(): Promise<HeaderNotificationModel> {
        let url_ = this.baseUrl + "/admin/SysAdminHeaderNotification";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processItem(_response));
        });
    }

    protected processItem(response: Response): Promise<HeaderNotificationModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HeaderNotificationModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HeaderNotificationModel>(null as any);
    }

    update(model: HeaderNotificationModel): Promise<void> {
        let url_ = this.baseUrl + "/admin/SysAdminHeaderNotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class SysAdminHarboursClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    all(searchTerm: string | null | undefined): Promise<HarbourLightModel[]> {
        let url_ = this.baseUrl + "/admin/SysAdminHarbours?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAll(_response));
        });
    }

    protected processAll(response: Response): Promise<HarbourLightModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HarbourLightModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HarbourLightModel[]>(null as any);
    }

    upsert(request: UpsertHarbourRequest): Promise<void> {
        let url_ = this.baseUrl + "/admin/SysAdminHarbours";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpsert(_response));
        });
    }

    protected processUpsert(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    details(id: string): Promise<HarbourDetailsModel> {
        let url_ = this.baseUrl + "/admin/SysAdminHarbours/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDetails(_response));
        });
    }

    protected processDetails(response: Response): Promise<HarbourDetailsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HarbourDetailsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HarbourDetailsModel>(null as any);
    }
}

export class SysAdminCountriesClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    list(): Promise<CountryModel[]> {
        let url_ = this.baseUrl + "/admin/SysAdminCountries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<CountryModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CountryModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountryModel[]>(null as any);
    }

    edit(request: EditCountriesRequest): Promise<void> {
        let url_ = this.baseUrl + "/admin/SysAdminCountries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEdit(_response));
        });
    }

    protected processEdit(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    listJson(): Promise<CountryJsonModel> {
        let url_ = this.baseUrl + "/admin/SysAdminCountries/list-json";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processListJson(_response));
        });
    }

    protected processListJson(response: Response): Promise<CountryJsonModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryJsonModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountryJsonModel>(null as any);
    }
}

export class SysAdminCertificateTypeTemplatesClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    list(): Promise<CertificateTypeTemplateModel[]> {
        let url_ = this.baseUrl + "/admin/sys/certificate-type-templates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<CertificateTypeTemplateModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CertificateTypeTemplateModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CertificateTypeTemplateModel[]>(null as any);
    }

    upsert(request: UpsertCertificateTypeTemplateRequest): Promise<void> {
        let url_ = this.baseUrl + "/admin/sys/certificate-type-templates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpsert(_response));
        });
    }

    protected processUpsert(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    get(id: string): Promise<CertificateTypeTemplateDetailsModel> {
        let url_ = this.baseUrl + "/admin/sys/certificate-type-templates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<CertificateTypeTemplateDetailsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CertificateTypeTemplateDetailsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CertificateTypeTemplateDetailsModel>(null as any);
    }

    deactivate(id: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/admin/sys/certificate-type-templates/{id}/deactivate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeactivate(_response));
        });
    }

    protected processDeactivate(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    activate(id: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/admin/sys/certificate-type-templates/{id}/activate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processActivate(_response));
        });
    }

    protected processActivate(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    download(id: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/admin/sys/certificate-type-templates/{id}/download";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownload(_response));
        });
    }

    protected processDownload(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    printPreview(id: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/admin/sys/certificate-type-templates/{id}/print-preview";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPrintPreview(_response));
        });
    }

    protected processPrintPreview(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class SysAdminCertificateTypesClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    list(): Promise<CertificateTypeLightModel[]> {
        let url_ = this.baseUrl + "/admin/SysAdminCertificateTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<CertificateTypeLightModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CertificateTypeLightModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CertificateTypeLightModel[]>(null as any);
    }

    upsert(request: UpsertCertificateTypeRequest): Promise<void> {
        let url_ = this.baseUrl + "/admin/SysAdminCertificateTypes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpsert(_response));
        });
    }

    protected processUpsert(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    get(id: string): Promise<CertificateTypeModel> {
        let url_ = this.baseUrl + "/admin/SysAdminCertificateTypes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<CertificateTypeModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CertificateTypeModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CertificateTypeModel>(null as any);
    }

    deactivate(id: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/admin/SysAdminCertificateTypes/{id}/deactivate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeactivate(_response));
        });
    }

    protected processDeactivate(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    activate(id: string): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/admin/SysAdminCertificateTypes/{id}/activate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processActivate(_response));
        });
    }

    protected processActivate(response: Response): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class SysAdminAreasClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    list(searchTerm: string | null | undefined): Promise<AreaLightModel[]> {
        let url_ = this.baseUrl + "/admin/SysAdminAreas?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<AreaLightModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AreaLightModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AreaLightModel[]>(null as any);
    }

    create(request: CreateOrUpdateAreaRequest): Promise<void> {
        let url_ = this.baseUrl + "/admin/SysAdminAreas";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    update(id: string, request: CreateOrUpdateAreaRequest): Promise<void> {
        let url_ = this.baseUrl + "/admin/SysAdminAreas/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    details(id: string): Promise<AreaDetailsModel> {
        let url_ = this.baseUrl + "/admin/SysAdminAreas/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDetails(_response));
        });
    }

    protected processDetails(response: Response): Promise<AreaDetailsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AreaDetailsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AreaDetailsModel>(null as any);
    }

    activate(id: string): Promise<void> {
        let url_ = this.baseUrl + "/admin/SysAdminAreas/{id}/activate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processActivate(_response));
        });
    }

    protected processActivate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deactivate(id: string): Promise<void> {
        let url_ = this.baseUrl + "/admin/SysAdminAreas/{id}/deactivate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeactivate(_response));
        });
    }

    protected processDeactivate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class SysAdminTemplatesClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    search(sort: SysAdminTemplatesSortField | null | undefined, isActive: boolean | undefined, isDeactive: boolean | undefined, showAll: boolean | undefined, pageNumber: number | undefined, pageSize: number | undefined, searchTerm: string | null | undefined): Promise<PagedResultOfTemplateLightModel> {
        let url_ = this.baseUrl + "/admin/SysAdminTemplates/search?";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        if (isActive === null)
            throw new Error("The parameter 'isActive' cannot be null.");
        else if (isActive !== undefined)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (isDeactive === null)
            throw new Error("The parameter 'isDeactive' cannot be null.");
        else if (isDeactive !== undefined)
            url_ += "IsDeactive=" + encodeURIComponent("" + isDeactive) + "&";
        if (showAll === null)
            throw new Error("The parameter 'showAll' cannot be null.");
        else if (showAll !== undefined)
            url_ += "ShowAll=" + encodeURIComponent("" + showAll) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearch(_response));
        });
    }

    protected processSearch(response: Response): Promise<PagedResultOfTemplateLightModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfTemplateLightModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfTemplateLightModel>(null as any);
    }

    get(id: string): Promise<TemplateModel> {
        let url_ = this.baseUrl + "/admin/SysAdminTemplates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<TemplateModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TemplateModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TemplateModel>(null as any);
    }

    allEndorsementPrintTemplates(): Promise<EndorsementPrintTemplateModel[]> {
        let url_ = this.baseUrl + "/admin/SysAdminTemplates/endorsement-print-templates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAllEndorsementPrintTemplates(_response));
        });
    }

    protected processAllEndorsementPrintTemplates(response: Response): Promise<EndorsementPrintTemplateModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EndorsementPrintTemplateModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EndorsementPrintTemplateModel[]>(null as any);
    }

    updateEndorsementPrintTemplate(model: EndorsementPrintTemplateModel): Promise<void> {
        let url_ = this.baseUrl + "/admin/SysAdminTemplates/endorsement-print-templates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateEndorsementPrintTemplate(_response));
        });
    }

    protected processUpdateEndorsementPrintTemplate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getEndorsementPrintTemplate(type: string): Promise<EndorsementPrintTemplateModel> {
        let url_ = this.baseUrl + "/admin/SysAdminTemplates/endorsement-print-templates/{type}";
        if (type === undefined || type === null)
            throw new Error("The parameter 'type' must be defined.");
        url_ = url_.replace("{type}", encodeURIComponent("" + type));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEndorsementPrintTemplate(_response));
        });
    }

    protected processGetEndorsementPrintTemplate(response: Response): Promise<EndorsementPrintTemplateModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EndorsementPrintTemplateModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EndorsementPrintTemplateModel>(null as any);
    }

    add(request: AddTemplateRequest): Promise<void> {
        let url_ = this.baseUrl + "/admin/SysAdminTemplates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAdd(_response));
        });
    }

    protected processAdd(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deactivate(id: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/admin/SysAdminTemplates/deactivate?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeactivate(_response));
        });
    }

    protected processDeactivate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    activate(id: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/admin/SysAdminTemplates/activate?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processActivate(_response));
        });
    }

    protected processActivate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ShipsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    search(searchTerm: string | undefined): Promise<ShipInfoModel[]> {
        let url_ = this.baseUrl + "/ships/search?";
        if (searchTerm === null)
            throw new Error("The parameter 'searchTerm' cannot be null.");
        else if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearch(_response));
        });
    }

    protected processSearch(response: Response): Promise<ShipInfoModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShipInfoModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShipInfoModel[]>(null as any);
    }

    shipOptions(): Promise<ShipOptionsResponse> {
        let url_ = this.baseUrl + "/ships/ship-options";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processShipOptions(_response));
        });
    }

    protected processShipOptions(response: Response): Promise<ShipOptionsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShipOptionsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShipOptionsResponse>(null as any);
    }
}

export class ShipTypesClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    shipTypesLocalized(searchTerm: string | null | undefined): Promise<ShipTypesLocalizedResponse> {
        let url_ = this.baseUrl + "/ship-types/ship-types-localized?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processShipTypesLocalized(_response));
        });
    }

    protected processShipTypesLocalized(response: Response): Promise<ShipTypesLocalizedResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShipTypesLocalizedResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShipTypesLocalizedResponse>(null as any);
    }

    shipTypes(searchTerm: string | null | undefined): Promise<ShipTypesResponse> {
        let url_ = this.baseUrl + "/ship-types/ship-types?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processShipTypes(_response));
        });
    }

    protected processShipTypes(response: Response): Promise<ShipTypesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShipTypesResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShipTypesResponse>(null as any);
    }
}

export class CountriesClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    countries(): Promise<CountryLightModel[]> {
        let url_ = this.baseUrl + "/countries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCountries(_response));
        });
    }

    protected processCountries(response: Response): Promise<CountryLightModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CountryLightModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountryLightModel[]>(null as any);
    }
}

export class SharedResourcesClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    authToken(accessLinkAccessToken: string | undefined, secret: string | null | undefined): Promise<AccessLinkAuthModel> {
        let url_ = this.baseUrl + "/shared-resources/auth-token?";
        if (accessLinkAccessToken === null)
            throw new Error("The parameter 'accessLinkAccessToken' cannot be null.");
        else if (accessLinkAccessToken !== undefined)
            url_ += "AccessLinkAccessToken=" + encodeURIComponent("" + accessLinkAccessToken) + "&";
        if (secret !== undefined && secret !== null)
            url_ += "Secret=" + encodeURIComponent("" + secret) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAuthToken(_response));
        });
    }

    protected processAuthToken(response: Response): Promise<AccessLinkAuthModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccessLinkAuthModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccessLinkAuthModel>(null as any);
    }

    list(seafarerId: string): Promise<AccessLinkModel[]> {
        let url_ = this.baseUrl + "/seafarers/{seafarerId}/shared-resources";
        if (seafarerId === undefined || seafarerId === null)
            throw new Error("The parameter 'seafarerId' must be defined.");
        url_ = url_.replace("{seafarerId}", encodeURIComponent("" + seafarerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<AccessLinkModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccessLinkModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccessLinkModel[]>(null as any);
    }

    add(request: CreateAccessLinkRequest, seafarerId: string): Promise<Ok> {
        let url_ = this.baseUrl + "/seafarers/{seafarerId}/shared-resources";
        if (seafarerId === undefined || seafarerId === null)
            throw new Error("The parameter 'seafarerId' must be defined.");
        url_ = url_.replace("{seafarerId}", encodeURIComponent("" + seafarerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAdd(_response));
        });
    }

    protected processAdd(response: Response): Promise<Ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Ok>(null as any);
    }

    revoke(linkId: string | undefined, seafarerId: string): Promise<Ok> {
        let url_ = this.baseUrl + "/seafarers/{seafarerId}/shared-resources?";
        if (seafarerId === undefined || seafarerId === null)
            throw new Error("The parameter 'seafarerId' must be defined.");
        url_ = url_.replace("{seafarerId}", encodeURIComponent("" + seafarerId));
        if (linkId === null)
            throw new Error("The parameter 'linkId' cannot be null.");
        else if (linkId !== undefined)
            url_ += "linkId=" + encodeURIComponent("" + linkId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRevoke(_response));
        });
    }

    protected processRevoke(response: Response): Promise<Ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Ok.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Ok>(null as any);
    }

    resourcesOptions(): Promise<ShareableResourceModel[]> {
        let url_ = this.baseUrl + "/shared-resources/resource-options";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processResourcesOptions(_response));
        });
    }

    protected processResourcesOptions(response: Response): Promise<ShareableResourceModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ShareableResourceModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShareableResourceModel[]>(null as any);
    }
}

export class PracticesClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    list(seafarerId: string): Promise<PracticeViewModel[]> {
        let url_ = this.baseUrl + "/seafarers/{seafarerId}/practices";
        if (seafarerId === undefined || seafarerId === null)
            throw new Error("The parameter 'seafarerId' must be defined.");
        url_ = url_.replace("{seafarerId}", encodeURIComponent("" + seafarerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<PracticeViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PracticeViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PracticeViewModel[]>(null as any);
    }

    officialPractices(searchTerm: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, showValid: boolean | undefined, showInvalid: boolean | undefined, showUnchecked: boolean | undefined, type: PracticeType | null | undefined, sortDir: SortOrder | null | undefined, sort: string | null | undefined): Promise<PagedResultOfOfficialPracticeLightViewModel> {
        let url_ = this.baseUrl + "/practices?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (showValid === null)
            throw new Error("The parameter 'showValid' cannot be null.");
        else if (showValid !== undefined)
            url_ += "ShowValid=" + encodeURIComponent("" + showValid) + "&";
        if (showInvalid === null)
            throw new Error("The parameter 'showInvalid' cannot be null.");
        else if (showInvalid !== undefined)
            url_ += "ShowInvalid=" + encodeURIComponent("" + showInvalid) + "&";
        if (showUnchecked === null)
            throw new Error("The parameter 'showUnchecked' cannot be null.");
        else if (showUnchecked !== undefined)
            url_ += "ShowUnchecked=" + encodeURIComponent("" + showUnchecked) + "&";
        if (type !== undefined && type !== null)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (sortDir !== undefined && sortDir !== null)
            url_ += "SortDir=" + encodeURIComponent("" + sortDir) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processOfficialPractices(_response));
        });
    }

    protected processOfficialPractices(response: Response): Promise<PagedResultOfOfficialPracticeLightViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfOfficialPracticeLightViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfOfficialPracticeLightViewModel>(null as any);
    }

    add(request: AddPracticeRequest, seafarerId: string | undefined): Promise<AddPracticeResponse> {
        let url_ = this.baseUrl + "/practices?";
        if (seafarerId === null)
            throw new Error("The parameter 'seafarerId' cannot be null.");
        else if (seafarerId !== undefined)
            url_ += "seafarerId=" + encodeURIComponent("" + seafarerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAdd(_response));
        });
    }

    protected processAdd(response: Response): Promise<AddPracticeResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddPracticeResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddPracticeResponse>(null as any);
    }

    hasOverlap(seafarerId: string, request: FindOverlappingPracticesRequest): Promise<boolean> {
        let url_ = this.baseUrl + "/seafarers/{seafarerId}/practices/has-overlap";
        if (seafarerId === undefined || seafarerId === null)
            throw new Error("The parameter 'seafarerId' must be defined.");
        url_ = url_.replace("{seafarerId}", encodeURIComponent("" + seafarerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processHasOverlap(_response));
        });
    }

    protected processHasOverlap(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    edit(request: AddPracticeRequest, seafarerId: string | undefined, id: string): Promise<AddPracticeResponse> {
        let url_ = this.baseUrl + "/practices/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (seafarerId === null)
            throw new Error("The parameter 'seafarerId' cannot be null.");
        else if (seafarerId !== undefined)
            url_ += "seafarerId=" + encodeURIComponent("" + seafarerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEdit(_response));
        });
    }

    protected processEdit(response: Response): Promise<AddPracticeResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddPracticeResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddPracticeResponse>(null as any);
    }

    delete(id: string): Promise<void> {
        let url_ = this.baseUrl + "/practices/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getShipRepair(id: string): Promise<ShipRepairPracticeDetailsModel> {
        let url_ = this.baseUrl + "/practices/ship-repair/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetShipRepair(_response));
        });
    }

    protected processGetShipRepair(response: Response): Promise<ShipRepairPracticeDetailsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShipRepairPracticeDetailsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShipRepairPracticeDetailsModel>(null as any);
    }

    getSeafaring(id: string): Promise<SeafaringPracticeDetailsModel> {
        let url_ = this.baseUrl + "/practices/seafaring/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSeafaring(_response));
        });
    }

    protected processGetSeafaring(response: Response): Promise<SeafaringPracticeDetailsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SeafaringPracticeDetailsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SeafaringPracticeDetailsModel>(null as any);
    }

    downloadShipRepairFile(id: string, fileId: string): Promise<DownloadUrl> {
        let url_ = this.baseUrl + "/practices/ship-repair/{id}/files/{fileId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadShipRepairFile(_response));
        });
    }

    protected processDownloadShipRepairFile(response: Response): Promise<DownloadUrl> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DownloadUrl.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DownloadUrl>(null as any);
    }

    downloadSeafaringFile(id: string, fileId: string): Promise<DownloadUrl> {
        let url_ = this.baseUrl + "/practices/seafaring/{id}/files/{fileId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadSeafaringFile(_response));
        });
    }

    protected processDownloadSeafaringFile(response: Response): Promise<DownloadUrl> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DownloadUrl.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DownloadUrl>(null as any);
    }

    getInlandVesselPractice(id: string): Promise<InlandVesselPracticeDetailsModel> {
        let url_ = this.baseUrl + "/practices/inland-vessel/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetInlandVesselPractice(_response));
        });
    }

    protected processGetInlandVesselPractice(response: Response): Promise<InlandVesselPracticeDetailsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InlandVesselPracticeDetailsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InlandVesselPracticeDetailsModel>(null as any);
    }

    getPilotagePractice(id: string): Promise<PilotagePracticeDetailsModel> {
        let url_ = this.baseUrl + "/practices/pilotage/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPilotagePractice(_response));
        });
    }

    protected processGetPilotagePractice(response: Response): Promise<PilotagePracticeDetailsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PilotagePracticeDetailsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PilotagePracticeDetailsModel>(null as any);
    }

    getVtsCenterPractice(id: string): Promise<VtsCenterPracticeDetailsModel> {
        let url_ = this.baseUrl + "/practices/vts-center/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetVtsCenterPractice(_response));
        });
    }

    protected processGetVtsCenterPractice(response: Response): Promise<VtsCenterPracticeDetailsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VtsCenterPracticeDetailsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VtsCenterPracticeDetailsModel>(null as any);
    }

    downloadInlandVesselFile(id: string, fileId: string): Promise<DownloadUrl> {
        let url_ = this.baseUrl + "/practices/inland-vessel/{id}/files/{fileId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadInlandVesselFile(_response));
        });
    }

    protected processDownloadInlandVesselFile(response: Response): Promise<DownloadUrl> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DownloadUrl.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DownloadUrl>(null as any);
    }

    downloadPilotageFile(id: string, fileId: string): Promise<DownloadUrl> {
        let url_ = this.baseUrl + "/practices/pilotage/{id}/files/{fileId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadPilotageFile(_response));
        });
    }

    protected processDownloadPilotageFile(response: Response): Promise<DownloadUrl> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DownloadUrl.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DownloadUrl>(null as any);
    }

    downloadVtsCenterFile(id: string, fileId: string): Promise<DownloadUrl> {
        let url_ = this.baseUrl + "/practices/vts-center/{id}/files/{fileId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadVtsCenterFile(_response));
        });
    }

    protected processDownloadVtsCenterFile(response: Response): Promise<DownloadUrl> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DownloadUrl.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DownloadUrl>(null as any);
    }

    shipRepairOrganizationOptions(): Promise<OrganizationOptionsResponse> {
        let url_ = this.baseUrl + "/practices/ship-repair-practice-organization-options";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processShipRepairOrganizationOptions(_response));
        });
    }

    protected processShipRepairOrganizationOptions(response: Response): Promise<OrganizationOptionsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationOptionsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationOptionsResponse>(null as any);
    }

    seafaringOrganizationOptions(): Promise<OrganizationOptionsResponse> {
        let url_ = this.baseUrl + "/practices/seafaring-practice-organization-options";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSeafaringOrganizationOptions(_response));
        });
    }

    protected processSeafaringOrganizationOptions(response: Response): Promise<OrganizationOptionsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationOptionsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationOptionsResponse>(null as any);
    }

    inlandVesselOrganizationOptions(): Promise<OrganizationOptionsResponse> {
        let url_ = this.baseUrl + "/practices/inland-vessel-practice-organization-options";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processInlandVesselOrganizationOptions(_response));
        });
    }

    protected processInlandVesselOrganizationOptions(response: Response): Promise<OrganizationOptionsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationOptionsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationOptionsResponse>(null as any);
    }

    pilotageOrganizationOptions(): Promise<OrganizationOptionsResponse> {
        let url_ = this.baseUrl + "/practices/pilotage-practice-organization-options";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPilotageOrganizationOptions(_response));
        });
    }

    protected processPilotageOrganizationOptions(response: Response): Promise<OrganizationOptionsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationOptionsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationOptionsResponse>(null as any);
    }

    vtsCenterOrganizationOptions(): Promise<OrganizationOptionsResponse> {
        let url_ = this.baseUrl + "/practices/vts-center-practice-organization-options";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVtsCenterOrganizationOptions(_response));
        });
    }

    protected processVtsCenterOrganizationOptions(response: Response): Promise<OrganizationOptionsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationOptionsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationOptionsResponse>(null as any);
    }

    availableActions(id: string): Promise<PracticeActions> {
        let url_ = this.baseUrl + "/practices/{id}/available-actions";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAvailableActions(_response));
        });
    }

    protected processAvailableActions(response: Response): Promise<PracticeActions> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PracticeActions.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PracticeActions>(null as any);
    }

    availableShipRepairActions(): Promise<ShipRepairPracticeActions> {
        let url_ = this.baseUrl + "/practices/available-ship-repair-actions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAvailableShipRepairActions(_response));
        });
    }

    protected processAvailableShipRepairActions(response: Response): Promise<ShipRepairPracticeActions> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShipRepairPracticeActions.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShipRepairPracticeActions>(null as any);
    }

    availableSeafaringActions(): Promise<SeafaringPracticeActions> {
        let url_ = this.baseUrl + "/practices/available-seafaring-actions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAvailableSeafaringActions(_response));
        });
    }

    protected processAvailableSeafaringActions(response: Response): Promise<SeafaringPracticeActions> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SeafaringPracticeActions.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SeafaringPracticeActions>(null as any);
    }

    availableInlandVesselActions(): Promise<InlandVesselPracticeActions> {
        let url_ = this.baseUrl + "/practices/available-inland-vessel-actions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAvailableInlandVesselActions(_response));
        });
    }

    protected processAvailableInlandVesselActions(response: Response): Promise<InlandVesselPracticeActions> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InlandVesselPracticeActions.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InlandVesselPracticeActions>(null as any);
    }

    availablePilotageActions(): Promise<PilotagePracticeActions> {
        let url_ = this.baseUrl + "/practices/available-pilotage-actions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAvailablePilotageActions(_response));
        });
    }

    protected processAvailablePilotageActions(response: Response): Promise<PilotagePracticeActions> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PilotagePracticeActions.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PilotagePracticeActions>(null as any);
    }

    availableVtsCenterActions(): Promise<VtsCenterPracticeActions> {
        let url_ = this.baseUrl + "/practices/available-vts-center-actions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAvailableVtsCenterActions(_response));
        });
    }

    protected processAvailableVtsCenterActions(response: Response): Promise<VtsCenterPracticeActions> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VtsCenterPracticeActions.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VtsCenterPracticeActions>(null as any);
    }

    getPilotInstructors(): Promise<InstructorOption[]> {
        let url_ = this.baseUrl + "/practices/pilot-instructors";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPilotInstructors(_response));
        });
    }

    protected processGetPilotInstructors(response: Response): Promise<InstructorOption[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InstructorOption.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstructorOption[]>(null as any);
    }

    availableListActions(seafarerId: string | undefined): Promise<PracticeListActions> {
        let url_ = this.baseUrl + "/practices/available-list-actions?";
        if (seafarerId === null)
            throw new Error("The parameter 'seafarerId' cannot be null.");
        else if (seafarerId !== undefined)
            url_ += "seafarerId=" + encodeURIComponent("" + seafarerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAvailableListActions(_response));
        });
    }

    protected processAvailableListActions(response: Response): Promise<PracticeListActions> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PracticeListActions.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PracticeListActions>(null as any);
    }

    importFromEmde(seafarerId: string): Promise<ImportFromEmdeResponse> {
        let url_ = this.baseUrl + "/seafarers/{seafarerId}/practices/import-from-emde";
        if (seafarerId === undefined || seafarerId === null)
            throw new Error("The parameter 'seafarerId' must be defined.");
        url_ = url_.replace("{seafarerId}", encodeURIComponent("" + seafarerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImportFromEmde(_response));
        });
    }

    protected processImportFromEmde(response: Response): Promise<ImportFromEmdeResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ImportFromEmdeResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportFromEmdeResponse>(null as any);
    }

    approve(id: string, version: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/practices/{id}/approve?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === null)
            throw new Error("The parameter 'version' cannot be null.");
        else if (version !== undefined)
            url_ += "version=" + encodeURIComponent("" + version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processApprove(_response));
        });
    }

    protected processApprove(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    disapprove(id: string, comment: string): Promise<void> {
        let url_ = this.baseUrl + "/practices/{id}/disapprove";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(comment);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDisapprove(_response));
        });
    }

    protected processDisapprove(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class PositionsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    list(): Promise<MultilanguagePosition[]> {
        let url_ = this.baseUrl + "/multilanguage-positions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<MultilanguagePosition[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MultilanguagePosition.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MultilanguagePosition[]>(null as any);
    }

    positionOptions(): Promise<PositionOption[]> {
        let url_ = this.baseUrl + "/position-options";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPositionOptions(_response));
        });
    }

    protected processPositionOptions(response: Response): Promise<PositionOption[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PositionOption.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PositionOption[]>(null as any);
    }

    activePositionOptions(): Promise<PositionOption[]> {
        let url_ = this.baseUrl + "/active-position-options";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processActivePositionOptions(_response));
        });
    }

    protected processActivePositionOptions(response: Response): Promise<PositionOption[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PositionOption.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PositionOption[]>(null as any);
    }

    levels(): Promise<PositionLevelModel[]> {
        let url_ = this.baseUrl + "/position-levels";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLevels(_response));
        });
    }

    protected processLevels(response: Response): Promise<PositionLevelModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PositionLevelModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PositionLevelModel[]>(null as any);
    }
}

export class PersonalInfoClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(seafarerId: string): Promise<PersonalInfoModel> {
        let url_ = this.baseUrl + "/seafarers/{seafarerId}/personal-info";
        if (seafarerId === undefined || seafarerId === null)
            throw new Error("The parameter 'seafarerId' must be defined.");
        url_ = url_.replace("{seafarerId}", encodeURIComponent("" + seafarerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<PersonalInfoModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonalInfoModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PersonalInfoModel>(null as any);
    }

    update(model: UpdatePersonalInfoRequest, seafarerId: string): Promise<any> {
        let url_ = this.baseUrl + "/seafarers/{seafarerId}/personal-info/save";
        if (seafarerId === undefined || seafarerId === null)
            throw new Error("The parameter 'seafarerId' must be defined.");
        url_ = url_.replace("{seafarerId}", encodeURIComponent("" + seafarerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    options(seafarerId: string): Promise<PersonalInfoOptions> {
        let url_ = this.baseUrl + "/seafarers/{seafarerId}/personal-info/options";
        if (seafarerId === undefined || seafarerId === null)
            throw new Error("The parameter 'seafarerId' must be defined.");
        url_ = url_.replace("{seafarerId}", encodeURIComponent("" + seafarerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processOptions(_response));
        });
    }

    protected processOptions(response: Response): Promise<PersonalInfoOptions> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonalInfoOptions.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PersonalInfoOptions>(null as any);
    }

    downloadFile(fileId: string, seafarerId: string): Promise<DownloadUrl> {
        let url_ = this.baseUrl + "/seafarers/{seafarerId}/personal-info/files/{fileId}";
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        if (seafarerId === undefined || seafarerId === null)
            throw new Error("The parameter 'seafarerId' must be defined.");
        url_ = url_.replace("{seafarerId}", encodeURIComponent("" + seafarerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadFile(_response));
        });
    }

    protected processDownloadFile(response: Response): Promise<DownloadUrl> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DownloadUrl.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DownloadUrl>(null as any);
    }

    approve(seafarerId: string, version: number | undefined): Promise<ApprovalStatus> {
        let url_ = this.baseUrl + "/seafarers/{seafarerId}/personal-info/approve?";
        if (seafarerId === undefined || seafarerId === null)
            throw new Error("The parameter 'seafarerId' must be defined.");
        url_ = url_.replace("{seafarerId}", encodeURIComponent("" + seafarerId));
        if (version === null)
            throw new Error("The parameter 'version' cannot be null.");
        else if (version !== undefined)
            url_ += "version=" + encodeURIComponent("" + version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processApprove(_response));
        });
    }

    protected processApprove(response: Response): Promise<ApprovalStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApprovalStatus>(null as any);
    }

    reject(seafarerId: string): Promise<ApprovalStatus> {
        let url_ = this.baseUrl + "/seafarers/{seafarerId}/personal-info/reject";
        if (seafarerId === undefined || seafarerId === null)
            throw new Error("The parameter 'seafarerId' must be defined.");
        url_ = url_.replace("{seafarerId}", encodeURIComponent("" + seafarerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReject(_response));
        });
    }

    protected processReject(response: Response): Promise<ApprovalStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApprovalStatus>(null as any);
    }

    getContactInfo(seafarerId: string): Promise<ContactInfoViewModel> {
        let url_ = this.baseUrl + "/seafarers/{seafarerId}/personal-info/contact-info";
        if (seafarerId === undefined || seafarerId === null)
            throw new Error("The parameter 'seafarerId' must be defined.");
        url_ = url_.replace("{seafarerId}", encodeURIComponent("" + seafarerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetContactInfo(_response));
        });
    }

    protected processGetContactInfo(response: Response): Promise<ContactInfoViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContactInfoViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContactInfoViewModel>(null as any);
    }

    updateContactInfo(request: UpdateContactInfoRequest, seafarerId: string): Promise<UpdateContactInfoRequest> {
        let url_ = this.baseUrl + "/seafarers/{seafarerId}/personal-info/contact-info";
        if (seafarerId === undefined || seafarerId === null)
            throw new Error("The parameter 'seafarerId' must be defined.");
        url_ = url_.replace("{seafarerId}", encodeURIComponent("" + seafarerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateContactInfo(_response));
        });
    }

    protected processUpdateContactInfo(response: Response): Promise<UpdateContactInfoRequest> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateContactInfoRequest.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateContactInfoRequest>(null as any);
    }

    updateEmailNotificationPreference(seafarerId: string, receiveEmailNotifications: boolean | undefined): Promise<void> {
        let url_ = this.baseUrl + "/seafarers/{seafarerId}/personal-info/email-notification-preference?";
        if (seafarerId === undefined || seafarerId === null)
            throw new Error("The parameter 'seafarerId' must be defined.");
        url_ = url_.replace("{seafarerId}", encodeURIComponent("" + seafarerId));
        if (receiveEmailNotifications === null)
            throw new Error("The parameter 'receiveEmailNotifications' cannot be null.");
        else if (receiveEmailNotifications !== undefined)
            url_ += "receiveEmailNotifications=" + encodeURIComponent("" + receiveEmailNotifications) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateEmailNotificationPreference(_response));
        });
    }

    protected processUpdateEmailNotificationPreference(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ResultError.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ResultError.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getMaritimeInfo(seafarerId: string): Promise<SeafarerMaritimeInfoModel> {
        let url_ = this.baseUrl + "/seafarers/{seafarerId}/personal-info/maritime-info";
        if (seafarerId === undefined || seafarerId === null)
            throw new Error("The parameter 'seafarerId' must be defined.");
        url_ = url_.replace("{seafarerId}", encodeURIComponent("" + seafarerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMaritimeInfo(_response));
        });
    }

    protected processGetMaritimeInfo(response: Response): Promise<SeafarerMaritimeInfoModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SeafarerMaritimeInfoModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SeafarerMaritimeInfoModel>(null as any);
    }

    updateMaritimeInfo(model: SeafarerMaritimeInfoModel, seafarerId: string): Promise<SeafarerMaritimeInfoModel> {
        let url_ = this.baseUrl + "/seafarers/{seafarerId}/personal-info/maritime-info";
        if (seafarerId === undefined || seafarerId === null)
            throw new Error("The parameter 'seafarerId' must be defined.");
        url_ = url_.replace("{seafarerId}", encodeURIComponent("" + seafarerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateMaritimeInfo(_response));
        });
    }

    protected processUpdateMaritimeInfo(response: Response): Promise<SeafarerMaritimeInfoModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SeafarerMaritimeInfoModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SeafarerMaritimeInfoModel>(null as any);
    }

    availableActions(seafarerId: string): Promise<PersonalInfoActions> {
        let url_ = this.baseUrl + "/seafarers/{seafarerId}/personal-info/available-actions";
        if (seafarerId === undefined || seafarerId === null)
            throw new Error("The parameter 'seafarerId' must be defined.");
        url_ = url_.replace("{seafarerId}", encodeURIComponent("" + seafarerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAvailableActions(_response));
        });
    }

    protected processAvailableActions(response: Response): Promise<PersonalInfoActions> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonalInfoActions.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PersonalInfoActions>(null as any);
    }

    updateFromRR(seafarerId: string): Promise<UpdatePersonalInfoFromRRResponse> {
        let url_ = this.baseUrl + "/seafarers/{seafarerId}/personal-info/update-from-xroad";
        if (seafarerId === undefined || seafarerId === null)
            throw new Error("The parameter 'seafarerId' must be defined.");
        url_ = url_.replace("{seafarerId}", encodeURIComponent("" + seafarerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateFromRR(_response));
        });
    }

    protected processUpdateFromRR(response: Response): Promise<UpdatePersonalInfoFromRRResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdatePersonalInfoFromRRResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdatePersonalInfoFromRRResponse>(null as any);
    }

    updatePersonalCode(model: UpdateSeafarerPersonalCodeModel, seafarerId: string): Promise<UpdateSeafarerPersonalCodeModel> {
        let url_ = this.baseUrl + "/seafarers/{seafarerId}/personal-info/personal-code";
        if (seafarerId === undefined || seafarerId === null)
            throw new Error("The parameter 'seafarerId' must be defined.");
        url_ = url_.replace("{seafarerId}", encodeURIComponent("" + seafarerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdatePersonalCode(_response));
        });
    }

    protected processUpdatePersonalCode(response: Response): Promise<UpdateSeafarerPersonalCodeModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateSeafarerPersonalCodeModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateSeafarerPersonalCodeModel>(null as any);
    }

    updateUsername(model: UpdateSeafarerUsernameModel, seafarerId: string): Promise<UpdateSeafarerUsernameModel> {
        let url_ = this.baseUrl + "/seafarers/{seafarerId}/personal-info/username";
        if (seafarerId === undefined || seafarerId === null)
            throw new Error("The parameter 'seafarerId' must be defined.");
        url_ = url_.replace("{seafarerId}", encodeURIComponent("" + seafarerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateUsername(_response));
        });
    }

    protected processUpdateUsername(response: Response): Promise<UpdateSeafarerUsernameModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateSeafarerUsernameModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateSeafarerUsernameModel>(null as any);
    }

    chooseActiveProfileImage(seafarerId: string, activeProfileImageId: string | undefined): Promise<Ok> {
        let url_ = this.baseUrl + "/seafarers/{seafarerId}/personal-info/displayed-profile-image?";
        if (seafarerId === undefined || seafarerId === null)
            throw new Error("The parameter 'seafarerId' must be defined.");
        url_ = url_.replace("{seafarerId}", encodeURIComponent("" + seafarerId));
        if (activeProfileImageId === null)
            throw new Error("The parameter 'activeProfileImageId' cannot be null.");
        else if (activeProfileImageId !== undefined)
            url_ += "activeProfileImageId=" + encodeURIComponent("" + activeProfileImageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processChooseActiveProfileImage(_response));
        });
    }

    protected processChooseActiveProfileImage(response: Response): Promise<Ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ResultError.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Ok>(null as any);
    }
}

export class SeafarersClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    search(onlyActive: boolean | undefined, sort: SeafarerProfileSortField | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, searchTerm: string | null | undefined): Promise<PagedResultOfSeafarerProfileLightViewModel> {
        let url_ = this.baseUrl + "/seafarers/search?";
        if (onlyActive === null)
            throw new Error("The parameter 'onlyActive' cannot be null.");
        else if (onlyActive !== undefined)
            url_ += "OnlyActive=" + encodeURIComponent("" + onlyActive) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearch(_response));
        });
    }

    protected processSearch(response: Response): Promise<PagedResultOfSeafarerProfileLightViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfSeafarerProfileLightViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfSeafarerProfileLightViewModel>(null as any);
    }

    availableActions(seafarerId: string): Promise<SeafarerActions> {
        let url_ = this.baseUrl + "/seafarers/{seafarerId}/available-actions";
        if (seafarerId === undefined || seafarerId === null)
            throw new Error("The parameter 'seafarerId' must be defined.");
        url_ = url_.replace("{seafarerId}", encodeURIComponent("" + seafarerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAvailableActions(_response));
        });
    }

    protected processAvailableActions(response: Response): Promise<SeafarerActions> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SeafarerActions.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SeafarerActions>(null as any);
    }

    availableSearchActions(): Promise<SearchSeafarersActions> {
        let url_ = this.baseUrl + "/seafarers/available-search-actions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAvailableSearchActions(_response));
        });
    }

    protected processAvailableSearchActions(response: Response): Promise<SearchSeafarersActions> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchSeafarersActions.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchSeafarersActions>(null as any);
    }

    addWithPersonalCode(personalCode: string): Promise<AddSeafarerResultModel> {
        let url_ = this.baseUrl + "/seafarers/add/with-personal-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(personalCode);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddWithPersonalCode(_response));
        });
    }

    protected processAddWithPersonalCode(response: Response): Promise<AddSeafarerResultModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddSeafarerResultModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddSeafarerResultModel>(null as any);
    }

    addWithoutPersonalCode(model: AddSeafarerWithoutPersonalCodeModel): Promise<AddSeafarerResultModel> {
        let url_ = this.baseUrl + "/seafarers/add/without-personal-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddWithoutPersonalCode(_response));
        });
    }

    protected processAddWithoutPersonalCode(response: Response): Promise<AddSeafarerResultModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddSeafarerResultModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddSeafarerResultModel>(null as any);
    }

    createProfile(model: AddSeafarerWithoutPersonalCodeModel): Promise<AddSeafarerResultModel> {
        let url_ = this.baseUrl + "/seafarers/create-profile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateProfile(_response));
        });
    }

    protected processCreateProfile(response: Response): Promise<AddSeafarerResultModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddSeafarerResultModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddSeafarerResultModel>(null as any);
    }

    becomeSeafarer(): Promise<BecomeSeafarerResultModel> {
        let url_ = this.baseUrl + "/seafarers/become-seafarer";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBecomeSeafarer(_response));
        });
    }

    protected processBecomeSeafarer(response: Response): Promise<BecomeSeafarerResultModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BecomeSeafarerResultModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BecomeSeafarerResultModel>(null as any);
    }

    deactivate(id: string): Promise<void> {
        let url_ = this.baseUrl + "/seafarers/{id}/deactivate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeactivate(_response));
        });
    }

    protected processDeactivate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    activate(id: string): Promise<void> {
        let url_ = this.baseUrl + "/seafarers/{id}/activate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processActivate(_response));
        });
    }

    protected processActivate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    basicInfo(seafarerId: string | undefined): Promise<SeafarerBasicInfoModel> {
        let url_ = this.baseUrl + "/seafarers/basic-info?";
        if (seafarerId === null)
            throw new Error("The parameter 'seafarerId' cannot be null.");
        else if (seafarerId !== undefined)
            url_ += "seafarerId=" + encodeURIComponent("" + seafarerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processBasicInfo(_response));
        });
    }

    protected processBasicInfo(response: Response): Promise<SeafarerBasicInfoModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SeafarerBasicInfoModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SeafarerBasicInfoModel>(null as any);
    }
}

export class EnterForeignCertificatesClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    submit(request: EnterForeignCertificateRequest, seafarerId: string): Promise<string> {
        let url_ = this.baseUrl + "/seafarers/{seafarerId}/foreign-certificate";
        if (seafarerId === undefined || seafarerId === null)
            throw new Error("The parameter 'seafarerId' must be defined.");
        url_ = url_.replace("{seafarerId}", encodeURIComponent("" + seafarerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSubmit(_response));
        });
    }

    protected processSubmit(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    validate(request: EnterForeignCertificateRequest, seafarerId: string): Promise<boolean> {
        let url_ = this.baseUrl + "/seafarers/{seafarerId}/foreign-certificate/validate";
        if (seafarerId === undefined || seafarerId === null)
            throw new Error("The parameter 'seafarerId' must be defined.");
        url_ = url_.replace("{seafarerId}", encodeURIComponent("" + seafarerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processValidate(_response));
        });
    }

    protected processValidate(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class OrganizationsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    details(organizationId: string): Promise<OrganizationDetailsModel> {
        let url_ = this.baseUrl + "/organizations/{organizationId}";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDetails(_response));
        });
    }

    protected processDetails(response: Response): Promise<OrganizationDetailsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationDetailsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationDetailsModel>(null as any);
    }

    saveContactInfo(request: UpdateOrganizationContactInfoModel, organizationId: string): Promise<Ok> {
        let url_ = this.baseUrl + "/organizations/{organizationId}/contact-info";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveContactInfo(_response));
        });
    }

    protected processSaveContactInfo(response: Response): Promise<Ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Ok>(null as any);
    }

    addRepresentative(request: AddRepresentativeModel, organizationId: string): Promise<Ok> {
        let url_ = this.baseUrl + "/organizations/{organizationId}/representatives";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddRepresentative(_response));
        });
    }

    protected processAddRepresentative(response: Response): Promise<Ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Ok>(null as any);
    }

    updateRepresentative(request: UpdateRepresentativeModel, id: string, organizationId: string): Promise<Ok> {
        let url_ = this.baseUrl + "/organizations/{organizationId}/representatives/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateRepresentative(_response));
        });
    }

    protected processUpdateRepresentative(response: Response): Promise<Ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Ok>(null as any);
    }

    updateFromRR(id: string, organizationId: string): Promise<Ok> {
        let url_ = this.baseUrl + "/organizations/{organizationId}/{id}/update-from-xroad";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateFromRR(_response));
        });
    }

    protected processUpdateFromRR(response: Response): Promise<Ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Ok>(null as any);
    }

    inactivateRepresentative(id: string, organizationId: string): Promise<Ok> {
        let url_ = this.baseUrl + "/organizations/{organizationId}/representatives/{id}/inactivate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processInactivateRepresentative(_response));
        });
    }

    protected processInactivateRepresentative(response: Response): Promise<Ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Ok>(null as any);
    }

    activateRepresentative(id: string, organizationId: string): Promise<Ok> {
        let url_ = this.baseUrl + "/organizations/{organizationId}/representatives/{id}/activate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processActivateRepresentative(_response));
        });
    }

    protected processActivateRepresentative(response: Response): Promise<Ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Ok>(null as any);
    }

    downloadRepresentativeSignatureFile(representativeId: string, fileId: string, organizationId: string): Promise<DownloadUrl> {
        let url_ = this.baseUrl + "/organizations/{organizationId}/representatives/{representativeId}/files/{fileId}";
        if (representativeId === undefined || representativeId === null)
            throw new Error("The parameter 'representativeId' must be defined.");
        url_ = url_.replace("{representativeId}", encodeURIComponent("" + representativeId));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadRepresentativeSignatureFile(_response));
        });
    }

    protected processDownloadRepresentativeSignatureFile(response: Response): Promise<DownloadUrl> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DownloadUrl.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DownloadUrl>(null as any);
    }

    availableActions(organizationId: string): Promise<OrganizationActions> {
        let url_ = this.baseUrl + "/organizations/{organizationId}/available-actions";
        if (organizationId === undefined || organizationId === null)
            throw new Error("The parameter 'organizationId' must be defined.");
        url_ = url_.replace("{organizationId}", encodeURIComponent("" + organizationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAvailableActions(_response));
        });
    }

    protected processAvailableActions(response: Response): Promise<OrganizationActions> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganizationActions.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OrganizationActions>(null as any);
    }
}

export class OfficialsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    all(): Promise<Official[]> {
        let url_ = this.baseUrl + "/officials";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAll(_response));
        });
    }

    protected processAll(response: Response): Promise<Official[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Official.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Official[]>(null as any);
    }
}

export class NotificationsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(pageNumber: number | undefined, pageSize: number | undefined, states: NotificationState[] | undefined): Promise<PagedResultOfNotificationModel> {
        let url_ = this.baseUrl + "/notifications?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (states === null)
            throw new Error("The parameter 'states' cannot be null.");
        else if (states !== undefined)
            states && states.forEach(item => { url_ += "States=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<PagedResultOfNotificationModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfNotificationModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfNotificationModel>(null as any);
    }

    markRead(notificationIds: string[]): Promise<void> {
        let url_ = this.baseUrl + "/notifications/mark-read";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(notificationIds);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processMarkRead(_response));
        });
    }

    protected processMarkRead(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    availableActions(): Promise<NotificationsActions> {
        let url_ = this.baseUrl + "/notifications/available-actions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAvailableActions(_response));
        });
    }

    protected processAvailableActions(response: Response): Promise<NotificationsActions> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationsActions.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationsActions>(null as any);
    }
}

export class MedicalCertificatesClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    list(seafarerId: string): Promise<ListMedicalCertificatesResponse> {
        let url_ = this.baseUrl + "/seafarers/{seafarerId}/medical-certificates";
        if (seafarerId === undefined || seafarerId === null)
            throw new Error("The parameter 'seafarerId' must be defined.");
        url_ = url_.replace("{seafarerId}", encodeURIComponent("" + seafarerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<ListMedicalCertificatesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ListMedicalCertificatesResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListMedicalCertificatesResponse>(null as any);
    }

    /**
     * @param searchTerm (optional) Text search from:
    seafarer name,  
    seafarer personal code,
    certificate name,
    document number
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param showValid (optional) 
     * @param showInvalid (optional) 
     * @param showUnchecked (optional) 
     * @param sortDir (optional) 
     * @param sort (optional) 
     */
    officialMedicalCertificates(searchTerm: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, showValid: boolean | undefined, showInvalid: boolean | undefined, showUnchecked: boolean | undefined, sortDir: SortOrder | null | undefined, sort: string | null | undefined): Promise<PagedResultOfOfficialMedicalCertificateLightViewModel> {
        let url_ = this.baseUrl + "/medical-certificates?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (showValid === null)
            throw new Error("The parameter 'showValid' cannot be null.");
        else if (showValid !== undefined)
            url_ += "ShowValid=" + encodeURIComponent("" + showValid) + "&";
        if (showInvalid === null)
            throw new Error("The parameter 'showInvalid' cannot be null.");
        else if (showInvalid !== undefined)
            url_ += "ShowInvalid=" + encodeURIComponent("" + showInvalid) + "&";
        if (showUnchecked === null)
            throw new Error("The parameter 'showUnchecked' cannot be null.");
        else if (showUnchecked !== undefined)
            url_ += "ShowUnchecked=" + encodeURIComponent("" + showUnchecked) + "&";
        if (sortDir !== undefined && sortDir !== null)
            url_ += "SortDir=" + encodeURIComponent("" + sortDir) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processOfficialMedicalCertificates(_response));
        });
    }

    protected processOfficialMedicalCertificates(response: Response): Promise<PagedResultOfOfficialMedicalCertificateLightViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfOfficialMedicalCertificateLightViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfOfficialMedicalCertificateLightViewModel>(null as any);
    }

    add(request: AddMedicalCertificateRequest, seafarerId: string | undefined): Promise<AddMedicalCertificateResponse> {
        let url_ = this.baseUrl + "/medical-certificates?";
        if (seafarerId === null)
            throw new Error("The parameter 'seafarerId' cannot be null.");
        else if (seafarerId !== undefined)
            url_ += "seafarerId=" + encodeURIComponent("" + seafarerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAdd(_response));
        });
    }

    protected processAdd(response: Response): Promise<AddMedicalCertificateResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddMedicalCertificateResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddMedicalCertificateResponse>(null as any);
    }

    get(id: string): Promise<GetMedicalCertificateResponse> {
        let url_ = this.baseUrl + "/medical-certificates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<GetMedicalCertificateResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMedicalCertificateResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetMedicalCertificateResponse>(null as any);
    }

    edit(request: AddMedicalCertificateRequest, seafarerId: string | undefined, id: string): Promise<AddMedicalCertificateResponse> {
        let url_ = this.baseUrl + "/medical-certificates/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (seafarerId === null)
            throw new Error("The parameter 'seafarerId' cannot be null.");
        else if (seafarerId !== undefined)
            url_ += "seafarerId=" + encodeURIComponent("" + seafarerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEdit(_response));
        });
    }

    protected processEdit(response: Response): Promise<AddMedicalCertificateResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddMedicalCertificateResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddMedicalCertificateResponse>(null as any);
    }

    delete(id: string): Promise<void> {
        let url_ = this.baseUrl + "/medical-certificates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    get2(): Promise<GetMedicalCertificateResponse> {
        let url_ = this.baseUrl + "/odata/MedicalCertificates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet2(_response));
        });
    }

    protected processGet2(response: Response): Promise<GetMedicalCertificateResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMedicalCertificateResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetMedicalCertificateResponse>(null as any);
    }

    get3(): Promise<GetMedicalCertificateResponse> {
        let url_ = this.baseUrl + "/odata/MedicalCertificates/$count";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet3(_response));
        });
    }

    protected processGet3(response: Response): Promise<GetMedicalCertificateResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMedicalCertificateResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetMedicalCertificateResponse>(null as any);
    }

    getByAccessToken(accessToken: string): Promise<MinimalDocumentModel> {
        let url_ = this.baseUrl + "/medical-certificates/by-access-token/{accessToken}";
        if (accessToken === undefined || accessToken === null)
            throw new Error("The parameter 'accessToken' must be defined.");
        url_ = url_.replace("{accessToken}", encodeURIComponent("" + accessToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetByAccessToken(_response));
        });
    }

    protected processGetByAccessToken(response: Response): Promise<MinimalDocumentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MinimalDocumentModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MinimalDocumentModel>(null as any);
    }

    medicalInstitutionOptions(): Promise<MedicalInstitutionOption[]> {
        let url_ = this.baseUrl + "/medical-certificates/medical-institution-options";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processMedicalInstitutionOptions(_response));
        });
    }

    protected processMedicalInstitutionOptions(response: Response): Promise<MedicalInstitutionOption[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(MedicalInstitutionOption.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MedicalInstitutionOption[]>(null as any);
    }

    downloadFile(id: string, fileId: string): Promise<DownloadUrl> {
        let url_ = this.baseUrl + "/medical-certificates/{id}/files/{fileId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadFile(_response));
        });
    }

    protected processDownloadFile(response: Response): Promise<DownloadUrl> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DownloadUrl.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DownloadUrl>(null as any);
    }

    availableActions(id: string | null | undefined): Promise<MedicalCertificateActions> {
        let url_ = this.baseUrl + "/medical-certificates/available-actions?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAvailableActions(_response));
        });
    }

    protected processAvailableActions(response: Response): Promise<MedicalCertificateActions> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalCertificateActions.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MedicalCertificateActions>(null as any);
    }

    availableListActions(seafarerId: string | undefined): Promise<MedicalCertificateListActions> {
        let url_ = this.baseUrl + "/medical-certificates/available-list-actions?";
        if (seafarerId === null)
            throw new Error("The parameter 'seafarerId' cannot be null.");
        else if (seafarerId !== undefined)
            url_ += "seafarerId=" + encodeURIComponent("" + seafarerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAvailableListActions(_response));
        });
    }

    protected processAvailableListActions(response: Response): Promise<MedicalCertificateListActions> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalCertificateListActions.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MedicalCertificateListActions>(null as any);
    }

    approve(id: string, version: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/medical-certificates/{id}/approve?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === null)
            throw new Error("The parameter 'version' cannot be null.");
        else if (version !== undefined)
            url_ += "version=" + encodeURIComponent("" + version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processApprove(_response));
        });
    }

    protected processApprove(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    disapprove(id: string, comment: string): Promise<void> {
        let url_ = this.baseUrl + "/medical-certificates/{id}/disapprove";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(comment);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDisapprove(_response));
        });
    }

    protected processDisapprove(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class HeaderNotificationClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    get(): Promise<HeaderNotification> {
        let url_ = this.baseUrl + "/header-notifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<HeaderNotification> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HeaderNotification.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HeaderNotification>(null as any);
    }
}

export class HarboursClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    harbourOptions(): Promise<HarbourOptionsResponse> {
        let url_ = this.baseUrl + "/harbours/harbour-options";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processHarbourOptions(_response));
        });
    }

    protected processHarbourOptions(response: Response): Promise<HarbourOptionsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HarbourOptionsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HarbourOptionsResponse>(null as any);
    }
}

export class UserTemporaryFilesClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    createUploadUrl(fileName: string | undefined): Promise<TempFileUploadDestinationModel> {
        let url_ = this.baseUrl + "/files/user-temporary/create?";
        if (fileName === null)
            throw new Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateUploadUrl(_response));
        });
    }

    protected processCreateUploadUrl(response: Response): Promise<TempFileUploadDestinationModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TempFileUploadDestinationModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TempFileUploadDestinationModel>(null as any);
    }
}

export class EndorsementsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    endorsements(seafarerId: string): Promise<EndorsementLightViewModel[]> {
        let url_ = this.baseUrl + "/seafarers/{seafarerId}/endorsements";
        if (seafarerId === undefined || seafarerId === null)
            throw new Error("The parameter 'seafarerId' must be defined.");
        url_ = url_.replace("{seafarerId}", encodeURIComponent("" + seafarerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEndorsements(_response));
        });
    }

    protected processEndorsements(response: Response): Promise<EndorsementLightViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EndorsementLightViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EndorsementLightViewModel[]>(null as any);
    }

    officialEndorsements(searchTerm: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, showValid: boolean | undefined, showInvalid: boolean | undefined, showSuspended: boolean | undefined): Promise<PagedResultOfOfficialEndorsementLightViewModel> {
        let url_ = this.baseUrl + "/endorsements?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (showValid === null)
            throw new Error("The parameter 'showValid' cannot be null.");
        else if (showValid !== undefined)
            url_ += "ShowValid=" + encodeURIComponent("" + showValid) + "&";
        if (showInvalid === null)
            throw new Error("The parameter 'showInvalid' cannot be null.");
        else if (showInvalid !== undefined)
            url_ += "ShowInvalid=" + encodeURIComponent("" + showInvalid) + "&";
        if (showSuspended === null)
            throw new Error("The parameter 'showSuspended' cannot be null.");
        else if (showSuspended !== undefined)
            url_ += "ShowSuspended=" + encodeURIComponent("" + showSuspended) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processOfficialEndorsements(_response));
        });
    }

    protected processOfficialEndorsements(response: Response): Promise<PagedResultOfOfficialEndorsementLightViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfOfficialEndorsementLightViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfOfficialEndorsementLightViewModel>(null as any);
    }

    details(id: string): Promise<EndorsementDetailsModel> {
        let url_ = this.baseUrl + "/endorsements/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDetails(_response));
        });
    }

    protected processDetails(response: Response): Promise<EndorsementDetailsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EndorsementDetailsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EndorsementDetailsModel>(null as any);
    }

    detailsByAccessToken(accessToken: string): Promise<MinimalDocumentModel> {
        let url_ = this.baseUrl + "/endorsements/by-access-token/{accessToken}";
        if (accessToken === undefined || accessToken === null)
            throw new Error("The parameter 'accessToken' must be defined.");
        url_ = url_.replace("{accessToken}", encodeURIComponent("" + accessToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDetailsByAccessToken(_response));
        });
    }

    protected processDetailsByAccessToken(response: Response): Promise<MinimalDocumentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MinimalDocumentModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MinimalDocumentModel>(null as any);
    }

    additionalInfo(id: string): Promise<string> {
        let url_ = this.baseUrl + "/endorsements/{id}/additional-info";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAdditionalInfo(_response));
        });
    }

    protected processAdditionalInfo(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    setAdditionalInfo(id: string, additionalInfo: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/endorsements/{id}/set-additional-info?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (additionalInfo !== undefined && additionalInfo !== null)
            url_ += "additionalInfo=" + encodeURIComponent("" + additionalInfo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetAdditionalInfo(_response));
        });
    }

    protected processSetAdditionalInfo(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    suspend(id: string, request: SuspendRequest): Promise<void> {
        let url_ = this.baseUrl + "/endorsements/{id}/suspend";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSuspend(_response));
        });
    }

    protected processSuspend(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    invalidate(id: string, request: InvalidationRequest): Promise<void> {
        let url_ = this.baseUrl + "/endorsements/{id}/invalidate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processInvalidate(_response));
        });
    }

    protected processInvalidate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    cancelSuspension(id: string): Promise<void> {
        let url_ = this.baseUrl + "/endorsements/{id}/cancel-suspension";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCancelSuspension(_response));
        });
    }

    protected processCancelSuspension(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    availableActions(id: string): Promise<EndorsementActions> {
        let url_ = this.baseUrl + "/endorsements/{id}/available-actions";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAvailableActions(_response));
        });
    }

    protected processAvailableActions(response: Response): Promise<EndorsementActions> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EndorsementActions.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EndorsementActions>(null as any);
    }

    suspensionReasons(): Promise<SuspensionReasonModel[]> {
        let url_ = this.baseUrl + "/endorsements/suspension-reasons";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSuspensionReasons(_response));
        });
    }

    protected processSuspensionReasons(response: Response): Promise<SuspensionReasonModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SuspensionReasonModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SuspensionReasonModel[]>(null as any);
    }

    printTemplate(id: string): Promise<PrintTemplate> {
        let url_ = this.baseUrl + "/endorsements/{id}/print-template";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPrintTemplate(_response));
        });
    }

    protected processPrintTemplate(response: Response): Promise<PrintTemplate> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrintTemplate.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrintTemplate>(null as any);
    }

    printTemplateByAccessToken(accessToken: string): Promise<PrintTemplate> {
        let url_ = this.baseUrl + "/endorsements/print-template-by-access-token/{accessToken}";
        if (accessToken === undefined || accessToken === null)
            throw new Error("The parameter 'accessToken' must be defined.");
        url_ = url_.replace("{accessToken}", encodeURIComponent("" + accessToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPrintTemplateByAccessToken(_response));
        });
    }

    protected processPrintTemplateByAccessToken(response: Response): Promise<PrintTemplate> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrintTemplate.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrintTemplate>(null as any);
    }
}

export class DocumentAttributesClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    certificateDocumentTypes(): Promise<CertificateDocumentTypeApiModel[]> {
        let url_ = this.baseUrl + "/document-attributes/certificate-document-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCertificateDocumentTypes(_response));
        });
    }

    protected processCertificateDocumentTypes(response: Response): Promise<CertificateDocumentTypeApiModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CertificateDocumentTypeApiModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CertificateDocumentTypeApiModel[]>(null as any);
    }

    foreignSeagoingCertificateTypes(): Promise<CertificateTypeApiModel[]> {
        let url_ = this.baseUrl + "/document-attributes/foreign-seagoing-certificate-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processForeignSeagoingCertificateTypes(_response));
        });
    }

    protected processForeignSeagoingCertificateTypes(response: Response): Promise<CertificateTypeApiModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CertificateTypeApiModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CertificateTypeApiModel[]>(null as any);
    }

    invalidationReasons(): Promise<InvalidationReasonModel[]> {
        let url_ = this.baseUrl + "/document-attributes/invalidation-reasons";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processInvalidationReasons(_response));
        });
    }

    protected processInvalidationReasons(response: Response): Promise<InvalidationReasonModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InvalidationReasonModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvalidationReasonModel[]>(null as any);
    }

    countries(): Promise<CountryLightModel[]> {
        let url_ = this.baseUrl + "/document-attributes/countries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCountries(_response));
        });
    }

    protected processCountries(response: Response): Promise<CountryLightModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CountryLightModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountryLightModel[]>(null as any);
    }
}

export class DocumentValidityClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    byDocumentNumber(personalCode: string | null | undefined, firstName: string | null | undefined, lastName: string | null | undefined, documentNumber: string | null | undefined, g_recaptcha_response: string | undefined): Promise<DocumentValidityModel> {
        let url_ = this.baseUrl + "/document-validity/by-document-number?";
        if (personalCode !== undefined && personalCode !== null)
            url_ += "PersonalCode=" + encodeURIComponent("" + personalCode) + "&";
        if (firstName !== undefined && firstName !== null)
            url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName !== undefined && lastName !== null)
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
        if (documentNumber !== undefined && documentNumber !== null)
            url_ += "DocumentNumber=" + encodeURIComponent("" + documentNumber) + "&";
        if (g_recaptcha_response === null)
            throw new Error("The parameter 'g_recaptcha_response' cannot be null.");
        else if (g_recaptcha_response !== undefined)
            url_ += "g-recaptcha-response=" + encodeURIComponent("" + g_recaptcha_response) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processByDocumentNumber(_response));
        });
    }

    protected processByDocumentNumber(response: Response): Promise<DocumentValidityModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DocumentValidityModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentValidityModel>(null as any);
    }

    byBirthdate(firstName: string | null | undefined, lastName: string | null | undefined, birthDate: Date | null | undefined, g_recaptcha_response: string | undefined): Promise<DocumentValidityModel[]> {
        let url_ = this.baseUrl + "/document-validity/by-birthdate?";
        if (firstName !== undefined && firstName !== null)
            url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName !== undefined && lastName !== null)
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
        if (birthDate !== undefined && birthDate !== null)
            url_ += "BirthDate=" + encodeURIComponent(birthDate ? "" + birthDate.toISOString() : "") + "&";
        if (g_recaptcha_response === null)
            throw new Error("The parameter 'g_recaptcha_response' cannot be null.");
        else if (g_recaptcha_response !== undefined)
            url_ += "g-recaptcha-response=" + encodeURIComponent("" + g_recaptcha_response) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processByBirthdate(_response));
        });
    }

    protected processByBirthdate(response: Response): Promise<DocumentValidityModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DocumentValidityModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DocumentValidityModel[]>(null as any);
    }

    byAccessToken(accessToken: string | null | undefined, captcha: string | undefined): Promise<MinimalDocumentModel> {
        let url_ = this.baseUrl + "/document-validity/by-access-token?";
        if (accessToken !== undefined && accessToken !== null)
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        if (captcha === null)
            throw new Error("The parameter 'captcha' cannot be null.");
        else if (captcha !== undefined)
            url_ += "captcha=" + encodeURIComponent("" + captcha) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processByAccessToken(_response));
        });
    }

    protected processByAccessToken(response: Response): Promise<MinimalDocumentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MinimalDocumentModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MinimalDocumentModel>(null as any);
    }
}

export class QualificationRecordsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    search(issuedAfter: Date | null | undefined, issuedBefore: Date | null | undefined, educationalInstitutions: string[] | null | undefined, sort: QualificationRecordsSortField | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, searchTerm: string | null | undefined): Promise<PagedResultOfQualificationRecordListItem> {
        let url_ = this.baseUrl + "/qualifications/records/search?";
        if (issuedAfter !== undefined && issuedAfter !== null)
            url_ += "IssuedAfter=" + encodeURIComponent(issuedAfter ? "" + issuedAfter.toISOString() : "") + "&";
        if (issuedBefore !== undefined && issuedBefore !== null)
            url_ += "IssuedBefore=" + encodeURIComponent(issuedBefore ? "" + issuedBefore.toISOString() : "") + "&";
        if (educationalInstitutions !== undefined && educationalInstitutions !== null)
            educationalInstitutions && educationalInstitutions.forEach(item => { url_ += "EducationalInstitutions=" + encodeURIComponent("" + item) + "&"; });
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearch(_response));
        });
    }

    protected processSearch(response: Response): Promise<PagedResultOfQualificationRecordListItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfQualificationRecordListItem.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfQualificationRecordListItem>(null as any);
    }

    getTrainingRecord(id: string): Promise<TrainingQualificationRecordModel> {
        let url_ = this.baseUrl + "/qualifications/records/training/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTrainingRecord(_response));
        });
    }

    protected processGetTrainingRecord(response: Response): Promise<TrainingQualificationRecordModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainingQualificationRecordModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TrainingQualificationRecordModel>(null as any);
    }

    getEducationalRecord(id: string): Promise<EducationalQualificationRecordModel> {
        let url_ = this.baseUrl + "/qualifications/records/educational/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEducationalRecord(_response));
        });
    }

    protected processGetEducationalRecord(response: Response): Promise<EducationalQualificationRecordModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EducationalQualificationRecordModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EducationalQualificationRecordModel>(null as any);
    }

    getTrainingRecordDetails(id: string): Promise<TrainingQualificationRecordDetailsModel> {
        let url_ = this.baseUrl + "/qualifications/records/details/training/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTrainingRecordDetails(_response));
        });
    }

    protected processGetTrainingRecordDetails(response: Response): Promise<TrainingQualificationRecordDetailsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainingQualificationRecordDetailsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TrainingQualificationRecordDetailsModel>(null as any);
    }

    getEducationalRecordDetails(id: string): Promise<EducationalQualificationRecordDetailsModel> {
        let url_ = this.baseUrl + "/qualifications/records/details/educational/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEducationalRecordDetails(_response));
        });
    }

    protected processGetEducationalRecordDetails(response: Response): Promise<EducationalQualificationRecordDetailsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EducationalQualificationRecordDetailsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EducationalQualificationRecordDetailsModel>(null as any);
    }

    addRecord(record: QualificationRecordModel): Promise<QualificationRecordModel> {
        let url_ = this.baseUrl + "/qualifications/records/add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(record);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddRecord(_response));
        });
    }

    protected processAddRecord(response: Response): Promise<QualificationRecordModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QualificationRecordModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QualificationRecordModel>(null as any);
    }

    deleteRecord(id: string): Promise<void> {
        let url_ = this.baseUrl + "/qualifications/records/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteRecord(_response));
        });
    }

    protected processDeleteRecord(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateQualificationResults(model: UpdateQualificationRecordResultsModel): Promise<UpdateQualificationRecordResultsModel> {
        let url_ = this.baseUrl + "/qualifications/records/results/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateQualificationResults(_response));
        });
    }

    protected processUpdateQualificationResults(response: Response): Promise<UpdateQualificationRecordResultsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateQualificationRecordResultsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateQualificationRecordResultsModel>(null as any);
    }

    addQualificationResult(model: AddQualificationRecordResultModel): Promise<AddQualificationRecordResultModel> {
        let url_ = this.baseUrl + "/qualifications/records/results/add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddQualificationResult(_response));
        });
    }

    protected processAddQualificationResult(response: Response): Promise<AddQualificationRecordResultModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddQualificationRecordResultModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddQualificationRecordResultModel>(null as any);
    }

    removeQualificationResult(model: RemoveQualificationRecordResultModel): Promise<void> {
        let url_ = this.baseUrl + "/qualifications/records/results/remove";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRemoveQualificationResult(_response));
        });
    }

    protected processRemoveQualificationResult(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    submit(request: SubmitQualificationRecordRequest): Promise<SubmitQualificationRecordResult> {
        let url_ = this.baseUrl + "/qualifications/records/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSubmit(_response));
        });
    }

    protected processSubmit(response: Response): Promise<SubmitQualificationRecordResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubmitQualificationRecordResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubmitQualificationRecordResult>(null as any);
    }

    validateQualificationResult(model: UpdateQualificationResultModel): Promise<UpdateQualificationResultModel> {
        let url_ = this.baseUrl + "/qualifications/records/results/validate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processValidateQualificationResult(_response));
        });
    }

    protected processValidateQualificationResult(response: Response): Promise<UpdateQualificationResultModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateQualificationResultModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdateQualificationResultModel>(null as any);
    }

    downloadTrainingRecordFile(id: string, fileId: string): Promise<DownloadUrl> {
        let url_ = this.baseUrl + "/qualifications/records/details/training/{id}/files/{fileId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadTrainingRecordFile(_response));
        });
    }

    protected processDownloadTrainingRecordFile(response: Response): Promise<DownloadUrl> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DownloadUrl.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DownloadUrl>(null as any);
    }

    downloadEducationalRecordFile(id: string, fileId: string): Promise<DownloadUrl> {
        let url_ = this.baseUrl + "/qualifications/records/details/educational/{id}/files/{fileId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadEducationalRecordFile(_response));
        });
    }

    protected processDownloadEducationalRecordFile(response: Response): Promise<DownloadUrl> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DownloadUrl.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DownloadUrl>(null as any);
    }

    setResultFailed(model: SetResultAsFailedModel): Promise<Ok> {
        let url_ = this.baseUrl + "/qualifications/records/results/set-failed";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetResultFailed(_response));
        });
    }

    protected processSetResultFailed(response: Response): Promise<Ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Ok>(null as any);
    }

    setResultPassed(model: SetResultAsPassedModel): Promise<Ok> {
        let url_ = this.baseUrl + "/qualifications/records/results/set-passed";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetResultPassed(_response));
        });
    }

    protected processSetResultPassed(response: Response): Promise<Ok> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Ok.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Ok>(null as any);
    }

    availableRecordActions(id: string): Promise<AvailableActions> {
        let url_ = this.baseUrl + "/qualifications/records/{id}/available-actions";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAvailableRecordActions(_response));
        });
    }

    protected processAvailableRecordActions(response: Response): Promise<AvailableActions> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AvailableActions.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AvailableActions>(null as any);
    }

    availableActions(): Promise<AvailableActions> {
        let url_ = this.baseUrl + "/qualifications/records/available-actions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAvailableActions(_response));
        });
    }

    protected processAvailableActions(response: Response): Promise<AvailableActions> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AvailableActions.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AvailableActions>(null as any);
    }

    educationalInstitutions(): Promise<EducationalInstitutionModel[]> {
        let url_ = this.baseUrl + "/qualifications/records/educational-institutions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEducationalInstitutions(_response));
        });
    }

    protected processEducationalInstitutions(response: Response): Promise<EducationalInstitutionModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EducationalInstitutionModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EducationalInstitutionModel[]>(null as any);
    }
}

export class QualificationsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    list(seafarerId: string): Promise<QualificationViewModel[]> {
        let url_ = this.baseUrl + "/seafarers/{seafarerId}/qualifications";
        if (seafarerId === undefined || seafarerId === null)
            throw new Error("The parameter 'seafarerId' must be defined.");
        url_ = url_.replace("{seafarerId}", encodeURIComponent("" + seafarerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<QualificationViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QualificationViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QualificationViewModel[]>(null as any);
    }

    qualifications(searchTerm: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, showValid: boolean | undefined, showInvalid: boolean | undefined, showUnchecked: boolean | undefined, showTraining: boolean | undefined, showEducational: boolean | undefined, sortDir: SortOrder | null | undefined, sort: string | null | undefined): Promise<PagedResultOfOfficialQualificationLightViewModel> {
        let url_ = this.baseUrl + "/qualifications?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (showValid === null)
            throw new Error("The parameter 'showValid' cannot be null.");
        else if (showValid !== undefined)
            url_ += "ShowValid=" + encodeURIComponent("" + showValid) + "&";
        if (showInvalid === null)
            throw new Error("The parameter 'showInvalid' cannot be null.");
        else if (showInvalid !== undefined)
            url_ += "ShowInvalid=" + encodeURIComponent("" + showInvalid) + "&";
        if (showUnchecked === null)
            throw new Error("The parameter 'showUnchecked' cannot be null.");
        else if (showUnchecked !== undefined)
            url_ += "ShowUnchecked=" + encodeURIComponent("" + showUnchecked) + "&";
        if (showTraining === null)
            throw new Error("The parameter 'showTraining' cannot be null.");
        else if (showTraining !== undefined)
            url_ += "ShowTraining=" + encodeURIComponent("" + showTraining) + "&";
        if (showEducational === null)
            throw new Error("The parameter 'showEducational' cannot be null.");
        else if (showEducational !== undefined)
            url_ += "ShowEducational=" + encodeURIComponent("" + showEducational) + "&";
        if (sortDir !== undefined && sortDir !== null)
            url_ += "SortDir=" + encodeURIComponent("" + sortDir) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processQualifications(_response));
        });
    }

    protected processQualifications(response: Response): Promise<PagedResultOfOfficialQualificationLightViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfOfficialQualificationLightViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfOfficialQualificationLightViewModel>(null as any);
    }

    getTrainingQualification(id: string): Promise<TrainingQualificationDetailsModel> {
        let url_ = this.baseUrl + "/qualifications/training/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTrainingQualification(_response));
        });
    }

    protected processGetTrainingQualification(response: Response): Promise<TrainingQualificationDetailsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainingQualificationDetailsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TrainingQualificationDetailsModel>(null as any);
    }

    getEducationalQualification(id: string): Promise<EducationalQualificationDetailsModel> {
        let url_ = this.baseUrl + "/qualifications/educational/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEducationalQualification(_response));
        });
    }

    protected processGetEducationalQualification(response: Response): Promise<EducationalQualificationDetailsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EducationalQualificationDetailsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EducationalQualificationDetailsModel>(null as any);
    }

    addQualification(model: QualificationModel): Promise<string> {
        let url_ = this.baseUrl + "/qualifications/add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddQualification(_response));
        });
    }

    protected processAddQualification(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    edit(id: string, model: QualificationModel): Promise<string> {
        let url_ = this.baseUrl + "/qualifications/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEdit(_response));
        });
    }

    protected processEdit(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    delete(id: string): Promise<void> {
        let url_ = this.baseUrl + "/qualifications/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    trainingOptions(): Promise<TrainingQualificationOptions> {
        let url_ = this.baseUrl + "/qualifications/training-options";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTrainingOptions(_response));
        });
    }

    protected processTrainingOptions(response: Response): Promise<TrainingQualificationOptions> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TrainingQualificationOptions.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TrainingQualificationOptions>(null as any);
    }

    educationalOptions(): Promise<EducationalQualificationOptions> {
        let url_ = this.baseUrl + "/qualifications/educational-options";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEducationalOptions(_response));
        });
    }

    protected processEducationalOptions(response: Response): Promise<EducationalQualificationOptions> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EducationalQualificationOptions.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EducationalQualificationOptions>(null as any);
    }

    downloadEducationalQualificationFile(id: string, fileId: string): Promise<DownloadUrl> {
        let url_ = this.baseUrl + "/qualifications/educational/{id}/files/{fileId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadEducationalQualificationFile(_response));
        });
    }

    protected processDownloadEducationalQualificationFile(response: Response): Promise<DownloadUrl> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DownloadUrl.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DownloadUrl>(null as any);
    }

    downloadTrainingQualificationFile(id: string, fileId: string): Promise<DownloadUrl> {
        let url_ = this.baseUrl + "/qualifications/training/{id}/files/{fileId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadTrainingQualificationFile(_response));
        });
    }

    protected processDownloadTrainingQualificationFile(response: Response): Promise<DownloadUrl> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DownloadUrl.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DownloadUrl>(null as any);
    }

    approve(id: string, version: number | undefined): Promise<void> {
        let url_ = this.baseUrl + "/qualifications/{id}/approve?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === null)
            throw new Error("The parameter 'version' cannot be null.");
        else if (version !== undefined)
            url_ += "version=" + encodeURIComponent("" + version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processApprove(_response));
        });
    }

    protected processApprove(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    disapprove(id: string, comment: string): Promise<void> {
        let url_ = this.baseUrl + "/qualifications/{id}/disapprove";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(comment);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDisapprove(_response));
        });
    }

    protected processDisapprove(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    availableActions(seafarerId: string | undefined, qualificationId: string | null | undefined): Promise<QualificationActions> {
        let url_ = this.baseUrl + "/qualifications/qualification/available-actions?";
        if (seafarerId === null)
            throw new Error("The parameter 'seafarerId' cannot be null.");
        else if (seafarerId !== undefined)
            url_ += "seafarerId=" + encodeURIComponent("" + seafarerId) + "&";
        if (qualificationId !== undefined && qualificationId !== null)
            url_ += "qualificationId=" + encodeURIComponent("" + qualificationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAvailableActions(_response));
        });
    }

    protected processAvailableActions(response: Response): Promise<QualificationActions> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QualificationActions.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QualificationActions>(null as any);
    }

    updateFromEHIS(seafarerId: string | undefined): Promise<QualificationUpdateResult> {
        let url_ = this.baseUrl + "/qualifications/update-from-xroad?";
        if (seafarerId === null)
            throw new Error("The parameter 'seafarerId' cannot be null.");
        else if (seafarerId !== undefined)
            url_ += "seafarerId=" + encodeURIComponent("" + seafarerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateFromEHIS(_response));
        });
    }

    protected processUpdateFromEHIS(response: Response): Promise<QualificationUpdateResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = QualificationUpdateResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QualificationUpdateResult>(null as any);
    }
}

export class RestrictionsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    list(): Promise<RestrictionOption[]> {
        let url_ = this.baseUrl + "/restrictions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<RestrictionOption[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RestrictionOption.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RestrictionOption[]>(null as any);
    }
}

export class CertificateTypeTemplatesPublicClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    download(id: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/certificate-type-templates/{id}/download";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownload(_response));
        });
    }

    protected processDownload(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    printPreview(id: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/certificate-type-templates/{id}/print-preview";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPrintPreview(_response));
        });
    }

    protected processPrintPreview(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class CertificateTypesPublicClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    downloadTemplate(id: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/certificate-types/{id}/download-template";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadTemplate(_response));
        });
    }

    protected processDownloadTemplate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    downloadFile(id: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/certificate-types/template/certificate/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadFile(_response));
        });
    }

    protected processDownloadFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    viewFile(id: string, name: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/certificate-types/background/{id}/{name}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (name === undefined || name === null)
            throw new Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processViewFile(_response));
        });
    }

    protected processViewFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class CertificatesClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    certificates(seafarerId: string): Promise<CertificatesResponse> {
        let url_ = this.baseUrl + "/seafarers/{seafarerId}/certificates";
        if (seafarerId === undefined || seafarerId === null)
            throw new Error("The parameter 'seafarerId' must be defined.");
        url_ = url_.replace("{seafarerId}", encodeURIComponent("" + seafarerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCertificates(_response));
        });
    }

    protected processCertificates(response: Response): Promise<CertificatesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CertificatesResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CertificatesResponse>(null as any);
    }

    /**
     * @param searchTerm (optional) Text search from:
    seafarer name,  
    seafarer personal code,
    certificate name,
    document number
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param showValid (optional) 
     * @param showInvalid (optional) 
     */
    certificates2(searchTerm: string | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, showValid: boolean | undefined, showInvalid: boolean | undefined): Promise<PagedResultOfOfficialCertificateLightViewModel> {
        let url_ = this.baseUrl + "/certificates/certificates?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (showValid === null)
            throw new Error("The parameter 'showValid' cannot be null.");
        else if (showValid !== undefined)
            url_ += "ShowValid=" + encodeURIComponent("" + showValid) + "&";
        if (showInvalid === null)
            throw new Error("The parameter 'showInvalid' cannot be null.");
        else if (showInvalid !== undefined)
            url_ += "ShowInvalid=" + encodeURIComponent("" + showInvalid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCertificates2(_response));
        });
    }

    protected processCertificates2(response: Response): Promise<PagedResultOfOfficialCertificateLightViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfOfficialCertificateLightViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfOfficialCertificateLightViewModel>(null as any);
    }

    details(id: string): Promise<CertificateDetailsModel> {
        let url_ = this.baseUrl + "/certificates/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDetails(_response));
        });
    }

    protected processDetails(response: Response): Promise<CertificateDetailsModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CertificateDetailsModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CertificateDetailsModel>(null as any);
    }

    detailsByAccessToken(accessToken: string): Promise<MinimalDocumentModel> {
        let url_ = this.baseUrl + "/certificates/by-access-token/{accessToken}";
        if (accessToken === undefined || accessToken === null)
            throw new Error("The parameter 'accessToken' must be defined.");
        url_ = url_.replace("{accessToken}", encodeURIComponent("" + accessToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDetailsByAccessToken(_response));
        });
    }

    protected processDetailsByAccessToken(response: Response): Promise<MinimalDocumentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MinimalDocumentModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MinimalDocumentModel>(null as any);
    }

    additionalInfo(id: string): Promise<string> {
        let url_ = this.baseUrl + "/certificates/{id}/additional-info";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAdditionalInfo(_response));
        });
    }

    protected processAdditionalInfo(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    setAdditionalInfo(id: string, additionalInfo: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/certificates/{id}/set-additional-info?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (additionalInfo !== undefined && additionalInfo !== null)
            url_ += "additionalInfo=" + encodeURIComponent("" + additionalInfo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetAdditionalInfo(_response));
        });
    }

    protected processSetAdditionalInfo(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    invalidate(id: string, request: InvalidationRequest): Promise<void> {
        let url_ = this.baseUrl + "/certificates/{id}/invalidate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processInvalidate(_response));
        });
    }

    protected processInvalidate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    availableActions(id: string): Promise<CertificatesActions> {
        let url_ = this.baseUrl + "/certificates/{id}/available-actions";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAvailableActions(_response));
        });
    }

    protected processAvailableActions(response: Response): Promise<CertificatesActions> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CertificatesActions.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CertificatesActions>(null as any);
    }

    printTemplate(id: string): Promise<PrintTemplate> {
        let url_ = this.baseUrl + "/certificates/{id}/print-template";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPrintTemplate(_response));
        });
    }

    protected processPrintTemplate(response: Response): Promise<PrintTemplate> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrintTemplate.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrintTemplate>(null as any);
    }

    printTemplateByAccessToken(accessToken: string): Promise<PrintTemplate> {
        let url_ = this.baseUrl + "/certificates/print-template-by-access-token/{accessToken}";
        if (accessToken === undefined || accessToken === null)
            throw new Error("The parameter 'accessToken' must be defined.");
        url_ = url_.replace("{accessToken}", encodeURIComponent("" + accessToken));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPrintTemplateByAccessToken(_response));
        });
    }

    protected processPrintTemplateByAccessToken(response: Response): Promise<PrintTemplate> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrintTemplate.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrintTemplate>(null as any);
    }

    downloadFile(id: string, fileId: string): Promise<DownloadUrl> {
        let url_ = this.baseUrl + "/certificates/{id}/files/{fileId}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadFile(_response));
        });
    }

    protected processDownloadFile(response: Response): Promise<DownloadUrl> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DownloadUrl.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DownloadUrl>(null as any);
    }
}

export class StcwIsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    list(): Promise<StcwIsListModel[]> {
        let url_ = this.baseUrl + "/stcw-is";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<StcwIsListModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StcwIsListModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StcwIsListModel[]>(null as any);
    }
}

export class StcwRulesClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    list(): Promise<StcwRuleLightModel[]> {
        let url_ = this.baseUrl + "/stcw-rules";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<StcwRuleLightModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StcwRuleLightModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StcwRuleLightModel[]>(null as any);
    }
}

export class AreasClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    areaOptions(): Promise<AreaOptionsResponse> {
        let url_ = this.baseUrl + "/areas/area-options";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAreaOptions(_response));
        });
    }

    protected processAreaOptions(response: Response): Promise<AreaOptionsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AreaOptionsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AreaOptionsResponse>(null as any);
    }

    inlandVesselAreaOptions(): Promise<AreaOptionsResponse> {
        let url_ = this.baseUrl + "/areas/inland-vessel-area-options";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processInlandVesselAreaOptions(_response));
        });
    }

    protected processInlandVesselAreaOptions(response: Response): Promise<AreaOptionsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AreaOptionsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AreaOptionsResponse>(null as any);
    }

    shippingLineOptions(): Promise<AreaOptionsResponse> {
        let url_ = this.baseUrl + "/areas/shipping-line-options";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processShippingLineOptions(_response));
        });
    }

    protected processShippingLineOptions(response: Response): Promise<AreaOptionsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AreaOptionsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AreaOptionsResponse>(null as any);
    }

    pilotageAreaOptions(): Promise<AreaOptionsResponse> {
        let url_ = this.baseUrl + "/areas/pilotage-area-options";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPilotageAreaOptions(_response));
        });
    }

    protected processPilotageAreaOptions(response: Response): Promise<AreaOptionsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AreaOptionsResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AreaOptionsResponse>(null as any);
    }
}

export class AreaTypesClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    all(): Promise<AreaTypeModel[]> {
        let url_ = this.baseUrl + "/area-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAll(_response));
        });
    }

    protected processAll(response: Response): Promise<AreaTypeModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AreaTypeModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AreaTypeModel[]>(null as any);
    }
}

export class ApplicableCertificatesClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Get a collection of application types
     */
    get(): Promise<ApplicableCertificate[]> {
        let url_ = this.baseUrl + "/applications/applicable-certificates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<ApplicableCertificate[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApplicableCertificate.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicableCertificate[]>(null as any);
    }
}

export class StartApplyingOrChangeTypeClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    startApplyingForCertificate(request: StartApplyingForCertificateRequest, seafarerId: string): Promise<StartApplyingOrChangeTypeResponse> {
        let url_ = this.baseUrl + "/seafarers/{seafarerId}/start-applying-for-certificate";
        if (seafarerId === undefined || seafarerId === null)
            throw new Error("The parameter 'seafarerId' must be defined.");
        url_ = url_.replace("{seafarerId}", encodeURIComponent("" + seafarerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processStartApplyingForCertificate(_response));
        });
    }

    protected processStartApplyingForCertificate(response: Response): Promise<StartApplyingOrChangeTypeResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StartApplyingOrChangeTypeResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StartApplyingOrChangeTypeResponse>(null as any);
    }

    changeTypeToCertificate(request: ChangeTypeToCertificateRequest, seafarerId: string): Promise<StartApplyingOrChangeTypeResponse> {
        let url_ = this.baseUrl + "/seafarers/{seafarerId}/change-type-to-certificate";
        if (seafarerId === undefined || seafarerId === null)
            throw new Error("The parameter 'seafarerId' must be defined.");
        url_ = url_.replace("{seafarerId}", encodeURIComponent("" + seafarerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processChangeTypeToCertificate(_response));
        });
    }

    protected processChangeTypeToCertificate(response: Response): Promise<StartApplyingOrChangeTypeResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StartApplyingOrChangeTypeResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StartApplyingOrChangeTypeResponse>(null as any);
    }

    /**
     * Get a collection of application types
     */
    getEndorsementsToApplyFor(seafarerId: string): Promise<PossibleToApplyForEndorsement[]> {
        let url_ = this.baseUrl + "/seafarers/{seafarerId}/endorsements-to-apply-for";
        if (seafarerId === undefined || seafarerId === null)
            throw new Error("The parameter 'seafarerId' must be defined.");
        url_ = url_.replace("{seafarerId}", encodeURIComponent("" + seafarerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEndorsementsToApplyFor(_response));
        });
    }

    protected processGetEndorsementsToApplyFor(response: Response): Promise<PossibleToApplyForEndorsement[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PossibleToApplyForEndorsement.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PossibleToApplyForEndorsement[]>(null as any);
    }

    /**
     * Get concession permits available to apply for based on endorsements
     */
    getConcessionPermitsToApplyFor(seafarerId: string): Promise<PossibleToApplyForConcessionPermit[]> {
        let url_ = this.baseUrl + "/seafarers/{seafarerId}/concession-permits-to-apply-for";
        if (seafarerId === undefined || seafarerId === null)
            throw new Error("The parameter 'seafarerId' must be defined.");
        url_ = url_.replace("{seafarerId}", encodeURIComponent("" + seafarerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetConcessionPermitsToApplyFor(_response));
        });
    }

    protected processGetConcessionPermitsToApplyFor(response: Response): Promise<PossibleToApplyForConcessionPermit[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PossibleToApplyForConcessionPermit.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PossibleToApplyForConcessionPermit[]>(null as any);
    }

    startApplyingForEndorsement(request: StartApplyingForEndorsementRequest, seafarerId: string): Promise<StartApplyingOrChangeTypeResponse> {
        let url_ = this.baseUrl + "/seafarers/{seafarerId}/start-applying-for-endorsement";
        if (seafarerId === undefined || seafarerId === null)
            throw new Error("The parameter 'seafarerId' must be defined.");
        url_ = url_.replace("{seafarerId}", encodeURIComponent("" + seafarerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processStartApplyingForEndorsement(_response));
        });
    }

    protected processStartApplyingForEndorsement(response: Response): Promise<StartApplyingOrChangeTypeResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StartApplyingOrChangeTypeResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StartApplyingOrChangeTypeResponse>(null as any);
    }

    startApplyingForConcessionPermit(request: StartApplyingForConcessionPermitRequest, seafarerId: string): Promise<StartApplyingOrChangeTypeResponse> {
        let url_ = this.baseUrl + "/seafarers/{seafarerId}/start-applying-for-concession-permit";
        if (seafarerId === undefined || seafarerId === null)
            throw new Error("The parameter 'seafarerId' must be defined.");
        url_ = url_.replace("{seafarerId}", encodeURIComponent("" + seafarerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processStartApplyingForConcessionPermit(_response));
        });
    }

    protected processStartApplyingForConcessionPermit(response: Response): Promise<StartApplyingOrChangeTypeResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StartApplyingOrChangeTypeResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StartApplyingOrChangeTypeResponse>(null as any);
    }

    changeTypeToEndorsement(request: ChangeTypeToEndorsementRequest, seafarerId: string): Promise<StartApplyingOrChangeTypeResponse> {
        let url_ = this.baseUrl + "/seafarers/{seafarerId}/change-type-to-endorsement";
        if (seafarerId === undefined || seafarerId === null)
            throw new Error("The parameter 'seafarerId' must be defined.");
        url_ = url_.replace("{seafarerId}", encodeURIComponent("" + seafarerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processChangeTypeToEndorsement(_response));
        });
    }

    protected processChangeTypeToEndorsement(response: Response): Promise<StartApplyingOrChangeTypeResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StartApplyingOrChangeTypeResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StartApplyingOrChangeTypeResponse>(null as any);
    }

    duplicableDocuments(seafarerId: string): Promise<DuplicableDocumentModel[]> {
        let url_ = this.baseUrl + "/seafarers/{seafarerId}/duplicable-documents";
        if (seafarerId === undefined || seafarerId === null)
            throw new Error("The parameter 'seafarerId' must be defined.");
        url_ = url_.replace("{seafarerId}", encodeURIComponent("" + seafarerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDuplicableDocuments(_response));
        });
    }

    protected processDuplicableDocuments(response: Response): Promise<DuplicableDocumentModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DuplicableDocumentModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DuplicableDocumentModel[]>(null as any);
    }

    startApplyingForDuplicate(request: StartApplyingForDuplicateRequest, seafarerId: string): Promise<StartApplyingOrChangeTypeResponse> {
        let url_ = this.baseUrl + "/seafarers/{seafarerId}/start-applying-for-duplicate";
        if (seafarerId === undefined || seafarerId === null)
            throw new Error("The parameter 'seafarerId' must be defined.");
        url_ = url_.replace("{seafarerId}", encodeURIComponent("" + seafarerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processStartApplyingForDuplicate(_response));
        });
    }

    protected processStartApplyingForDuplicate(response: Response): Promise<StartApplyingOrChangeTypeResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StartApplyingOrChangeTypeResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StartApplyingOrChangeTypeResponse>(null as any);
    }

    changeTypeToDuplicate(request: ChangeTypeToDuplicateRequest, seafarerId: string): Promise<StartApplyingOrChangeTypeResponse> {
        let url_ = this.baseUrl + "/seafarers/{seafarerId}/change-type-to-duplicate";
        if (seafarerId === undefined || seafarerId === null)
            throw new Error("The parameter 'seafarerId' must be defined.");
        url_ = url_.replace("{seafarerId}", encodeURIComponent("" + seafarerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processChangeTypeToDuplicate(_response));
        });
    }

    protected processChangeTypeToDuplicate(response: Response): Promise<StartApplyingOrChangeTypeResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StartApplyingOrChangeTypeResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StartApplyingOrChangeTypeResponse>(null as any);
    }
}

export class ApplicationsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    find(applicationId: string): Promise<ApplicationViewModel> {
        let url_ = this.baseUrl + "/applications/{applicationId}";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processFind(_response));
        });
    }

    protected processFind(response: Response): Promise<ApplicationViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicationViewModel>(null as any);
    }

    delete(applicationId: string): Promise<void> {
        let url_ = this.baseUrl + "/applications/{applicationId}";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getAdditionalInfo(applicationId: string): Promise<string> {
        let url_ = this.baseUrl + "/applications/{applicationId}/additional-info";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAdditionalInfo(_response));
        });
    }

    protected processGetAdditionalInfo(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    submit(applicationId: string): Promise<void> {
        let url_ = this.baseUrl + "/applications/{applicationId}/submit";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSubmit(_response));
        });
    }

    protected processSubmit(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    startProcessing(applicationId: string): Promise<void> {
        let url_ = this.baseUrl + "/applications/{applicationId}/start-processing";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processStartProcessing(_response));
        });
    }

    protected processStartProcessing(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    takeOverProcessing(applicationId: string): Promise<void> {
        let url_ = this.baseUrl + "/applications/{applicationId}/take-over-processing";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTakeOverProcessing(_response));
        });
    }

    protected processTakeOverProcessing(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    reject(request: RejectApplicationRequest, applicationId: string): Promise<void> {
        let url_ = this.baseUrl + "/applications/{applicationId}/reject";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReject(_response));
        });
    }

    protected processReject(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    setDocumentDeliveryMethod(request: SetDocumentDeliveryMethodRequest, applicationId: string): Promise<void> {
        let url_ = this.baseUrl + "/applications/{applicationId}/set-document-delivery-method";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetDocumentDeliveryMethod(_response));
        });
    }

    protected processSetDocumentDeliveryMethod(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    confirmDocumentDeliveryAddress(applicationId: string): Promise<void> {
        let url_ = this.baseUrl + "/applications/{applicationId}/confirm-document-delivery-address";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processConfirmDocumentDeliveryAddress(_response));
        });
    }

    protected processConfirmDocumentDeliveryAddress(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    confirmDocumentDelivery(applicationId: string): Promise<void> {
        let url_ = this.baseUrl + "/applications/{applicationId}/confirm-document-delivery";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processConfirmDocumentDelivery(_response));
        });
    }

    protected processConfirmDocumentDelivery(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    changeDocument(request: ChangeDocumentRequest, applicationId: string): Promise<void> {
        let url_ = this.baseUrl + "/applications/{applicationId}/change-document";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processChangeDocument(_response));
        });
    }

    protected processChangeDocument(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    confirmDocumentPrint(applicationId: string): Promise<void> {
        let url_ = this.baseUrl + "/applications/{applicationId}/confirm-document-print";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processConfirmDocumentPrint(_response));
        });
    }

    protected processConfirmDocumentPrint(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    history(applicationId: string): Promise<ApplicationHistoryEventModel[]> {
        let url_ = this.baseUrl + "/applications/{applicationId}/history";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processHistory(_response));
        });
    }

    protected processHistory(response: Response): Promise<ApplicationHistoryEventModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApplicationHistoryEventModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicationHistoryEventModel[]>(null as any);
    }

    printTemplate(applicationId: string): Promise<PrintTemplate> {
        let url_ = this.baseUrl + "/applications/{applicationId}/print-template";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPrintTemplate(_response));
        });
    }

    protected processPrintTemplate(response: Response): Promise<PrintTemplate> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PrintTemplate.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrintTemplate>(null as any);
    }

    availableActions(applicationId: string): Promise<ApplicationActions> {
        let url_ = this.baseUrl + "/applications/{applicationId}/available-actions";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAvailableActions(_response));
        });
    }

    protected processAvailableActions(response: Response): Promise<ApplicationActions> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationActions.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicationActions>(null as any);
    }
}

export class RequirementsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    chooseQualification(id: string | undefined, applicationId: string, requirementId: string): Promise<void> {
        let url_ = this.baseUrl + "/applications/{applicationId}/requirements/{requirementId}/choose-qualification?";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        if (requirementId === undefined || requirementId === null)
            throw new Error("The parameter 'requirementId' must be defined.");
        url_ = url_.replace("{requirementId}", encodeURIComponent("" + requirementId));
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processChooseQualification(_response));
        });
    }

    protected processChooseQualification(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    chooseCertificate(id: string | undefined, applicationId: string, requirementId: string): Promise<void> {
        let url_ = this.baseUrl + "/applications/{applicationId}/requirements/{requirementId}/choose-certificate?";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        if (requirementId === undefined || requirementId === null)
            throw new Error("The parameter 'requirementId' must be defined.");
        url_ = url_.replace("{requirementId}", encodeURIComponent("" + requirementId));
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processChooseCertificate(_response));
        });
    }

    protected processChooseCertificate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    chooseMedicalCertificate(id: string | undefined, applicationId: string, requirementId: string): Promise<void> {
        let url_ = this.baseUrl + "/applications/{applicationId}/requirements/{requirementId}/choose-medical-certificate?";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        if (requirementId === undefined || requirementId === null)
            throw new Error("The parameter 'requirementId' must be defined.");
        url_ = url_.replace("{requirementId}", encodeURIComponent("" + requirementId));
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processChooseMedicalCertificate(_response));
        });
    }

    protected processChooseMedicalCertificate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    choosePositions(ids: string[], applicationId: string, requirementId: string): Promise<void> {
        let url_ = this.baseUrl + "/applications/{applicationId}/requirements/{requirementId}/choose-position";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        if (requirementId === undefined || requirementId === null)
            throw new Error("The parameter 'requirementId' must be defined.");
        url_ = url_.replace("{requirementId}", encodeURIComponent("" + requirementId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processChoosePositions(_response));
        });
    }

    protected processChoosePositions(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    choosePractice(id: string | undefined, applicationId: string, requirementId: string): Promise<void> {
        let url_ = this.baseUrl + "/applications/{applicationId}/requirements/{requirementId}/choose-practice?";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        if (requirementId === undefined || requirementId === null)
            throw new Error("The parameter 'requirementId' must be defined.");
        url_ = url_.replace("{requirementId}", encodeURIComponent("" + requirementId));
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processChoosePractice(_response));
        });
    }

    protected processChoosePractice(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    chooseFiles(files: TempFileModel[], applicationId: string, requirementId: string): Promise<void> {
        let url_ = this.baseUrl + "/applications/{applicationId}/requirements/{requirementId}/choose-files";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        if (requirementId === undefined || requirementId === null)
            throw new Error("The parameter 'requirementId' must be defined.");
        url_ = url_.replace("{requirementId}", encodeURIComponent("" + requirementId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(files);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processChooseFiles(_response));
        });
    }

    protected processChooseFiles(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    chooseDuplicationReason(reasonType: string | null | undefined, additionalInfo: string | null | undefined, applicationId: string, requirementId: string): Promise<void> {
        let url_ = this.baseUrl + "/applications/{applicationId}/requirements/{requirementId}/choose-duplication-reason?";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        if (requirementId === undefined || requirementId === null)
            throw new Error("The parameter 'requirementId' must be defined.");
        url_ = url_.replace("{requirementId}", encodeURIComponent("" + requirementId));
        if (reasonType !== undefined && reasonType !== null)
            url_ += "reasonType=" + encodeURIComponent("" + reasonType) + "&";
        if (additionalInfo !== undefined && additionalInfo !== null)
            url_ += "additionalInfo=" + encodeURIComponent("" + additionalInfo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processChooseDuplicationReason(_response));
        });
    }

    protected processChooseDuplicationReason(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    choosePaymentMethod(method: string | undefined, applicationId: string, requirementId: string): Promise<void> {
        let url_ = this.baseUrl + "/applications/{applicationId}/requirements/{requirementId}/choose-payment-method?";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        if (requirementId === undefined || requirementId === null)
            throw new Error("The parameter 'requirementId' must be defined.");
        url_ = url_.replace("{requirementId}", encodeURIComponent("" + requirementId));
        if (method === null)
            throw new Error("The parameter 'method' cannot be null.");
        else if (method !== undefined)
            url_ += "method=" + encodeURIComponent("" + method) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processChoosePaymentMethod(_response));
        });
    }

    protected processChoosePaymentMethod(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    swedbankBankLinkProviders(applicationId: string, requirementId: string): Promise<Provider[]> {
        let url_ = this.baseUrl + "/applications/{applicationId}/requirements/{requirementId}/swedbank-banklink-providers";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        if (requirementId === undefined || requirementId === null)
            throw new Error("The parameter 'requirementId' must be defined.");
        url_ = url_.replace("{requirementId}", encodeURIComponent("" + requirementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSwedbankBankLinkProviders(_response));
        });
    }

    protected processSwedbankBankLinkProviders(response: Response): Promise<Provider[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Provider.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Provider[]>(null as any);
    }

    createSwedbankBankLink(request: CreateSwedbankBankLinkRequest, applicationId: string, requirementId: string): Promise<Request> {
        let url_ = this.baseUrl + "/applications/{applicationId}/requirements/{requirementId}/create-swedbank-bank-link";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        if (requirementId === undefined || requirementId === null)
            throw new Error("The parameter 'requirementId' must be defined.");
        url_ = url_.replace("{requirementId}", encodeURIComponent("" + requirementId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateSwedbankBankLink(_response));
        });
    }

    protected processCreateSwedbankBankLink(response: Response): Promise<Request> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Request.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Request>(null as any);
    }

    swedbankCheckPaymentStatus(applicationId: string, requirementId: string): Promise<void> {
        let url_ = this.baseUrl + "/applications/{applicationId}/requirements/{requirementId}/swedbank-check-payment-status";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        if (requirementId === undefined || requirementId === null)
            throw new Error("The parameter 'requirementId' must be defined.");
        url_ = url_.replace("{requirementId}", encodeURIComponent("" + requirementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSwedbankCheckPaymentStatus(_response));
        });
    }

    protected processSwedbankCheckPaymentStatus(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    confirmPayment(paymentConfirmation: PaymentConfirmationRequest, applicationId: string, requirementId: string): Promise<void> {
        let url_ = this.baseUrl + "/applications/{applicationId}/requirements/{requirementId}/confirm-payment";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        if (requirementId === undefined || requirementId === null)
            throw new Error("The parameter 'requirementId' must be defined.");
        url_ = url_.replace("{requirementId}", encodeURIComponent("" + requirementId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(paymentConfirmation);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processConfirmPayment(_response));
        });
    }

    protected processConfirmPayment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    refundPayment(request: PaymentRefundRequest, applicationId: string, requirementId: string): Promise<void> {
        let url_ = this.baseUrl + "/applications/{applicationId}/requirements/{requirementId}/refund-payment";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        if (requirementId === undefined || requirementId === null)
            throw new Error("The parameter 'requirementId' must be defined.");
        url_ = url_.replace("{requirementId}", encodeURIComponent("" + requirementId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRefundPayment(_response));
        });
    }

    protected processRefundPayment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    removeChosenValue(applicationId: string, requirementId: string): Promise<void> {
        let url_ = this.baseUrl + "/applications/{applicationId}/requirements/{requirementId}/remove-chosen-value";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        if (requirementId === undefined || requirementId === null)
            throw new Error("The parameter 'requirementId' must be defined.");
        url_ = url_.replace("{requirementId}", encodeURIComponent("" + requirementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRemoveChosenValue(_response));
        });
    }

    protected processRemoveChosenValue(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    removePaymentConfirmation(applicationId: string, requirementId: string): Promise<void> {
        let url_ = this.baseUrl + "/applications/{applicationId}/requirements/{requirementId}/remove-payment-confirmation";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        if (requirementId === undefined || requirementId === null)
            throw new Error("The parameter 'requirementId' must be defined.");
        url_ = url_.replace("{requirementId}", encodeURIComponent("" + requirementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRemovePaymentConfirmation(_response));
        });
    }

    protected processRemovePaymentConfirmation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    removeChosenPractice(practiceId: string | undefined, applicationId: string, requirementId: string): Promise<void> {
        let url_ = this.baseUrl + "/applications/{applicationId}/requirements/{requirementId}/remove-chosen-practice?";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        if (requirementId === undefined || requirementId === null)
            throw new Error("The parameter 'requirementId' must be defined.");
        url_ = url_.replace("{requirementId}", encodeURIComponent("" + requirementId));
        if (practiceId === null)
            throw new Error("The parameter 'practiceId' cannot be null.");
        else if (practiceId !== undefined)
            url_ += "practiceId=" + encodeURIComponent("" + practiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRemoveChosenPractice(_response));
        });
    }

    protected processRemoveChosenPractice(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    removeChosenCertificate(certificateId: string | undefined, applicationId: string, requirementId: string): Promise<void> {
        let url_ = this.baseUrl + "/applications/{applicationId}/requirements/{requirementId}/remove-chosen-certificate?";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        if (requirementId === undefined || requirementId === null)
            throw new Error("The parameter 'requirementId' must be defined.");
        url_ = url_.replace("{requirementId}", encodeURIComponent("" + requirementId));
        if (certificateId === null)
            throw new Error("The parameter 'certificateId' cannot be null.");
        else if (certificateId !== undefined)
            url_ += "certificateId=" + encodeURIComponent("" + certificateId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRemoveChosenCertificate(_response));
        });
    }

    protected processRemoveChosenCertificate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    removeChosenQualification(qualificationId: string | undefined, applicationId: string, requirementId: string): Promise<void> {
        let url_ = this.baseUrl + "/applications/{applicationId}/requirements/{requirementId}/remove-chosen-qualification?";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        if (requirementId === undefined || requirementId === null)
            throw new Error("The parameter 'requirementId' must be defined.");
        url_ = url_.replace("{requirementId}", encodeURIComponent("" + requirementId));
        if (qualificationId === null)
            throw new Error("The parameter 'qualificationId' cannot be null.");
        else if (qualificationId !== undefined)
            url_ += "qualificationId=" + encodeURIComponent("" + qualificationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRemoveChosenQualification(_response));
        });
    }

    protected processRemoveChosenQualification(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    removeChosenFile(fileId: string | undefined, applicationId: string, requirementId: string): Promise<void> {
        let url_ = this.baseUrl + "/applications/{applicationId}/requirements/{requirementId}/remove-chosen-file?";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        if (requirementId === undefined || requirementId === null)
            throw new Error("The parameter 'requirementId' must be defined.");
        url_ = url_.replace("{requirementId}", encodeURIComponent("" + requirementId));
        if (fileId === null)
            throw new Error("The parameter 'fileId' cannot be null.");
        else if (fileId !== undefined)
            url_ += "fileId=" + encodeURIComponent("" + fileId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRemoveChosenFile(_response));
        });
    }

    protected processRemoveChosenFile(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return or

    or

    or

    or
     */
    choosable(applicationId: string, requirementId: string): Promise<any> {
        let url_ = this.baseUrl + "/applications/{applicationId}/requirements/{requirementId}/choosable";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        if (requirementId === undefined || requirementId === null)
            throw new Error("The parameter 'requirementId' must be defined.");
        url_ = url_.replace("{requirementId}", encodeURIComponent("" + requirementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processChoosable(_response));
        });
    }

    protected processChoosable(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    chosenQualifications(applicationId: string, requirementId: string): Promise<QualificationViewModel[]> {
        let url_ = this.baseUrl + "/applications/{applicationId}/requirements/{requirementId}/chosen-qualifications";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        if (requirementId === undefined || requirementId === null)
            throw new Error("The parameter 'requirementId' must be defined.");
        url_ = url_.replace("{requirementId}", encodeURIComponent("" + requirementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processChosenQualifications(_response));
        });
    }

    protected processChosenQualifications(response: Response): Promise<QualificationViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QualificationViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QualificationViewModel[]>(null as any);
    }

    chosenCertificate(applicationId: string, requirementId: string): Promise<Certificate[]> {
        let url_ = this.baseUrl + "/applications/{applicationId}/requirements/{requirementId}/chosen-certificate";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        if (requirementId === undefined || requirementId === null)
            throw new Error("The parameter 'requirementId' must be defined.");
        url_ = url_.replace("{requirementId}", encodeURIComponent("" + requirementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processChosenCertificate(_response));
        });
    }

    protected processChosenCertificate(response: Response): Promise<Certificate[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Certificate.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Certificate[]>(null as any);
    }

    chosenMedicalCertificate(applicationId: string, requirementId: string): Promise<MedicalCertificateListItem> {
        let url_ = this.baseUrl + "/applications/{applicationId}/requirements/{requirementId}/chosen-medical-certificate";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        if (requirementId === undefined || requirementId === null)
            throw new Error("The parameter 'requirementId' must be defined.");
        url_ = url_.replace("{requirementId}", encodeURIComponent("" + requirementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processChosenMedicalCertificate(_response));
        });
    }

    protected processChosenMedicalCertificate(response: Response): Promise<MedicalCertificateListItem> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MedicalCertificateListItem.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MedicalCertificateListItem>(null as any);
    }

    chosenPositions(applicationId: string, requirementId: string): Promise<PositionApiModel[]> {
        let url_ = this.baseUrl + "/applications/{applicationId}/requirements/{requirementId}/chosen-positions";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        if (requirementId === undefined || requirementId === null)
            throw new Error("The parameter 'requirementId' must be defined.");
        url_ = url_.replace("{requirementId}", encodeURIComponent("" + requirementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processChosenPositions(_response));
        });
    }

    protected processChosenPositions(response: Response): Promise<PositionApiModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PositionApiModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PositionApiModel[]>(null as any);
    }

    chosenPractices(applicationId: string, requirementId: string): Promise<ChosenPractices> {
        let url_ = this.baseUrl + "/applications/{applicationId}/requirements/{requirementId}/chosen-practices";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        if (requirementId === undefined || requirementId === null)
            throw new Error("The parameter 'requirementId' must be defined.");
        url_ = url_.replace("{requirementId}", encodeURIComponent("" + requirementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processChosenPractices(_response));
        });
    }

    protected processChosenPractices(response: Response): Promise<ChosenPractices> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChosenPractices.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChosenPractices>(null as any);
    }

    chosenFiles(applicationId: string, requirementId: string): Promise<FileModel[]> {
        let url_ = this.baseUrl + "/applications/{applicationId}/requirements/{requirementId}/chosen-files";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        if (requirementId === undefined || requirementId === null)
            throw new Error("The parameter 'requirementId' must be defined.");
        url_ = url_.replace("{requirementId}", encodeURIComponent("" + requirementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processChosenFiles(_response));
        });
    }

    protected processChosenFiles(response: Response): Promise<FileModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FileModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileModel[]>(null as any);
    }

    chosenDuplicationReason(applicationId: string, requirementId: string): Promise<DuplicationReasonModel> {
        let url_ = this.baseUrl + "/applications/{applicationId}/requirements/{requirementId}/chosen-duplication-reason";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        if (requirementId === undefined || requirementId === null)
            throw new Error("The parameter 'requirementId' must be defined.");
        url_ = url_.replace("{requirementId}", encodeURIComponent("" + requirementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processChosenDuplicationReason(_response));
        });
    }

    protected processChosenDuplicationReason(response: Response): Promise<DuplicationReasonModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DuplicationReasonModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DuplicationReasonModel>(null as any);
    }

    paymentDetails(applicationId: string, requirementId: string): Promise<ChosenPayment> {
        let url_ = this.baseUrl + "/applications/{applicationId}/requirements/{requirementId}/payment-details";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        if (requirementId === undefined || requirementId === null)
            throw new Error("The parameter 'requirementId' must be defined.");
        url_ = url_.replace("{requirementId}", encodeURIComponent("" + requirementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPaymentDetails(_response));
        });
    }

    protected processPaymentDetails(response: Response): Promise<ChosenPayment> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChosenPayment.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChosenPayment>(null as any);
    }

    decide(request: MakeRequirementProcessingDecisionRequest, applicationId: string, requirementId: string): Promise<void> {
        let url_ = this.baseUrl + "/applications/{applicationId}/requirements/{requirementId}/decide";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        if (requirementId === undefined || requirementId === null)
            throw new Error("The parameter 'requirementId' must be defined.");
        url_ = url_.replace("{requirementId}", encodeURIComponent("" + requirementId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDecide(_response));
        });
    }

    protected processDecide(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    downloadFile(fileId: string, applicationId: string, requirementId: string): Promise<DownloadUrl> {
        let url_ = this.baseUrl + "/applications/{applicationId}/requirements/{requirementId}/files/{fileId}";
        if (fileId === undefined || fileId === null)
            throw new Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        if (requirementId === undefined || requirementId === null)
            throw new Error("The parameter 'requirementId' must be defined.");
        url_ = url_.replace("{requirementId}", encodeURIComponent("" + requirementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadFile(_response));
        });
    }

    protected processDownloadFile(response: Response): Promise<DownloadUrl> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DownloadUrl.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DownloadUrl>(null as any);
    }

    setRequirementImage(request: FileModel, applicationId: string, requirementId: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/applications/{applicationId}/requirements/{requirementId}/personal-info-image";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        if (requirementId === undefined || requirementId === null)
            throw new Error("The parameter 'requirementId' must be defined.");
        url_ = url_.replace("{requirementId}", encodeURIComponent("" + requirementId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetRequirementImage(_response));
        });
    }

    protected processSetRequirementImage(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    paymentMethods(applicationId: string, requirementId: string): Promise<PaymentMethodWithDescription[]> {
        let url_ = this.baseUrl + "/applications/{applicationId}/requirements/{requirementId}/payment-methods";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        if (requirementId === undefined || requirementId === null)
            throw new Error("The parameter 'requirementId' must be defined.");
        url_ = url_.replace("{requirementId}", encodeURIComponent("" + requirementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPaymentMethods(_response));
        });
    }

    protected processPaymentMethods(response: Response): Promise<PaymentMethodWithDescription[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PaymentMethodWithDescription.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentMethodWithDescription[]>(null as any);
    }

    duplicationReasonTypes(applicationId: string, requirementId: string): Promise<DuplicationReasonTypeModel[]> {
        let url_ = this.baseUrl + "/applications/{applicationId}/requirements/{requirementId}/duplication-reasons";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        if (requirementId === undefined || requirementId === null)
            throw new Error("The parameter 'requirementId' must be defined.");
        url_ = url_.replace("{requirementId}", encodeURIComponent("" + requirementId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDuplicationReasonTypes(_response));
        });
    }

    protected processDuplicationReasonTypes(response: Response): Promise<DuplicationReasonTypeModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DuplicationReasonTypeModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DuplicationReasonTypeModel[]>(null as any);
    }

    submitRequirementValueChangeComment(comment: string | null | undefined, applicationId: string, requirementId: string): Promise<void> {
        let url_ = this.baseUrl + "/applications/{applicationId}/requirements/{requirementId}/submit-requirement-value-change-comment?";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        if (requirementId === undefined || requirementId === null)
            throw new Error("The parameter 'requirementId' must be defined.");
        url_ = url_.replace("{requirementId}", encodeURIComponent("" + requirementId));
        if (comment !== undefined && comment !== null)
            url_ += "comment=" + encodeURIComponent("" + comment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSubmitRequirementValueChangeComment(_response));
        });
    }

    protected processSubmitRequirementValueChangeComment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class IssueDocumentClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    details(applicationId: string): Promise<IssueDocumentDetailsApiModel> {
        let url_ = this.baseUrl + "/applications/{applicationId}/issue-document";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDetails(_response));
        });
    }

    protected processDetails(response: Response): Promise<IssueDocumentDetailsApiModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IssueDocumentDetailsApiModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IssueDocumentDetailsApiModel>(null as any);
    }

    issueDocument(request: IssueDocumentRequest, applicationId: string): Promise<void> {
        let url_ = this.baseUrl + "/applications/{applicationId}/issue-document";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIssueDocument(_response));
        });
    }

    protected processIssueDocument(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    edit(request: EditDocumentSeedRequest, applicationId: string): Promise<void> {
        let url_ = this.baseUrl + "/applications/{applicationId}/issue-document/edit";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEdit(_response));
        });
    }

    protected processEdit(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    editAdditionalInfo(request: EditAdditionalInfoRequest, applicationId: string): Promise<void> {
        let url_ = this.baseUrl + "/applications/{applicationId}/issue-document/edit-additionalinfo";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEditAdditionalInfo(_response));
        });
    }

    protected processEditAdditionalInfo(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    sign(applicationId: string): Promise<void> {
        let url_ = this.baseUrl + "/applications/{applicationId}/issue-document/sign";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSign(_response));
        });
    }

    protected processSign(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    removeSignature(applicationId: string): Promise<void> {
        let url_ = this.baseUrl + "/applications/{applicationId}/issue-document/remove-signature";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRemoveSignature(_response));
        });
    }

    protected processRemoveSignature(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    forwardToSigning(applicationId: string): Promise<void> {
        let url_ = this.baseUrl + "/applications/{applicationId}/issue-document/forward-to-signing";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processForwardToSigning(_response));
        });
    }

    protected processForwardToSigning(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    undoForwardToSigning(applicationId: string): Promise<void> {
        let url_ = this.baseUrl + "/applications/{applicationId}/issue-document/undo-forward-to-signing";
        if (applicationId === undefined || applicationId === null)
            throw new Error("The parameter 'applicationId' must be defined.");
        url_ = url_.replace("{applicationId}", encodeURIComponent("" + applicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUndoForwardToSigning(_response));
        });
    }

    protected processUndoForwardToSigning(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ApplicationsListClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Get a list of seafarer applications
     * @param applicationIds (optional) 
     */
    seafarer(applicationIds: string[] | null | undefined): Promise<SeafarerApplicationLightViewModel[]> {
        let url_ = this.baseUrl + "/applications/seafarer?";
        if (applicationIds !== undefined && applicationIds !== null)
            applicationIds && applicationIds.forEach(item => { url_ += "applicationIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSeafarer(_response));
        });
    }

    protected processSeafarer(response: Response): Promise<SeafarerApplicationLightViewModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SeafarerApplicationLightViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SeafarerApplicationLightViewModel[]>(null as any);
    }

    /**
     * Get all applications for official that match given filter parameters.
     * @param searchTerm (optional) Text search from:
    seafarer name,  
    seafarer personal code,
    certificate name,
    document number
     * @param documentTypeCode (optional) 
     * @param states (optional) 
     * @param signingState (optional) 
     * @param processingOfficialId (optional) 
     * @param applicationType (optional) 
     * @param pageNumber (optional) 
     * @param pageSize (optional) 
     * @param isDeleted (optional) 
     * @param sort (optional) 
     */
    official(searchTerm: string | null | undefined, documentTypeCode: string | null | undefined, states: ApplicationState[] | undefined, signingState: ApplicationSigningState | null | undefined, processingOfficialId: string | null | undefined, applicationType: ApplicationType | null | undefined, pageNumber: number | undefined, pageSize: number | undefined, isDeleted: boolean | undefined, sort: ApplicationSortField | null | undefined): Promise<PagedResultOfOfficialApplicationLightViewModel> {
        let url_ = this.baseUrl + "/applications/official?";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (documentTypeCode !== undefined && documentTypeCode !== null)
            url_ += "DocumentTypeCode=" + encodeURIComponent("" + documentTypeCode) + "&";
        if (states === null)
            throw new Error("The parameter 'states' cannot be null.");
        else if (states !== undefined)
            states && states.forEach(item => { url_ += "States=" + encodeURIComponent("" + item) + "&"; });
        if (signingState !== undefined && signingState !== null)
            url_ += "SigningState=" + encodeURIComponent("" + signingState) + "&";
        if (processingOfficialId !== undefined && processingOfficialId !== null)
            url_ += "ProcessingOfficialId=" + encodeURIComponent("" + processingOfficialId) + "&";
        if (applicationType !== undefined && applicationType !== null)
            url_ += "ApplicationType=" + encodeURIComponent("" + applicationType) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (isDeleted === null)
            throw new Error("The parameter 'isDeleted' cannot be null.");
        else if (isDeleted !== undefined)
            url_ += "IsDeleted=" + encodeURIComponent("" + isDeleted) + "&";
        if (sort !== undefined && sort !== null)
            url_ += "Sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processOfficial(_response));
        });
    }

    protected processOfficial(response: Response): Promise<PagedResultOfOfficialApplicationLightViewModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfOfficialApplicationLightViewModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagedResultOfOfficialApplicationLightViewModel>(null as any);
    }

    availableActions(): Promise<ApplicationsListActions> {
        let url_ = this.baseUrl + "/applications/available-actions";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAvailableActions(_response));
        });
    }

    protected processAvailableActions(response: Response): Promise<ApplicationsListActions> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationsListActions.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicationsListActions>(null as any);
    }
}

export class HarbormasterEligibilityClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Sadamakaptenina töötamiseks sobivuse kontroll
     * @param personalCode (optional) Meremehe isikukood
     * @param grossTonnage (optional) Sadamas teenindatava laeva kogumahutavus
     * @return or
     */
    checkEligibility(personalCode: string | null | undefined, grossTonnage: number | null | undefined): Promise<HarbormasterEligibilityResult> {
        let url_ = this.baseUrl + "/harbormastereligibility?";
        if (personalCode !== undefined && personalCode !== null)
            url_ += "personal_code=" + encodeURIComponent("" + personalCode) + "&";
        if (grossTonnage !== undefined && grossTonnage !== null)
            url_ += "gross_tonnage=" + encodeURIComponent("" + grossTonnage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCheckEligibility(_response));
        });
    }

    protected processCheckEligibility(response: Response): Promise<HarbormasterEligibilityResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HarbormasterEligibilityResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = PersonNotFound.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HarbormasterEligibilityResult>(null as any);
    }
}

export class SeafaringEligibilityClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Isiku merel töötamiseks sobivuse kontroll
     * @param personalCode (optional) Meremehe isikukood
     */
    checkEligibility(personalCode: string | null | undefined): Promise<PersonIsQualifiedForSeafaring> {
        let url_ = this.baseUrl + "/seafaringeligibility?";
        if (personalCode !== undefined && personalCode !== null)
            url_ += "personal_code=" + encodeURIComponent("" + personalCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCheckEligibility(_response));
        });
    }

    protected processCheckEligibility(response: Response): Promise<PersonIsQualifiedForSeafaring> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PersonIsQualifiedForSeafaring.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = SeafaringEligibilityResult.fromJS(resultData404);
            return throwException("\nor\n", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PersonIsQualifiedForSeafaring>(null as any);
    }
}

export class SeafarerDocumentsQueryClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Kehtivate meremehega seotud dokumentide pärimine
     * @param first_name (optional) Meremehe eesnimi
     * @param last_name (optional) Meremehe perekonnanimi
     * @param nationality (optional) Meremehe kodakondsus
     * @param birth_date (optional) Meremehe sünnikuupäev
     * @param personal_code (optional) Meremehe isikukood
     */
    documents(first_name: string | null | undefined, last_name: string | null | undefined, nationality: string | null | undefined, birth_date: Date | null | undefined, personal_code: string | null | undefined): Promise<SeafarerDocumentsModel[]> {
        let url_ = this.baseUrl + "/seafarerdocuments?";
        if (first_name !== undefined && first_name !== null)
            url_ += "first_name=" + encodeURIComponent("" + first_name) + "&";
        if (last_name !== undefined && last_name !== null)
            url_ += "last_name=" + encodeURIComponent("" + last_name) + "&";
        if (nationality !== undefined && nationality !== null)
            url_ += "nationality=" + encodeURIComponent("" + nationality) + "&";
        if (birth_date !== undefined && birth_date !== null)
            url_ += "birth_date=" + encodeURIComponent(birth_date ? "" + birth_date.toISOString() : "") + "&";
        if (personal_code !== undefined && personal_code !== null)
            url_ += "personal_code=" + encodeURIComponent("" + personal_code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDocuments(_response));
        });
    }

    protected processDocuments(response: Response): Promise<SeafarerDocumentsModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SeafarerDocumentsModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SeafarerDocumentsModel[]>(null as any);
    }
}

export class DataTrackerClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Kasutusteabe küsimine
     * @param x_Road_UserId (optional) Päringu algataja isikukood koos riigi koodiga, nt "EE31234567890".
    X-tee REST sõnumiprotokolli kohane päis. Spec v1.6 ptk 6.1.3.
     * @param userCode (optional) Andmesubjekti isikukood, kelle kohta tuleks tagastada kasutusteavet.
    Võib erineda X-Road-UserId päise väärtusest, kui päring on käivitatud esindusõiguse abil.
     * @param offset (optional) Jätta vahele näidatud arvu kirjed ja tagastada järgmised.
     * @param limit (optional) Maksimaalne tagastatud kirjete arv, vaikimisi 1000.
     * @param periodStart (optional) Perioodi alguskuupäev.
     * @param periodEnd (optional) Perioodi lõppkuupäev.
     */
    findUsage(x_Road_UserId: string | undefined, userCode: string | undefined, offset: number | null | undefined, limit: number | null | undefined, periodStart: Date | null | undefined, periodEnd: Date | null | undefined): Promise<FindUsageResponse> {
        let url_ = this.baseUrl + "/v2/findUsage?";
        if (userCode === null)
            throw new Error("The parameter 'userCode' cannot be null.");
        else if (userCode !== undefined)
            url_ += "userCode=" + encodeURIComponent("" + userCode) + "&";
        if (offset !== undefined && offset !== null)
            url_ += "offset=" + encodeURIComponent("" + offset) + "&";
        if (limit !== undefined && limit !== null)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        if (periodStart !== undefined && periodStart !== null)
            url_ += "periodStart=" + encodeURIComponent(periodStart ? "" + periodStart.toISOString() : "") + "&";
        if (periodEnd !== undefined && periodEnd !== null)
            url_ += "periodEnd=" + encodeURIComponent(periodEnd ? "" + periodEnd.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "X-Road-UserId": x_Road_UserId !== undefined && x_Road_UserId !== null ? "" + x_Road_UserId : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processFindUsage(_response));
        });
    }

    protected processFindUsage(response: Response): Promise<FindUsageResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FindUsageResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FindUsageResponse>(null as any);
    }

    /**
     * Kasutusteabe perioodi küsimine
     */
    usagePeriod(): Promise<UsagePeriodResponse> {
        let url_ = this.baseUrl + "/v2/usagePeriod";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUsagePeriod(_response));
        });
    }

    protected processUsagePeriod(response: Response): Promise<UsagePeriodResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UsagePeriodResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UsagePeriodResponse>(null as any);
    }

    /**
     * Elutukse kontroll
     */
    heartbeat(): Promise<HeartbeatResponse> {
        let url_ = this.baseUrl + "/v2/heartbeat";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processHeartbeat(_response));
        });
    }

    protected processHeartbeat(response: Response): Promise<HeartbeatResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HeartbeatResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HeartbeatResponse>(null as any);
    }
}

export class HarbormasterEligibilityControllerVClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Sadamakaptenina töötamiseks sobivuse kontroll
     * @param personalCode (optional) Meremehe isikukood
     * @param grossTonnage (optional) Sadamas teenindatava laeva kogumahutavus
     * @return or

    or
     */
    checkEligibility(personalCode: string | null | undefined, grossTonnage: number | null | undefined): Promise<HarbormasterEligibilityResult> {
        let url_ = this.baseUrl + "/v2/harbormastereligibility?";
        if (personalCode !== undefined && personalCode !== null)
            url_ += "personal_code=" + encodeURIComponent("" + personalCode) + "&";
        if (grossTonnage !== undefined && grossTonnage !== null)
            url_ += "gross_tonnage=" + encodeURIComponent("" + grossTonnage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCheckEligibility(_response));
        });
    }

    protected processCheckEligibility(response: Response): Promise<HarbormasterEligibilityResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HarbormasterEligibilityResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HarbormasterEligibilityResult>(null as any);
    }
}

export class SeafaringEligibilityControllerVClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Isiku merel töötamiseks sobivuse kontroll
     * @param personalCode (optional) Meremehe isikukood
     * @return or

    or
     */
    checkEligibility(personalCode: string | null | undefined): Promise<SeafaringEligibilityResult> {
        let url_ = this.baseUrl + "/v2/seafaringeligibility?";
        if (personalCode !== undefined && personalCode !== null)
            url_ += "personal_code=" + encodeURIComponent("" + personalCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCheckEligibility(_response));
        });
    }

    protected processCheckEligibility(response: Response): Promise<SeafaringEligibilityResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SeafaringEligibilityResult.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ResultError.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SeafaringEligibilityResult>(null as any);
    }
}

export class UserInfoResponse implements IUserInfoResponse {
    userName!: string;
    firstName!: string;
    lastName!: string;
    role?: string | null;
    seafarerId?: string | null;
    organizationId?: string | null;
    organizationName?: string | null;
    isAccessLinkUser!: boolean;

    constructor(data?: IUserInfoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"] !== undefined ? _data["userName"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.role = _data["role"] !== undefined ? _data["role"] : <any>null;
            this.seafarerId = _data["seafarerId"] !== undefined ? _data["seafarerId"] : <any>null;
            this.organizationId = _data["organizationId"] !== undefined ? _data["organizationId"] : <any>null;
            this.organizationName = _data["organizationName"] !== undefined ? _data["organizationName"] : <any>null;
            this.isAccessLinkUser = _data["isAccessLinkUser"] !== undefined ? _data["isAccessLinkUser"] : <any>null;
        }
    }

    static fromJS(data: any): UserInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName !== undefined ? this.userName : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["role"] = this.role !== undefined ? this.role : <any>null;
        data["seafarerId"] = this.seafarerId !== undefined ? this.seafarerId : <any>null;
        data["organizationId"] = this.organizationId !== undefined ? this.organizationId : <any>null;
        data["organizationName"] = this.organizationName !== undefined ? this.organizationName : <any>null;
        data["isAccessLinkUser"] = this.isAccessLinkUser !== undefined ? this.isAccessLinkUser : <any>null;
        return data;
    }
}

export interface IUserInfoResponse {
    userName: string;
    firstName: string;
    lastName: string;
    role?: string | null;
    seafarerId?: string | null;
    organizationId?: string | null;
    organizationName?: string | null;
    isAccessLinkUser: boolean;
}

export class AnonymousUserInfoResponse extends UserInfoResponse implements IAnonymousUserInfoResponse {

    constructor(data?: IAnonymousUserInfoResponse) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): AnonymousUserInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AnonymousUserInfoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IAnonymousUserInfoResponse extends IUserInfoResponse {
}

export class AvailableProfileModel implements IAvailableProfileModel {
    id!: string;
    name!: string;
    isSeafarer!: boolean;
    isAccessLinkUser!: boolean;

    constructor(data?: IAvailableProfileModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.isSeafarer = _data["isSeafarer"] !== undefined ? _data["isSeafarer"] : <any>null;
            this.isAccessLinkUser = _data["isAccessLinkUser"] !== undefined ? _data["isAccessLinkUser"] : <any>null;
        }
    }

    static fromJS(data: any): AvailableProfileModel {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableProfileModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["isSeafarer"] = this.isSeafarer !== undefined ? this.isSeafarer : <any>null;
        data["isAccessLinkUser"] = this.isAccessLinkUser !== undefined ? this.isAccessLinkUser : <any>null;
        return data;
    }
}

export interface IAvailableProfileModel {
    id: string;
    name: string;
    isSeafarer: boolean;
    isAccessLinkUser: boolean;
}

export class UserActions implements IUserActions {
    canViewDashboard!: boolean;
    canSearchSeafarers!: boolean;
    canViewQualificationRecords!: boolean;
    canViewAllApplications!: boolean;
    canViewAdminPanel!: boolean;
    canViewOrganization!: boolean;
    canQuerySeafarerDocuments!: boolean;

    constructor(data?: IUserActions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canViewDashboard = _data["canViewDashboard"] !== undefined ? _data["canViewDashboard"] : <any>null;
            this.canSearchSeafarers = _data["canSearchSeafarers"] !== undefined ? _data["canSearchSeafarers"] : <any>null;
            this.canViewQualificationRecords = _data["canViewQualificationRecords"] !== undefined ? _data["canViewQualificationRecords"] : <any>null;
            this.canViewAllApplications = _data["canViewAllApplications"] !== undefined ? _data["canViewAllApplications"] : <any>null;
            this.canViewAdminPanel = _data["canViewAdminPanel"] !== undefined ? _data["canViewAdminPanel"] : <any>null;
            this.canViewOrganization = _data["canViewOrganization"] !== undefined ? _data["canViewOrganization"] : <any>null;
            this.canQuerySeafarerDocuments = _data["canQuerySeafarerDocuments"] !== undefined ? _data["canQuerySeafarerDocuments"] : <any>null;
        }
    }

    static fromJS(data: any): UserActions {
        data = typeof data === 'object' ? data : {};
        let result = new UserActions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canViewDashboard"] = this.canViewDashboard !== undefined ? this.canViewDashboard : <any>null;
        data["canSearchSeafarers"] = this.canSearchSeafarers !== undefined ? this.canSearchSeafarers : <any>null;
        data["canViewQualificationRecords"] = this.canViewQualificationRecords !== undefined ? this.canViewQualificationRecords : <any>null;
        data["canViewAllApplications"] = this.canViewAllApplications !== undefined ? this.canViewAllApplications : <any>null;
        data["canViewAdminPanel"] = this.canViewAdminPanel !== undefined ? this.canViewAdminPanel : <any>null;
        data["canViewOrganization"] = this.canViewOrganization !== undefined ? this.canViewOrganization : <any>null;
        data["canQuerySeafarerDocuments"] = this.canQuerySeafarerDocuments !== undefined ? this.canQuerySeafarerDocuments : <any>null;
        return data;
    }
}

export interface IUserActions {
    canViewDashboard: boolean;
    canSearchSeafarers: boolean;
    canViewQualificationRecords: boolean;
    canViewAllApplications: boolean;
    canViewAdminPanel: boolean;
    canViewOrganization: boolean;
    canQuerySeafarerDocuments: boolean;
}

export class ConfirmDataResponse implements IConfirmDataResponse {
    contactInfo!: ContactInfoViewModel;
    countries!: CountryLightModel[];
    seafarerId!: string;

    constructor(data?: IConfirmDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.contactInfo = new ContactInfoViewModel();
            this.countries = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactInfo = _data["contactInfo"] ? ContactInfoViewModel.fromJS(_data["contactInfo"]) : new ContactInfoViewModel();
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(CountryLightModel.fromJS(item));
            }
            else {
                this.countries = <any>null;
            }
            this.seafarerId = _data["seafarerId"] !== undefined ? _data["seafarerId"] : <any>null;
        }
    }

    static fromJS(data: any): ConfirmDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ConfirmDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactInfo"] = this.contactInfo ? this.contactInfo.toJSON() : <any>null;
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item.toJSON());
        }
        data["seafarerId"] = this.seafarerId !== undefined ? this.seafarerId : <any>null;
        return data;
    }
}

export interface IConfirmDataResponse {
    contactInfo: ContactInfoViewModel;
    countries: CountryLightModel[];
    seafarerId: string;
}

export class ContactInfoViewModel implements IContactInfoViewModel {
    phoneNumber!: string;
    email!: string;
    canReceiveEmailNotifications!: boolean;
    address!: AddressModel;

    constructor(data?: IContactInfoViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.address = new AddressModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.canReceiveEmailNotifications = _data["canReceiveEmailNotifications"] !== undefined ? _data["canReceiveEmailNotifications"] : <any>null;
            this.address = _data["address"] ? AddressModel.fromJS(_data["address"]) : new AddressModel();
        }
    }

    static fromJS(data: any): ContactInfoViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContactInfoViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["canReceiveEmailNotifications"] = this.canReceiveEmailNotifications !== undefined ? this.canReceiveEmailNotifications : <any>null;
        data["address"] = this.address ? this.address.toJSON() : <any>null;
        return data;
    }
}

export interface IContactInfoViewModel {
    phoneNumber: string;
    email: string;
    canReceiveEmailNotifications: boolean;
    address: AddressModel;
}

export class AddressModel implements IAddressModel {
    countryOfResidence!: string;
    province!: string;
    municipality!: string;
    district!: string;
    street!: string;
    houseNumber!: string;
    flatNumber!: string;
    postalCode!: string;
    adsOid!: string;
    adrId!: string;

    constructor(data?: IAddressModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.countryOfResidence = "";
            this.province = "";
            this.municipality = "";
            this.district = "";
            this.street = "";
            this.houseNumber = "";
            this.flatNumber = "";
            this.postalCode = "";
            this.adsOid = "";
            this.adrId = "";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryOfResidence = _data["countryOfResidence"] !== undefined ? _data["countryOfResidence"] : "";
            this.province = _data["province"] !== undefined ? _data["province"] : "";
            this.municipality = _data["municipality"] !== undefined ? _data["municipality"] : "";
            this.district = _data["district"] !== undefined ? _data["district"] : "";
            this.street = _data["street"] !== undefined ? _data["street"] : "";
            this.houseNumber = _data["houseNumber"] !== undefined ? _data["houseNumber"] : "";
            this.flatNumber = _data["flatNumber"] !== undefined ? _data["flatNumber"] : "";
            this.postalCode = _data["postalCode"] !== undefined ? _data["postalCode"] : "";
            this.adsOid = _data["adsOid"] !== undefined ? _data["adsOid"] : "";
            this.adrId = _data["adrId"] !== undefined ? _data["adrId"] : "";
        }
    }

    static fromJS(data: any): AddressModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddressModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryOfResidence"] = this.countryOfResidence !== undefined ? this.countryOfResidence : <any>null;
        data["province"] = this.province !== undefined ? this.province : <any>null;
        data["municipality"] = this.municipality !== undefined ? this.municipality : <any>null;
        data["district"] = this.district !== undefined ? this.district : <any>null;
        data["street"] = this.street !== undefined ? this.street : <any>null;
        data["houseNumber"] = this.houseNumber !== undefined ? this.houseNumber : <any>null;
        data["flatNumber"] = this.flatNumber !== undefined ? this.flatNumber : <any>null;
        data["postalCode"] = this.postalCode !== undefined ? this.postalCode : <any>null;
        data["adsOid"] = this.adsOid !== undefined ? this.adsOid : <any>null;
        data["adrId"] = this.adrId !== undefined ? this.adrId : <any>null;
        return data;
    }
}

export interface IAddressModel {
    countryOfResidence: string;
    province: string;
    municipality: string;
    district: string;
    street: string;
    houseNumber: string;
    flatNumber: string;
    postalCode: string;
    adsOid: string;
    adrId: string;
}

export class CountryLightModel implements ICountryLightModel {
    letterCode!: string;
    name!: string;

    constructor(data?: ICountryLightModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.letterCode = _data["letterCode"] !== undefined ? _data["letterCode"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): CountryLightModel {
        data = typeof data === 'object' ? data : {};
        let result = new CountryLightModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["letterCode"] = this.letterCode !== undefined ? this.letterCode : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface ICountryLightModel {
    letterCode: string;
    name: string;
}

export class SpecialityLightModel implements ISpecialityLightModel {
    id!: string;
    name!: string;
    isActive!: boolean;
    createdAt?: Date | null;

    constructor(data?: ISpecialityLightModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): SpecialityLightModel {
        data = typeof data === 'object' ? data : {};
        let result = new SpecialityLightModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        return data;
    }
}

export interface ISpecialityLightModel {
    id: string;
    name: string;
    isActive: boolean;
    createdAt?: Date | null;
}

export class PagedResultOfSpecialityLightModel implements IPagedResultOfSpecialityLightModel {
    pageNumber!: number;
    pageSize!: number;
    pageResult!: SpecialityLightModel[];
    totalCount!: number;

    constructor(data?: IPagedResultOfSpecialityLightModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageResult = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"] !== undefined ? _data["pageNumber"] : <any>null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : <any>null;
            if (Array.isArray(_data["pageResult"])) {
                this.pageResult = [] as any;
                for (let item of _data["pageResult"])
                    this.pageResult!.push(SpecialityLightModel.fromJS(item));
            }
            else {
                this.pageResult = <any>null;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): PagedResultOfSpecialityLightModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfSpecialityLightModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber !== undefined ? this.pageNumber : <any>null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
        if (Array.isArray(this.pageResult)) {
            data["pageResult"] = [];
            for (let item of this.pageResult)
                data["pageResult"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data;
    }
}

export interface IPagedResultOfSpecialityLightModel {
    pageNumber: number;
    pageSize: number;
    pageResult: SpecialityLightModel[];
    totalCount: number;
}

export enum SysAdminSpecialitiesSortField {
    CreatedAtAsc = "createdAtAsc",
    CreatedAtDesc = "createdAtDesc",
    NameAsc = "nameAsc",
    NameDesc = "nameDesc",
    ActiveAsc = "activeAsc",
    ActiveDesc = "activeDesc",
}

export class SpecialityDetailsModel implements ISpecialityDetailsModel {
    id!: string;
    nameEst!: string;
    nameEng!: string;
    type!: SpecialityType;
    specialityCode!: string[];
    educationCode!: string;
    isActive!: boolean;
    stcwRules!: StcwRuleLightModel[];
    additionalInformation!: string;

    constructor(data?: ISpecialityDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.specialityCode = [];
            this.stcwRules = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nameEst = _data["nameEst"] !== undefined ? _data["nameEst"] : <any>null;
            this.nameEng = _data["nameEng"] !== undefined ? _data["nameEng"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            if (Array.isArray(_data["specialityCode"])) {
                this.specialityCode = [] as any;
                for (let item of _data["specialityCode"])
                    this.specialityCode!.push(item);
            }
            else {
                this.specialityCode = <any>null;
            }
            this.educationCode = _data["educationCode"] !== undefined ? _data["educationCode"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            if (Array.isArray(_data["stcwRules"])) {
                this.stcwRules = [] as any;
                for (let item of _data["stcwRules"])
                    this.stcwRules!.push(StcwRuleLightModel.fromJS(item));
            }
            else {
                this.stcwRules = <any>null;
            }
            this.additionalInformation = _data["additionalInformation"] !== undefined ? _data["additionalInformation"] : <any>null;
        }
    }

    static fromJS(data: any): SpecialityDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new SpecialityDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nameEst"] = this.nameEst !== undefined ? this.nameEst : <any>null;
        data["nameEng"] = this.nameEng !== undefined ? this.nameEng : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        if (Array.isArray(this.specialityCode)) {
            data["specialityCode"] = [];
            for (let item of this.specialityCode)
                data["specialityCode"].push(item);
        }
        data["educationCode"] = this.educationCode !== undefined ? this.educationCode : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        if (Array.isArray(this.stcwRules)) {
            data["stcwRules"] = [];
            for (let item of this.stcwRules)
                data["stcwRules"].push(item.toJSON());
        }
        data["additionalInformation"] = this.additionalInformation !== undefined ? this.additionalInformation : <any>null;
        return data;
    }
}

export interface ISpecialityDetailsModel {
    id: string;
    nameEst: string;
    nameEng: string;
    type: SpecialityType;
    specialityCode: string[];
    educationCode: string;
    isActive: boolean;
    stcwRules: StcwRuleLightModel[];
    additionalInformation: string;
}

export enum SpecialityType {
    Educational = "educational",
    Training = "training",
}

export class StcwRuleLightModel implements IStcwRuleLightModel {
    id!: string;
    code!: string;
    name!: string;

    constructor(data?: IStcwRuleLightModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): StcwRuleLightModel {
        data = typeof data === 'object' ? data : {};
        let result = new StcwRuleLightModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface IStcwRuleLightModel {
    id: string;
    code: string;
    name: string;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    extensions!: { [key: string]: any; };

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.extensions = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.detail = _data["detail"] !== undefined ? _data["detail"] : <any>null;
            this.instance = _data["instance"] !== undefined ? _data["instance"] : <any>null;
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        (<any>this.extensions)![key] = _data["extensions"][key] !== undefined ? _data["extensions"][key] : <any>null;
                }
            }
            else {
                this.extensions = <any>null;
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["detail"] = this.detail !== undefined ? this.detail : <any>null;
        data["instance"] = this.instance !== undefined ? this.instance : <any>null;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    (<any>data["extensions"])[key] = this.extensions[key] !== undefined ? this.extensions[key] : <any>null;
            }
        }
        return data;
    }
}

export interface IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    extensions: { [key: string]: any; };

    [key: string]: any;
}

export class ResultError implements IResultError {
    messages!: { [key: string]: string[]; };

    // Keys that have their messages bound to an input field. These messages are shown below the input fields.
    // The binding is defined as retrieving a message via a specific method defined in this.
    readonly handledKeys = new Set();

    get isEmpty(){
        return !this.hasMessages();
    }

    hasMessages(key: string | null = null): boolean {
        return key ? _.keys(this.messages).includes(key) : _.keys(this.messages).length > 0;
    }

    getAndSetAsHandled(key: string): string[] {
        if (this.hasMessages(key)) {
            this.handledKeys.add(key)
            return this.messages[key];
        } else {
            return [];
        }
    }

    findAndSetAsHandled(approximateKey: string): string[] {
        const matchedKeys: string[] = _.keys(this.messages).filter(key => key.includes(approximateKey));
        const messages = new Set<string>(); // no need to show duplicate messages

        for (const matchedKey of matchedKeys) {
            messages.add(this.messages[matchedKey].join('. '));
            this.handledKeys.add(matchedKey);
        }

        return Array.from(messages);
    }

    get messagesFlattened() {
        return _.flatten(_.values(this.messages));
    }

    getNotHandledMessages(): string[] {
        const notHandledKeys: string[] = [];
        for (const key of _.keys(this.messages)) {
            if (!this.handledKeys.has(key)) {
                notHandledKeys.push(key);
            }
        }

        const notHandledMessages: string[] = [];
        for (const key of notHandledKeys) {
            notHandledMessages.push(this.messages[key].join('. '));
        }

        return notHandledMessages;
    }

    // Need to wait with this.$nextTick() until DOM is updated and any error messages are displayed below input fields
    // NOTE: This is not meant to be used directly. Use Vue component's setValidationErrors instead.
    showToastsIfNecessary(nextTick: (callback: Function) => void, toastTextIfHasAnyHandledMessages: string | null) {
        nextTick(() => {
            if (toastTextIfHasAnyHandledMessages && this.handledKeys.size > 0) {
                toasts.failure(toastTextIfHasAnyHandledMessages);
            }

            for (const message of this.getNotHandledMessages()) {
                toasts.failure(message, 0);
            }
        });
    }

    appendMessage(message: string, key = ""){
        if(key === "") {
            this.messages = { ...this.messages, [key]: [message] };
            return ResultError.fromJS(this);
        }
        if (this.messages[key]) {
            this.messages[key].push(message); // Vue's reactivity works with Array.push.
        } else {
            this.messages = { ...this.messages, [key]: [message] }; // Vue's reactivity does not work when adding new key to an object, so we trigger reactivity by replacing whole object.
        }
        return ResultError.fromJS(this);
    }

    clearKey(key:string) {
        if(!this.messages) return;
        delete this.messages[key];
        this.handledKeys.delete(key);
    }

    clear(){
        this.messages = {};
        this.handledKeys.clear();
    }

    static createEmpty(){
        return factory.create(ResultError);
    }

    constructor(data?: IResultError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.messages = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["messages"]) {
                this.messages = {} as any;
                for (let key in _data["messages"]) {
                    if (_data["messages"].hasOwnProperty(key))
                        (<any>this.messages)![key] = _data["messages"][key] !== undefined ? _data["messages"][key] : [];
                }
            }
            else {
                this.messages = <any>null;
            }
        }
    }

    static fromJS(data: any): ResultError {
        data = typeof data === 'object' ? data : {};
        let result = new ResultError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.messages) {
            data["messages"] = {};
            for (let key in this.messages) {
                if (this.messages.hasOwnProperty(key))
                    (<any>data["messages"])[key] = this.messages[key] !== undefined ? this.messages[key] : <any>null;
            }
        }
        return data;
    }
}

export interface IResultError {
    messages: { [key: string]: string[]; };
}

export class UpsertSpecialityRequest implements IUpsertSpecialityRequest {
    id?: string | null;
    nameEst?: string | null;
    nameEng?: string | null;
    type?: SpecialityType | null;
    specialityCode?: string[] | null;
    educationCode?: string | null;
    isActive!: boolean;
    stcwRules!: string[];
    additionalInformation?: string | null;

    constructor(data?: IUpsertSpecialityRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.stcwRules = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nameEst = _data["nameEst"] !== undefined ? _data["nameEst"] : <any>null;
            this.nameEng = _data["nameEng"] !== undefined ? _data["nameEng"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            if (Array.isArray(_data["specialityCode"])) {
                this.specialityCode = [] as any;
                for (let item of _data["specialityCode"])
                    this.specialityCode!.push(item);
            }
            else {
                this.specialityCode = <any>null;
            }
            this.educationCode = _data["educationCode"] !== undefined ? _data["educationCode"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            if (Array.isArray(_data["stcwRules"])) {
                this.stcwRules = [] as any;
                for (let item of _data["stcwRules"])
                    this.stcwRules!.push(item);
            }
            else {
                this.stcwRules = <any>null;
            }
            this.additionalInformation = _data["additionalInformation"] !== undefined ? _data["additionalInformation"] : <any>null;
        }
    }

    static fromJS(data: any): UpsertSpecialityRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertSpecialityRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nameEst"] = this.nameEst !== undefined ? this.nameEst : <any>null;
        data["nameEng"] = this.nameEng !== undefined ? this.nameEng : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        if (Array.isArray(this.specialityCode)) {
            data["specialityCode"] = [];
            for (let item of this.specialityCode)
                data["specialityCode"].push(item);
        }
        data["educationCode"] = this.educationCode !== undefined ? this.educationCode : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        if (Array.isArray(this.stcwRules)) {
            data["stcwRules"] = [];
            for (let item of this.stcwRules)
                data["stcwRules"].push(item);
        }
        data["additionalInformation"] = this.additionalInformation !== undefined ? this.additionalInformation : <any>null;
        return data;
    }
}

export interface IUpsertSpecialityRequest {
    id?: string | null;
    nameEst?: string | null;
    nameEng?: string | null;
    type?: SpecialityType | null;
    specialityCode?: string[] | null;
    educationCode?: string | null;
    isActive: boolean;
    stcwRules: string[];
    additionalInformation?: string | null;
}

export class EducationModel implements IEducationModel {
    code!: string;
    description!: string;

    constructor(data?: IEducationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
        }
    }

    static fromJS(data: any): EducationModel {
        data = typeof data === 'object' ? data : {};
        let result = new EducationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        return data;
    }
}

export interface IEducationModel {
    code: string;
    description: string;
}

export class PagedResultOfShipLightModel implements IPagedResultOfShipLightModel {
    pageNumber!: number;
    pageSize!: number;
    pageResult!: ShipLightModel[];
    totalCount!: number;

    constructor(data?: IPagedResultOfShipLightModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageResult = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"] !== undefined ? _data["pageNumber"] : <any>null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : <any>null;
            if (Array.isArray(_data["pageResult"])) {
                this.pageResult = [] as any;
                for (let item of _data["pageResult"])
                    this.pageResult!.push(ShipLightModel.fromJS(item));
            }
            else {
                this.pageResult = <any>null;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): PagedResultOfShipLightModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfShipLightModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber !== undefined ? this.pageNumber : <any>null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
        if (Array.isArray(this.pageResult)) {
            data["pageResult"] = [];
            for (let item of this.pageResult)
                data["pageResult"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data;
    }
}

export interface IPagedResultOfShipLightModel {
    pageNumber: number;
    pageSize: number;
    pageResult: ShipLightModel[];
    totalCount: number;
}

export class ShipLightModel implements IShipLightModel {
    id!: string;
    name!: string;
    isActive!: boolean;
    createdAt?: Date | null;
    imoNr?: string | null;

    constructor(data?: IShipLightModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.imoNr = _data["imoNr"] !== undefined ? _data["imoNr"] : <any>null;
        }
    }

    static fromJS(data: any): ShipLightModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShipLightModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        data["imoNr"] = this.imoNr !== undefined ? this.imoNr : <any>null;
        return data;
    }
}

export interface IShipLightModel {
    id: string;
    name: string;
    isActive: boolean;
    createdAt?: Date | null;
    imoNr?: string | null;
}

export enum SysAdminShipsSortField {
    CreatedAtAsc = "createdAtAsc",
    CreatedAtDesc = "createdAtDesc",
    NameAsc = "nameAsc",
    NameDesc = "nameDesc",
    ActiveAsc = "activeAsc",
    ActiveDesc = "activeDesc",
}

export class AddOrUpdateShipRequest implements IAddOrUpdateShipRequest {
    name?: string | null;
    type?: string | null;
    imoNr?: string | null;
    call?: string | null;
    mmsi?: string | null;
    countryCode?: string | null;
    grossTonnage?: number | null;
    mainPower?: number | null;
    electricPower?: number | null;
    coldProduction?: number | null;
    lengthOverall?: number | null;
    additionalInfo?: string | null;

    constructor(data?: IAddOrUpdateShipRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.imoNr = _data["imoNr"] !== undefined ? _data["imoNr"] : <any>null;
            this.call = _data["call"] !== undefined ? _data["call"] : <any>null;
            this.mmsi = _data["mmsi"] !== undefined ? _data["mmsi"] : <any>null;
            this.countryCode = _data["countryCode"] !== undefined ? _data["countryCode"] : <any>null;
            this.grossTonnage = _data["grossTonnage"] !== undefined ? _data["grossTonnage"] : <any>null;
            this.mainPower = _data["mainPower"] !== undefined ? _data["mainPower"] : <any>null;
            this.electricPower = _data["electricPower"] !== undefined ? _data["electricPower"] : <any>null;
            this.coldProduction = _data["coldProduction"] !== undefined ? _data["coldProduction"] : <any>null;
            this.lengthOverall = _data["lengthOverall"] !== undefined ? _data["lengthOverall"] : <any>null;
            this.additionalInfo = _data["additionalInfo"] !== undefined ? _data["additionalInfo"] : <any>null;
        }
    }

    static fromJS(data: any): AddOrUpdateShipRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddOrUpdateShipRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["imoNr"] = this.imoNr !== undefined ? this.imoNr : <any>null;
        data["call"] = this.call !== undefined ? this.call : <any>null;
        data["mmsi"] = this.mmsi !== undefined ? this.mmsi : <any>null;
        data["countryCode"] = this.countryCode !== undefined ? this.countryCode : <any>null;
        data["grossTonnage"] = this.grossTonnage !== undefined ? this.grossTonnage : <any>null;
        data["mainPower"] = this.mainPower !== undefined ? this.mainPower : <any>null;
        data["electricPower"] = this.electricPower !== undefined ? this.electricPower : <any>null;
        data["coldProduction"] = this.coldProduction !== undefined ? this.coldProduction : <any>null;
        data["lengthOverall"] = this.lengthOverall !== undefined ? this.lengthOverall : <any>null;
        data["additionalInfo"] = this.additionalInfo !== undefined ? this.additionalInfo : <any>null;
        return data;
    }
}

export interface IAddOrUpdateShipRequest {
    name?: string | null;
    type?: string | null;
    imoNr?: string | null;
    call?: string | null;
    mmsi?: string | null;
    countryCode?: string | null;
    grossTonnage?: number | null;
    mainPower?: number | null;
    electricPower?: number | null;
    coldProduction?: number | null;
    lengthOverall?: number | null;
    additionalInfo?: string | null;
}

export class ShipDetailsModel implements IShipDetailsModel {
    id!: string;
    isActive!: boolean;
    name!: string;
    type!: string;
    imoNr?: string | null;
    call?: string | null;
    mmsi?: string | null;
    countryCode?: string | null;
    grossTonnage!: number;
    mainPower!: number;
    electricPower?: number | null;
    coldProduction?: number | null;
    additionalInfo?: string | null;
    lengthOverall?: number | null;

    constructor(data?: IShipDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.imoNr = _data["imoNr"] !== undefined ? _data["imoNr"] : <any>null;
            this.call = _data["call"] !== undefined ? _data["call"] : <any>null;
            this.mmsi = _data["mmsi"] !== undefined ? _data["mmsi"] : <any>null;
            this.countryCode = _data["countryCode"] !== undefined ? _data["countryCode"] : <any>null;
            this.grossTonnage = _data["grossTonnage"] !== undefined ? _data["grossTonnage"] : <any>null;
            this.mainPower = _data["mainPower"] !== undefined ? _data["mainPower"] : <any>null;
            this.electricPower = _data["electricPower"] !== undefined ? _data["electricPower"] : <any>null;
            this.coldProduction = _data["coldProduction"] !== undefined ? _data["coldProduction"] : <any>null;
            this.additionalInfo = _data["additionalInfo"] !== undefined ? _data["additionalInfo"] : <any>null;
            this.lengthOverall = _data["lengthOverall"] !== undefined ? _data["lengthOverall"] : <any>null;
        }
    }

    static fromJS(data: any): ShipDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShipDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["imoNr"] = this.imoNr !== undefined ? this.imoNr : <any>null;
        data["call"] = this.call !== undefined ? this.call : <any>null;
        data["mmsi"] = this.mmsi !== undefined ? this.mmsi : <any>null;
        data["countryCode"] = this.countryCode !== undefined ? this.countryCode : <any>null;
        data["grossTonnage"] = this.grossTonnage !== undefined ? this.grossTonnage : <any>null;
        data["mainPower"] = this.mainPower !== undefined ? this.mainPower : <any>null;
        data["electricPower"] = this.electricPower !== undefined ? this.electricPower : <any>null;
        data["coldProduction"] = this.coldProduction !== undefined ? this.coldProduction : <any>null;
        data["additionalInfo"] = this.additionalInfo !== undefined ? this.additionalInfo : <any>null;
        data["lengthOverall"] = this.lengthOverall !== undefined ? this.lengthOverall : <any>null;
        return data;
    }
}

export interface IShipDetailsModel {
    id: string;
    isActive: boolean;
    name: string;
    type: string;
    imoNr?: string | null;
    call?: string | null;
    mmsi?: string | null;
    countryCode?: string | null;
    grossTonnage: number;
    mainPower: number;
    electricPower?: number | null;
    coldProduction?: number | null;
    additionalInfo?: string | null;
    lengthOverall?: number | null;
}

export class ShipTypeLightModel implements IShipTypeLightModel {
    id!: string;
    name!: LocalizedString;
    isActive!: boolean;
    createdAt?: Date | null;

    constructor(data?: IShipTypeLightModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.name = new LocalizedString();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] ? LocalizedString.fromJS(_data["name"]) : new LocalizedString();
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): ShipTypeLightModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShipTypeLightModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name ? this.name.toJSON() : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        return data;
    }
}

export interface IShipTypeLightModel {
    id: string;
    name: LocalizedString;
    isActive: boolean;
    createdAt?: Date | null;
}

export abstract class ValueObject implements IValueObject {

    constructor(data?: IValueObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ValueObject {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ValueObject' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IValueObject {
}

export class LocalizedString extends ValueObject implements ILocalizedString {
    estonian!: string;
    english!: string;
    localizedOrDefault!: string;

    constructor(data?: ILocalizedString) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.estonian = _data["estonian"] !== undefined ? _data["estonian"] : <any>null;
            this.english = _data["english"] !== undefined ? _data["english"] : <any>null;
            this.localizedOrDefault = _data["localizedOrDefault"] !== undefined ? _data["localizedOrDefault"] : <any>null;
        }
    }

    static fromJS(data: any): LocalizedString {
        data = typeof data === 'object' ? data : {};
        let result = new LocalizedString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["estonian"] = this.estonian !== undefined ? this.estonian : <any>null;
        data["english"] = this.english !== undefined ? this.english : <any>null;
        data["localizedOrDefault"] = this.localizedOrDefault !== undefined ? this.localizedOrDefault : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ILocalizedString extends IValueObject {
    estonian: string;
    english: string;
    localizedOrDefault: string;
}

export enum SysAdminShipTypesSortField {
    NameAsc = "nameAsc",
    NameDesc = "nameDesc",
}

export class AddOrUpdateShipTypeRequest implements IAddOrUpdateShipTypeRequest {
    name?: string | null;
    nameEn?: string | null;

    constructor(data?: IAddOrUpdateShipTypeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.nameEn = _data["nameEn"] !== undefined ? _data["nameEn"] : <any>null;
        }
    }

    static fromJS(data: any): AddOrUpdateShipTypeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddOrUpdateShipTypeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["nameEn"] = this.nameEn !== undefined ? this.nameEn : <any>null;
        return data;
    }
}

export interface IAddOrUpdateShipTypeRequest {
    name?: string | null;
    nameEn?: string | null;
}

export class ShipTypeDetailsModel implements IShipTypeDetailsModel {
    id!: string;
    isActive!: boolean;
    name!: LocalizedString;

    constructor(data?: IShipTypeDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.name = new LocalizedString();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.name = _data["name"] ? LocalizedString.fromJS(_data["name"]) : new LocalizedString();
        }
    }

    static fromJS(data: any): ShipTypeDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShipTypeDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["name"] = this.name ? this.name.toJSON() : <any>null;
        return data;
    }
}

export interface IShipTypeDetailsModel {
    id: string;
    isActive: boolean;
    name: LocalizedString;
}

export class RestrictionLightModel implements IRestrictionLightModel {
    id!: string;
    name!: string;
    isActive!: boolean;

    constructor(data?: IRestrictionLightModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): RestrictionLightModel {
        data = typeof data === 'object' ? data : {};
        let result = new RestrictionLightModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data;
    }
}

export interface IRestrictionLightModel {
    id: string;
    name: string;
    isActive: boolean;
}

export class RestrictionDetailsModel implements IRestrictionDetailsModel {
    id!: string;
    nameEst!: string;
    nameEng!: string;
    isActive!: boolean;

    constructor(data?: IRestrictionDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nameEst = _data["nameEst"] !== undefined ? _data["nameEst"] : <any>null;
            this.nameEng = _data["nameEng"] !== undefined ? _data["nameEng"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): RestrictionDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new RestrictionDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nameEst"] = this.nameEst !== undefined ? this.nameEst : <any>null;
        data["nameEng"] = this.nameEng !== undefined ? this.nameEng : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data;
    }
}

export interface IRestrictionDetailsModel {
    id: string;
    nameEst: string;
    nameEng: string;
    isActive: boolean;
}

export class UpsertRestrictionRequest implements IUpsertRestrictionRequest {
    id?: string | null;
    nameEst?: string | null;
    nameEng?: string | null;
    isActive!: boolean;

    constructor(data?: IUpsertRestrictionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nameEst = _data["nameEst"] !== undefined ? _data["nameEst"] : <any>null;
            this.nameEng = _data["nameEng"] !== undefined ? _data["nameEng"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): UpsertRestrictionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertRestrictionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nameEst"] = this.nameEst !== undefined ? this.nameEst : <any>null;
        data["nameEng"] = this.nameEng !== undefined ? this.nameEng : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data;
    }
}

export interface IUpsertRestrictionRequest {
    id?: string | null;
    nameEst?: string | null;
    nameEng?: string | null;
    isActive: boolean;
}

export class PagedResultOfPrintBackgroundTemplateModel implements IPagedResultOfPrintBackgroundTemplateModel {
    pageNumber!: number;
    pageSize!: number;
    pageResult!: PrintBackgroundTemplateModel[];
    totalCount!: number;

    constructor(data?: IPagedResultOfPrintBackgroundTemplateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageResult = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"] !== undefined ? _data["pageNumber"] : <any>null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : <any>null;
            if (Array.isArray(_data["pageResult"])) {
                this.pageResult = [] as any;
                for (let item of _data["pageResult"])
                    this.pageResult!.push(PrintBackgroundTemplateModel.fromJS(item));
            }
            else {
                this.pageResult = <any>null;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): PagedResultOfPrintBackgroundTemplateModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfPrintBackgroundTemplateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber !== undefined ? this.pageNumber : <any>null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
        if (Array.isArray(this.pageResult)) {
            data["pageResult"] = [];
            for (let item of this.pageResult)
                data["pageResult"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data;
    }
}

export interface IPagedResultOfPrintBackgroundTemplateModel {
    pageNumber: number;
    pageSize: number;
    pageResult: PrintBackgroundTemplateModel[];
    totalCount: number;
}

export class PrintBackgroundTemplateModel implements IPrintBackgroundTemplateModel {
    id!: string;
    name!: string;
    createdAt?: Date | null;

    constructor(data?: IPrintBackgroundTemplateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): PrintBackgroundTemplateModel {
        data = typeof data === 'object' ? data : {};
        let result = new PrintBackgroundTemplateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        return data;
    }
}

export interface IPrintBackgroundTemplateModel {
    id: string;
    name: string;
    createdAt?: Date | null;
}

export enum SysAdminPrintBackgroundTemplatesSortField {
    CreatedAtAsc = "createdAtAsc",
    CreatedAtDesc = "createdAtDesc",
    NameAsc = "nameAsc",
    NameDesc = "nameDesc",
}

export class PrintBackgroundTemplateDetailsModel implements IPrintBackgroundTemplateDetailsModel {
    id!: string;
    name!: string;
    frontFile?: FileModel[] | null;
    backFile?: FileModel[] | null;

    constructor(data?: IPrintBackgroundTemplateDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            if (Array.isArray(_data["frontFile"])) {
                this.frontFile = [] as any;
                for (let item of _data["frontFile"])
                    this.frontFile!.push(FileModel.fromJS(item));
            }
            else {
                this.frontFile = <any>null;
            }
            if (Array.isArray(_data["backFile"])) {
                this.backFile = [] as any;
                for (let item of _data["backFile"])
                    this.backFile!.push(FileModel.fromJS(item));
            }
            else {
                this.backFile = <any>null;
            }
        }
    }

    static fromJS(data: any): PrintBackgroundTemplateDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new PrintBackgroundTemplateDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        if (Array.isArray(this.frontFile)) {
            data["frontFile"] = [];
            for (let item of this.frontFile)
                data["frontFile"].push(item.toJSON());
        }
        if (Array.isArray(this.backFile)) {
            data["backFile"] = [];
            for (let item of this.backFile)
                data["backFile"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPrintBackgroundTemplateDetailsModel {
    id: string;
    name: string;
    frontFile?: FileModel[] | null;
    backFile?: FileModel[] | null;
}

export class FileModel implements IFileModel {
    id!: string;
    name!: string;

    constructor(data?: IFileModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): FileModel {
        data = typeof data === 'object' ? data : {};
        let result = new FileModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface IFileModel {
    id: string;
    name: string;
}

export class UpsertPrintBackgroundTemplateRequest implements IUpsertPrintBackgroundTemplateRequest {
    id?: string | null;
    name!: string;
    frontFile!: TempFileModel[];
    backFile!: TempFileModel[];

    constructor(data?: IUpsertPrintBackgroundTemplateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.frontFile = [];
            this.backFile = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            if (Array.isArray(_data["frontFile"])) {
                this.frontFile = [] as any;
                for (let item of _data["frontFile"])
                    this.frontFile!.push(TempFileModel.fromJS(item));
            }
            else {
                this.frontFile = <any>null;
            }
            if (Array.isArray(_data["backFile"])) {
                this.backFile = [] as any;
                for (let item of _data["backFile"])
                    this.backFile!.push(TempFileModel.fromJS(item));
            }
            else {
                this.backFile = <any>null;
            }
        }
    }

    static fromJS(data: any): UpsertPrintBackgroundTemplateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertPrintBackgroundTemplateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        if (Array.isArray(this.frontFile)) {
            data["frontFile"] = [];
            for (let item of this.frontFile)
                data["frontFile"].push(item.toJSON());
        }
        if (Array.isArray(this.backFile)) {
            data["backFile"] = [];
            for (let item of this.backFile)
                data["backFile"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpsertPrintBackgroundTemplateRequest {
    id?: string | null;
    name: string;
    frontFile: TempFileModel[];
    backFile: TempFileModel[];
}

export class TempFileModel implements ITempFileModel {
    id!: string;
    fileName!: string;

    constructor(data?: ITempFileModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
        }
    }

    static fromJS(data: any): TempFileModel {
        data = typeof data === 'object' ? data : {};
        let result = new TempFileModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        return data;
    }
}

export interface ITempFileModel {
    id: string;
    fileName: string;
}

export class PrintBackgroundTemplateDownloadUrls implements IPrintBackgroundTemplateDownloadUrls {
    frontFile?: string | null;
    backFile?: string | null;

    constructor(data?: IPrintBackgroundTemplateDownloadUrls) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.frontFile = _data["frontFile"] !== undefined ? _data["frontFile"] : <any>null;
            this.backFile = _data["backFile"] !== undefined ? _data["backFile"] : <any>null;
        }
    }

    static fromJS(data: any): PrintBackgroundTemplateDownloadUrls {
        data = typeof data === 'object' ? data : {};
        let result = new PrintBackgroundTemplateDownloadUrls();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["frontFile"] = this.frontFile !== undefined ? this.frontFile : <any>null;
        data["backFile"] = this.backFile !== undefined ? this.backFile : <any>null;
        return data;
    }
}

export interface IPrintBackgroundTemplateDownloadUrls {
    frontFile?: string | null;
    backFile?: string | null;
}

export class PrintBackgroundOption implements IPrintBackgroundOption {
    value!: string;
    text!: string;

    constructor(data?: IPrintBackgroundOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.text = _data["text"] !== undefined ? _data["text"] : <any>null;
        }
    }

    static fromJS(data: any): PrintBackgroundOption {
        data = typeof data === 'object' ? data : {};
        let result = new PrintBackgroundOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["text"] = this.text !== undefined ? this.text : <any>null;
        return data;
    }
}

export interface IPrintBackgroundOption {
    value: string;
    text: string;
}

export class PositionLightModel implements IPositionLightModel {
    id!: string;
    name!: string;
    isActive!: boolean;

    constructor(data?: IPositionLightModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): PositionLightModel {
        data = typeof data === 'object' ? data : {};
        let result = new PositionLightModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data;
    }
}

export interface IPositionLightModel {
    id: string;
    name: string;
    isActive: boolean;
}

export class PositionDetailsModel implements IPositionDetailsModel {
    id!: string;
    nameEst!: string;
    nameEng!: string;
    levelKey!: string;
    responsibilitiesEst!: string;
    responsibilitiesEng!: string;
    isActive!: boolean;
    additionalInformation!: string;

    constructor(data?: IPositionDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nameEst = _data["nameEst"] !== undefined ? _data["nameEst"] : <any>null;
            this.nameEng = _data["nameEng"] !== undefined ? _data["nameEng"] : <any>null;
            this.levelKey = _data["levelKey"] !== undefined ? _data["levelKey"] : <any>null;
            this.responsibilitiesEst = _data["responsibilitiesEst"] !== undefined ? _data["responsibilitiesEst"] : <any>null;
            this.responsibilitiesEng = _data["responsibilitiesEng"] !== undefined ? _data["responsibilitiesEng"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.additionalInformation = _data["additionalInformation"] !== undefined ? _data["additionalInformation"] : <any>null;
        }
    }

    static fromJS(data: any): PositionDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new PositionDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nameEst"] = this.nameEst !== undefined ? this.nameEst : <any>null;
        data["nameEng"] = this.nameEng !== undefined ? this.nameEng : <any>null;
        data["levelKey"] = this.levelKey !== undefined ? this.levelKey : <any>null;
        data["responsibilitiesEst"] = this.responsibilitiesEst !== undefined ? this.responsibilitiesEst : <any>null;
        data["responsibilitiesEng"] = this.responsibilitiesEng !== undefined ? this.responsibilitiesEng : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["additionalInformation"] = this.additionalInformation !== undefined ? this.additionalInformation : <any>null;
        return data;
    }
}

export interface IPositionDetailsModel {
    id: string;
    nameEst: string;
    nameEng: string;
    levelKey: string;
    responsibilitiesEst: string;
    responsibilitiesEng: string;
    isActive: boolean;
    additionalInformation: string;
}

export class UpsertPositionRequest implements IUpsertPositionRequest {
    id?: string | null;
    nameEst?: string | null;
    nameEng?: string | null;
    levelKey?: string | null;
    responsibilitiesEst?: string | null;
    responsibilitiesEng?: string | null;
    additionalInformation?: string | null;
    isActive!: boolean;

    constructor(data?: IUpsertPositionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nameEst = _data["nameEst"] !== undefined ? _data["nameEst"] : <any>null;
            this.nameEng = _data["nameEng"] !== undefined ? _data["nameEng"] : <any>null;
            this.levelKey = _data["levelKey"] !== undefined ? _data["levelKey"] : <any>null;
            this.responsibilitiesEst = _data["responsibilitiesEst"] !== undefined ? _data["responsibilitiesEst"] : <any>null;
            this.responsibilitiesEng = _data["responsibilitiesEng"] !== undefined ? _data["responsibilitiesEng"] : <any>null;
            this.additionalInformation = _data["additionalInformation"] !== undefined ? _data["additionalInformation"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): UpsertPositionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertPositionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nameEst"] = this.nameEst !== undefined ? this.nameEst : <any>null;
        data["nameEng"] = this.nameEng !== undefined ? this.nameEng : <any>null;
        data["levelKey"] = this.levelKey !== undefined ? this.levelKey : <any>null;
        data["responsibilitiesEst"] = this.responsibilitiesEst !== undefined ? this.responsibilitiesEst : <any>null;
        data["responsibilitiesEng"] = this.responsibilitiesEng !== undefined ? this.responsibilitiesEng : <any>null;
        data["additionalInformation"] = this.additionalInformation !== undefined ? this.additionalInformation : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data;
    }
}

export interface IUpsertPositionRequest {
    id?: string | null;
    nameEst?: string | null;
    nameEng?: string | null;
    levelKey?: string | null;
    responsibilitiesEst?: string | null;
    responsibilitiesEng?: string | null;
    additionalInformation?: string | null;
    isActive: boolean;
}

export class OrganizationLightModel implements IOrganizationLightModel {
    id!: string;
    name!: string;
    active!: boolean;
    types!: string[];

    constructor(data?: IOrganizationLightModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.types = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.active = _data["active"] !== undefined ? _data["active"] : <any>null;
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(item);
            }
            else {
                this.types = <any>null;
            }
        }
    }

    static fromJS(data: any): OrganizationLightModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationLightModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["active"] = this.active !== undefined ? this.active : <any>null;
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item);
        }
        return data;
    }
}

export interface IOrganizationLightModel {
    id: string;
    name: string;
    active: boolean;
    types: string[];
}

export class UpsertOrganizationRequest implements IUpsertOrganizationRequest {
    id?: string | null;
    nameEst?: string | null;
    nameEng?: string | null;
    registerCode?: string | null;
    types!: string[];
    additionalInfo?: string | null;
    countryLetterCode?: string | null;
    active?: boolean | null;
    specialities!: string[];

    constructor(data?: IUpsertOrganizationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.types = [];
            this.specialities = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nameEst = _data["nameEst"] !== undefined ? _data["nameEst"] : <any>null;
            this.nameEng = _data["nameEng"] !== undefined ? _data["nameEng"] : <any>null;
            this.registerCode = _data["registerCode"] !== undefined ? _data["registerCode"] : <any>null;
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(item);
            }
            else {
                this.types = <any>null;
            }
            this.additionalInfo = _data["additionalInfo"] !== undefined ? _data["additionalInfo"] : <any>null;
            this.countryLetterCode = _data["countryLetterCode"] !== undefined ? _data["countryLetterCode"] : <any>null;
            this.active = _data["active"] !== undefined ? _data["active"] : <any>null;
            if (Array.isArray(_data["specialities"])) {
                this.specialities = [] as any;
                for (let item of _data["specialities"])
                    this.specialities!.push(item);
            }
            else {
                this.specialities = <any>null;
            }
        }
    }

    static fromJS(data: any): UpsertOrganizationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertOrganizationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nameEst"] = this.nameEst !== undefined ? this.nameEst : <any>null;
        data["nameEng"] = this.nameEng !== undefined ? this.nameEng : <any>null;
        data["registerCode"] = this.registerCode !== undefined ? this.registerCode : <any>null;
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item);
        }
        data["additionalInfo"] = this.additionalInfo !== undefined ? this.additionalInfo : <any>null;
        data["countryLetterCode"] = this.countryLetterCode !== undefined ? this.countryLetterCode : <any>null;
        data["active"] = this.active !== undefined ? this.active : <any>null;
        if (Array.isArray(this.specialities)) {
            data["specialities"] = [];
            for (let item of this.specialities)
                data["specialities"].push(item);
        }
        return data;
    }
}

export interface IUpsertOrganizationRequest {
    id?: string | null;
    nameEst?: string | null;
    nameEng?: string | null;
    registerCode?: string | null;
    types: string[];
    additionalInfo?: string | null;
    countryLetterCode?: string | null;
    active?: boolean | null;
    specialities: string[];
}

export class OrganizationDetailsModel implements IOrganizationDetailsModel {
    id!: string;
    nameEst!: string;
    nameEng!: string;
    registerCode!: string;
    types!: OrganizationTypeModel[];
    roles!: RoleModel[];
    representatives!: RepresentativeViewModel[];
    contactInfo!: OrganizationContactInfoViewModel;
    additionalInfo!: string;
    countryLetterCode!: string;
    countryName!: string;
    active!: boolean;
    specialities!: SpecialityId[];

    constructor(data?: IOrganizationDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.types = [];
            this.roles = [];
            this.representatives = [];
            this.contactInfo = new OrganizationContactInfoViewModel();
            this.specialities = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nameEst = _data["nameEst"] !== undefined ? _data["nameEst"] : <any>null;
            this.nameEng = _data["nameEng"] !== undefined ? _data["nameEng"] : <any>null;
            this.registerCode = _data["registerCode"] !== undefined ? _data["registerCode"] : <any>null;
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(OrganizationTypeModel.fromJS(item));
            }
            else {
                this.types = <any>null;
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(RoleModel.fromJS(item));
            }
            else {
                this.roles = <any>null;
            }
            if (Array.isArray(_data["representatives"])) {
                this.representatives = [] as any;
                for (let item of _data["representatives"])
                    this.representatives!.push(RepresentativeViewModel.fromJS(item));
            }
            else {
                this.representatives = <any>null;
            }
            this.contactInfo = _data["contactInfo"] ? OrganizationContactInfoViewModel.fromJS(_data["contactInfo"]) : new OrganizationContactInfoViewModel();
            this.additionalInfo = _data["additionalInfo"] !== undefined ? _data["additionalInfo"] : <any>null;
            this.countryLetterCode = _data["countryLetterCode"] !== undefined ? _data["countryLetterCode"] : <any>null;
            this.countryName = _data["countryName"] !== undefined ? _data["countryName"] : <any>null;
            this.active = _data["active"] !== undefined ? _data["active"] : <any>null;
            if (Array.isArray(_data["specialities"])) {
                this.specialities = [] as any;
                for (let item of _data["specialities"])
                    this.specialities!.push(SpecialityId.fromJS(item));
            }
            else {
                this.specialities = <any>null;
            }
        }
    }

    static fromJS(data: any): OrganizationDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nameEst"] = this.nameEst !== undefined ? this.nameEst : <any>null;
        data["nameEng"] = this.nameEng !== undefined ? this.nameEng : <any>null;
        data["registerCode"] = this.registerCode !== undefined ? this.registerCode : <any>null;
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item.toJSON());
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        if (Array.isArray(this.representatives)) {
            data["representatives"] = [];
            for (let item of this.representatives)
                data["representatives"].push(item.toJSON());
        }
        data["contactInfo"] = this.contactInfo ? this.contactInfo.toJSON() : <any>null;
        data["additionalInfo"] = this.additionalInfo !== undefined ? this.additionalInfo : <any>null;
        data["countryLetterCode"] = this.countryLetterCode !== undefined ? this.countryLetterCode : <any>null;
        data["countryName"] = this.countryName !== undefined ? this.countryName : <any>null;
        data["active"] = this.active !== undefined ? this.active : <any>null;
        if (Array.isArray(this.specialities)) {
            data["specialities"] = [];
            for (let item of this.specialities)
                data["specialities"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOrganizationDetailsModel {
    id: string;
    nameEst: string;
    nameEng: string;
    registerCode: string;
    types: OrganizationTypeModel[];
    roles: RoleModel[];
    representatives: RepresentativeViewModel[];
    contactInfo: OrganizationContactInfoViewModel;
    additionalInfo: string;
    countryLetterCode: string;
    countryName: string;
    active: boolean;
    specialities: SpecialityId[];
}

export class OrganizationTypeModel implements IOrganizationTypeModel {
    name!: string;
    value!: string;

    constructor(data?: IOrganizationTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): OrganizationTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data;
    }
}

export interface IOrganizationTypeModel {
    name: string;
    value: string;
}

export class RoleModel implements IRoleModel {
    name!: string;
    description!: string;
    value!: string;

    constructor(data?: IRoleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): RoleModel {
        data = typeof data === 'object' ? data : {};
        let result = new RoleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data;
    }
}

export interface IRoleModel {
    name: string;
    description: string;
    value: string;
}

export class RepresentativeViewModel implements IRepresentativeViewModel {
    id!: string;
    firstName!: string;
    lastName!: string;
    isActive!: boolean;
    fullName!: string;
    username?: string | null;
    personalCode?: string | null;
    roles!: RoleModel[];
    phone?: string | null;
    contactEmail?: string | null;
    signatureImage?: FileModel | null;

    constructor(data?: IRepresentativeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.roles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
            this.username = _data["username"] !== undefined ? _data["username"] : <any>null;
            this.personalCode = _data["personalCode"] !== undefined ? _data["personalCode"] : <any>null;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(RoleModel.fromJS(item));
            }
            else {
                this.roles = <any>null;
            }
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.contactEmail = _data["contactEmail"] !== undefined ? _data["contactEmail"] : <any>null;
            this.signatureImage = _data["signatureImage"] ? FileModel.fromJS(_data["signatureImage"]) : <any>null;
        }
    }

    static fromJS(data: any): RepresentativeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RepresentativeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        data["username"] = this.username !== undefined ? this.username : <any>null;
        data["personalCode"] = this.personalCode !== undefined ? this.personalCode : <any>null;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["contactEmail"] = this.contactEmail !== undefined ? this.contactEmail : <any>null;
        data["signatureImage"] = this.signatureImage ? this.signatureImage.toJSON() : <any>null;
        return data;
    }
}

export interface IRepresentativeViewModel {
    id: string;
    firstName: string;
    lastName: string;
    isActive: boolean;
    fullName: string;
    username?: string | null;
    personalCode?: string | null;
    roles: RoleModel[];
    phone?: string | null;
    contactEmail?: string | null;
    signatureImage?: FileModel | null;
}

export class OrganizationContactInfoViewModel implements IOrganizationContactInfoViewModel {
    phone!: string;
    email!: string;
    address!: string;

    constructor(data?: IOrganizationContactInfoViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.address = _data["address"] !== undefined ? _data["address"] : <any>null;
        }
    }

    static fromJS(data: any): OrganizationContactInfoViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationContactInfoViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["address"] = this.address !== undefined ? this.address : <any>null;
        return data;
    }
}

export interface IOrganizationContactInfoViewModel {
    phone: string;
    email: string;
    address: string;
}

export abstract class SingleValueObjectOfGuid extends ValueObject implements ISingleValueObjectOfGuid {
    value!: string;

    constructor(data?: ISingleValueObjectOfGuid) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): SingleValueObjectOfGuid {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'SingleValueObjectOfGuid' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISingleValueObjectOfGuid extends IValueObject {
    value: string;
}

export abstract class IdentityOfSpecialityId extends SingleValueObjectOfGuid implements IIdentityOfSpecialityId {

    constructor(data?: IIdentityOfSpecialityId) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): IdentityOfSpecialityId {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IdentityOfSpecialityId' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IIdentityOfSpecialityId extends ISingleValueObjectOfGuid {
}

export class SpecialityId extends IdentityOfSpecialityId implements ISpecialityId {

    constructor(data?: ISpecialityId) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SpecialityId {
        data = typeof data === 'object' ? data : {};
        let result = new SpecialityId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISpecialityId extends IIdentityOfSpecialityId {
}

/** Empty type for 200 */
export class Ok implements IOk {

    constructor(data?: IOk) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): Ok {
        data = typeof data === 'object' ? data : {};
        let result = new Ok();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

/** Empty type for 200 */
export interface IOk {
}

export class UpdateOrganizationRolesModel implements IUpdateOrganizationRolesModel {
    roles!: string[];

    constructor(data?: IUpdateOrganizationRolesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.roles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            else {
                this.roles = <any>null;
            }
        }
    }

    static fromJS(data: any): UpdateOrganizationRolesModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrganizationRolesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface IUpdateOrganizationRolesModel {
    roles: string[];
}

export class MedicalPractitionerViewModel implements IMedicalPractitionerViewModel {
    usernameOrPersonalCode!: string;
    medicalPractitionerModels!: MedicalPractitionerModel[];

    constructor(data?: IMedicalPractitionerViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.medicalPractitionerModels = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.usernameOrPersonalCode = _data["usernameOrPersonalCode"] !== undefined ? _data["usernameOrPersonalCode"] : <any>null;
            if (Array.isArray(_data["medicalPractitionerModels"])) {
                this.medicalPractitionerModels = [] as any;
                for (let item of _data["medicalPractitionerModels"])
                    this.medicalPractitionerModels!.push(MedicalPractitionerModel.fromJS(item));
            }
            else {
                this.medicalPractitionerModels = <any>null;
            }
        }
    }

    static fromJS(data: any): MedicalPractitionerViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalPractitionerViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["usernameOrPersonalCode"] = this.usernameOrPersonalCode !== undefined ? this.usernameOrPersonalCode : <any>null;
        if (Array.isArray(this.medicalPractitionerModels)) {
            data["medicalPractitionerModels"] = [];
            for (let item of this.medicalPractitionerModels)
                data["medicalPractitionerModels"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMedicalPractitionerViewModel {
    usernameOrPersonalCode: string;
    medicalPractitionerModels: MedicalPractitionerModel[];
}

export class MedicalPractitionerModel implements IMedicalPractitionerModel {
    id!: string;
    firstName!: string;
    lastName!: string;
    organizationId!: string;
    organizationName!: string;
    isActive!: boolean;
    representative?: RepresentativeModel | null;

    constructor(data?: IMedicalPractitionerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.organizationId = _data["organizationId"] !== undefined ? _data["organizationId"] : <any>null;
            this.organizationName = _data["organizationName"] !== undefined ? _data["organizationName"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.representative = _data["representative"] ? RepresentativeModel.fromJS(_data["representative"]) : <any>null;
        }
    }

    static fromJS(data: any): MedicalPractitionerModel {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalPractitionerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["organizationId"] = this.organizationId !== undefined ? this.organizationId : <any>null;
        data["organizationName"] = this.organizationName !== undefined ? this.organizationName : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["representative"] = this.representative ? this.representative.toJSON() : <any>null;
        return data;
    }
}

export interface IMedicalPractitionerModel {
    id: string;
    firstName: string;
    lastName: string;
    organizationId: string;
    organizationName: string;
    isActive: boolean;
    representative?: RepresentativeModel | null;
}

export class RepresentativeModel implements IRepresentativeModel {
    fullName!: string;
    id!: string;
    usernameOrPersonalCode!: string;

    constructor(data?: IRepresentativeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.usernameOrPersonalCode = _data["usernameOrPersonalCode"] !== undefined ? _data["usernameOrPersonalCode"] : <any>null;
        }
    }

    static fromJS(data: any): RepresentativeModel {
        data = typeof data === 'object' ? data : {};
        let result = new RepresentativeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["usernameOrPersonalCode"] = this.usernameOrPersonalCode !== undefined ? this.usernameOrPersonalCode : <any>null;
        return data;
    }
}

export interface IRepresentativeModel {
    fullName: string;
    id: string;
    usernameOrPersonalCode: string;
}

export abstract class IdentityOfMedicalPractitionerId extends SingleValueObjectOfGuid implements IIdentityOfMedicalPractitionerId {

    constructor(data?: IIdentityOfMedicalPractitionerId) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): IdentityOfMedicalPractitionerId {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IdentityOfMedicalPractitionerId' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IIdentityOfMedicalPractitionerId extends ISingleValueObjectOfGuid {
}

export class MedicalPractitionerId extends IdentityOfMedicalPractitionerId implements IMedicalPractitionerId {

    constructor(data?: IMedicalPractitionerId) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): MedicalPractitionerId {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalPractitionerId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IMedicalPractitionerId extends IIdentityOfMedicalPractitionerId {
}

export class UpsertMedicalPractitionerRequest implements IUpsertMedicalPractitionerRequest {
    id?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    organizationId?: string | null;
    representativeId?: string | null;
    isActive?: boolean | null;

    constructor(data?: IUpsertMedicalPractitionerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.organizationId = _data["organizationId"] !== undefined ? _data["organizationId"] : <any>null;
            this.representativeId = _data["representativeId"] !== undefined ? _data["representativeId"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): UpsertMedicalPractitionerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertMedicalPractitionerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["organizationId"] = this.organizationId !== undefined ? this.organizationId : <any>null;
        data["representativeId"] = this.representativeId !== undefined ? this.representativeId : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data;
    }
}

export interface IUpsertMedicalPractitionerRequest {
    id?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    organizationId?: string | null;
    representativeId?: string | null;
    isActive?: boolean | null;
}

export class OrganizationModel implements IOrganizationModel {
    name!: string;
    id!: string;
    representatives!: RepresentativeModel[];

    constructor(data?: IOrganizationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.representatives = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            if (Array.isArray(_data["representatives"])) {
                this.representatives = [] as any;
                for (let item of _data["representatives"])
                    this.representatives!.push(RepresentativeModel.fromJS(item));
            }
            else {
                this.representatives = <any>null;
            }
        }
    }

    static fromJS(data: any): OrganizationModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        if (Array.isArray(this.representatives)) {
            data["representatives"] = [];
            for (let item of this.representatives)
                data["representatives"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOrganizationModel {
    name: string;
    id: string;
    representatives: RepresentativeModel[];
}

export class HeaderNotificationModel implements IHeaderNotificationModel {
    id?: string | null;
    title!: string;
    message!: string;
    titleEn!: string;
    messageEn!: string;
    isActive!: boolean;

    constructor(data?: IHeaderNotificationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.message = _data["message"] !== undefined ? _data["message"] : <any>null;
            this.titleEn = _data["titleEn"] !== undefined ? _data["titleEn"] : <any>null;
            this.messageEn = _data["messageEn"] !== undefined ? _data["messageEn"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): HeaderNotificationModel {
        data = typeof data === 'object' ? data : {};
        let result = new HeaderNotificationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["message"] = this.message !== undefined ? this.message : <any>null;
        data["titleEn"] = this.titleEn !== undefined ? this.titleEn : <any>null;
        data["messageEn"] = this.messageEn !== undefined ? this.messageEn : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data;
    }
}

export interface IHeaderNotificationModel {
    id?: string | null;
    title: string;
    message: string;
    titleEn: string;
    messageEn: string;
    isActive: boolean;
}

export class HarbourLightModel implements IHarbourLightModel {
    id!: string;
    name!: string;
    isActive!: boolean;

    constructor(data?: IHarbourLightModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): HarbourLightModel {
        data = typeof data === 'object' ? data : {};
        let result = new HarbourLightModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data;
    }
}

export interface IHarbourLightModel {
    id: string;
    name: string;
    isActive: boolean;
}

export class HarbourDetailsModel implements IHarbourDetailsModel {
    id!: string;
    name!: string;
    countryLetterCode!: string;
    harbourCode?: string | null;
    additionalInformation?: string | null;
    isActive!: boolean;

    constructor(data?: IHarbourDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.countryLetterCode = _data["countryLetterCode"] !== undefined ? _data["countryLetterCode"] : <any>null;
            this.harbourCode = _data["harbourCode"] !== undefined ? _data["harbourCode"] : <any>null;
            this.additionalInformation = _data["additionalInformation"] !== undefined ? _data["additionalInformation"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): HarbourDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new HarbourDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["countryLetterCode"] = this.countryLetterCode !== undefined ? this.countryLetterCode : <any>null;
        data["harbourCode"] = this.harbourCode !== undefined ? this.harbourCode : <any>null;
        data["additionalInformation"] = this.additionalInformation !== undefined ? this.additionalInformation : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data;
    }
}

export interface IHarbourDetailsModel {
    id: string;
    name: string;
    countryLetterCode: string;
    harbourCode?: string | null;
    additionalInformation?: string | null;
    isActive: boolean;
}

export class UpsertHarbourRequest implements IUpsertHarbourRequest {
    id?: string | null;
    name?: string | null;
    countryLetterCode?: string | null;
    harbourCode?: string | null;
    additionalInformation?: string | null;
    isActive?: boolean | null;

    constructor(data?: IUpsertHarbourRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.countryLetterCode = _data["countryLetterCode"] !== undefined ? _data["countryLetterCode"] : <any>null;
            this.harbourCode = _data["harbourCode"] !== undefined ? _data["harbourCode"] : <any>null;
            this.additionalInformation = _data["additionalInformation"] !== undefined ? _data["additionalInformation"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): UpsertHarbourRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertHarbourRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["countryLetterCode"] = this.countryLetterCode !== undefined ? this.countryLetterCode : <any>null;
        data["harbourCode"] = this.harbourCode !== undefined ? this.harbourCode : <any>null;
        data["additionalInformation"] = this.additionalInformation !== undefined ? this.additionalInformation : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data;
    }
}

export interface IUpsertHarbourRequest {
    id?: string | null;
    name?: string | null;
    countryLetterCode?: string | null;
    harbourCode?: string | null;
    additionalInformation?: string | null;
    isActive?: boolean | null;
}

export class CountryModel implements ICountryModel {
    letterCode!: string;
    numericCode!: number;
    nameEng!: string;
    nameEst!: string;
    nameEstPossessiveCase!: string;
    nameEngPossessiveCase!: string;

    constructor(data?: ICountryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.letterCode = _data["letterCode"] !== undefined ? _data["letterCode"] : <any>null;
            this.numericCode = _data["numericCode"] !== undefined ? _data["numericCode"] : <any>null;
            this.nameEng = _data["nameEng"] !== undefined ? _data["nameEng"] : <any>null;
            this.nameEst = _data["nameEst"] !== undefined ? _data["nameEst"] : <any>null;
            this.nameEstPossessiveCase = _data["nameEstPossessiveCase"] !== undefined ? _data["nameEstPossessiveCase"] : <any>null;
            this.nameEngPossessiveCase = _data["nameEngPossessiveCase"] !== undefined ? _data["nameEngPossessiveCase"] : <any>null;
        }
    }

    static fromJS(data: any): CountryModel {
        data = typeof data === 'object' ? data : {};
        let result = new CountryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["letterCode"] = this.letterCode !== undefined ? this.letterCode : <any>null;
        data["numericCode"] = this.numericCode !== undefined ? this.numericCode : <any>null;
        data["nameEng"] = this.nameEng !== undefined ? this.nameEng : <any>null;
        data["nameEst"] = this.nameEst !== undefined ? this.nameEst : <any>null;
        data["nameEstPossessiveCase"] = this.nameEstPossessiveCase !== undefined ? this.nameEstPossessiveCase : <any>null;
        data["nameEngPossessiveCase"] = this.nameEngPossessiveCase !== undefined ? this.nameEngPossessiveCase : <any>null;
        return data;
    }
}

export interface ICountryModel {
    letterCode: string;
    numericCode: number;
    nameEng: string;
    nameEst: string;
    nameEstPossessiveCase: string;
    nameEngPossessiveCase: string;
}

export class CountryJsonModel implements ICountryJsonModel {
    countriesJson!: string;

    constructor(data?: ICountryJsonModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countriesJson = _data["countriesJson"] !== undefined ? _data["countriesJson"] : <any>null;
        }
    }

    static fromJS(data: any): CountryJsonModel {
        data = typeof data === 'object' ? data : {};
        let result = new CountryJsonModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countriesJson"] = this.countriesJson !== undefined ? this.countriesJson : <any>null;
        return data;
    }
}

export interface ICountryJsonModel {
    countriesJson: string;
}

export class EditCountriesRequest implements IEditCountriesRequest {
    countriesJson?: any[] | null;
    dryRun!: boolean;

    constructor(data?: IEditCountriesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.dryRun = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["countriesJson"])) {
                this.countriesJson = [] as any;
                for (let item of _data["countriesJson"])
                    this.countriesJson!.push(item);
            }
            else {
                this.countriesJson = <any>null;
            }
            this.dryRun = _data["dryRun"] !== undefined ? _data["dryRun"] : false;
        }
    }

    static fromJS(data: any): EditCountriesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditCountriesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.countriesJson)) {
            data["countriesJson"] = [];
            for (let item of this.countriesJson)
                data["countriesJson"].push(item);
        }
        data["dryRun"] = this.dryRun !== undefined ? this.dryRun : <any>null;
        return data;
    }
}

export interface IEditCountriesRequest {
    countriesJson?: any[] | null;
    dryRun: boolean;
}

export class CertificateTypeTemplateModel implements ICertificateTypeTemplateModel {
    id!: string;
    name!: string;
    certificateTypeIds!: string[];
    certificateTypeNames!: string[];
    certificateTypeDisplayName!: string;
    isActive!: boolean;

    constructor(data?: ICertificateTypeTemplateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.certificateTypeIds = [];
            this.certificateTypeNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            if (Array.isArray(_data["certificateTypeIds"])) {
                this.certificateTypeIds = [] as any;
                for (let item of _data["certificateTypeIds"])
                    this.certificateTypeIds!.push(item);
            }
            else {
                this.certificateTypeIds = <any>null;
            }
            if (Array.isArray(_data["certificateTypeNames"])) {
                this.certificateTypeNames = [] as any;
                for (let item of _data["certificateTypeNames"])
                    this.certificateTypeNames!.push(item);
            }
            else {
                this.certificateTypeNames = <any>null;
            }
            this.certificateTypeDisplayName = _data["certificateTypeDisplayName"] !== undefined ? _data["certificateTypeDisplayName"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): CertificateTypeTemplateModel {
        data = typeof data === 'object' ? data : {};
        let result = new CertificateTypeTemplateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        if (Array.isArray(this.certificateTypeIds)) {
            data["certificateTypeIds"] = [];
            for (let item of this.certificateTypeIds)
                data["certificateTypeIds"].push(item);
        }
        if (Array.isArray(this.certificateTypeNames)) {
            data["certificateTypeNames"] = [];
            for (let item of this.certificateTypeNames)
                data["certificateTypeNames"].push(item);
        }
        data["certificateTypeDisplayName"] = this.certificateTypeDisplayName !== undefined ? this.certificateTypeDisplayName : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data;
    }
}

export interface ICertificateTypeTemplateModel {
    id: string;
    name: string;
    certificateTypeIds: string[];
    certificateTypeNames: string[];
    certificateTypeDisplayName: string;
    isActive: boolean;
}

export class CertificateTypeTemplateDetailsModel implements ICertificateTypeTemplateDetailsModel {
    id!: string;
    name!: string;
    certificateTypeIds!: string[];
    certificateTypeNames!: string[];
    description!: MultilanguageModel;
    templateVersion!: string;
    isActive!: boolean;
    templateFileUrl?: string | null;
    textLiterals?: string | null;

    constructor(data?: ICertificateTypeTemplateDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.certificateTypeIds = [];
            this.certificateTypeNames = [];
            this.description = new MultilanguageModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            if (Array.isArray(_data["certificateTypeIds"])) {
                this.certificateTypeIds = [] as any;
                for (let item of _data["certificateTypeIds"])
                    this.certificateTypeIds!.push(item);
            }
            else {
                this.certificateTypeIds = <any>null;
            }
            if (Array.isArray(_data["certificateTypeNames"])) {
                this.certificateTypeNames = [] as any;
                for (let item of _data["certificateTypeNames"])
                    this.certificateTypeNames!.push(item);
            }
            else {
                this.certificateTypeNames = <any>null;
            }
            this.description = _data["description"] ? MultilanguageModel.fromJS(_data["description"]) : new MultilanguageModel();
            this.templateVersion = _data["templateVersion"] !== undefined ? _data["templateVersion"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.templateFileUrl = _data["templateFileUrl"] !== undefined ? _data["templateFileUrl"] : <any>null;
            this.textLiterals = _data["textLiterals"] !== undefined ? _data["textLiterals"] : <any>null;
        }
    }

    static fromJS(data: any): CertificateTypeTemplateDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new CertificateTypeTemplateDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        if (Array.isArray(this.certificateTypeIds)) {
            data["certificateTypeIds"] = [];
            for (let item of this.certificateTypeIds)
                data["certificateTypeIds"].push(item);
        }
        if (Array.isArray(this.certificateTypeNames)) {
            data["certificateTypeNames"] = [];
            for (let item of this.certificateTypeNames)
                data["certificateTypeNames"].push(item);
        }
        data["description"] = this.description ? this.description.toJSON() : <any>null;
        data["templateVersion"] = this.templateVersion !== undefined ? this.templateVersion : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["templateFileUrl"] = this.templateFileUrl !== undefined ? this.templateFileUrl : <any>null;
        data["textLiterals"] = this.textLiterals !== undefined ? this.textLiterals : <any>null;
        return data;
    }
}

export interface ICertificateTypeTemplateDetailsModel {
    id: string;
    name: string;
    certificateTypeIds: string[];
    certificateTypeNames: string[];
    description: MultilanguageModel;
    templateVersion: string;
    isActive: boolean;
    templateFileUrl?: string | null;
    textLiterals?: string | null;
}

export class MultilanguageModel implements IMultilanguageModel {
    et?: string | null;
    en?: string | null;

    constructor(data?: IMultilanguageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.et = _data["et"] !== undefined ? _data["et"] : <any>null;
            this.en = _data["en"] !== undefined ? _data["en"] : <any>null;
        }
    }

    static fromJS(data: any): MultilanguageModel {
        data = typeof data === 'object' ? data : {};
        let result = new MultilanguageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["et"] = this.et !== undefined ? this.et : <any>null;
        data["en"] = this.en !== undefined ? this.en : <any>null;
        return data;
    }
}

export interface IMultilanguageModel {
    et?: string | null;
    en?: string | null;
}

export class UpsertCertificateTypeTemplateRequest implements IUpsertCertificateTypeTemplateRequest {
    id?: string | null;
    name!: MultilanguageModel;
    certificateTypeIds!: string[];
    description!: MultilanguageModel;
    templateVersion!: string;
    templateFile?: TempFileModel | null;
    textLiterals?: string | null;

    constructor(data?: IUpsertCertificateTypeTemplateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.name = new MultilanguageModel();
            this.certificateTypeIds = [];
            this.description = new MultilanguageModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] ? MultilanguageModel.fromJS(_data["name"]) : new MultilanguageModel();
            if (Array.isArray(_data["certificateTypeIds"])) {
                this.certificateTypeIds = [] as any;
                for (let item of _data["certificateTypeIds"])
                    this.certificateTypeIds!.push(item);
            }
            else {
                this.certificateTypeIds = <any>null;
            }
            this.description = _data["description"] ? MultilanguageModel.fromJS(_data["description"]) : new MultilanguageModel();
            this.templateVersion = _data["templateVersion"] !== undefined ? _data["templateVersion"] : <any>null;
            this.templateFile = _data["templateFile"] ? TempFileModel.fromJS(_data["templateFile"]) : <any>null;
            this.textLiterals = _data["textLiterals"] !== undefined ? _data["textLiterals"] : <any>null;
        }
    }

    static fromJS(data: any): UpsertCertificateTypeTemplateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertCertificateTypeTemplateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name ? this.name.toJSON() : <any>null;
        if (Array.isArray(this.certificateTypeIds)) {
            data["certificateTypeIds"] = [];
            for (let item of this.certificateTypeIds)
                data["certificateTypeIds"].push(item);
        }
        data["description"] = this.description ? this.description.toJSON() : <any>null;
        data["templateVersion"] = this.templateVersion !== undefined ? this.templateVersion : <any>null;
        data["templateFile"] = this.templateFile ? this.templateFile.toJSON() : <any>null;
        data["textLiterals"] = this.textLiterals !== undefined ? this.textLiterals : <any>null;
        return data;
    }
}

export interface IUpsertCertificateTypeTemplateRequest {
    id?: string | null;
    name: MultilanguageModel;
    certificateTypeIds: string[];
    description: MultilanguageModel;
    templateVersion: string;
    templateFile?: TempFileModel | null;
    textLiterals?: string | null;
}

export class CertificateTypeLightModel implements ICertificateTypeLightModel {
    id!: string;
    name!: string;
    isActive!: boolean;

    constructor(data?: ICertificateTypeLightModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): CertificateTypeLightModel {
        data = typeof data === 'object' ? data : {};
        let result = new CertificateTypeLightModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data;
    }
}

export interface ICertificateTypeLightModel {
    id: string;
    name: string;
    isActive: boolean;
}

export class CertificateTypeModel implements ICertificateTypeModel {
    id!: string;
    name!: MultiLanguageString;
    legalName!: MultiLanguageString;
    certificateDocumentType!: CertificateDocumentTypeApiModel;
    prefix?: string | null;
    stcwRule?: StcwRuleModel | null;
    stcwIs?: StcwIsModel | null;
    position?: PositionApiModel | null;
    isOnlyForForeignCertificates!: boolean;
    emsaRestriction?: string | null;
    actOfLaw?: string | null;
    additionalInfo?: string | null;
    printTemplateUrl?: DownloadUrl | null;
    printTemplateName?: MultiLanguageString | null;
    allowEndorsement!: boolean;
    allowedEndorsementPositions!: PositionApiModel[];
    certificateTypeTemplateId?: string | null;
    printBackgroundTemplateId?: string | null;
    templateTextLiterals?: string | null;
    templateName?: string | null;

    constructor(data?: ICertificateTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.name = new MultiLanguageString();
            this.legalName = new MultiLanguageString();
            this.certificateDocumentType = new CertificateDocumentTypeApiModel();
            this.allowedEndorsementPositions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] ? MultiLanguageString.fromJS(_data["name"]) : new MultiLanguageString();
            this.legalName = _data["legalName"] ? MultiLanguageString.fromJS(_data["legalName"]) : new MultiLanguageString();
            this.certificateDocumentType = _data["certificateDocumentType"] ? CertificateDocumentTypeApiModel.fromJS(_data["certificateDocumentType"]) : new CertificateDocumentTypeApiModel();
            this.prefix = _data["prefix"] !== undefined ? _data["prefix"] : <any>null;
            this.stcwRule = _data["stcwRule"] ? StcwRuleModel.fromJS(_data["stcwRule"]) : <any>null;
            this.stcwIs = _data["stcwIs"] ? StcwIsModel.fromJS(_data["stcwIs"]) : <any>null;
            this.position = _data["position"] ? PositionApiModel.fromJS(_data["position"]) : <any>null;
            this.isOnlyForForeignCertificates = _data["isOnlyForForeignCertificates"] !== undefined ? _data["isOnlyForForeignCertificates"] : <any>null;
            this.emsaRestriction = _data["emsaRestriction"] !== undefined ? _data["emsaRestriction"] : <any>null;
            this.actOfLaw = _data["actOfLaw"] !== undefined ? _data["actOfLaw"] : <any>null;
            this.additionalInfo = _data["additionalInfo"] !== undefined ? _data["additionalInfo"] : <any>null;
            this.printTemplateUrl = _data["printTemplateUrl"] ? DownloadUrl.fromJS(_data["printTemplateUrl"]) : <any>null;
            this.printTemplateName = _data["printTemplateName"] ? MultiLanguageString.fromJS(_data["printTemplateName"]) : <any>null;
            this.allowEndorsement = _data["allowEndorsement"] !== undefined ? _data["allowEndorsement"] : <any>null;
            if (Array.isArray(_data["allowedEndorsementPositions"])) {
                this.allowedEndorsementPositions = [] as any;
                for (let item of _data["allowedEndorsementPositions"])
                    this.allowedEndorsementPositions!.push(PositionApiModel.fromJS(item));
            }
            else {
                this.allowedEndorsementPositions = <any>null;
            }
            this.certificateTypeTemplateId = _data["certificateTypeTemplateId"] !== undefined ? _data["certificateTypeTemplateId"] : <any>null;
            this.printBackgroundTemplateId = _data["printBackgroundTemplateId"] !== undefined ? _data["printBackgroundTemplateId"] : <any>null;
            this.templateTextLiterals = _data["templateTextLiterals"] !== undefined ? _data["templateTextLiterals"] : <any>null;
            this.templateName = _data["templateName"] !== undefined ? _data["templateName"] : <any>null;
        }
    }

    static fromJS(data: any): CertificateTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new CertificateTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name ? this.name.toJSON() : <any>null;
        data["legalName"] = this.legalName ? this.legalName.toJSON() : <any>null;
        data["certificateDocumentType"] = this.certificateDocumentType ? this.certificateDocumentType.toJSON() : <any>null;
        data["prefix"] = this.prefix !== undefined ? this.prefix : <any>null;
        data["stcwRule"] = this.stcwRule ? this.stcwRule.toJSON() : <any>null;
        data["stcwIs"] = this.stcwIs ? this.stcwIs.toJSON() : <any>null;
        data["position"] = this.position ? this.position.toJSON() : <any>null;
        data["isOnlyForForeignCertificates"] = this.isOnlyForForeignCertificates !== undefined ? this.isOnlyForForeignCertificates : <any>null;
        data["emsaRestriction"] = this.emsaRestriction !== undefined ? this.emsaRestriction : <any>null;
        data["actOfLaw"] = this.actOfLaw !== undefined ? this.actOfLaw : <any>null;
        data["additionalInfo"] = this.additionalInfo !== undefined ? this.additionalInfo : <any>null;
        data["printTemplateUrl"] = this.printTemplateUrl ? this.printTemplateUrl.toJSON() : <any>null;
        data["printTemplateName"] = this.printTemplateName ? this.printTemplateName.toJSON() : <any>null;
        data["allowEndorsement"] = this.allowEndorsement !== undefined ? this.allowEndorsement : <any>null;
        if (Array.isArray(this.allowedEndorsementPositions)) {
            data["allowedEndorsementPositions"] = [];
            for (let item of this.allowedEndorsementPositions)
                data["allowedEndorsementPositions"].push(item.toJSON());
        }
        data["certificateTypeTemplateId"] = this.certificateTypeTemplateId !== undefined ? this.certificateTypeTemplateId : <any>null;
        data["printBackgroundTemplateId"] = this.printBackgroundTemplateId !== undefined ? this.printBackgroundTemplateId : <any>null;
        data["templateTextLiterals"] = this.templateTextLiterals !== undefined ? this.templateTextLiterals : <any>null;
        data["templateName"] = this.templateName !== undefined ? this.templateName : <any>null;
        return data;
    }
}

export interface ICertificateTypeModel {
    id: string;
    name: MultiLanguageString;
    legalName: MultiLanguageString;
    certificateDocumentType: CertificateDocumentTypeApiModel;
    prefix?: string | null;
    stcwRule?: StcwRuleModel | null;
    stcwIs?: StcwIsModel | null;
    position?: PositionApiModel | null;
    isOnlyForForeignCertificates: boolean;
    emsaRestriction?: string | null;
    actOfLaw?: string | null;
    additionalInfo?: string | null;
    printTemplateUrl?: DownloadUrl | null;
    printTemplateName?: MultiLanguageString | null;
    allowEndorsement: boolean;
    allowedEndorsementPositions: PositionApiModel[];
    certificateTypeTemplateId?: string | null;
    printBackgroundTemplateId?: string | null;
    templateTextLiterals?: string | null;
    templateName?: string | null;
}

export class MultiLanguageString implements IMultiLanguageString {
    localized!: string;
    estonian!: string;
    english!: string;

    constructor(data?: IMultiLanguageString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.localized = _data["localized"] !== undefined ? _data["localized"] : <any>null;
            this.estonian = _data["estonian"] !== undefined ? _data["estonian"] : <any>null;
            this.english = _data["english"] !== undefined ? _data["english"] : <any>null;
        }
    }

    static fromJS(data: any): MultiLanguageString {
        data = typeof data === 'object' ? data : {};
        let result = new MultiLanguageString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["localized"] = this.localized !== undefined ? this.localized : <any>null;
        data["estonian"] = this.estonian !== undefined ? this.estonian : <any>null;
        data["english"] = this.english !== undefined ? this.english : <any>null;
        return data;
    }
}

export interface IMultiLanguageString {
    localized: string;
    estonian: string;
    english: string;
}

/** Pädevustunnistuse dokumendi liik */
export class CertificateDocumentTypeApiModel implements ICertificateDocumentTypeApiModel {
    code!: string;
    name!: string;

    constructor(data?: ICertificateDocumentTypeApiModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): CertificateDocumentTypeApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new CertificateDocumentTypeApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

/** Pädevustunnistuse dokumendi liik */
export interface ICertificateDocumentTypeApiModel {
    code: string;
    name: string;
}

export class StcwRuleModel implements IStcwRuleModel {
    id!: string;
    code!: string;
    name!: string;

    constructor(data?: IStcwRuleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): StcwRuleModel {
        data = typeof data === 'object' ? data : {};
        let result = new StcwRuleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface IStcwRuleModel {
    id: string;
    code: string;
    name: string;
}

export class StcwIsModel implements IStcwIsModel {
    value!: string;
    name!: string;

    constructor(data?: IStcwIsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): StcwIsModel {
        data = typeof data === 'object' ? data : {};
        let result = new StcwIsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface IStcwIsModel {
    value: string;
    name: string;
}

export class PositionApiModel implements IPositionApiModel {
    id!: string;
    name!: string;

    constructor(data?: IPositionApiModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): PositionApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new PositionApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface IPositionApiModel {
    id: string;
    name: string;
}

export class DownloadUrl implements IDownloadUrl {
    url!: string;

    constructor(data?: IDownloadUrl) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
        }
    }

    static fromJS(data: any): DownloadUrl {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadUrl();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url !== undefined ? this.url : <any>null;
        return data;
    }
}

export interface IDownloadUrl {
    url: string;
}

export class UpsertCertificateTypeRequest implements IUpsertCertificateTypeRequest {
    id?: string | null;
    nameEst?: string | null;
    nameEng?: string | null;
    legalNameEst?: string | null;
    legalNameEng?: string | null;
    prefix?: string | null;
    certificateDocumentTypeCode?: string | null;
    stcwRuleId?: string | null;
    stcwIs?: string | null;
    emsaRestriction?: string | null;
    additionalInfo?: string | null;
    actOfLaw?: string | null;
    hasPrintTemplate?: boolean | null;
    printTemplate?: PrintTemplatePostModel | null;
    positionId?: string | null;
    allowEndorsement?: boolean | null;
    allowedEndorsementPositionIds!: string[];
    onlyForForeignSeagoingCertificates?: boolean | null;
    certificateTypeTemplateId?: string | null;
    printBackgroundTemplateId?: string | null;
    templateTextLiterals?: string | null;

    constructor(data?: IUpsertCertificateTypeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.allowedEndorsementPositionIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nameEst = _data["nameEst"] !== undefined ? _data["nameEst"] : <any>null;
            this.nameEng = _data["nameEng"] !== undefined ? _data["nameEng"] : <any>null;
            this.legalNameEst = _data["legalNameEst"] !== undefined ? _data["legalNameEst"] : <any>null;
            this.legalNameEng = _data["legalNameEng"] !== undefined ? _data["legalNameEng"] : <any>null;
            this.prefix = _data["prefix"] !== undefined ? _data["prefix"] : <any>null;
            this.certificateDocumentTypeCode = _data["certificateDocumentTypeCode"] !== undefined ? _data["certificateDocumentTypeCode"] : <any>null;
            this.stcwRuleId = _data["stcwRuleId"] !== undefined ? _data["stcwRuleId"] : <any>null;
            this.stcwIs = _data["stcwIs"] !== undefined ? _data["stcwIs"] : <any>null;
            this.emsaRestriction = _data["emsaRestriction"] !== undefined ? _data["emsaRestriction"] : <any>null;
            this.additionalInfo = _data["additionalInfo"] !== undefined ? _data["additionalInfo"] : <any>null;
            this.actOfLaw = _data["actOfLaw"] !== undefined ? _data["actOfLaw"] : <any>null;
            this.hasPrintTemplate = _data["hasPrintTemplate"] !== undefined ? _data["hasPrintTemplate"] : <any>null;
            this.printTemplate = _data["printTemplate"] ? PrintTemplatePostModel.fromJS(_data["printTemplate"]) : <any>null;
            this.positionId = _data["positionId"] !== undefined ? _data["positionId"] : <any>null;
            this.allowEndorsement = _data["allowEndorsement"] !== undefined ? _data["allowEndorsement"] : <any>null;
            if (Array.isArray(_data["allowedEndorsementPositionIds"])) {
                this.allowedEndorsementPositionIds = [] as any;
                for (let item of _data["allowedEndorsementPositionIds"])
                    this.allowedEndorsementPositionIds!.push(item);
            }
            else {
                this.allowedEndorsementPositionIds = <any>null;
            }
            this.onlyForForeignSeagoingCertificates = _data["onlyForForeignSeagoingCertificates"] !== undefined ? _data["onlyForForeignSeagoingCertificates"] : <any>null;
            this.certificateTypeTemplateId = _data["certificateTypeTemplateId"] !== undefined ? _data["certificateTypeTemplateId"] : <any>null;
            this.printBackgroundTemplateId = _data["printBackgroundTemplateId"] !== undefined ? _data["printBackgroundTemplateId"] : <any>null;
            this.templateTextLiterals = _data["templateTextLiterals"] !== undefined ? _data["templateTextLiterals"] : <any>null;
        }
    }

    static fromJS(data: any): UpsertCertificateTypeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertCertificateTypeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nameEst"] = this.nameEst !== undefined ? this.nameEst : <any>null;
        data["nameEng"] = this.nameEng !== undefined ? this.nameEng : <any>null;
        data["legalNameEst"] = this.legalNameEst !== undefined ? this.legalNameEst : <any>null;
        data["legalNameEng"] = this.legalNameEng !== undefined ? this.legalNameEng : <any>null;
        data["prefix"] = this.prefix !== undefined ? this.prefix : <any>null;
        data["certificateDocumentTypeCode"] = this.certificateDocumentTypeCode !== undefined ? this.certificateDocumentTypeCode : <any>null;
        data["stcwRuleId"] = this.stcwRuleId !== undefined ? this.stcwRuleId : <any>null;
        data["stcwIs"] = this.stcwIs !== undefined ? this.stcwIs : <any>null;
        data["emsaRestriction"] = this.emsaRestriction !== undefined ? this.emsaRestriction : <any>null;
        data["additionalInfo"] = this.additionalInfo !== undefined ? this.additionalInfo : <any>null;
        data["actOfLaw"] = this.actOfLaw !== undefined ? this.actOfLaw : <any>null;
        data["hasPrintTemplate"] = this.hasPrintTemplate !== undefined ? this.hasPrintTemplate : <any>null;
        data["printTemplate"] = this.printTemplate ? this.printTemplate.toJSON() : <any>null;
        data["positionId"] = this.positionId !== undefined ? this.positionId : <any>null;
        data["allowEndorsement"] = this.allowEndorsement !== undefined ? this.allowEndorsement : <any>null;
        if (Array.isArray(this.allowedEndorsementPositionIds)) {
            data["allowedEndorsementPositionIds"] = [];
            for (let item of this.allowedEndorsementPositionIds)
                data["allowedEndorsementPositionIds"].push(item);
        }
        data["onlyForForeignSeagoingCertificates"] = this.onlyForForeignSeagoingCertificates !== undefined ? this.onlyForForeignSeagoingCertificates : <any>null;
        data["certificateTypeTemplateId"] = this.certificateTypeTemplateId !== undefined ? this.certificateTypeTemplateId : <any>null;
        data["printBackgroundTemplateId"] = this.printBackgroundTemplateId !== undefined ? this.printBackgroundTemplateId : <any>null;
        data["templateTextLiterals"] = this.templateTextLiterals !== undefined ? this.templateTextLiterals : <any>null;
        return data;
    }
}

export interface IUpsertCertificateTypeRequest {
    id?: string | null;
    nameEst?: string | null;
    nameEng?: string | null;
    legalNameEst?: string | null;
    legalNameEng?: string | null;
    prefix?: string | null;
    certificateDocumentTypeCode?: string | null;
    stcwRuleId?: string | null;
    stcwIs?: string | null;
    emsaRestriction?: string | null;
    additionalInfo?: string | null;
    actOfLaw?: string | null;
    hasPrintTemplate?: boolean | null;
    printTemplate?: PrintTemplatePostModel | null;
    positionId?: string | null;
    allowEndorsement?: boolean | null;
    allowedEndorsementPositionIds: string[];
    onlyForForeignSeagoingCertificates?: boolean | null;
    certificateTypeTemplateId?: string | null;
    printBackgroundTemplateId?: string | null;
    templateTextLiterals?: string | null;
}

export class PrintTemplatePostModel implements IPrintTemplatePostModel {
    nameEst?: string | null;
    nameEng?: string | null;
    file?: TempFileModel | null;

    constructor(data?: IPrintTemplatePostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nameEst = _data["nameEst"] !== undefined ? _data["nameEst"] : <any>null;
            this.nameEng = _data["nameEng"] !== undefined ? _data["nameEng"] : <any>null;
            this.file = _data["file"] ? TempFileModel.fromJS(_data["file"]) : <any>null;
        }
    }

    static fromJS(data: any): PrintTemplatePostModel {
        data = typeof data === 'object' ? data : {};
        let result = new PrintTemplatePostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nameEst"] = this.nameEst !== undefined ? this.nameEst : <any>null;
        data["nameEng"] = this.nameEng !== undefined ? this.nameEng : <any>null;
        data["file"] = this.file ? this.file.toJSON() : <any>null;
        return data;
    }
}

export interface IPrintTemplatePostModel {
    nameEst?: string | null;
    nameEng?: string | null;
    file?: TempFileModel | null;
}

export class AreaLightModel implements IAreaLightModel {
    id!: string;
    name!: string;
    isActive!: boolean;

    constructor(data?: IAreaLightModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): AreaLightModel {
        data = typeof data === 'object' ? data : {};
        let result = new AreaLightModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data;
    }
}

export interface IAreaLightModel {
    id: string;
    name: string;
    isActive: boolean;
}

export class CreateOrUpdateAreaRequest implements ICreateOrUpdateAreaRequest {
    nameEst?: string | null;
    nameEng?: string | null;
    typeKeys?: string[] | null;
    additionalInformation?: string | null;

    constructor(data?: ICreateOrUpdateAreaRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nameEst = _data["nameEst"] !== undefined ? _data["nameEst"] : <any>null;
            this.nameEng = _data["nameEng"] !== undefined ? _data["nameEng"] : <any>null;
            if (Array.isArray(_data["typeKeys"])) {
                this.typeKeys = [] as any;
                for (let item of _data["typeKeys"])
                    this.typeKeys!.push(item);
            }
            else {
                this.typeKeys = <any>null;
            }
            this.additionalInformation = _data["additionalInformation"] !== undefined ? _data["additionalInformation"] : <any>null;
        }
    }

    static fromJS(data: any): CreateOrUpdateAreaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrUpdateAreaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nameEst"] = this.nameEst !== undefined ? this.nameEst : <any>null;
        data["nameEng"] = this.nameEng !== undefined ? this.nameEng : <any>null;
        if (Array.isArray(this.typeKeys)) {
            data["typeKeys"] = [];
            for (let item of this.typeKeys)
                data["typeKeys"].push(item);
        }
        data["additionalInformation"] = this.additionalInformation !== undefined ? this.additionalInformation : <any>null;
        return data;
    }
}

export interface ICreateOrUpdateAreaRequest {
    nameEst?: string | null;
    nameEng?: string | null;
    typeKeys?: string[] | null;
    additionalInformation?: string | null;
}

export class AreaDetailsModel implements IAreaDetailsModel {
    id!: string;
    nameEst!: string;
    nameEng!: string;
    typeKeys!: string[];
    isActive!: boolean;
    additionalInformation?: string | null;

    constructor(data?: IAreaDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.typeKeys = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nameEst = _data["nameEst"] !== undefined ? _data["nameEst"] : <any>null;
            this.nameEng = _data["nameEng"] !== undefined ? _data["nameEng"] : <any>null;
            if (Array.isArray(_data["typeKeys"])) {
                this.typeKeys = [] as any;
                for (let item of _data["typeKeys"])
                    this.typeKeys!.push(item);
            }
            else {
                this.typeKeys = <any>null;
            }
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.additionalInformation = _data["additionalInformation"] !== undefined ? _data["additionalInformation"] : <any>null;
        }
    }

    static fromJS(data: any): AreaDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new AreaDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nameEst"] = this.nameEst !== undefined ? this.nameEst : <any>null;
        data["nameEng"] = this.nameEng !== undefined ? this.nameEng : <any>null;
        if (Array.isArray(this.typeKeys)) {
            data["typeKeys"] = [];
            for (let item of this.typeKeys)
                data["typeKeys"].push(item);
        }
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["additionalInformation"] = this.additionalInformation !== undefined ? this.additionalInformation : <any>null;
        return data;
    }
}

export interface IAreaDetailsModel {
    id: string;
    nameEst: string;
    nameEng: string;
    typeKeys: string[];
    isActive: boolean;
    additionalInformation?: string | null;
}

export class PagedResultOfTemplateLightModel implements IPagedResultOfTemplateLightModel {
    pageNumber!: number;
    pageSize!: number;
    pageResult!: TemplateLightModel[];
    totalCount!: number;

    constructor(data?: IPagedResultOfTemplateLightModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageResult = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"] !== undefined ? _data["pageNumber"] : <any>null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : <any>null;
            if (Array.isArray(_data["pageResult"])) {
                this.pageResult = [] as any;
                for (let item of _data["pageResult"])
                    this.pageResult!.push(TemplateLightModel.fromJS(item));
            }
            else {
                this.pageResult = <any>null;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): PagedResultOfTemplateLightModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfTemplateLightModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber !== undefined ? this.pageNumber : <any>null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
        if (Array.isArray(this.pageResult)) {
            data["pageResult"] = [];
            for (let item of this.pageResult)
                data["pageResult"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data;
    }
}

export interface IPagedResultOfTemplateLightModel {
    pageNumber: number;
    pageSize: number;
    pageResult: TemplateLightModel[];
    totalCount: number;
}

export class TemplateLightModel implements ITemplateLightModel {
    id!: string;
    name!: string;
    isActive?: boolean | null;

    constructor(data?: ITemplateLightModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): TemplateLightModel {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateLightModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data;
    }
}

export interface ITemplateLightModel {
    id: string;
    name: string;
    isActive?: boolean | null;
}

export enum SysAdminTemplatesSortField {
    NameAsc = "nameAsc",
    NameDesc = "nameDesc",
    ActiveAsc = "activeAsc",
    ActiveDesc = "activeDesc",
}

export class TemplateModel implements ITemplateModel {
    id!: string;
    name!: MultiLanguageString;
    templateJson!: TemplateJsonModel;

    constructor(data?: ITemplateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.name = new MultiLanguageString();
            this.templateJson = new TemplateJsonModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] ? MultiLanguageString.fromJS(_data["name"]) : new MultiLanguageString();
            this.templateJson = _data["templateJson"] ? TemplateJsonModel.fromJS(_data["templateJson"]) : new TemplateJsonModel();
        }
    }

    static fromJS(data: any): TemplateModel {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name ? this.name.toJSON() : <any>null;
        data["templateJson"] = this.templateJson ? this.templateJson.toJSON() : <any>null;
        return data;
    }
}

export interface ITemplateModel {
    id: string;
    name: MultiLanguageString;
    templateJson: TemplateJsonModel;
}

export class TemplateJsonModel implements ITemplateJsonModel {
    applicableFor!: any;
    requirementGroups!: any;
    requirements!: any;

    constructor(data?: ITemplateJsonModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicableFor = _data["applicableFor"] !== undefined ? _data["applicableFor"] : <any>null;
            this.requirementGroups = _data["requirementGroups"] !== undefined ? _data["requirementGroups"] : <any>null;
            this.requirements = _data["requirements"] !== undefined ? _data["requirements"] : <any>null;
        }
    }

    static fromJS(data: any): TemplateJsonModel {
        data = typeof data === 'object' ? data : {};
        let result = new TemplateJsonModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicableFor"] = this.applicableFor !== undefined ? this.applicableFor : <any>null;
        data["requirementGroups"] = this.requirementGroups !== undefined ? this.requirementGroups : <any>null;
        data["requirements"] = this.requirements !== undefined ? this.requirements : <any>null;
        return data;
    }
}

export interface ITemplateJsonModel {
    applicableFor: any;
    requirementGroups: any;
    requirements: any;
}

export class EndorsementPrintTemplateModel implements IEndorsementPrintTemplateModel {
    id?: string | null;
    printTemplate?: PrintTemplatePostModel | null;
    printTemplateToUpdate?: EndorsementPrintTemplateType | null;
    printTemplateUrl?: DownloadUrl | null;
    forInlandVesselPrintBackgroundTemplateId?: string | null;
    forForeignSeagoingShipPrintBackgroundTemplateId?: string | null;
    forForeignFastVesselPrintBackgroundTemplateId?: string | null;
    forSeagoingShipAndWithStcwRulePrintBackgroundTemplateId?: string | null;
    forSeagoingShipAndWithoutStcwRulePrintBackgroundTemplateId?: string | null;

    constructor(data?: IEndorsementPrintTemplateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.printTemplate = _data["printTemplate"] ? PrintTemplatePostModel.fromJS(_data["printTemplate"]) : <any>null;
            this.printTemplateToUpdate = _data["printTemplateToUpdate"] !== undefined ? _data["printTemplateToUpdate"] : <any>null;
            this.printTemplateUrl = _data["printTemplateUrl"] ? DownloadUrl.fromJS(_data["printTemplateUrl"]) : <any>null;
            this.forInlandVesselPrintBackgroundTemplateId = _data["forInlandVesselPrintBackgroundTemplateId"] !== undefined ? _data["forInlandVesselPrintBackgroundTemplateId"] : <any>null;
            this.forForeignSeagoingShipPrintBackgroundTemplateId = _data["forForeignSeagoingShipPrintBackgroundTemplateId"] !== undefined ? _data["forForeignSeagoingShipPrintBackgroundTemplateId"] : <any>null;
            this.forForeignFastVesselPrintBackgroundTemplateId = _data["forForeignFastVesselPrintBackgroundTemplateId"] !== undefined ? _data["forForeignFastVesselPrintBackgroundTemplateId"] : <any>null;
            this.forSeagoingShipAndWithStcwRulePrintBackgroundTemplateId = _data["forSeagoingShipAndWithStcwRulePrintBackgroundTemplateId"] !== undefined ? _data["forSeagoingShipAndWithStcwRulePrintBackgroundTemplateId"] : <any>null;
            this.forSeagoingShipAndWithoutStcwRulePrintBackgroundTemplateId = _data["forSeagoingShipAndWithoutStcwRulePrintBackgroundTemplateId"] !== undefined ? _data["forSeagoingShipAndWithoutStcwRulePrintBackgroundTemplateId"] : <any>null;
        }
    }

    static fromJS(data: any): EndorsementPrintTemplateModel {
        data = typeof data === 'object' ? data : {};
        let result = new EndorsementPrintTemplateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["printTemplate"] = this.printTemplate ? this.printTemplate.toJSON() : <any>null;
        data["printTemplateToUpdate"] = this.printTemplateToUpdate !== undefined ? this.printTemplateToUpdate : <any>null;
        data["printTemplateUrl"] = this.printTemplateUrl ? this.printTemplateUrl.toJSON() : <any>null;
        data["forInlandVesselPrintBackgroundTemplateId"] = this.forInlandVesselPrintBackgroundTemplateId !== undefined ? this.forInlandVesselPrintBackgroundTemplateId : <any>null;
        data["forForeignSeagoingShipPrintBackgroundTemplateId"] = this.forForeignSeagoingShipPrintBackgroundTemplateId !== undefined ? this.forForeignSeagoingShipPrintBackgroundTemplateId : <any>null;
        data["forForeignFastVesselPrintBackgroundTemplateId"] = this.forForeignFastVesselPrintBackgroundTemplateId !== undefined ? this.forForeignFastVesselPrintBackgroundTemplateId : <any>null;
        data["forSeagoingShipAndWithStcwRulePrintBackgroundTemplateId"] = this.forSeagoingShipAndWithStcwRulePrintBackgroundTemplateId !== undefined ? this.forSeagoingShipAndWithStcwRulePrintBackgroundTemplateId : <any>null;
        data["forSeagoingShipAndWithoutStcwRulePrintBackgroundTemplateId"] = this.forSeagoingShipAndWithoutStcwRulePrintBackgroundTemplateId !== undefined ? this.forSeagoingShipAndWithoutStcwRulePrintBackgroundTemplateId : <any>null;
        return data;
    }
}

export interface IEndorsementPrintTemplateModel {
    id?: string | null;
    printTemplate?: PrintTemplatePostModel | null;
    printTemplateToUpdate?: EndorsementPrintTemplateType | null;
    printTemplateUrl?: DownloadUrl | null;
    forInlandVesselPrintBackgroundTemplateId?: string | null;
    forForeignSeagoingShipPrintBackgroundTemplateId?: string | null;
    forForeignFastVesselPrintBackgroundTemplateId?: string | null;
    forSeagoingShipAndWithStcwRulePrintBackgroundTemplateId?: string | null;
    forSeagoingShipAndWithoutStcwRulePrintBackgroundTemplateId?: string | null;
}

export enum EndorsementPrintTemplateType {
    ForInlandVessel = "forInlandVessel",
    ForForeignSeagoingShip = "forForeignSeagoingShip",
    ForForeignFastVessel = "forForeignFastVessel",
    ForSeagoingShipAndWithStcwRule = "forSeagoingShipAndWithStcwRule",
    ForSeagoingShipAndWithoutStcwRule = "forSeagoingShipAndWithoutStcwRule",
}

export class AddTemplateRequest implements IAddTemplateRequest {
    id?: string | null;
    nameEst?: string | null;
    nameEng?: string | null;
    templateJson?: any | null;
    /** Does not actually create a new template if set to true. */
    dryRun!: boolean;
    update!: boolean;

    constructor(data?: IAddTemplateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.dryRun = false;
            this.update = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nameEst = _data["nameEst"] !== undefined ? _data["nameEst"] : <any>null;
            this.nameEng = _data["nameEng"] !== undefined ? _data["nameEng"] : <any>null;
            this.templateJson = _data["templateJson"] !== undefined ? _data["templateJson"] : <any>null;
            this.dryRun = _data["dryRun"] !== undefined ? _data["dryRun"] : false;
            this.update = _data["update"] !== undefined ? _data["update"] : false;
        }
    }

    static fromJS(data: any): AddTemplateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddTemplateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nameEst"] = this.nameEst !== undefined ? this.nameEst : <any>null;
        data["nameEng"] = this.nameEng !== undefined ? this.nameEng : <any>null;
        data["templateJson"] = this.templateJson !== undefined ? this.templateJson : <any>null;
        data["dryRun"] = this.dryRun !== undefined ? this.dryRun : <any>null;
        data["update"] = this.update !== undefined ? this.update : <any>null;
        return data;
    }
}

export interface IAddTemplateRequest {
    id?: string | null;
    nameEst?: string | null;
    nameEng?: string | null;
    templateJson?: any | null;
    /** Does not actually create a new template if set to true. */
    dryRun: boolean;
    update: boolean;
}

export class ShipInfoModel implements IShipInfoModel {
    id?: string | null;
    relatedId?: string | null;
    createdBy?: string | null;
    name?: string | null;
    type?: ShipTypeLocalizedModel | null;
    withImoNr!: boolean;
    imoNr?: string | null;
    /** In estonian: kutsung  */
    call?: string | null;
    /** In estonian: MMSI */
    mmsi?: string | null;
    country?: CountryLightModel | null;
    /** In estonian: kogumahutavus */
    grossTonnage?: number | null;
    /** In estonian: peamasinate võimsus (kW) */
    mainPower?: number | null;
    /** In estonian: elektri võimsus (kW) */
    electricPower?: number | null;
    /** In estonian: külmatootlikus (kW) */
    coldProduction?: number | null;
    lengthOverall?: number | null;
    additionalInfo?: string | null;

    constructor(data?: IShipInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.relatedId = _data["relatedId"] !== undefined ? _data["relatedId"] : <any>null;
            this.createdBy = _data["createdBy"] !== undefined ? _data["createdBy"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.type = _data["type"] ? ShipTypeLocalizedModel.fromJS(_data["type"]) : <any>null;
            this.withImoNr = _data["withImoNr"] !== undefined ? _data["withImoNr"] : <any>null;
            this.imoNr = _data["imoNr"] !== undefined ? _data["imoNr"] : <any>null;
            this.call = _data["call"] !== undefined ? _data["call"] : <any>null;
            this.mmsi = _data["mmsi"] !== undefined ? _data["mmsi"] : <any>null;
            this.country = _data["country"] ? CountryLightModel.fromJS(_data["country"]) : <any>null;
            this.grossTonnage = _data["grossTonnage"] !== undefined ? _data["grossTonnage"] : <any>null;
            this.mainPower = _data["mainPower"] !== undefined ? _data["mainPower"] : <any>null;
            this.electricPower = _data["electricPower"] !== undefined ? _data["electricPower"] : <any>null;
            this.coldProduction = _data["coldProduction"] !== undefined ? _data["coldProduction"] : <any>null;
            this.lengthOverall = _data["lengthOverall"] !== undefined ? _data["lengthOverall"] : <any>null;
            this.additionalInfo = _data["additionalInfo"] !== undefined ? _data["additionalInfo"] : <any>null;
        }
    }

    static fromJS(data: any): ShipInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShipInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["relatedId"] = this.relatedId !== undefined ? this.relatedId : <any>null;
        data["createdBy"] = this.createdBy !== undefined ? this.createdBy : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["type"] = this.type ? this.type.toJSON() : <any>null;
        data["withImoNr"] = this.withImoNr !== undefined ? this.withImoNr : <any>null;
        data["imoNr"] = this.imoNr !== undefined ? this.imoNr : <any>null;
        data["call"] = this.call !== undefined ? this.call : <any>null;
        data["mmsi"] = this.mmsi !== undefined ? this.mmsi : <any>null;
        data["country"] = this.country ? this.country.toJSON() : <any>null;
        data["grossTonnage"] = this.grossTonnage !== undefined ? this.grossTonnage : <any>null;
        data["mainPower"] = this.mainPower !== undefined ? this.mainPower : <any>null;
        data["electricPower"] = this.electricPower !== undefined ? this.electricPower : <any>null;
        data["coldProduction"] = this.coldProduction !== undefined ? this.coldProduction : <any>null;
        data["lengthOverall"] = this.lengthOverall !== undefined ? this.lengthOverall : <any>null;
        data["additionalInfo"] = this.additionalInfo !== undefined ? this.additionalInfo : <any>null;
        return data;
    }
}

export interface IShipInfoModel {
    id?: string | null;
    relatedId?: string | null;
    createdBy?: string | null;
    name?: string | null;
    type?: ShipTypeLocalizedModel | null;
    withImoNr: boolean;
    imoNr?: string | null;
    /** In estonian: kutsung  */
    call?: string | null;
    /** In estonian: MMSI */
    mmsi?: string | null;
    country?: CountryLightModel | null;
    /** In estonian: kogumahutavus */
    grossTonnage?: number | null;
    /** In estonian: peamasinate võimsus (kW) */
    mainPower?: number | null;
    /** In estonian: elektri võimsus (kW) */
    electricPower?: number | null;
    /** In estonian: külmatootlikus (kW) */
    coldProduction?: number | null;
    lengthOverall?: number | null;
    additionalInfo?: string | null;
}

export class ShipTypeLocalizedModel implements IShipTypeLocalizedModel {
    id!: string;
    name!: string;

    constructor(data?: IShipTypeLocalizedModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): ShipTypeLocalizedModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShipTypeLocalizedModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface IShipTypeLocalizedModel {
    id: string;
    name: string;
}

export class ShipOptionsResponse implements IShipOptionsResponse {
    ships!: ShipOption[];

    constructor(data?: IShipOptionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ships = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ships"])) {
                this.ships = [] as any;
                for (let item of _data["ships"])
                    this.ships!.push(ShipOption.fromJS(item));
            }
            else {
                this.ships = <any>null;
            }
        }
    }

    static fromJS(data: any): ShipOptionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ShipOptionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ships)) {
            data["ships"] = [];
            for (let item of this.ships)
                data["ships"].push(item.toJSON());
        }
        return data;
    }
}

export interface IShipOptionsResponse {
    ships: ShipOption[];
}

export class ShipOption implements IShipOption {
    value!: string;
    text!: string;

    constructor(data?: IShipOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.text = _data["text"] !== undefined ? _data["text"] : <any>null;
        }
    }

    static fromJS(data: any): ShipOption {
        data = typeof data === 'object' ? data : {};
        let result = new ShipOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["text"] = this.text !== undefined ? this.text : <any>null;
        return data;
    }
}

export interface IShipOption {
    value: string;
    text: string;
}

export class ShipTypesLocalizedResponse implements IShipTypesLocalizedResponse {
    shipTypesLocalized!: ShipTypeLocalizedModel[];

    constructor(data?: IShipTypesLocalizedResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.shipTypesLocalized = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["shipTypesLocalized"])) {
                this.shipTypesLocalized = [] as any;
                for (let item of _data["shipTypesLocalized"])
                    this.shipTypesLocalized!.push(ShipTypeLocalizedModel.fromJS(item));
            }
            else {
                this.shipTypesLocalized = <any>null;
            }
        }
    }

    static fromJS(data: any): ShipTypesLocalizedResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ShipTypesLocalizedResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.shipTypesLocalized)) {
            data["shipTypesLocalized"] = [];
            for (let item of this.shipTypesLocalized)
                data["shipTypesLocalized"].push(item.toJSON());
        }
        return data;
    }
}

export interface IShipTypesLocalizedResponse {
    shipTypesLocalized: ShipTypeLocalizedModel[];
}

export class ShipTypesResponse implements IShipTypesResponse {
    shipTypes!: ShipTypeModel[];

    constructor(data?: IShipTypesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.shipTypes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["shipTypes"])) {
                this.shipTypes = [] as any;
                for (let item of _data["shipTypes"])
                    this.shipTypes!.push(ShipTypeModel.fromJS(item));
            }
            else {
                this.shipTypes = <any>null;
            }
        }
    }

    static fromJS(data: any): ShipTypesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ShipTypesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.shipTypes)) {
            data["shipTypes"] = [];
            for (let item of this.shipTypes)
                data["shipTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IShipTypesResponse {
    shipTypes: ShipTypeModel[];
}

export class ShipTypeModel implements IShipTypeModel {
    id!: string;
    nameEst!: string;
    nameEng!: string;

    constructor(data?: IShipTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.nameEst = _data["nameEst"] !== undefined ? _data["nameEst"] : <any>null;
            this.nameEng = _data["nameEng"] !== undefined ? _data["nameEng"] : <any>null;
        }
    }

    static fromJS(data: any): ShipTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShipTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["nameEst"] = this.nameEst !== undefined ? this.nameEst : <any>null;
        data["nameEng"] = this.nameEng !== undefined ? this.nameEng : <any>null;
        return data;
    }
}

export interface IShipTypeModel {
    id: string;
    nameEst: string;
    nameEng: string;
}

export class AccessLinkAuthModel implements IAccessLinkAuthModel {
    tokenType!: string;
    token!: string;
    expiresAt!: number;

    constructor(data?: IAccessLinkAuthModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tokenType = _data["tokenType"] !== undefined ? _data["tokenType"] : <any>null;
            this.token = _data["token"] !== undefined ? _data["token"] : <any>null;
            this.expiresAt = _data["expiresAt"] !== undefined ? _data["expiresAt"] : <any>null;
        }
    }

    static fromJS(data: any): AccessLinkAuthModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccessLinkAuthModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tokenType"] = this.tokenType !== undefined ? this.tokenType : <any>null;
        data["token"] = this.token !== undefined ? this.token : <any>null;
        data["expiresAt"] = this.expiresAt !== undefined ? this.expiresAt : <any>null;
        return data;
    }
}

export interface IAccessLinkAuthModel {
    tokenType: string;
    token: string;
    expiresAt: number;
}

export class AccessLinkModel implements IAccessLinkModel {
    id!: string;
    validFrom!: Date;
    validUntil!: Date;
    sharedResources!: ShareableResourceModel[];
    isValid!: boolean;
    secret!: string;
    accessToken!: string;

    constructor(data?: IAccessLinkModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sharedResources = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>null;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : <any>null;
            if (Array.isArray(_data["sharedResources"])) {
                this.sharedResources = [] as any;
                for (let item of _data["sharedResources"])
                    this.sharedResources!.push(ShareableResourceModel.fromJS(item));
            }
            else {
                this.sharedResources = <any>null;
            }
            this.isValid = _data["isValid"] !== undefined ? _data["isValid"] : <any>null;
            this.secret = _data["secret"] !== undefined ? _data["secret"] : <any>null;
            this.accessToken = _data["accessToken"] !== undefined ? _data["accessToken"] : <any>null;
        }
    }

    static fromJS(data: any): AccessLinkModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccessLinkModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : <any>null;
        if (Array.isArray(this.sharedResources)) {
            data["sharedResources"] = [];
            for (let item of this.sharedResources)
                data["sharedResources"].push(item.toJSON());
        }
        data["isValid"] = this.isValid !== undefined ? this.isValid : <any>null;
        data["secret"] = this.secret !== undefined ? this.secret : <any>null;
        data["accessToken"] = this.accessToken !== undefined ? this.accessToken : <any>null;
        return data;
    }
}

export interface IAccessLinkModel {
    id: string;
    validFrom: Date;
    validUntil: Date;
    sharedResources: ShareableResourceModel[];
    isValid: boolean;
    secret: string;
    accessToken: string;
}

export class ShareableResourceModel implements IShareableResourceModel {
    value!: string;
    name!: string;

    constructor(data?: IShareableResourceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): ShareableResourceModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShareableResourceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface IShareableResourceModel {
    value: string;
    name: string;
}

export class CreateAccessLinkRequest implements ICreateAccessLinkRequest {
    validUntil?: Date | null;
    sharedResources!: string[];

    constructor(data?: ICreateAccessLinkRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.sharedResources = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : <any>null;
            if (Array.isArray(_data["sharedResources"])) {
                this.sharedResources = [] as any;
                for (let item of _data["sharedResources"])
                    this.sharedResources!.push(item);
            }
            else {
                this.sharedResources = <any>null;
            }
        }
    }

    static fromJS(data: any): CreateAccessLinkRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAccessLinkRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : <any>null;
        if (Array.isArray(this.sharedResources)) {
            data["sharedResources"] = [];
            for (let item of this.sharedResources)
                data["sharedResources"].push(item);
        }
        return data;
    }
}

export interface ICreateAccessLinkRequest {
    validUntil?: Date | null;
    sharedResources: string[];
}

export class PracticeViewModel implements IPracticeViewModel {
    id!: string;
    organizationName?: string | null;
    type!: PracticeType;
    kind!: PracticeKind;
    positionName?: string | null;
    hasCargoOperationsOrHarbourVisits!: boolean;
    startedOn!: Date;
    endedOn!: Date;
    issuedOn!: Date;
    status!: ValidityStatus;
    practicePeriods!: PracticePeriod[];
    seafaringDetails?: SeafaringProperties | null;
    isDeleted!: boolean;
    pilotageArea?: string | null;
    harbourName?: string | null;
    pilotageShip?: ShipInfoModel | null;
    instructor?: InstructorInfo | null;
    inOutFlag?: boolean | null;
    pilotageType?: PilotageType | null;
    inlandVesselShip?: ShipInfoModel | null;
    harbourVisitsCount!: number;
    vtsCenterNotes?: string | null;

    constructor(data?: IPracticeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.practicePeriods = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.organizationName = _data["organizationName"] !== undefined ? _data["organizationName"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.kind = _data["kind"] !== undefined ? _data["kind"] : <any>null;
            this.positionName = _data["positionName"] !== undefined ? _data["positionName"] : <any>null;
            this.hasCargoOperationsOrHarbourVisits = _data["hasCargoOperationsOrHarbourVisits"] !== undefined ? _data["hasCargoOperationsOrHarbourVisits"] : <any>null;
            this.startedOn = _data["startedOn"] ? new Date(_data["startedOn"].toString()) : <any>null;
            this.endedOn = _data["endedOn"] ? new Date(_data["endedOn"].toString()) : <any>null;
            this.issuedOn = _data["issuedOn"] ? new Date(_data["issuedOn"].toString()) : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            if (Array.isArray(_data["practicePeriods"])) {
                this.practicePeriods = [] as any;
                for (let item of _data["practicePeriods"])
                    this.practicePeriods!.push(PracticePeriod.fromJS(item));
            }
            else {
                this.practicePeriods = <any>null;
            }
            this.seafaringDetails = _data["seafaringDetails"] ? SeafaringProperties.fromJS(_data["seafaringDetails"]) : <any>null;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : <any>null;
            this.pilotageArea = _data["pilotageArea"] !== undefined ? _data["pilotageArea"] : <any>null;
            this.harbourName = _data["harbourName"] !== undefined ? _data["harbourName"] : <any>null;
            this.pilotageShip = _data["pilotageShip"] ? ShipInfoModel.fromJS(_data["pilotageShip"]) : <any>null;
            this.instructor = _data["instructor"] ? InstructorInfo.fromJS(_data["instructor"]) : <any>null;
            this.inOutFlag = _data["inOutFlag"] !== undefined ? _data["inOutFlag"] : <any>null;
            this.pilotageType = _data["pilotageType"] !== undefined ? _data["pilotageType"] : <any>null;
            this.inlandVesselShip = _data["inlandVesselShip"] ? ShipInfoModel.fromJS(_data["inlandVesselShip"]) : <any>null;
            this.harbourVisitsCount = _data["harbourVisitsCount"] !== undefined ? _data["harbourVisitsCount"] : <any>null;
            this.vtsCenterNotes = _data["vtsCenterNotes"] !== undefined ? _data["vtsCenterNotes"] : <any>null;
        }
    }

    static fromJS(data: any): PracticeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PracticeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["organizationName"] = this.organizationName !== undefined ? this.organizationName : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["kind"] = this.kind !== undefined ? this.kind : <any>null;
        data["positionName"] = this.positionName !== undefined ? this.positionName : <any>null;
        data["hasCargoOperationsOrHarbourVisits"] = this.hasCargoOperationsOrHarbourVisits !== undefined ? this.hasCargoOperationsOrHarbourVisits : <any>null;
        data["startedOn"] = this.startedOn ? this.startedOn.toISOString() : <any>null;
        data["endedOn"] = this.endedOn ? this.endedOn.toISOString() : <any>null;
        data["issuedOn"] = this.issuedOn ? this.issuedOn.toISOString() : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        if (Array.isArray(this.practicePeriods)) {
            data["practicePeriods"] = [];
            for (let item of this.practicePeriods)
                data["practicePeriods"].push(item.toJSON());
        }
        data["seafaringDetails"] = this.seafaringDetails ? this.seafaringDetails.toJSON() : <any>null;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : <any>null;
        data["pilotageArea"] = this.pilotageArea !== undefined ? this.pilotageArea : <any>null;
        data["harbourName"] = this.harbourName !== undefined ? this.harbourName : <any>null;
        data["pilotageShip"] = this.pilotageShip ? this.pilotageShip.toJSON() : <any>null;
        data["instructor"] = this.instructor ? this.instructor.toJSON() : <any>null;
        data["inOutFlag"] = this.inOutFlag !== undefined ? this.inOutFlag : <any>null;
        data["pilotageType"] = this.pilotageType !== undefined ? this.pilotageType : <any>null;
        data["inlandVesselShip"] = this.inlandVesselShip ? this.inlandVesselShip.toJSON() : <any>null;
        data["harbourVisitsCount"] = this.harbourVisitsCount !== undefined ? this.harbourVisitsCount : <any>null;
        data["vtsCenterNotes"] = this.vtsCenterNotes !== undefined ? this.vtsCenterNotes : <any>null;
        return data;
    }
}

export interface IPracticeViewModel {
    id: string;
    organizationName?: string | null;
    type: PracticeType;
    kind: PracticeKind;
    positionName?: string | null;
    hasCargoOperationsOrHarbourVisits: boolean;
    startedOn: Date;
    endedOn: Date;
    issuedOn: Date;
    status: ValidityStatus;
    practicePeriods: PracticePeriod[];
    seafaringDetails?: SeafaringProperties | null;
    isDeleted: boolean;
    pilotageArea?: string | null;
    harbourName?: string | null;
    pilotageShip?: ShipInfoModel | null;
    instructor?: InstructorInfo | null;
    inOutFlag?: boolean | null;
    pilotageType?: PilotageType | null;
    inlandVesselShip?: ShipInfoModel | null;
    harbourVisitsCount: number;
    vtsCenterNotes?: string | null;
}

export enum PracticeType {
    ShipRepair = "shipRepair",
    Seafaring = "seafaring",
    InlandVessel = "inlandVessel",
    Pilotage = "pilotage",
    VtsCenter = "vtsCenter",
}

export enum PracticeKind {
    Educational = "educational",
    Work = "work",
}

export enum ValidityStatus {
    Unchecked = "unchecked",
    Valid = "valid",
    Invalid = "invalid",
}

export class PracticePeriod implements IPracticePeriod {
    startedOn?: Date | null;
    endedOn?: Date | null;
    durationInDays?: number | null;
    navigationalWatchDays?: number | null;
    engineRoomWatchDays?: number | null;
    voyageCount?: number | null;
    notes?: string | null;
    inOutFlag?: boolean | null;
    instructorId?: string | null;
    instructorFullName?: string | null;
    instructorPersonalCode?: string | null;

    constructor(data?: IPracticePeriod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startedOn = _data["startedOn"] ? new Date(_data["startedOn"].toString()) : <any>null;
            this.endedOn = _data["endedOn"] ? new Date(_data["endedOn"].toString()) : <any>null;
            this.durationInDays = _data["durationInDays"] !== undefined ? _data["durationInDays"] : <any>null;
            this.navigationalWatchDays = _data["navigationalWatchDays"] !== undefined ? _data["navigationalWatchDays"] : <any>null;
            this.engineRoomWatchDays = _data["engineRoomWatchDays"] !== undefined ? _data["engineRoomWatchDays"] : <any>null;
            this.voyageCount = _data["voyageCount"] !== undefined ? _data["voyageCount"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
            this.inOutFlag = _data["inOutFlag"] !== undefined ? _data["inOutFlag"] : <any>null;
            this.instructorId = _data["instructorId"] !== undefined ? _data["instructorId"] : <any>null;
            this.instructorFullName = _data["instructorFullName"] !== undefined ? _data["instructorFullName"] : <any>null;
            this.instructorPersonalCode = _data["instructorPersonalCode"] !== undefined ? _data["instructorPersonalCode"] : <any>null;
        }
    }

    static fromJS(data: any): PracticePeriod {
        data = typeof data === 'object' ? data : {};
        let result = new PracticePeriod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startedOn"] = this.startedOn ? this.startedOn.toISOString() : <any>null;
        data["endedOn"] = this.endedOn ? this.endedOn.toISOString() : <any>null;
        data["durationInDays"] = this.durationInDays !== undefined ? this.durationInDays : <any>null;
        data["navigationalWatchDays"] = this.navigationalWatchDays !== undefined ? this.navigationalWatchDays : <any>null;
        data["engineRoomWatchDays"] = this.engineRoomWatchDays !== undefined ? this.engineRoomWatchDays : <any>null;
        data["voyageCount"] = this.voyageCount !== undefined ? this.voyageCount : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        data["inOutFlag"] = this.inOutFlag !== undefined ? this.inOutFlag : <any>null;
        data["instructorId"] = this.instructorId !== undefined ? this.instructorId : <any>null;
        data["instructorFullName"] = this.instructorFullName !== undefined ? this.instructorFullName : <any>null;
        data["instructorPersonalCode"] = this.instructorPersonalCode !== undefined ? this.instructorPersonalCode : <any>null;
        return data;
    }
}

export interface IPracticePeriod {
    startedOn?: Date | null;
    endedOn?: Date | null;
    durationInDays?: number | null;
    navigationalWatchDays?: number | null;
    engineRoomWatchDays?: number | null;
    voyageCount?: number | null;
    notes?: string | null;
    inOutFlag?: boolean | null;
    instructorId?: string | null;
    instructorFullName?: string | null;
    instructorPersonalCode?: string | null;
}

export class SeafaringProperties implements ISeafaringProperties {
    cargoOperationsCount!: number;
    harbourVisitsCount!: number;
    areaId!: AreaId;
    shipName!: string;
    imoNr?: string | null;
    shipGrossTonnage!: number;
    shipMainPower!: number;
    shipColdProduction?: number | null;
    shipTypeId!: ShipTypeId;

    constructor(data?: ISeafaringProperties) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.areaId = new AreaId();
            this.shipTypeId = new ShipTypeId();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cargoOperationsCount = _data["cargoOperationsCount"] !== undefined ? _data["cargoOperationsCount"] : <any>null;
            this.harbourVisitsCount = _data["harbourVisitsCount"] !== undefined ? _data["harbourVisitsCount"] : <any>null;
            this.areaId = _data["areaId"] ? AreaId.fromJS(_data["areaId"]) : new AreaId();
            this.shipName = _data["shipName"] !== undefined ? _data["shipName"] : <any>null;
            this.imoNr = _data["imoNr"] !== undefined ? _data["imoNr"] : <any>null;
            this.shipGrossTonnage = _data["shipGrossTonnage"] !== undefined ? _data["shipGrossTonnage"] : <any>null;
            this.shipMainPower = _data["shipMainPower"] !== undefined ? _data["shipMainPower"] : <any>null;
            this.shipColdProduction = _data["shipColdProduction"] !== undefined ? _data["shipColdProduction"] : <any>null;
            this.shipTypeId = _data["shipTypeId"] ? ShipTypeId.fromJS(_data["shipTypeId"]) : new ShipTypeId();
        }
    }

    static fromJS(data: any): SeafaringProperties {
        data = typeof data === 'object' ? data : {};
        let result = new SeafaringProperties();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cargoOperationsCount"] = this.cargoOperationsCount !== undefined ? this.cargoOperationsCount : <any>null;
        data["harbourVisitsCount"] = this.harbourVisitsCount !== undefined ? this.harbourVisitsCount : <any>null;
        data["areaId"] = this.areaId ? this.areaId.toJSON() : <any>null;
        data["shipName"] = this.shipName !== undefined ? this.shipName : <any>null;
        data["imoNr"] = this.imoNr !== undefined ? this.imoNr : <any>null;
        data["shipGrossTonnage"] = this.shipGrossTonnage !== undefined ? this.shipGrossTonnage : <any>null;
        data["shipMainPower"] = this.shipMainPower !== undefined ? this.shipMainPower : <any>null;
        data["shipColdProduction"] = this.shipColdProduction !== undefined ? this.shipColdProduction : <any>null;
        data["shipTypeId"] = this.shipTypeId ? this.shipTypeId.toJSON() : <any>null;
        return data;
    }
}

export interface ISeafaringProperties {
    cargoOperationsCount: number;
    harbourVisitsCount: number;
    areaId: AreaId;
    shipName: string;
    imoNr?: string | null;
    shipGrossTonnage: number;
    shipMainPower: number;
    shipColdProduction?: number | null;
    shipTypeId: ShipTypeId;
}

export abstract class IdentityOfAreaId extends SingleValueObjectOfGuid implements IIdentityOfAreaId {

    constructor(data?: IIdentityOfAreaId) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): IdentityOfAreaId {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IdentityOfAreaId' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IIdentityOfAreaId extends ISingleValueObjectOfGuid {
}

export class AreaId extends IdentityOfAreaId implements IAreaId {

    constructor(data?: IAreaId) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): AreaId {
        data = typeof data === 'object' ? data : {};
        let result = new AreaId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IAreaId extends IIdentityOfAreaId {
}

export abstract class IdentityOfShipTypeId extends SingleValueObjectOfGuid implements IIdentityOfShipTypeId {

    constructor(data?: IIdentityOfShipTypeId) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): IdentityOfShipTypeId {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IdentityOfShipTypeId' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IIdentityOfShipTypeId extends ISingleValueObjectOfGuid {
}

export class ShipTypeId extends IdentityOfShipTypeId implements IShipTypeId {

    constructor(data?: IShipTypeId) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ShipTypeId {
        data = typeof data === 'object' ? data : {};
        let result = new ShipTypeId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IShipTypeId extends IIdentityOfShipTypeId {
}

export class InstructorInfo implements IInstructorInfo {
    id?: SeafarerId | null;
    fullName?: string | null;
    personalCode?: string | null;

    constructor(data?: IInstructorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] ? SeafarerId.fromJS(_data["id"]) : <any>null;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
            this.personalCode = _data["personalCode"] !== undefined ? _data["personalCode"] : <any>null;
        }
    }

    static fromJS(data: any): InstructorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new InstructorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        data["personalCode"] = this.personalCode !== undefined ? this.personalCode : <any>null;
        return data;
    }
}

export interface IInstructorInfo {
    id?: SeafarerId | null;
    fullName?: string | null;
    personalCode?: string | null;
}

export abstract class IdentityOfSeafarerId extends SingleValueObjectOfGuid implements IIdentityOfSeafarerId {

    constructor(data?: IIdentityOfSeafarerId) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): IdentityOfSeafarerId {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IdentityOfSeafarerId' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IIdentityOfSeafarerId extends ISingleValueObjectOfGuid {
}

export class SeafarerId extends IdentityOfSeafarerId implements ISeafarerId {

    constructor(data?: ISeafarerId) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SeafarerId {
        data = typeof data === 'object' ? data : {};
        let result = new SeafarerId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISeafarerId extends IIdentityOfSeafarerId {
}

export enum PilotageType {
    Pilotage = "pilotage",
    PracticalPilotage = "practicalPilotage",
}

export class PagedResultOfOfficialPracticeLightViewModel implements IPagedResultOfOfficialPracticeLightViewModel {
    pageNumber!: number;
    pageSize!: number;
    pageResult!: OfficialPracticeLightViewModel[];
    totalCount!: number;

    constructor(data?: IPagedResultOfOfficialPracticeLightViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageResult = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"] !== undefined ? _data["pageNumber"] : <any>null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : <any>null;
            if (Array.isArray(_data["pageResult"])) {
                this.pageResult = [] as any;
                for (let item of _data["pageResult"])
                    this.pageResult!.push(OfficialPracticeLightViewModel.fromJS(item));
            }
            else {
                this.pageResult = <any>null;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): PagedResultOfOfficialPracticeLightViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfOfficialPracticeLightViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber !== undefined ? this.pageNumber : <any>null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
        if (Array.isArray(this.pageResult)) {
            data["pageResult"] = [];
            for (let item of this.pageResult)
                data["pageResult"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data;
    }
}

export interface IPagedResultOfOfficialPracticeLightViewModel {
    pageNumber: number;
    pageSize: number;
    pageResult: OfficialPracticeLightViewModel[];
    totalCount: number;
}

export class OfficialPracticeLightViewModel implements IOfficialPracticeLightViewModel {
    id!: string;
    positionName!: string;
    seafarerName!: string;
    seafarerId!: string;
    birthDate?: Date | null;
    issuedAt!: Date;
    createdAt?: Date | null;
    status!: ValidityStatus;
    type!: PracticeType;
    kind?: PracticeKind | null;

    constructor(data?: IOfficialPracticeLightViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.positionName = _data["positionName"] !== undefined ? _data["positionName"] : <any>null;
            this.seafarerName = _data["seafarerName"] !== undefined ? _data["seafarerName"] : <any>null;
            this.seafarerId = _data["seafarerId"] !== undefined ? _data["seafarerId"] : <any>null;
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>null;
            this.issuedAt = _data["issuedAt"] ? new Date(_data["issuedAt"].toString()) : <any>null;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.kind = _data["kind"] !== undefined ? _data["kind"] : <any>null;
        }
    }

    static fromJS(data: any): OfficialPracticeLightViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OfficialPracticeLightViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["positionName"] = this.positionName !== undefined ? this.positionName : <any>null;
        data["seafarerName"] = this.seafarerName !== undefined ? this.seafarerName : <any>null;
        data["seafarerId"] = this.seafarerId !== undefined ? this.seafarerId : <any>null;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>null;
        data["issuedAt"] = this.issuedAt ? this.issuedAt.toISOString() : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["kind"] = this.kind !== undefined ? this.kind : <any>null;
        return data;
    }
}

export interface IOfficialPracticeLightViewModel {
    id: string;
    positionName: string;
    seafarerName: string;
    seafarerId: string;
    birthDate?: Date | null;
    issuedAt: Date;
    createdAt?: Date | null;
    status: ValidityStatus;
    type: PracticeType;
    kind?: PracticeKind | null;
}

export enum SortOrder {
    DESC = "desc",
    ASC = "asc",
}

export class FindOverlappingPracticesRequest implements IFindOverlappingPracticesRequest {
    positionId!: string;
    practiceType!: PracticeType;
    organizationId?: string | null;
    practicePeriod!: PracticePeriod;

    constructor(data?: IFindOverlappingPracticesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.practicePeriod = new PracticePeriod();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.positionId = _data["positionId"] !== undefined ? _data["positionId"] : <any>null;
            this.practiceType = _data["practiceType"] !== undefined ? _data["practiceType"] : <any>null;
            this.organizationId = _data["organizationId"] !== undefined ? _data["organizationId"] : <any>null;
            this.practicePeriod = _data["practicePeriod"] ? PracticePeriod.fromJS(_data["practicePeriod"]) : new PracticePeriod();
        }
    }

    static fromJS(data: any): FindOverlappingPracticesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FindOverlappingPracticesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["positionId"] = this.positionId !== undefined ? this.positionId : <any>null;
        data["practiceType"] = this.practiceType !== undefined ? this.practiceType : <any>null;
        data["organizationId"] = this.organizationId !== undefined ? this.organizationId : <any>null;
        data["practicePeriod"] = this.practicePeriod ? this.practicePeriod.toJSON() : <any>null;
        return data;
    }
}

export interface IFindOverlappingPracticesRequest {
    positionId: string;
    practiceType: PracticeType;
    organizationId?: string | null;
    practicePeriod: PracticePeriod;
}

export class AddPracticeResponse implements IAddPracticeResponse {
    id!: string;

    constructor(data?: IAddPracticeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): AddPracticeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddPracticeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }
}

export interface IAddPracticeResponse {
    id: string;
}

export abstract class AddPracticeRequest implements IAddPracticeRequest {
    positionId?: string | null;
    kind?: PracticeKind | null;
    issuedOn?: Date | null;
    confirmerId?: string | null;
    confirmer?: string | null;
    additionalNotes?: string | null;
    practicePeriods!: PracticePeriod[];
    addedFiles!: TempFileModel[];
    removedFiles!: FileModel[];
    existingFiles!: FileModel[];
    organizationId?: string | null;
    version?: number | null;
    comment?: string | null;
    updatedAt?: Date | null;

    protected _discriminator: string;

    constructor(data?: IAddPracticeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.practicePeriods = [];
            this.addedFiles = [];
            this.removedFiles = [];
            this.existingFiles = [];
        }
        this._discriminator = "AddPracticeRequest";
    }

    init(_data?: any) {
        if (_data) {
            this.positionId = _data["positionId"] !== undefined ? _data["positionId"] : <any>null;
            this.kind = _data["kind"] !== undefined ? _data["kind"] : <any>null;
            this.issuedOn = _data["issuedOn"] ? new Date(_data["issuedOn"].toString()) : <any>null;
            this.confirmerId = _data["confirmerId"] !== undefined ? _data["confirmerId"] : <any>null;
            this.confirmer = _data["confirmer"] !== undefined ? _data["confirmer"] : <any>null;
            this.additionalNotes = _data["additionalNotes"] !== undefined ? _data["additionalNotes"] : <any>null;
            if (Array.isArray(_data["practicePeriods"])) {
                this.practicePeriods = [] as any;
                for (let item of _data["practicePeriods"])
                    this.practicePeriods!.push(PracticePeriod.fromJS(item));
            }
            else {
                this.practicePeriods = <any>null;
            }
            if (Array.isArray(_data["addedFiles"])) {
                this.addedFiles = [] as any;
                for (let item of _data["addedFiles"])
                    this.addedFiles!.push(TempFileModel.fromJS(item));
            }
            else {
                this.addedFiles = <any>null;
            }
            if (Array.isArray(_data["removedFiles"])) {
                this.removedFiles = [] as any;
                for (let item of _data["removedFiles"])
                    this.removedFiles!.push(FileModel.fromJS(item));
            }
            else {
                this.removedFiles = <any>null;
            }
            if (Array.isArray(_data["existingFiles"])) {
                this.existingFiles = [] as any;
                for (let item of _data["existingFiles"])
                    this.existingFiles!.push(FileModel.fromJS(item));
            }
            else {
                this.existingFiles = <any>null;
            }
            this.organizationId = _data["organizationId"] !== undefined ? _data["organizationId"] : <any>null;
            this.version = _data["version"] !== undefined ? _data["version"] : <any>null;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): AddPracticeRequest {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "AddShipRepairPracticeRequest") {
            let result = new AddShipRepairPracticeRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "AddSeafaringPracticeRequest") {
            let result = new AddSeafaringPracticeRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "AddInlandVesselPracticeRequest") {
            let result = new AddInlandVesselPracticeRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "AddPilotagePracticeRequest") {
            let result = new AddPilotagePracticeRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "AddVtsCenterPracticeRequest") {
            let result = new AddVtsCenterPracticeRequest();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'AddPracticeRequest' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        data["positionId"] = this.positionId !== undefined ? this.positionId : <any>null;
        data["kind"] = this.kind !== undefined ? this.kind : <any>null;
        data["issuedOn"] = this.issuedOn ? this.issuedOn.toISOString() : <any>null;
        data["confirmerId"] = this.confirmerId !== undefined ? this.confirmerId : <any>null;
        data["confirmer"] = this.confirmer !== undefined ? this.confirmer : <any>null;
        data["additionalNotes"] = this.additionalNotes !== undefined ? this.additionalNotes : <any>null;
        if (Array.isArray(this.practicePeriods)) {
            data["practicePeriods"] = [];
            for (let item of this.practicePeriods)
                data["practicePeriods"].push(item.toJSON());
        }
        if (Array.isArray(this.addedFiles)) {
            data["addedFiles"] = [];
            for (let item of this.addedFiles)
                data["addedFiles"].push(item.toJSON());
        }
        if (Array.isArray(this.removedFiles)) {
            data["removedFiles"] = [];
            for (let item of this.removedFiles)
                data["removedFiles"].push(item.toJSON());
        }
        if (Array.isArray(this.existingFiles)) {
            data["existingFiles"] = [];
            for (let item of this.existingFiles)
                data["existingFiles"].push(item.toJSON());
        }
        data["organizationId"] = this.organizationId !== undefined ? this.organizationId : <any>null;
        data["version"] = this.version !== undefined ? this.version : <any>null;
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>null;
        return data;
    }
}

export interface IAddPracticeRequest {
    positionId?: string | null;
    kind?: PracticeKind | null;
    issuedOn?: Date | null;
    confirmerId?: string | null;
    confirmer?: string | null;
    additionalNotes?: string | null;
    practicePeriods: PracticePeriod[];
    addedFiles: TempFileModel[];
    removedFiles: FileModel[];
    existingFiles: FileModel[];
    organizationId?: string | null;
    version?: number | null;
    comment?: string | null;
    updatedAt?: Date | null;
}

export class AddShipRepairPracticeRequest extends AddPracticeRequest implements IAddShipRepairPracticeRequest {

    constructor(data?: IAddShipRepairPracticeRequest) {
        super(data);
        this._discriminator = "AddShipRepairPracticeRequest";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): AddShipRepairPracticeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddShipRepairPracticeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IAddShipRepairPracticeRequest extends IAddPracticeRequest {
}

export class AddSeafaringPracticeRequest extends AddPracticeRequest implements IAddSeafaringPracticeRequest {
    /** In estonian: sõidupiirkond */
    areaId?: string | null;
    /** In estonian: praktikatõendiga või ilma */
    withPracticeCertificate?: boolean | null;
    /** In estonian: tankeri lastioperatsioonidega või ilma */
    withCargoOperations?: boolean | null;
    /** In estonian: sadamakülastustega või ilma */
    withHarbourVisits?: boolean | null;
    /** In estonian: tankeri lastioperatsioonid */
    cargoOperations!: CargoOperationModel[];
    /** In estonian: Sadamakülastused */
    harbourVisits!: HarbourVisitModel[];
    ship?: ShipInfoModel | null;
    organizationName?: string | null;

    constructor(data?: IAddSeafaringPracticeRequest) {
        super(data);
        if (!data) {
            this.cargoOperations = [];
            this.harbourVisits = [];
        }
        this._discriminator = "AddSeafaringPracticeRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.areaId = _data["areaId"] !== undefined ? _data["areaId"] : <any>null;
            this.withPracticeCertificate = _data["withPracticeCertificate"] !== undefined ? _data["withPracticeCertificate"] : <any>null;
            this.withCargoOperations = _data["withCargoOperations"] !== undefined ? _data["withCargoOperations"] : <any>null;
            this.withHarbourVisits = _data["withHarbourVisits"] !== undefined ? _data["withHarbourVisits"] : <any>null;
            if (Array.isArray(_data["cargoOperations"])) {
                this.cargoOperations = [] as any;
                for (let item of _data["cargoOperations"])
                    this.cargoOperations!.push(CargoOperationModel.fromJS(item));
            }
            else {
                this.cargoOperations = <any>null;
            }
            if (Array.isArray(_data["harbourVisits"])) {
                this.harbourVisits = [] as any;
                for (let item of _data["harbourVisits"])
                    this.harbourVisits!.push(HarbourVisitModel.fromJS(item));
            }
            else {
                this.harbourVisits = <any>null;
            }
            this.ship = _data["ship"] ? ShipInfoModel.fromJS(_data["ship"]) : <any>null;
            this.organizationName = _data["organizationName"] !== undefined ? _data["organizationName"] : <any>null;
        }
    }

    static fromJS(data: any): AddSeafaringPracticeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddSeafaringPracticeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaId"] = this.areaId !== undefined ? this.areaId : <any>null;
        data["withPracticeCertificate"] = this.withPracticeCertificate !== undefined ? this.withPracticeCertificate : <any>null;
        data["withCargoOperations"] = this.withCargoOperations !== undefined ? this.withCargoOperations : <any>null;
        data["withHarbourVisits"] = this.withHarbourVisits !== undefined ? this.withHarbourVisits : <any>null;
        if (Array.isArray(this.cargoOperations)) {
            data["cargoOperations"] = [];
            for (let item of this.cargoOperations)
                data["cargoOperations"].push(item.toJSON());
        }
        if (Array.isArray(this.harbourVisits)) {
            data["harbourVisits"] = [];
            for (let item of this.harbourVisits)
                data["harbourVisits"].push(item.toJSON());
        }
        data["ship"] = this.ship ? this.ship.toJSON() : <any>null;
        data["organizationName"] = this.organizationName !== undefined ? this.organizationName : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAddSeafaringPracticeRequest extends IAddPracticeRequest {
    /** In estonian: sõidupiirkond */
    areaId?: string | null;
    /** In estonian: praktikatõendiga või ilma */
    withPracticeCertificate?: boolean | null;
    /** In estonian: tankeri lastioperatsioonidega või ilma */
    withCargoOperations?: boolean | null;
    /** In estonian: sadamakülastustega või ilma */
    withHarbourVisits?: boolean | null;
    /** In estonian: tankeri lastioperatsioonid */
    cargoOperations: CargoOperationModel[];
    /** In estonian: Sadamakülastused */
    harbourVisits: HarbourVisitModel[];
    ship?: ShipInfoModel | null;
    organizationName?: string | null;
}

export class CargoOperationModel implements ICargoOperationModel {
    date?: Date | null;
    harbour?: HarbourOption | null;
    type?: CargoOperationType | null;

    constructor(data?: ICargoOperationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>null;
            this.harbour = _data["harbour"] ? HarbourOption.fromJS(_data["harbour"]) : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
        }
    }

    static fromJS(data: any): CargoOperationModel {
        data = typeof data === 'object' ? data : {};
        let result = new CargoOperationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>null;
        data["harbour"] = this.harbour ? this.harbour.toJSON() : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        return data;
    }
}

export interface ICargoOperationModel {
    date?: Date | null;
    harbour?: HarbourOption | null;
    type?: CargoOperationType | null;
}

export class HarbourOption implements IHarbourOption {
    value!: string;
    text!: string;

    constructor(data?: IHarbourOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.text = _data["text"] !== undefined ? _data["text"] : <any>null;
        }
    }

    static fromJS(data: any): HarbourOption {
        data = typeof data === 'object' ? data : {};
        let result = new HarbourOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["text"] = this.text !== undefined ? this.text : <any>null;
        return data;
    }
}

export interface IHarbourOption {
    value: string;
    text: string;
}

export enum CargoOperationType {
    Loading = "loading",
    Unloading = "unloading",
}

export class HarbourVisitModel implements IHarbourVisitModel {
    harbour?: HarbourOption | null;
    enteredOn?: Date | null;
    /** In estonian: loots (sisenemisel) */
    enteringPilot?: string | null;
    exitedOn?: Date | null;
    /** In estonian: loots (väljumisel) */
    exitingPilot?: string | null;

    constructor(data?: IHarbourVisitModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.harbour = _data["harbour"] ? HarbourOption.fromJS(_data["harbour"]) : <any>null;
            this.enteredOn = _data["enteredOn"] ? new Date(_data["enteredOn"].toString()) : <any>null;
            this.enteringPilot = _data["enteringPilot"] !== undefined ? _data["enteringPilot"] : <any>null;
            this.exitedOn = _data["exitedOn"] ? new Date(_data["exitedOn"].toString()) : <any>null;
            this.exitingPilot = _data["exitingPilot"] !== undefined ? _data["exitingPilot"] : <any>null;
        }
    }

    static fromJS(data: any): HarbourVisitModel {
        data = typeof data === 'object' ? data : {};
        let result = new HarbourVisitModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["harbour"] = this.harbour ? this.harbour.toJSON() : <any>null;
        data["enteredOn"] = this.enteredOn ? this.enteredOn.toISOString() : <any>null;
        data["enteringPilot"] = this.enteringPilot !== undefined ? this.enteringPilot : <any>null;
        data["exitedOn"] = this.exitedOn ? this.exitedOn.toISOString() : <any>null;
        data["exitingPilot"] = this.exitingPilot !== undefined ? this.exitingPilot : <any>null;
        return data;
    }
}

export interface IHarbourVisitModel {
    harbour?: HarbourOption | null;
    enteredOn?: Date | null;
    /** In estonian: loots (sisenemisel) */
    enteringPilot?: string | null;
    exitedOn?: Date | null;
    /** In estonian: loots (väljumisel) */
    exitingPilot?: string | null;
}

export class AddInlandVesselPracticeRequest extends AddPracticeRequest implements IAddInlandVesselPracticeRequest {
    /** In estonian: sõidupiirkond */
    areaId?: string | null;
    /** In estonian: praktikatõendiga või ilma */
    withPracticeCertificate?: boolean | null;
    /** In estonian: sadamakülastustega või ilma */
    withHarbourVisits?: boolean | null;
    /** In estonian: Sadamakülastused */
    harbourVisits!: HarbourVisitModel[];
    ship?: ShipInfoModel | null;
    organizationName?: string | null;

    constructor(data?: IAddInlandVesselPracticeRequest) {
        super(data);
        if (!data) {
            this.harbourVisits = [];
        }
        this._discriminator = "AddInlandVesselPracticeRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.areaId = _data["areaId"] !== undefined ? _data["areaId"] : <any>null;
            this.withPracticeCertificate = _data["withPracticeCertificate"] !== undefined ? _data["withPracticeCertificate"] : <any>null;
            this.withHarbourVisits = _data["withHarbourVisits"] !== undefined ? _data["withHarbourVisits"] : <any>null;
            if (Array.isArray(_data["harbourVisits"])) {
                this.harbourVisits = [] as any;
                for (let item of _data["harbourVisits"])
                    this.harbourVisits!.push(HarbourVisitModel.fromJS(item));
            }
            else {
                this.harbourVisits = <any>null;
            }
            this.ship = _data["ship"] ? ShipInfoModel.fromJS(_data["ship"]) : <any>null;
            this.organizationName = _data["organizationName"] !== undefined ? _data["organizationName"] : <any>null;
        }
    }

    static fromJS(data: any): AddInlandVesselPracticeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddInlandVesselPracticeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaId"] = this.areaId !== undefined ? this.areaId : <any>null;
        data["withPracticeCertificate"] = this.withPracticeCertificate !== undefined ? this.withPracticeCertificate : <any>null;
        data["withHarbourVisits"] = this.withHarbourVisits !== undefined ? this.withHarbourVisits : <any>null;
        if (Array.isArray(this.harbourVisits)) {
            data["harbourVisits"] = [];
            for (let item of this.harbourVisits)
                data["harbourVisits"].push(item.toJSON());
        }
        data["ship"] = this.ship ? this.ship.toJSON() : <any>null;
        data["organizationName"] = this.organizationName !== undefined ? this.organizationName : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAddInlandVesselPracticeRequest extends IAddPracticeRequest {
    /** In estonian: sõidupiirkond */
    areaId?: string | null;
    /** In estonian: praktikatõendiga või ilma */
    withPracticeCertificate?: boolean | null;
    /** In estonian: sadamakülastustega või ilma */
    withHarbourVisits?: boolean | null;
    /** In estonian: Sadamakülastused */
    harbourVisits: HarbourVisitModel[];
    ship?: ShipInfoModel | null;
    organizationName?: string | null;
}

export class AddPilotagePracticeRequest extends AddPracticeRequest implements IAddPilotagePracticeRequest {
    /** In estonian: Lootsimise piirkond (sõidupiirkond) */
    areaId?: string | null;
    /** In estonian: Praktika liik */
    pilotageType?: PilotageType | null;
    /** In estonian: Sadam */
    harbourId?: string | null;
    /** In estonian: Praktika laev */
    ship?: ShipInfoModel | null;
    /** In estonian: Laevakülastuse number (for EMDE import) */
    shipVisitNumber?: string | null;

    constructor(data?: IAddPilotagePracticeRequest) {
        super(data);
        this._discriminator = "AddPilotagePracticeRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.areaId = _data["areaId"] !== undefined ? _data["areaId"] : <any>null;
            this.pilotageType = _data["pilotageType"] !== undefined ? _data["pilotageType"] : <any>null;
            this.harbourId = _data["harbourId"] !== undefined ? _data["harbourId"] : <any>null;
            this.ship = _data["ship"] ? ShipInfoModel.fromJS(_data["ship"]) : <any>null;
            this.shipVisitNumber = _data["shipVisitNumber"] !== undefined ? _data["shipVisitNumber"] : <any>null;
        }
    }

    static fromJS(data: any): AddPilotagePracticeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddPilotagePracticeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["areaId"] = this.areaId !== undefined ? this.areaId : <any>null;
        data["pilotageType"] = this.pilotageType !== undefined ? this.pilotageType : <any>null;
        data["harbourId"] = this.harbourId !== undefined ? this.harbourId : <any>null;
        data["ship"] = this.ship ? this.ship.toJSON() : <any>null;
        data["shipVisitNumber"] = this.shipVisitNumber !== undefined ? this.shipVisitNumber : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAddPilotagePracticeRequest extends IAddPracticeRequest {
    /** In estonian: Lootsimise piirkond (sõidupiirkond) */
    areaId?: string | null;
    /** In estonian: Praktika liik */
    pilotageType?: PilotageType | null;
    /** In estonian: Sadam */
    harbourId?: string | null;
    /** In estonian: Praktika laev */
    ship?: ShipInfoModel | null;
    /** In estonian: Laevakülastuse number (for EMDE import) */
    shipVisitNumber?: string | null;
}

export class AddVtsCenterPracticeRequest extends AddPracticeRequest implements IAddVtsCenterPracticeRequest {
    organizationName?: string | null;

    constructor(data?: IAddVtsCenterPracticeRequest) {
        super(data);
        this._discriminator = "AddVtsCenterPracticeRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.organizationName = _data["organizationName"] !== undefined ? _data["organizationName"] : <any>null;
        }
    }

    static fromJS(data: any): AddVtsCenterPracticeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddVtsCenterPracticeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationName"] = this.organizationName !== undefined ? this.organizationName : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAddVtsCenterPracticeRequest extends IAddPracticeRequest {
    organizationName?: string | null;
}

export abstract class PracticeDetailsModel implements IPracticeDetailsModel {
    id!: string;
    seafarerId!: string;
    createdAt!: Date;
    validity!: ValidityStatus;
    position!: string;
    practiceKind!: PracticeKind;
    issuedOn!: Date;
    confirmer?: string | null;
    files!: FileModel[];
    practicePeriods!: PracticePeriod[];
    additionalNotes?: string | null;
    creator!: NameAndOrganization;
    rejectionDetails?: RejectionDetailsModel | null;
    usedInApplications!: string[];
    organizationName?: string | null;
    positionId?: string | null;
    kind?: PracticeKind | null;
    confirmerId?: string | null;
    organizationId?: string | null;
    version?: number | null;
    comment!: string;
    updatedAt?: Date | null;
    isDeleted!: boolean;
    recentProfileImageChange?: HistoryDetails | null;
    changeInfo?: HistoryDetails | null;
    realCreator?: HistoryDetails | null;

    constructor(data?: IPracticeDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.confirmer = "";
            this.files = [];
            this.practicePeriods = [];
            this.creator = new NameAndOrganization();
            this.usedInApplications = [];
            this.organizationName = "";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.seafarerId = _data["seafarerId"] !== undefined ? _data["seafarerId"] : <any>null;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.validity = _data["validity"] !== undefined ? _data["validity"] : <any>null;
            this.position = _data["position"] !== undefined ? _data["position"] : <any>null;
            this.practiceKind = _data["practiceKind"] !== undefined ? _data["practiceKind"] : <any>null;
            this.issuedOn = _data["issuedOn"] ? new Date(_data["issuedOn"].toString()) : <any>null;
            this.confirmer = _data["confirmer"] !== undefined ? _data["confirmer"] : "";
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(FileModel.fromJS(item));
            }
            else {
                this.files = <any>null;
            }
            if (Array.isArray(_data["practicePeriods"])) {
                this.practicePeriods = [] as any;
                for (let item of _data["practicePeriods"])
                    this.practicePeriods!.push(PracticePeriod.fromJS(item));
            }
            else {
                this.practicePeriods = <any>null;
            }
            this.additionalNotes = _data["additionalNotes"] !== undefined ? _data["additionalNotes"] : <any>null;
            this.creator = _data["creator"] ? NameAndOrganization.fromJS(_data["creator"]) : new NameAndOrganization();
            this.rejectionDetails = _data["rejectionDetails"] ? RejectionDetailsModel.fromJS(_data["rejectionDetails"]) : <any>null;
            if (Array.isArray(_data["usedInApplications"])) {
                this.usedInApplications = [] as any;
                for (let item of _data["usedInApplications"])
                    this.usedInApplications!.push(item);
            }
            else {
                this.usedInApplications = <any>null;
            }
            this.organizationName = _data["organizationName"] !== undefined ? _data["organizationName"] : "";
            this.positionId = _data["positionId"] !== undefined ? _data["positionId"] : <any>null;
            this.kind = _data["kind"] !== undefined ? _data["kind"] : <any>null;
            this.confirmerId = _data["confirmerId"] !== undefined ? _data["confirmerId"] : <any>null;
            this.organizationId = _data["organizationId"] !== undefined ? _data["organizationId"] : <any>null;
            this.version = _data["version"] !== undefined ? _data["version"] : <any>null;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>null;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : <any>null;
            this.recentProfileImageChange = _data["recentProfileImageChange"] ? HistoryDetails.fromJS(_data["recentProfileImageChange"]) : <any>null;
            this.changeInfo = _data["changeInfo"] ? HistoryDetails.fromJS(_data["changeInfo"]) : <any>null;
            this.realCreator = _data["realCreator"] ? HistoryDetails.fromJS(_data["realCreator"]) : <any>null;
        }
    }

    static fromJS(data: any): PracticeDetailsModel {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'PracticeDetailsModel' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["seafarerId"] = this.seafarerId !== undefined ? this.seafarerId : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        data["validity"] = this.validity !== undefined ? this.validity : <any>null;
        data["position"] = this.position !== undefined ? this.position : <any>null;
        data["practiceKind"] = this.practiceKind !== undefined ? this.practiceKind : <any>null;
        data["issuedOn"] = this.issuedOn ? this.issuedOn.toISOString() : <any>null;
        data["confirmer"] = this.confirmer !== undefined ? this.confirmer : <any>null;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        if (Array.isArray(this.practicePeriods)) {
            data["practicePeriods"] = [];
            for (let item of this.practicePeriods)
                data["practicePeriods"].push(item.toJSON());
        }
        data["additionalNotes"] = this.additionalNotes !== undefined ? this.additionalNotes : <any>null;
        data["creator"] = this.creator ? this.creator.toJSON() : <any>null;
        data["rejectionDetails"] = this.rejectionDetails ? this.rejectionDetails.toJSON() : <any>null;
        if (Array.isArray(this.usedInApplications)) {
            data["usedInApplications"] = [];
            for (let item of this.usedInApplications)
                data["usedInApplications"].push(item);
        }
        data["organizationName"] = this.organizationName !== undefined ? this.organizationName : <any>null;
        data["positionId"] = this.positionId !== undefined ? this.positionId : <any>null;
        data["kind"] = this.kind !== undefined ? this.kind : <any>null;
        data["confirmerId"] = this.confirmerId !== undefined ? this.confirmerId : <any>null;
        data["organizationId"] = this.organizationId !== undefined ? this.organizationId : <any>null;
        data["version"] = this.version !== undefined ? this.version : <any>null;
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>null;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : <any>null;
        data["recentProfileImageChange"] = this.recentProfileImageChange ? this.recentProfileImageChange.toJSON() : <any>null;
        data["changeInfo"] = this.changeInfo ? this.changeInfo.toJSON() : <any>null;
        data["realCreator"] = this.realCreator ? this.realCreator.toJSON() : <any>null;
        return data;
    }
}

export interface IPracticeDetailsModel {
    id: string;
    seafarerId: string;
    createdAt: Date;
    validity: ValidityStatus;
    position: string;
    practiceKind: PracticeKind;
    issuedOn: Date;
    confirmer?: string | null;
    files: FileModel[];
    practicePeriods: PracticePeriod[];
    additionalNotes?: string | null;
    creator: NameAndOrganization;
    rejectionDetails?: RejectionDetailsModel | null;
    usedInApplications: string[];
    organizationName?: string | null;
    positionId?: string | null;
    kind?: PracticeKind | null;
    confirmerId?: string | null;
    organizationId?: string | null;
    version?: number | null;
    comment: string;
    updatedAt?: Date | null;
    isDeleted: boolean;
    recentProfileImageChange?: HistoryDetails | null;
    changeInfo?: HistoryDetails | null;
    realCreator?: HistoryDetails | null;
}

export class ShipRepairPracticeDetailsModel extends PracticeDetailsModel implements IShipRepairPracticeDetailsModel {

    constructor(data?: IShipRepairPracticeDetailsModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ShipRepairPracticeDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new ShipRepairPracticeDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IShipRepairPracticeDetailsModel extends IPracticeDetailsModel {
}

export class NameAndOrganization implements INameAndOrganization {
    name!: string;
    organizationName!: string;

    constructor(data?: INameAndOrganization) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.organizationName = _data["organizationName"] !== undefined ? _data["organizationName"] : <any>null;
        }
    }

    static fromJS(data: any): NameAndOrganization {
        data = typeof data === 'object' ? data : {};
        let result = new NameAndOrganization();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["organizationName"] = this.organizationName !== undefined ? this.organizationName : <any>null;
        return data;
    }
}

export interface INameAndOrganization {
    name: string;
    organizationName: string;
}

export class RejectionDetailsModel implements IRejectionDetailsModel {
    name!: string;
    comment!: string;
    time!: Date;
    reason?: InvalidationReasonModel | null;

    constructor(data?: IRejectionDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
            this.time = _data["time"] ? new Date(_data["time"].toString()) : <any>null;
            this.reason = _data["reason"] ? InvalidationReasonModel.fromJS(_data["reason"]) : <any>null;
        }
    }

    static fromJS(data: any): RejectionDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new RejectionDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        data["time"] = this.time ? this.time.toISOString() : <any>null;
        data["reason"] = this.reason ? this.reason.toJSON() : <any>null;
        return data;
    }
}

export interface IRejectionDetailsModel {
    name: string;
    comment: string;
    time: Date;
    reason?: InvalidationReasonModel | null;
}

export class InvalidationReasonModel implements IInvalidationReasonModel {
    value!: ManualInvalidationReason;
    text!: string;

    constructor(data?: IInvalidationReasonModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.value = new ManualInvalidationReason();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] ? ManualInvalidationReason.fromJS(_data["value"]) : new ManualInvalidationReason();
            this.text = _data["text"] !== undefined ? _data["text"] : <any>null;
        }
    }

    static fromJS(data: any): InvalidationReasonModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvalidationReasonModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : <any>null;
        data["text"] = this.text !== undefined ? this.text : <any>null;
        return data;
    }
}

export interface IInvalidationReasonModel {
    value: ManualInvalidationReason;
    text: string;
}

export abstract class SingleValueObjectOfString extends ValueObject implements ISingleValueObjectOfString {
    value?: string | null;

    constructor(data?: ISingleValueObjectOfString) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): SingleValueObjectOfString {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'SingleValueObjectOfString' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISingleValueObjectOfString extends IValueObject {
    value?: string | null;
}

export class ManualInvalidationReason extends SingleValueObjectOfString implements IManualInvalidationReason {

    constructor(data?: IManualInvalidationReason) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ManualInvalidationReason {
        data = typeof data === 'object' ? data : {};
        let result = new ManualInvalidationReason();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IManualInvalidationReason extends ISingleValueObjectOfString {
}

export class HistoryDetails implements IHistoryDetails {
    changeDate!: Date;
    fullName!: string;

    constructor(data?: IHistoryDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.changeDate = _data["changeDate"] ? new Date(_data["changeDate"].toString()) : <any>null;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
        }
    }

    static fromJS(data: any): HistoryDetails {
        data = typeof data === 'object' ? data : {};
        let result = new HistoryDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["changeDate"] = this.changeDate ? this.changeDate.toISOString() : <any>null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        return data;
    }
}

export interface IHistoryDetails {
    changeDate: Date;
    fullName: string;
}

export class SeafaringPracticeDetailsModel extends PracticeDetailsModel implements ISeafaringPracticeDetailsModel {
    area!: string;
    ship!: ShipInfoModel;
    areaId?: string | null;
    withPracticeCertificate!: boolean;
    withCargoOperations?: boolean | null;
    withHarbourVisits?: boolean | null;
    cargoOperations!: CargoOperationModel[];
    harbourVisits!: HarbourVisitModel[];

    constructor(data?: ISeafaringPracticeDetailsModel) {
        super(data);
        if (!data) {
            this.ship = new ShipInfoModel();
            this.cargoOperations = [];
            this.harbourVisits = [];
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.area = _data["area"] !== undefined ? _data["area"] : <any>null;
            this.ship = _data["ship"] ? ShipInfoModel.fromJS(_data["ship"]) : new ShipInfoModel();
            this.areaId = _data["areaId"] !== undefined ? _data["areaId"] : <any>null;
            this.withPracticeCertificate = _data["withPracticeCertificate"] !== undefined ? _data["withPracticeCertificate"] : <any>null;
            this.withCargoOperations = _data["withCargoOperations"] !== undefined ? _data["withCargoOperations"] : <any>null;
            this.withHarbourVisits = _data["withHarbourVisits"] !== undefined ? _data["withHarbourVisits"] : <any>null;
            if (Array.isArray(_data["cargoOperations"])) {
                this.cargoOperations = [] as any;
                for (let item of _data["cargoOperations"])
                    this.cargoOperations!.push(CargoOperationModel.fromJS(item));
            }
            else {
                this.cargoOperations = <any>null;
            }
            if (Array.isArray(_data["harbourVisits"])) {
                this.harbourVisits = [] as any;
                for (let item of _data["harbourVisits"])
                    this.harbourVisits!.push(HarbourVisitModel.fromJS(item));
            }
            else {
                this.harbourVisits = <any>null;
            }
        }
    }

    static fromJS(data: any): SeafaringPracticeDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new SeafaringPracticeDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["area"] = this.area !== undefined ? this.area : <any>null;
        data["ship"] = this.ship ? this.ship.toJSON() : <any>null;
        data["areaId"] = this.areaId !== undefined ? this.areaId : <any>null;
        data["withPracticeCertificate"] = this.withPracticeCertificate !== undefined ? this.withPracticeCertificate : <any>null;
        data["withCargoOperations"] = this.withCargoOperations !== undefined ? this.withCargoOperations : <any>null;
        data["withHarbourVisits"] = this.withHarbourVisits !== undefined ? this.withHarbourVisits : <any>null;
        if (Array.isArray(this.cargoOperations)) {
            data["cargoOperations"] = [];
            for (let item of this.cargoOperations)
                data["cargoOperations"].push(item.toJSON());
        }
        if (Array.isArray(this.harbourVisits)) {
            data["harbourVisits"] = [];
            for (let item of this.harbourVisits)
                data["harbourVisits"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISeafaringPracticeDetailsModel extends IPracticeDetailsModel {
    area: string;
    ship: ShipInfoModel;
    areaId?: string | null;
    withPracticeCertificate: boolean;
    withCargoOperations?: boolean | null;
    withHarbourVisits?: boolean | null;
    cargoOperations: CargoOperationModel[];
    harbourVisits: HarbourVisitModel[];
}

export class InlandVesselPracticeDetailsModel extends PracticeDetailsModel implements IInlandVesselPracticeDetailsModel {
    area!: string;
    ship!: ShipInfoModel;
    areaId?: string | null;
    withPracticeCertificate!: boolean;
    withHarbourVisits?: boolean | null;
    harbourVisits!: HarbourVisitModel[];

    constructor(data?: IInlandVesselPracticeDetailsModel) {
        super(data);
        if (!data) {
            this.ship = new ShipInfoModel();
            this.harbourVisits = [];
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.area = _data["area"] !== undefined ? _data["area"] : <any>null;
            this.ship = _data["ship"] ? ShipInfoModel.fromJS(_data["ship"]) : new ShipInfoModel();
            this.areaId = _data["areaId"] !== undefined ? _data["areaId"] : <any>null;
            this.withPracticeCertificate = _data["withPracticeCertificate"] !== undefined ? _data["withPracticeCertificate"] : <any>null;
            this.withHarbourVisits = _data["withHarbourVisits"] !== undefined ? _data["withHarbourVisits"] : <any>null;
            if (Array.isArray(_data["harbourVisits"])) {
                this.harbourVisits = [] as any;
                for (let item of _data["harbourVisits"])
                    this.harbourVisits!.push(HarbourVisitModel.fromJS(item));
            }
            else {
                this.harbourVisits = <any>null;
            }
        }
    }

    static fromJS(data: any): InlandVesselPracticeDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new InlandVesselPracticeDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["area"] = this.area !== undefined ? this.area : <any>null;
        data["ship"] = this.ship ? this.ship.toJSON() : <any>null;
        data["areaId"] = this.areaId !== undefined ? this.areaId : <any>null;
        data["withPracticeCertificate"] = this.withPracticeCertificate !== undefined ? this.withPracticeCertificate : <any>null;
        data["withHarbourVisits"] = this.withHarbourVisits !== undefined ? this.withHarbourVisits : <any>null;
        if (Array.isArray(this.harbourVisits)) {
            data["harbourVisits"] = [];
            for (let item of this.harbourVisits)
                data["harbourVisits"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IInlandVesselPracticeDetailsModel extends IPracticeDetailsModel {
    area: string;
    ship: ShipInfoModel;
    areaId?: string | null;
    withPracticeCertificate: boolean;
    withHarbourVisits?: boolean | null;
    harbourVisits: HarbourVisitModel[];
}

export class PilotagePracticeDetailsModel extends PracticeDetailsModel implements IPilotagePracticeDetailsModel {
    area?: string | null;
    areaId?: string | null;
    pilotageType?: PilotageType | null;
    harbourId?: string | null;
    harbourName?: string | null;
    ship?: ShipInfoModel | null;
    shipVisitNumber?: string | null;

    constructor(data?: IPilotagePracticeDetailsModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.area = _data["area"] !== undefined ? _data["area"] : <any>null;
            this.areaId = _data["areaId"] !== undefined ? _data["areaId"] : <any>null;
            this.pilotageType = _data["pilotageType"] !== undefined ? _data["pilotageType"] : <any>null;
            this.harbourId = _data["harbourId"] !== undefined ? _data["harbourId"] : <any>null;
            this.harbourName = _data["harbourName"] !== undefined ? _data["harbourName"] : <any>null;
            this.ship = _data["ship"] ? ShipInfoModel.fromJS(_data["ship"]) : <any>null;
            this.shipVisitNumber = _data["shipVisitNumber"] !== undefined ? _data["shipVisitNumber"] : <any>null;
        }
    }

    static fromJS(data: any): PilotagePracticeDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new PilotagePracticeDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["area"] = this.area !== undefined ? this.area : <any>null;
        data["areaId"] = this.areaId !== undefined ? this.areaId : <any>null;
        data["pilotageType"] = this.pilotageType !== undefined ? this.pilotageType : <any>null;
        data["harbourId"] = this.harbourId !== undefined ? this.harbourId : <any>null;
        data["harbourName"] = this.harbourName !== undefined ? this.harbourName : <any>null;
        data["ship"] = this.ship ? this.ship.toJSON() : <any>null;
        data["shipVisitNumber"] = this.shipVisitNumber !== undefined ? this.shipVisitNumber : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPilotagePracticeDetailsModel extends IPracticeDetailsModel {
    area?: string | null;
    areaId?: string | null;
    pilotageType?: PilotageType | null;
    harbourId?: string | null;
    harbourName?: string | null;
    ship?: ShipInfoModel | null;
    shipVisitNumber?: string | null;
}

export class VtsCenterPracticeDetailsModel extends PracticeDetailsModel implements IVtsCenterPracticeDetailsModel {

    constructor(data?: IVtsCenterPracticeDetailsModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): VtsCenterPracticeDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new VtsCenterPracticeDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IVtsCenterPracticeDetailsModel extends IPracticeDetailsModel {
}

export class OrganizationOptionsResponse implements IOrganizationOptionsResponse {
    organizationOptions!: OrganizationOption[];

    constructor(data?: IOrganizationOptionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.organizationOptions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["organizationOptions"])) {
                this.organizationOptions = [] as any;
                for (let item of _data["organizationOptions"])
                    this.organizationOptions!.push(OrganizationOption.fromJS(item));
            }
            else {
                this.organizationOptions = <any>null;
            }
        }
    }

    static fromJS(data: any): OrganizationOptionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationOptionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.organizationOptions)) {
            data["organizationOptions"] = [];
            for (let item of this.organizationOptions)
                data["organizationOptions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOrganizationOptionsResponse {
    organizationOptions: OrganizationOption[];
}

export class OrganizationOption implements IOrganizationOption {
    value!: string;
    text!: string;
    personOptions!: PersonOption[];
    active!: boolean;

    constructor(data?: IOrganizationOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.personOptions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.text = _data["text"] !== undefined ? _data["text"] : <any>null;
            if (Array.isArray(_data["personOptions"])) {
                this.personOptions = [] as any;
                for (let item of _data["personOptions"])
                    this.personOptions!.push(PersonOption.fromJS(item));
            }
            else {
                this.personOptions = <any>null;
            }
            this.active = _data["active"] !== undefined ? _data["active"] : <any>null;
        }
    }

    static fromJS(data: any): OrganizationOption {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["text"] = this.text !== undefined ? this.text : <any>null;
        if (Array.isArray(this.personOptions)) {
            data["personOptions"] = [];
            for (let item of this.personOptions)
                data["personOptions"].push(item.toJSON());
        }
        data["active"] = this.active !== undefined ? this.active : <any>null;
        return data;
    }
}

export interface IOrganizationOption {
    value: string;
    text: string;
    personOptions: PersonOption[];
    active: boolean;
}

export class PersonOption implements IPersonOption {
    value!: string;
    text!: string;

    constructor(data?: IPersonOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.text = _data["text"] !== undefined ? _data["text"] : <any>null;
        }
    }

    static fromJS(data: any): PersonOption {
        data = typeof data === 'object' ? data : {};
        let result = new PersonOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["text"] = this.text !== undefined ? this.text : <any>null;
        return data;
    }
}

export interface IPersonOption {
    value: string;
    text: string;
}

export class PracticeActions implements IPracticeActions {
    canApprove!: boolean;
    canDisapprove!: boolean;
    canComment!: boolean;
    canForwardForConfirmation!: boolean;
    canModify!: boolean;
    canViewSeafarerApplications!: boolean;
    isOfficial!: boolean;
    canInsertConfirmerNameManually!: boolean;

    constructor(data?: IPracticeActions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canApprove = _data["canApprove"] !== undefined ? _data["canApprove"] : <any>null;
            this.canDisapprove = _data["canDisapprove"] !== undefined ? _data["canDisapprove"] : <any>null;
            this.canComment = _data["canComment"] !== undefined ? _data["canComment"] : <any>null;
            this.canForwardForConfirmation = _data["canForwardForConfirmation"] !== undefined ? _data["canForwardForConfirmation"] : <any>null;
            this.canModify = _data["canModify"] !== undefined ? _data["canModify"] : <any>null;
            this.canViewSeafarerApplications = _data["canViewSeafarerApplications"] !== undefined ? _data["canViewSeafarerApplications"] : <any>null;
            this.isOfficial = _data["isOfficial"] !== undefined ? _data["isOfficial"] : <any>null;
            this.canInsertConfirmerNameManually = _data["canInsertConfirmerNameManually"] !== undefined ? _data["canInsertConfirmerNameManually"] : <any>null;
        }
    }

    static fromJS(data: any): PracticeActions {
        data = typeof data === 'object' ? data : {};
        let result = new PracticeActions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canApprove"] = this.canApprove !== undefined ? this.canApprove : <any>null;
        data["canDisapprove"] = this.canDisapprove !== undefined ? this.canDisapprove : <any>null;
        data["canComment"] = this.canComment !== undefined ? this.canComment : <any>null;
        data["canForwardForConfirmation"] = this.canForwardForConfirmation !== undefined ? this.canForwardForConfirmation : <any>null;
        data["canModify"] = this.canModify !== undefined ? this.canModify : <any>null;
        data["canViewSeafarerApplications"] = this.canViewSeafarerApplications !== undefined ? this.canViewSeafarerApplications : <any>null;
        data["isOfficial"] = this.isOfficial !== undefined ? this.isOfficial : <any>null;
        data["canInsertConfirmerNameManually"] = this.canInsertConfirmerNameManually !== undefined ? this.canInsertConfirmerNameManually : <any>null;
        return data;
    }
}

export interface IPracticeActions {
    canApprove: boolean;
    canDisapprove: boolean;
    canComment: boolean;
    canForwardForConfirmation: boolean;
    canModify: boolean;
    canViewSeafarerApplications: boolean;
    isOfficial: boolean;
    canInsertConfirmerNameManually: boolean;
}

export class ShipRepairPracticeActions extends PracticeActions implements IShipRepairPracticeActions {
    canChooseOrganizationAndConfirmer!: boolean;
    canStartEnteringEducational!: boolean;
    canStartEnteringWorking!: boolean;
    canOmitFile!: boolean;

    constructor(data?: IShipRepairPracticeActions) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.canChooseOrganizationAndConfirmer = _data["canChooseOrganizationAndConfirmer"] !== undefined ? _data["canChooseOrganizationAndConfirmer"] : <any>null;
            this.canStartEnteringEducational = _data["canStartEnteringEducational"] !== undefined ? _data["canStartEnteringEducational"] : <any>null;
            this.canStartEnteringWorking = _data["canStartEnteringWorking"] !== undefined ? _data["canStartEnteringWorking"] : <any>null;
            this.canOmitFile = _data["canOmitFile"] !== undefined ? _data["canOmitFile"] : <any>null;
        }
    }

    static fromJS(data: any): ShipRepairPracticeActions {
        data = typeof data === 'object' ? data : {};
        let result = new ShipRepairPracticeActions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canChooseOrganizationAndConfirmer"] = this.canChooseOrganizationAndConfirmer !== undefined ? this.canChooseOrganizationAndConfirmer : <any>null;
        data["canStartEnteringEducational"] = this.canStartEnteringEducational !== undefined ? this.canStartEnteringEducational : <any>null;
        data["canStartEnteringWorking"] = this.canStartEnteringWorking !== undefined ? this.canStartEnteringWorking : <any>null;
        data["canOmitFile"] = this.canOmitFile !== undefined ? this.canOmitFile : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IShipRepairPracticeActions extends IPracticeActions {
    canChooseOrganizationAndConfirmer: boolean;
    canStartEnteringEducational: boolean;
    canStartEnteringWorking: boolean;
    canOmitFile: boolean;
}

export class SeafaringPracticeActions extends PracticeActions implements ISeafaringPracticeActions {
    canStartEnteringEducational!: boolean;
    canStartEnteringWorking!: boolean;
    canChooseWithOrWithoutFile!: boolean;
    canChooseOrganizationAndConfirmer!: boolean;
    canOmitFile!: boolean;

    constructor(data?: ISeafaringPracticeActions) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.canStartEnteringEducational = _data["canStartEnteringEducational"] !== undefined ? _data["canStartEnteringEducational"] : <any>null;
            this.canStartEnteringWorking = _data["canStartEnteringWorking"] !== undefined ? _data["canStartEnteringWorking"] : <any>null;
            this.canChooseWithOrWithoutFile = _data["canChooseWithOrWithoutFile"] !== undefined ? _data["canChooseWithOrWithoutFile"] : <any>null;
            this.canChooseOrganizationAndConfirmer = _data["canChooseOrganizationAndConfirmer"] !== undefined ? _data["canChooseOrganizationAndConfirmer"] : <any>null;
            this.canOmitFile = _data["canOmitFile"] !== undefined ? _data["canOmitFile"] : <any>null;
        }
    }

    static fromJS(data: any): SeafaringPracticeActions {
        data = typeof data === 'object' ? data : {};
        let result = new SeafaringPracticeActions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canStartEnteringEducational"] = this.canStartEnteringEducational !== undefined ? this.canStartEnteringEducational : <any>null;
        data["canStartEnteringWorking"] = this.canStartEnteringWorking !== undefined ? this.canStartEnteringWorking : <any>null;
        data["canChooseWithOrWithoutFile"] = this.canChooseWithOrWithoutFile !== undefined ? this.canChooseWithOrWithoutFile : <any>null;
        data["canChooseOrganizationAndConfirmer"] = this.canChooseOrganizationAndConfirmer !== undefined ? this.canChooseOrganizationAndConfirmer : <any>null;
        data["canOmitFile"] = this.canOmitFile !== undefined ? this.canOmitFile : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISeafaringPracticeActions extends IPracticeActions {
    canStartEnteringEducational: boolean;
    canStartEnteringWorking: boolean;
    canChooseWithOrWithoutFile: boolean;
    canChooseOrganizationAndConfirmer: boolean;
    canOmitFile: boolean;
}

export class InlandVesselPracticeActions extends PracticeActions implements IInlandVesselPracticeActions {
    canStartEnteringEducational!: boolean;
    canStartEnteringWorking!: boolean;
    canChooseOrganizationAndConfirmer!: boolean;
    canChooseWithOrWithoutFile!: boolean;
    canOmitFile!: boolean;

    constructor(data?: IInlandVesselPracticeActions) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.canStartEnteringEducational = _data["canStartEnteringEducational"] !== undefined ? _data["canStartEnteringEducational"] : <any>null;
            this.canStartEnteringWorking = _data["canStartEnteringWorking"] !== undefined ? _data["canStartEnteringWorking"] : <any>null;
            this.canChooseOrganizationAndConfirmer = _data["canChooseOrganizationAndConfirmer"] !== undefined ? _data["canChooseOrganizationAndConfirmer"] : <any>null;
            this.canChooseWithOrWithoutFile = _data["canChooseWithOrWithoutFile"] !== undefined ? _data["canChooseWithOrWithoutFile"] : <any>null;
            this.canOmitFile = _data["canOmitFile"] !== undefined ? _data["canOmitFile"] : <any>null;
        }
    }

    static fromJS(data: any): InlandVesselPracticeActions {
        data = typeof data === 'object' ? data : {};
        let result = new InlandVesselPracticeActions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canStartEnteringEducational"] = this.canStartEnteringEducational !== undefined ? this.canStartEnteringEducational : <any>null;
        data["canStartEnteringWorking"] = this.canStartEnteringWorking !== undefined ? this.canStartEnteringWorking : <any>null;
        data["canChooseOrganizationAndConfirmer"] = this.canChooseOrganizationAndConfirmer !== undefined ? this.canChooseOrganizationAndConfirmer : <any>null;
        data["canChooseWithOrWithoutFile"] = this.canChooseWithOrWithoutFile !== undefined ? this.canChooseWithOrWithoutFile : <any>null;
        data["canOmitFile"] = this.canOmitFile !== undefined ? this.canOmitFile : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IInlandVesselPracticeActions extends IPracticeActions {
    canStartEnteringEducational: boolean;
    canStartEnteringWorking: boolean;
    canChooseOrganizationAndConfirmer: boolean;
    canChooseWithOrWithoutFile: boolean;
    canOmitFile: boolean;
}

export class PilotagePracticeActions extends PracticeActions implements IPilotagePracticeActions {
    canStartEnteringEducational!: boolean;
    canStartEnteringWorking!: boolean;
    canChooseOrganizationAndConfirmer!: boolean;
    canOmitFile!: boolean;

    constructor(data?: IPilotagePracticeActions) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.canStartEnteringEducational = _data["canStartEnteringEducational"] !== undefined ? _data["canStartEnteringEducational"] : <any>null;
            this.canStartEnteringWorking = _data["canStartEnteringWorking"] !== undefined ? _data["canStartEnteringWorking"] : <any>null;
            this.canChooseOrganizationAndConfirmer = _data["canChooseOrganizationAndConfirmer"] !== undefined ? _data["canChooseOrganizationAndConfirmer"] : <any>null;
            this.canOmitFile = _data["canOmitFile"] !== undefined ? _data["canOmitFile"] : <any>null;
        }
    }

    static fromJS(data: any): PilotagePracticeActions {
        data = typeof data === 'object' ? data : {};
        let result = new PilotagePracticeActions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canStartEnteringEducational"] = this.canStartEnteringEducational !== undefined ? this.canStartEnteringEducational : <any>null;
        data["canStartEnteringWorking"] = this.canStartEnteringWorking !== undefined ? this.canStartEnteringWorking : <any>null;
        data["canChooseOrganizationAndConfirmer"] = this.canChooseOrganizationAndConfirmer !== undefined ? this.canChooseOrganizationAndConfirmer : <any>null;
        data["canOmitFile"] = this.canOmitFile !== undefined ? this.canOmitFile : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPilotagePracticeActions extends IPracticeActions {
    canStartEnteringEducational: boolean;
    canStartEnteringWorking: boolean;
    canChooseOrganizationAndConfirmer: boolean;
    canOmitFile: boolean;
}

export class VtsCenterPracticeActions extends PracticeActions implements IVtsCenterPracticeActions {
    canStartEnteringEducational!: boolean;
    canStartEnteringWorking!: boolean;
    canChooseOrganizationAndConfirmer!: boolean;
    canOmitFile!: boolean;

    constructor(data?: IVtsCenterPracticeActions) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.canStartEnteringEducational = _data["canStartEnteringEducational"] !== undefined ? _data["canStartEnteringEducational"] : <any>null;
            this.canStartEnteringWorking = _data["canStartEnteringWorking"] !== undefined ? _data["canStartEnteringWorking"] : <any>null;
            this.canChooseOrganizationAndConfirmer = _data["canChooseOrganizationAndConfirmer"] !== undefined ? _data["canChooseOrganizationAndConfirmer"] : <any>null;
            this.canOmitFile = _data["canOmitFile"] !== undefined ? _data["canOmitFile"] : <any>null;
        }
    }

    static fromJS(data: any): VtsCenterPracticeActions {
        data = typeof data === 'object' ? data : {};
        let result = new VtsCenterPracticeActions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canStartEnteringEducational"] = this.canStartEnteringEducational !== undefined ? this.canStartEnteringEducational : <any>null;
        data["canStartEnteringWorking"] = this.canStartEnteringWorking !== undefined ? this.canStartEnteringWorking : <any>null;
        data["canChooseOrganizationAndConfirmer"] = this.canChooseOrganizationAndConfirmer !== undefined ? this.canChooseOrganizationAndConfirmer : <any>null;
        data["canOmitFile"] = this.canOmitFile !== undefined ? this.canOmitFile : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IVtsCenterPracticeActions extends IPracticeActions {
    canStartEnteringEducational: boolean;
    canStartEnteringWorking: boolean;
    canChooseOrganizationAndConfirmer: boolean;
    canOmitFile: boolean;
}

export class InstructorOption implements IInstructorOption {
    value!: string;
    text!: string;

    constructor(data?: IInstructorOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.text = _data["text"] !== undefined ? _data["text"] : <any>null;
        }
    }

    static fromJS(data: any): InstructorOption {
        data = typeof data === 'object' ? data : {};
        let result = new InstructorOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["text"] = this.text !== undefined ? this.text : <any>null;
        return data;
    }
}

export interface IInstructorOption {
    value: string;
    text: string;
}

export class PracticeListActions implements IPracticeListActions {
    canStartEnteringSeafaring!: boolean;
    canStartEnteringShipRepair!: boolean;
    canStartEnteringInlandVessel!: boolean;
    canStartEnteringPilotage!: boolean;
    canStartEnteringVtsCenter!: boolean;
    skipToShipRepair!: boolean;
    canAdd!: boolean;
    canImportFromEmde!: boolean;

    constructor(data?: IPracticeListActions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canStartEnteringSeafaring = _data["canStartEnteringSeafaring"] !== undefined ? _data["canStartEnteringSeafaring"] : <any>null;
            this.canStartEnteringShipRepair = _data["canStartEnteringShipRepair"] !== undefined ? _data["canStartEnteringShipRepair"] : <any>null;
            this.canStartEnteringInlandVessel = _data["canStartEnteringInlandVessel"] !== undefined ? _data["canStartEnteringInlandVessel"] : <any>null;
            this.canStartEnteringPilotage = _data["canStartEnteringPilotage"] !== undefined ? _data["canStartEnteringPilotage"] : <any>null;
            this.canStartEnteringVtsCenter = _data["canStartEnteringVtsCenter"] !== undefined ? _data["canStartEnteringVtsCenter"] : <any>null;
            this.skipToShipRepair = _data["skipToShipRepair"] !== undefined ? _data["skipToShipRepair"] : <any>null;
            this.canAdd = _data["canAdd"] !== undefined ? _data["canAdd"] : <any>null;
            this.canImportFromEmde = _data["canImportFromEmde"] !== undefined ? _data["canImportFromEmde"] : <any>null;
        }
    }

    static fromJS(data: any): PracticeListActions {
        data = typeof data === 'object' ? data : {};
        let result = new PracticeListActions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canStartEnteringSeafaring"] = this.canStartEnteringSeafaring !== undefined ? this.canStartEnteringSeafaring : <any>null;
        data["canStartEnteringShipRepair"] = this.canStartEnteringShipRepair !== undefined ? this.canStartEnteringShipRepair : <any>null;
        data["canStartEnteringInlandVessel"] = this.canStartEnteringInlandVessel !== undefined ? this.canStartEnteringInlandVessel : <any>null;
        data["canStartEnteringPilotage"] = this.canStartEnteringPilotage !== undefined ? this.canStartEnteringPilotage : <any>null;
        data["canStartEnteringVtsCenter"] = this.canStartEnteringVtsCenter !== undefined ? this.canStartEnteringVtsCenter : <any>null;
        data["skipToShipRepair"] = this.skipToShipRepair !== undefined ? this.skipToShipRepair : <any>null;
        data["canAdd"] = this.canAdd !== undefined ? this.canAdd : <any>null;
        data["canImportFromEmde"] = this.canImportFromEmde !== undefined ? this.canImportFromEmde : <any>null;
        return data;
    }
}

export interface IPracticeListActions {
    canStartEnteringSeafaring: boolean;
    canStartEnteringShipRepair: boolean;
    canStartEnteringInlandVessel: boolean;
    canStartEnteringPilotage: boolean;
    canStartEnteringVtsCenter: boolean;
    skipToShipRepair: boolean;
    canAdd: boolean;
    canImportFromEmde: boolean;
}

export class ImportFromEmdeResponse implements IImportFromEmdeResponse {
    importedCount!: number;
    skippedDuplicateCount!: number;

    constructor(data?: IImportFromEmdeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.importedCount = _data["importedCount"] !== undefined ? _data["importedCount"] : <any>null;
            this.skippedDuplicateCount = _data["skippedDuplicateCount"] !== undefined ? _data["skippedDuplicateCount"] : <any>null;
        }
    }

    static fromJS(data: any): ImportFromEmdeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ImportFromEmdeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["importedCount"] = this.importedCount !== undefined ? this.importedCount : <any>null;
        data["skippedDuplicateCount"] = this.skippedDuplicateCount !== undefined ? this.skippedDuplicateCount : <any>null;
        return data;
    }
}

export interface IImportFromEmdeResponse {
    importedCount: number;
    skippedDuplicateCount: number;
}

export class MultilanguagePosition implements IMultilanguagePosition {
    id!: PositionId;
    name!: LocalizedString;
    level!: LocalizedString;
    responsibilities?: LocalizedString | null;
    isActive!: boolean;
    additionalInfo?: string | null;

    constructor(data?: IMultilanguagePosition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.id = new PositionId();
            this.name = new LocalizedString();
            this.level = new LocalizedString();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] ? PositionId.fromJS(_data["id"]) : new PositionId();
            this.name = _data["name"] ? LocalizedString.fromJS(_data["name"]) : new LocalizedString();
            this.level = _data["level"] ? LocalizedString.fromJS(_data["level"]) : new LocalizedString();
            this.responsibilities = _data["responsibilities"] ? LocalizedString.fromJS(_data["responsibilities"]) : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.additionalInfo = _data["additionalInfo"] !== undefined ? _data["additionalInfo"] : <any>null;
        }
    }

    static fromJS(data: any): MultilanguagePosition {
        data = typeof data === 'object' ? data : {};
        let result = new MultilanguagePosition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id ? this.id.toJSON() : <any>null;
        data["name"] = this.name ? this.name.toJSON() : <any>null;
        data["level"] = this.level ? this.level.toJSON() : <any>null;
        data["responsibilities"] = this.responsibilities ? this.responsibilities.toJSON() : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["additionalInfo"] = this.additionalInfo !== undefined ? this.additionalInfo : <any>null;
        return data;
    }
}

export interface IMultilanguagePosition {
    id: PositionId;
    name: LocalizedString;
    level: LocalizedString;
    responsibilities?: LocalizedString | null;
    isActive: boolean;
    additionalInfo?: string | null;
}

export abstract class IdentityOfPositionId extends SingleValueObjectOfGuid implements IIdentityOfPositionId {

    constructor(data?: IIdentityOfPositionId) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): IdentityOfPositionId {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IdentityOfPositionId' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IIdentityOfPositionId extends ISingleValueObjectOfGuid {
}

export class PositionId extends IdentityOfPositionId implements IPositionId {

    constructor(data?: IPositionId) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): PositionId {
        data = typeof data === 'object' ? data : {};
        let result = new PositionId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPositionId extends IIdentityOfPositionId {
}

export class PositionOption implements IPositionOption {
    value!: string;
    text!: string;
    est!: string;
    eng!: string;

    constructor(data?: IPositionOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.text = _data["text"] !== undefined ? _data["text"] : <any>null;
            this.est = _data["est"] !== undefined ? _data["est"] : <any>null;
            this.eng = _data["eng"] !== undefined ? _data["eng"] : <any>null;
        }
    }

    static fromJS(data: any): PositionOption {
        data = typeof data === 'object' ? data : {};
        let result = new PositionOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["text"] = this.text !== undefined ? this.text : <any>null;
        data["est"] = this.est !== undefined ? this.est : <any>null;
        data["eng"] = this.eng !== undefined ? this.eng : <any>null;
        return data;
    }
}

export interface IPositionOption {
    value: string;
    text: string;
    est: string;
    eng: string;
}

export class PositionLevelModel implements IPositionLevelModel {
    key!: string;
    name!: string;

    constructor(data?: IPositionLevelModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): PositionLevelModel {
        data = typeof data === 'object' ? data : {};
        let result = new PositionLevelModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface IPositionLevelModel {
    key: string;
    name: string;
}

export class PersonalInfoModel implements IPersonalInfoModel {
    approval!: ApprovalStatus;
    personalCode?: string | null;
    firstName!: string;
    lastName!: string;
    userName?: string | null;
    nationality?: string | null;
    birthPlace?: string | null;
    birthdate?: Date | null;
    deathDate?: Date | null;
    createdAt?: Date | null;
    gender?: Gender | null;
    activeProfileImageId?: string | null;
    signatureImages!: FileModel[];
    officialProfileImages!: FileModel[];
    customProfileImages!: FileModel[];
    identificationDocuments!: FileModel[];
    recentProfileImageChange?: HistoryDetails | null;
    created?: HistoryDetails | null;
    changeInfo?: HistoryDetails | null;
    updatedAt!: Date;
    isActive!: boolean;
    version!: number;

    constructor(data?: IPersonalInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.personalCode = "";
            this.firstName = "";
            this.lastName = "";
            this.signatureImages = [];
            this.officialProfileImages = [];
            this.customProfileImages = [];
            this.identificationDocuments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.approval = _data["approval"] !== undefined ? _data["approval"] : <any>null;
            this.personalCode = _data["personalCode"] !== undefined ? _data["personalCode"] : "";
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : "";
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : "";
            this.userName = _data["userName"] !== undefined ? _data["userName"] : <any>null;
            this.nationality = _data["nationality"] !== undefined ? _data["nationality"] : <any>null;
            this.birthPlace = _data["birthPlace"] !== undefined ? _data["birthPlace"] : <any>null;
            this.birthdate = _data["birthdate"] ? new Date(_data["birthdate"].toString()) : <any>null;
            this.deathDate = _data["deathDate"] ? new Date(_data["deathDate"].toString()) : <any>null;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.gender = _data["gender"] !== undefined ? _data["gender"] : <any>null;
            this.activeProfileImageId = _data["activeProfileImageId"] !== undefined ? _data["activeProfileImageId"] : <any>null;
            if (Array.isArray(_data["signatureImages"])) {
                this.signatureImages = [] as any;
                for (let item of _data["signatureImages"])
                    this.signatureImages!.push(FileModel.fromJS(item));
            }
            else {
                this.signatureImages = <any>null;
            }
            if (Array.isArray(_data["officialProfileImages"])) {
                this.officialProfileImages = [] as any;
                for (let item of _data["officialProfileImages"])
                    this.officialProfileImages!.push(FileModel.fromJS(item));
            }
            else {
                this.officialProfileImages = <any>null;
            }
            if (Array.isArray(_data["customProfileImages"])) {
                this.customProfileImages = [] as any;
                for (let item of _data["customProfileImages"])
                    this.customProfileImages!.push(FileModel.fromJS(item));
            }
            else {
                this.customProfileImages = <any>null;
            }
            if (Array.isArray(_data["identificationDocuments"])) {
                this.identificationDocuments = [] as any;
                for (let item of _data["identificationDocuments"])
                    this.identificationDocuments!.push(FileModel.fromJS(item));
            }
            else {
                this.identificationDocuments = <any>null;
            }
            this.recentProfileImageChange = _data["recentProfileImageChange"] ? HistoryDetails.fromJS(_data["recentProfileImageChange"]) : <any>null;
            this.created = _data["created"] ? HistoryDetails.fromJS(_data["created"]) : <any>null;
            this.changeInfo = _data["changeInfo"] ? HistoryDetails.fromJS(_data["changeInfo"]) : <any>null;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.version = _data["version"] !== undefined ? _data["version"] : <any>null;
        }
    }

    static fromJS(data: any): PersonalInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new PersonalInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approval"] = this.approval !== undefined ? this.approval : <any>null;
        data["personalCode"] = this.personalCode !== undefined ? this.personalCode : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["userName"] = this.userName !== undefined ? this.userName : <any>null;
        data["nationality"] = this.nationality !== undefined ? this.nationality : <any>null;
        data["birthPlace"] = this.birthPlace !== undefined ? this.birthPlace : <any>null;
        data["birthdate"] = this.birthdate ? this.birthdate.toISOString() : <any>null;
        data["deathDate"] = this.deathDate ? this.deathDate.toISOString() : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        data["gender"] = this.gender !== undefined ? this.gender : <any>null;
        data["activeProfileImageId"] = this.activeProfileImageId !== undefined ? this.activeProfileImageId : <any>null;
        if (Array.isArray(this.signatureImages)) {
            data["signatureImages"] = [];
            for (let item of this.signatureImages)
                data["signatureImages"].push(item.toJSON());
        }
        if (Array.isArray(this.officialProfileImages)) {
            data["officialProfileImages"] = [];
            for (let item of this.officialProfileImages)
                data["officialProfileImages"].push(item.toJSON());
        }
        if (Array.isArray(this.customProfileImages)) {
            data["customProfileImages"] = [];
            for (let item of this.customProfileImages)
                data["customProfileImages"].push(item.toJSON());
        }
        if (Array.isArray(this.identificationDocuments)) {
            data["identificationDocuments"] = [];
            for (let item of this.identificationDocuments)
                data["identificationDocuments"].push(item.toJSON());
        }
        data["recentProfileImageChange"] = this.recentProfileImageChange ? this.recentProfileImageChange.toJSON() : <any>null;
        data["created"] = this.created ? this.created.toJSON() : <any>null;
        data["changeInfo"] = this.changeInfo ? this.changeInfo.toJSON() : <any>null;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["version"] = this.version !== undefined ? this.version : <any>null;
        return data;
    }
}

export interface IPersonalInfoModel {
    approval: ApprovalStatus;
    personalCode?: string | null;
    firstName: string;
    lastName: string;
    userName?: string | null;
    nationality?: string | null;
    birthPlace?: string | null;
    birthdate?: Date | null;
    deathDate?: Date | null;
    createdAt?: Date | null;
    gender?: Gender | null;
    activeProfileImageId?: string | null;
    signatureImages: FileModel[];
    officialProfileImages: FileModel[];
    customProfileImages: FileModel[];
    identificationDocuments: FileModel[];
    recentProfileImageChange?: HistoryDetails | null;
    created?: HistoryDetails | null;
    changeInfo?: HistoryDetails | null;
    updatedAt: Date;
    isActive: boolean;
    version: number;
}

export enum ApprovalStatus {
    Unchecked = "unchecked",
    Approved = "approved",
    Rejected = "rejected",
}

export enum Gender {
    Undefined = "undefined",
    Male = "male",
    Female = "female",
}

export class UpdatePersonalInfoRequest implements IUpdatePersonalInfoRequest {
    firstName!: string;
    lastName!: string;
    nationality?: string | null;
    withoutNationality!: boolean;
    birthPlace?: string | null;
    birthdate?: Date | null;
    gender?: Gender | null;
    addedSignatureImages!: TempFileModel[];
    addedCustomProfileImages!: TempFileModel[];
    addedIdentificationDocuments!: TempFileModel[];
    version!: number;
    applicationId?: string | null;

    constructor(data?: IUpdatePersonalInfoRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.firstName = "";
            this.lastName = "";
            this.withoutNationality = false;
            this.addedSignatureImages = [];
            this.addedCustomProfileImages = [];
            this.addedIdentificationDocuments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : "";
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : "";
            this.nationality = _data["nationality"] !== undefined ? _data["nationality"] : <any>null;
            this.withoutNationality = _data["withoutNationality"] !== undefined ? _data["withoutNationality"] : false;
            this.birthPlace = _data["birthPlace"] !== undefined ? _data["birthPlace"] : <any>null;
            this.birthdate = _data["birthdate"] ? new Date(_data["birthdate"].toString()) : <any>null;
            this.gender = _data["gender"] !== undefined ? _data["gender"] : <any>null;
            if (Array.isArray(_data["addedSignatureImages"])) {
                this.addedSignatureImages = [] as any;
                for (let item of _data["addedSignatureImages"])
                    this.addedSignatureImages!.push(TempFileModel.fromJS(item));
            }
            else {
                this.addedSignatureImages = <any>null;
            }
            if (Array.isArray(_data["addedCustomProfileImages"])) {
                this.addedCustomProfileImages = [] as any;
                for (let item of _data["addedCustomProfileImages"])
                    this.addedCustomProfileImages!.push(TempFileModel.fromJS(item));
            }
            else {
                this.addedCustomProfileImages = <any>null;
            }
            if (Array.isArray(_data["addedIdentificationDocuments"])) {
                this.addedIdentificationDocuments = [] as any;
                for (let item of _data["addedIdentificationDocuments"])
                    this.addedIdentificationDocuments!.push(TempFileModel.fromJS(item));
            }
            else {
                this.addedIdentificationDocuments = <any>null;
            }
            this.version = _data["version"] !== undefined ? _data["version"] : <any>null;
            this.applicationId = _data["applicationId"] !== undefined ? _data["applicationId"] : <any>null;
        }
    }

    static fromJS(data: any): UpdatePersonalInfoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePersonalInfoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["nationality"] = this.nationality !== undefined ? this.nationality : <any>null;
        data["withoutNationality"] = this.withoutNationality !== undefined ? this.withoutNationality : <any>null;
        data["birthPlace"] = this.birthPlace !== undefined ? this.birthPlace : <any>null;
        data["birthdate"] = this.birthdate ? this.birthdate.toISOString() : <any>null;
        data["gender"] = this.gender !== undefined ? this.gender : <any>null;
        if (Array.isArray(this.addedSignatureImages)) {
            data["addedSignatureImages"] = [];
            for (let item of this.addedSignatureImages)
                data["addedSignatureImages"].push(item.toJSON());
        }
        if (Array.isArray(this.addedCustomProfileImages)) {
            data["addedCustomProfileImages"] = [];
            for (let item of this.addedCustomProfileImages)
                data["addedCustomProfileImages"].push(item.toJSON());
        }
        if (Array.isArray(this.addedIdentificationDocuments)) {
            data["addedIdentificationDocuments"] = [];
            for (let item of this.addedIdentificationDocuments)
                data["addedIdentificationDocuments"].push(item.toJSON());
        }
        data["version"] = this.version !== undefined ? this.version : <any>null;
        data["applicationId"] = this.applicationId !== undefined ? this.applicationId : <any>null;
        return data;
    }
}

export interface IUpdatePersonalInfoRequest {
    firstName: string;
    lastName: string;
    nationality?: string | null;
    withoutNationality: boolean;
    birthPlace?: string | null;
    birthdate?: Date | null;
    gender?: Gender | null;
    addedSignatureImages: TempFileModel[];
    addedCustomProfileImages: TempFileModel[];
    addedIdentificationDocuments: TempFileModel[];
    version: number;
    applicationId?: string | null;
}

export class PersonalInfoOptions implements IPersonalInfoOptions {
    countries!: CountryLightModel[];
    characteristics!: SeafarerCharacteristicModel[];

    constructor(data?: IPersonalInfoOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.countries = [];
            this.characteristics = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(CountryLightModel.fromJS(item));
            }
            else {
                this.countries = <any>null;
            }
            if (Array.isArray(_data["characteristics"])) {
                this.characteristics = [] as any;
                for (let item of _data["characteristics"])
                    this.characteristics!.push(SeafarerCharacteristicModel.fromJS(item));
            }
            else {
                this.characteristics = <any>null;
            }
        }
    }

    static fromJS(data: any): PersonalInfoOptions {
        data = typeof data === 'object' ? data : {};
        let result = new PersonalInfoOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item.toJSON());
        }
        if (Array.isArray(this.characteristics)) {
            data["characteristics"] = [];
            for (let item of this.characteristics)
                data["characteristics"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPersonalInfoOptions {
    countries: CountryLightModel[];
    characteristics: SeafarerCharacteristicModel[];
}

export class SeafarerCharacteristicModel implements ISeafarerCharacteristicModel {
    id!: string;
    name!: string;

    constructor(data?: ISeafarerCharacteristicModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): SeafarerCharacteristicModel {
        data = typeof data === 'object' ? data : {};
        let result = new SeafarerCharacteristicModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface ISeafarerCharacteristicModel {
    id: string;
    name: string;
}

export class UpdateContactInfoRequest implements IUpdateContactInfoRequest {
    phoneNumber!: string;
    email!: string;
    address!: AddressModel;

    constructor(data?: IUpdateContactInfoRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.phoneNumber = "";
            this.email = "";
            this.address = new AddressModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : "";
            this.email = _data["email"] !== undefined ? _data["email"] : "";
            this.address = _data["address"] ? AddressModel.fromJS(_data["address"]) : new AddressModel();
        }
    }

    static fromJS(data: any): UpdateContactInfoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateContactInfoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["address"] = this.address ? this.address.toJSON() : <any>null;
        return data;
    }
}

export interface IUpdateContactInfoRequest {
    phoneNumber: string;
    email: string;
    address: AddressModel;
}

export class SeafarerMaritimeInfoModel implements ISeafarerMaritimeInfoModel {
    characteristicId?: string | null;
    remark!: string;
    additionalInfo!: string;

    constructor(data?: ISeafarerMaritimeInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.remark = "";
            this.additionalInfo = "";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.characteristicId = _data["characteristicId"] !== undefined ? _data["characteristicId"] : <any>null;
            this.remark = _data["remark"] !== undefined ? _data["remark"] : "";
            this.additionalInfo = _data["additionalInfo"] !== undefined ? _data["additionalInfo"] : "";
        }
    }

    static fromJS(data: any): SeafarerMaritimeInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new SeafarerMaritimeInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["characteristicId"] = this.characteristicId !== undefined ? this.characteristicId : <any>null;
        data["remark"] = this.remark !== undefined ? this.remark : <any>null;
        data["additionalInfo"] = this.additionalInfo !== undefined ? this.additionalInfo : <any>null;
        return data;
    }
}

export interface ISeafarerMaritimeInfoModel {
    characteristicId?: string | null;
    remark: string;
    additionalInfo: string;
}

export class PersonalInfoActions implements IPersonalInfoActions {
    canApprove!: boolean;
    canReject!: boolean;
    canViewMaritimeInfo!: boolean;
    canUpdatePersonalInfo!: boolean;
    canUpdatePersonalCode!: boolean;
    canUpdateUsername!: boolean;
    canChangeEmailNotificationPreferences!: boolean;
    canChooseActiveProfileImage!: boolean;
    canEditAndApprove!: boolean;
    isOfficial!: boolean;

    constructor(data?: IPersonalInfoActions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canApprove = _data["canApprove"] !== undefined ? _data["canApprove"] : <any>null;
            this.canReject = _data["canReject"] !== undefined ? _data["canReject"] : <any>null;
            this.canViewMaritimeInfo = _data["canViewMaritimeInfo"] !== undefined ? _data["canViewMaritimeInfo"] : <any>null;
            this.canUpdatePersonalInfo = _data["canUpdatePersonalInfo"] !== undefined ? _data["canUpdatePersonalInfo"] : <any>null;
            this.canUpdatePersonalCode = _data["canUpdatePersonalCode"] !== undefined ? _data["canUpdatePersonalCode"] : <any>null;
            this.canUpdateUsername = _data["canUpdateUsername"] !== undefined ? _data["canUpdateUsername"] : <any>null;
            this.canChangeEmailNotificationPreferences = _data["canChangeEmailNotificationPreferences"] !== undefined ? _data["canChangeEmailNotificationPreferences"] : <any>null;
            this.canChooseActiveProfileImage = _data["canChooseActiveProfileImage"] !== undefined ? _data["canChooseActiveProfileImage"] : <any>null;
            this.canEditAndApprove = _data["canEditAndApprove"] !== undefined ? _data["canEditAndApprove"] : <any>null;
            this.isOfficial = _data["isOfficial"] !== undefined ? _data["isOfficial"] : <any>null;
        }
    }

    static fromJS(data: any): PersonalInfoActions {
        data = typeof data === 'object' ? data : {};
        let result = new PersonalInfoActions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canApprove"] = this.canApprove !== undefined ? this.canApprove : <any>null;
        data["canReject"] = this.canReject !== undefined ? this.canReject : <any>null;
        data["canViewMaritimeInfo"] = this.canViewMaritimeInfo !== undefined ? this.canViewMaritimeInfo : <any>null;
        data["canUpdatePersonalInfo"] = this.canUpdatePersonalInfo !== undefined ? this.canUpdatePersonalInfo : <any>null;
        data["canUpdatePersonalCode"] = this.canUpdatePersonalCode !== undefined ? this.canUpdatePersonalCode : <any>null;
        data["canUpdateUsername"] = this.canUpdateUsername !== undefined ? this.canUpdateUsername : <any>null;
        data["canChangeEmailNotificationPreferences"] = this.canChangeEmailNotificationPreferences !== undefined ? this.canChangeEmailNotificationPreferences : <any>null;
        data["canChooseActiveProfileImage"] = this.canChooseActiveProfileImage !== undefined ? this.canChooseActiveProfileImage : <any>null;
        data["canEditAndApprove"] = this.canEditAndApprove !== undefined ? this.canEditAndApprove : <any>null;
        data["isOfficial"] = this.isOfficial !== undefined ? this.isOfficial : <any>null;
        return data;
    }
}

export interface IPersonalInfoActions {
    canApprove: boolean;
    canReject: boolean;
    canViewMaritimeInfo: boolean;
    canUpdatePersonalInfo: boolean;
    canUpdatePersonalCode: boolean;
    canUpdateUsername: boolean;
    canChangeEmailNotificationPreferences: boolean;
    canChooseActiveProfileImage: boolean;
    canEditAndApprove: boolean;
    isOfficial: boolean;
}

export class UpdatePersonalInfoFromRRResponse implements IUpdatePersonalInfoFromRRResponse {
    isProfileImageProvided!: boolean;
    isSignatureImageProvided!: boolean;

    constructor(data?: IUpdatePersonalInfoFromRRResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isProfileImageProvided = _data["isProfileImageProvided"] !== undefined ? _data["isProfileImageProvided"] : <any>null;
            this.isSignatureImageProvided = _data["isSignatureImageProvided"] !== undefined ? _data["isSignatureImageProvided"] : <any>null;
        }
    }

    static fromJS(data: any): UpdatePersonalInfoFromRRResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePersonalInfoFromRRResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isProfileImageProvided"] = this.isProfileImageProvided !== undefined ? this.isProfileImageProvided : <any>null;
        data["isSignatureImageProvided"] = this.isSignatureImageProvided !== undefined ? this.isSignatureImageProvided : <any>null;
        return data;
    }
}

export interface IUpdatePersonalInfoFromRRResponse {
    isProfileImageProvided: boolean;
    isSignatureImageProvided: boolean;
}

export class UpdateSeafarerPersonalCodeModel implements IUpdateSeafarerPersonalCodeModel {
    personalCode!: string;

    constructor(data?: IUpdateSeafarerPersonalCodeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.personalCode = "";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.personalCode = _data["personalCode"] !== undefined ? _data["personalCode"] : "";
        }
    }

    static fromJS(data: any): UpdateSeafarerPersonalCodeModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSeafarerPersonalCodeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["personalCode"] = this.personalCode !== undefined ? this.personalCode : <any>null;
        return data;
    }
}

export interface IUpdateSeafarerPersonalCodeModel {
    personalCode: string;
}

export class UpdateSeafarerUsernameModel implements IUpdateSeafarerUsernameModel {
    username?: string | null;

    constructor(data?: IUpdateSeafarerUsernameModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"] !== undefined ? _data["username"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateSeafarerUsernameModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSeafarerUsernameModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username !== undefined ? this.username : <any>null;
        return data;
    }
}

export interface IUpdateSeafarerUsernameModel {
    username?: string | null;
}

export class PagedResultOfSeafarerProfileLightViewModel implements IPagedResultOfSeafarerProfileLightViewModel {
    pageNumber!: number;
    pageSize!: number;
    pageResult!: SeafarerProfileLightViewModel[];
    totalCount!: number;

    constructor(data?: IPagedResultOfSeafarerProfileLightViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageResult = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"] !== undefined ? _data["pageNumber"] : <any>null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : <any>null;
            if (Array.isArray(_data["pageResult"])) {
                this.pageResult = [] as any;
                for (let item of _data["pageResult"])
                    this.pageResult!.push(SeafarerProfileLightViewModel.fromJS(item));
            }
            else {
                this.pageResult = <any>null;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): PagedResultOfSeafarerProfileLightViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfSeafarerProfileLightViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber !== undefined ? this.pageNumber : <any>null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
        if (Array.isArray(this.pageResult)) {
            data["pageResult"] = [];
            for (let item of this.pageResult)
                data["pageResult"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data;
    }
}

export interface IPagedResultOfSeafarerProfileLightViewModel {
    pageNumber: number;
    pageSize: number;
    pageResult: SeafarerProfileLightViewModel[];
    totalCount: number;
}

export class SeafarerProfileLightViewModel implements ISeafarerProfileLightViewModel {
    id!: string;
    firstName!: string;
    lastName!: string;
    personalCode?: string | null;
    birthDate!: Date;
    nationality?: string | null;
    createdAt!: Date;
    isActive!: boolean;
    approval!: ApprovalStatus;
    hasInfo!: boolean;

    constructor(data?: ISeafarerProfileLightViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.personalCode = _data["personalCode"] !== undefined ? _data["personalCode"] : <any>null;
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>null;
            this.nationality = _data["nationality"] !== undefined ? _data["nationality"] : <any>null;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.approval = _data["approval"] !== undefined ? _data["approval"] : <any>null;
            this.hasInfo = _data["hasInfo"] !== undefined ? _data["hasInfo"] : <any>null;
        }
    }

    static fromJS(data: any): SeafarerProfileLightViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SeafarerProfileLightViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["personalCode"] = this.personalCode !== undefined ? this.personalCode : <any>null;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>null;
        data["nationality"] = this.nationality !== undefined ? this.nationality : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["approval"] = this.approval !== undefined ? this.approval : <any>null;
        data["hasInfo"] = this.hasInfo !== undefined ? this.hasInfo : <any>null;
        return data;
    }
}

export interface ISeafarerProfileLightViewModel {
    id: string;
    firstName: string;
    lastName: string;
    personalCode?: string | null;
    birthDate: Date;
    nationality?: string | null;
    createdAt: Date;
    isActive: boolean;
    approval: ApprovalStatus;
    hasInfo: boolean;
}

export enum SeafarerProfileSortField {
    FirstNameAsc = "firstNameAsc",
    FirstNameDesc = "firstNameDesc",
    LastNameAsc = "lastNameAsc",
    LastNameDesc = "lastNameDesc",
    ApprovalAsc = "approvalAsc",
    ApprovalDesc = "approvalDesc",
}

export class SeafarerActions implements ISeafarerActions {
    canViewQualifications!: boolean;
    canViewMedicalCertificates!: boolean;
    canViewCertificates!: boolean;
    canViewEndorsements!: boolean;
    canViewPersonalInformation!: boolean;
    canViewPractices!: boolean;
    canViewBasicInfo!: boolean;
    canViewSharedResources!: boolean;
    canDeactivateSeafarer!: boolean;
    canActivateSeafarer!: boolean;
    canEnterForeignCertificate!: boolean;
    canStartApplicationForSeafarer!: boolean;
    canViewAllDocuments!: boolean;
    canStartConcessionPermitApplication!: boolean;

    constructor(data?: ISeafarerActions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canViewQualifications = _data["canViewQualifications"] !== undefined ? _data["canViewQualifications"] : <any>null;
            this.canViewMedicalCertificates = _data["canViewMedicalCertificates"] !== undefined ? _data["canViewMedicalCertificates"] : <any>null;
            this.canViewCertificates = _data["canViewCertificates"] !== undefined ? _data["canViewCertificates"] : <any>null;
            this.canViewEndorsements = _data["canViewEndorsements"] !== undefined ? _data["canViewEndorsements"] : <any>null;
            this.canViewPersonalInformation = _data["canViewPersonalInformation"] !== undefined ? _data["canViewPersonalInformation"] : <any>null;
            this.canViewPractices = _data["canViewPractices"] !== undefined ? _data["canViewPractices"] : <any>null;
            this.canViewBasicInfo = _data["canViewBasicInfo"] !== undefined ? _data["canViewBasicInfo"] : <any>null;
            this.canViewSharedResources = _data["canViewSharedResources"] !== undefined ? _data["canViewSharedResources"] : <any>null;
            this.canDeactivateSeafarer = _data["canDeactivateSeafarer"] !== undefined ? _data["canDeactivateSeafarer"] : <any>null;
            this.canActivateSeafarer = _data["canActivateSeafarer"] !== undefined ? _data["canActivateSeafarer"] : <any>null;
            this.canEnterForeignCertificate = _data["canEnterForeignCertificate"] !== undefined ? _data["canEnterForeignCertificate"] : <any>null;
            this.canStartApplicationForSeafarer = _data["canStartApplicationForSeafarer"] !== undefined ? _data["canStartApplicationForSeafarer"] : <any>null;
            this.canViewAllDocuments = _data["canViewAllDocuments"] !== undefined ? _data["canViewAllDocuments"] : <any>null;
            this.canStartConcessionPermitApplication = _data["canStartConcessionPermitApplication"] !== undefined ? _data["canStartConcessionPermitApplication"] : <any>null;
        }
    }

    static fromJS(data: any): SeafarerActions {
        data = typeof data === 'object' ? data : {};
        let result = new SeafarerActions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canViewQualifications"] = this.canViewQualifications !== undefined ? this.canViewQualifications : <any>null;
        data["canViewMedicalCertificates"] = this.canViewMedicalCertificates !== undefined ? this.canViewMedicalCertificates : <any>null;
        data["canViewCertificates"] = this.canViewCertificates !== undefined ? this.canViewCertificates : <any>null;
        data["canViewEndorsements"] = this.canViewEndorsements !== undefined ? this.canViewEndorsements : <any>null;
        data["canViewPersonalInformation"] = this.canViewPersonalInformation !== undefined ? this.canViewPersonalInformation : <any>null;
        data["canViewPractices"] = this.canViewPractices !== undefined ? this.canViewPractices : <any>null;
        data["canViewBasicInfo"] = this.canViewBasicInfo !== undefined ? this.canViewBasicInfo : <any>null;
        data["canViewSharedResources"] = this.canViewSharedResources !== undefined ? this.canViewSharedResources : <any>null;
        data["canDeactivateSeafarer"] = this.canDeactivateSeafarer !== undefined ? this.canDeactivateSeafarer : <any>null;
        data["canActivateSeafarer"] = this.canActivateSeafarer !== undefined ? this.canActivateSeafarer : <any>null;
        data["canEnterForeignCertificate"] = this.canEnterForeignCertificate !== undefined ? this.canEnterForeignCertificate : <any>null;
        data["canStartApplicationForSeafarer"] = this.canStartApplicationForSeafarer !== undefined ? this.canStartApplicationForSeafarer : <any>null;
        data["canViewAllDocuments"] = this.canViewAllDocuments !== undefined ? this.canViewAllDocuments : <any>null;
        data["canStartConcessionPermitApplication"] = this.canStartConcessionPermitApplication !== undefined ? this.canStartConcessionPermitApplication : <any>null;
        return data;
    }
}

export interface ISeafarerActions {
    canViewQualifications: boolean;
    canViewMedicalCertificates: boolean;
    canViewCertificates: boolean;
    canViewEndorsements: boolean;
    canViewPersonalInformation: boolean;
    canViewPractices: boolean;
    canViewBasicInfo: boolean;
    canViewSharedResources: boolean;
    canDeactivateSeafarer: boolean;
    canActivateSeafarer: boolean;
    canEnterForeignCertificate: boolean;
    canStartApplicationForSeafarer: boolean;
    canViewAllDocuments: boolean;
    canStartConcessionPermitApplication: boolean;
}

export class SearchSeafarersActions implements ISearchSeafarersActions {
    canSearchForAllSeafarers!: boolean;
    canAddSeafarerWithPersonalCode!: boolean;
    canAddSeafarerWithoutPersonalCode!: boolean;
    canViewInactiveSeafarers!: boolean;

    constructor(data?: ISearchSeafarersActions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canSearchForAllSeafarers = _data["canSearchForAllSeafarers"] !== undefined ? _data["canSearchForAllSeafarers"] : <any>null;
            this.canAddSeafarerWithPersonalCode = _data["canAddSeafarerWithPersonalCode"] !== undefined ? _data["canAddSeafarerWithPersonalCode"] : <any>null;
            this.canAddSeafarerWithoutPersonalCode = _data["canAddSeafarerWithoutPersonalCode"] !== undefined ? _data["canAddSeafarerWithoutPersonalCode"] : <any>null;
            this.canViewInactiveSeafarers = _data["canViewInactiveSeafarers"] !== undefined ? _data["canViewInactiveSeafarers"] : <any>null;
        }
    }

    static fromJS(data: any): SearchSeafarersActions {
        data = typeof data === 'object' ? data : {};
        let result = new SearchSeafarersActions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canSearchForAllSeafarers"] = this.canSearchForAllSeafarers !== undefined ? this.canSearchForAllSeafarers : <any>null;
        data["canAddSeafarerWithPersonalCode"] = this.canAddSeafarerWithPersonalCode !== undefined ? this.canAddSeafarerWithPersonalCode : <any>null;
        data["canAddSeafarerWithoutPersonalCode"] = this.canAddSeafarerWithoutPersonalCode !== undefined ? this.canAddSeafarerWithoutPersonalCode : <any>null;
        data["canViewInactiveSeafarers"] = this.canViewInactiveSeafarers !== undefined ? this.canViewInactiveSeafarers : <any>null;
        return data;
    }
}

export interface ISearchSeafarersActions {
    canSearchForAllSeafarers: boolean;
    canAddSeafarerWithPersonalCode: boolean;
    canAddSeafarerWithoutPersonalCode: boolean;
    canViewInactiveSeafarers: boolean;
}

export class AddSeafarerResultModel implements IAddSeafarerResultModel {
    id!: string;

    constructor(data?: IAddSeafarerResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): AddSeafarerResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddSeafarerResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }
}

export interface IAddSeafarerResultModel {
    id: string;
}

export class AddSeafarerWithoutPersonalCodeModel implements IAddSeafarerWithoutPersonalCodeModel {
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    nationality?: string | null;
    withoutNationality!: boolean;
    birthdate?: Date | null;
    gender?: Gender | null;
    addedIdentificationDocuments!: TempFileModel[];

    constructor(data?: IAddSeafarerWithoutPersonalCodeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.withoutNationality = false;
            this.gender = Gender.Undefined;
            this.addedIdentificationDocuments = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.nationality = _data["nationality"] !== undefined ? _data["nationality"] : <any>null;
            this.withoutNationality = _data["withoutNationality"] !== undefined ? _data["withoutNationality"] : false;
            this.birthdate = _data["birthdate"] ? new Date(_data["birthdate"].toString()) : <any>null;
            this.gender = _data["gender"] !== undefined ? _data["gender"] : Gender.Undefined;
            if (Array.isArray(_data["addedIdentificationDocuments"])) {
                this.addedIdentificationDocuments = [] as any;
                for (let item of _data["addedIdentificationDocuments"])
                    this.addedIdentificationDocuments!.push(TempFileModel.fromJS(item));
            }
            else {
                this.addedIdentificationDocuments = <any>null;
            }
        }
    }

    static fromJS(data: any): AddSeafarerWithoutPersonalCodeModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddSeafarerWithoutPersonalCodeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["nationality"] = this.nationality !== undefined ? this.nationality : <any>null;
        data["withoutNationality"] = this.withoutNationality !== undefined ? this.withoutNationality : <any>null;
        data["birthdate"] = this.birthdate ? this.birthdate.toISOString() : <any>null;
        data["gender"] = this.gender !== undefined ? this.gender : <any>null;
        if (Array.isArray(this.addedIdentificationDocuments)) {
            data["addedIdentificationDocuments"] = [];
            for (let item of this.addedIdentificationDocuments)
                data["addedIdentificationDocuments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAddSeafarerWithoutPersonalCodeModel {
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    nationality?: string | null;
    withoutNationality: boolean;
    birthdate?: Date | null;
    gender?: Gender | null;
    addedIdentificationDocuments: TempFileModel[];
}

export class BecomeSeafarerResultModel implements IBecomeSeafarerResultModel {
    seafarerId?: string | null;
    alreadyHasSeafarerProfile!: boolean;

    constructor(data?: IBecomeSeafarerResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seafarerId = _data["seafarerId"] !== undefined ? _data["seafarerId"] : <any>null;
            this.alreadyHasSeafarerProfile = _data["alreadyHasSeafarerProfile"] !== undefined ? _data["alreadyHasSeafarerProfile"] : <any>null;
        }
    }

    static fromJS(data: any): BecomeSeafarerResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new BecomeSeafarerResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seafarerId"] = this.seafarerId !== undefined ? this.seafarerId : <any>null;
        data["alreadyHasSeafarerProfile"] = this.alreadyHasSeafarerProfile !== undefined ? this.alreadyHasSeafarerProfile : <any>null;
        return data;
    }
}

export interface IBecomeSeafarerResultModel {
    seafarerId?: string | null;
    alreadyHasSeafarerProfile: boolean;
}

export class SeafarerBasicInfoModel implements ISeafarerBasicInfoModel {
    firstName!: string;
    lastName!: string;
    personalCode?: string | null;
    birthDate!: Date;
    approval!: ApprovalStatus;
    isActive!: boolean;

    constructor(data?: ISeafarerBasicInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.personalCode = _data["personalCode"] !== undefined ? _data["personalCode"] : <any>null;
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>null;
            this.approval = _data["approval"] !== undefined ? _data["approval"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): SeafarerBasicInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new SeafarerBasicInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["personalCode"] = this.personalCode !== undefined ? this.personalCode : <any>null;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>null;
        data["approval"] = this.approval !== undefined ? this.approval : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data;
    }
}

export interface ISeafarerBasicInfoModel {
    firstName: string;
    lastName: string;
    personalCode?: string | null;
    birthDate: Date;
    approval: ApprovalStatus;
    isActive: boolean;
}

export class EnterForeignCertificateRequest implements IEnterForeignCertificateRequest {
    documentNumber!: string;
    certificateTypeId?: string | null;
    issueDate?: Date | null;
    validUntil?: Date | null;
    additionalInfo?: string | null;
    issuerCountryCode?: string | null;
    addedFiles!: TempFileModel[];

    constructor(data?: IEnterForeignCertificateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.addedFiles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentNumber = _data["documentNumber"] !== undefined ? _data["documentNumber"] : <any>null;
            this.certificateTypeId = _data["certificateTypeId"] !== undefined ? _data["certificateTypeId"] : <any>null;
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : <any>null;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : <any>null;
            this.additionalInfo = _data["additionalInfo"] !== undefined ? _data["additionalInfo"] : <any>null;
            this.issuerCountryCode = _data["issuerCountryCode"] !== undefined ? _data["issuerCountryCode"] : <any>null;
            if (Array.isArray(_data["addedFiles"])) {
                this.addedFiles = [] as any;
                for (let item of _data["addedFiles"])
                    this.addedFiles!.push(TempFileModel.fromJS(item));
            }
            else {
                this.addedFiles = <any>null;
            }
        }
    }

    static fromJS(data: any): EnterForeignCertificateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EnterForeignCertificateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentNumber"] = this.documentNumber !== undefined ? this.documentNumber : <any>null;
        data["certificateTypeId"] = this.certificateTypeId !== undefined ? this.certificateTypeId : <any>null;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : <any>null;
        data["additionalInfo"] = this.additionalInfo !== undefined ? this.additionalInfo : <any>null;
        data["issuerCountryCode"] = this.issuerCountryCode !== undefined ? this.issuerCountryCode : <any>null;
        if (Array.isArray(this.addedFiles)) {
            data["addedFiles"] = [];
            for (let item of this.addedFiles)
                data["addedFiles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEnterForeignCertificateRequest {
    documentNumber: string;
    certificateTypeId?: string | null;
    issueDate?: Date | null;
    validUntil?: Date | null;
    additionalInfo?: string | null;
    issuerCountryCode?: string | null;
    addedFiles: TempFileModel[];
}

export class UpdateOrganizationContactInfoModel implements IUpdateOrganizationContactInfoModel {
    phone!: string;
    email!: string;
    address!: string;

    constructor(data?: IUpdateOrganizationContactInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.address = _data["address"] !== undefined ? _data["address"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateOrganizationContactInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateOrganizationContactInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["address"] = this.address !== undefined ? this.address : <any>null;
        return data;
    }
}

export interface IUpdateOrganizationContactInfoModel {
    phone: string;
    email: string;
    address: string;
}

export class AddRepresentativeModel implements IAddRepresentativeModel {
    firstName!: string;
    lastName!: string;
    username?: string | null;
    personalCode?: string | null;
    roles!: RoleModel[];
    phone?: string | null;
    contactEmail?: string | null;
    addedSignatureImages!: TempFileModel[];

    constructor(data?: IAddRepresentativeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.roles = [];
            this.addedSignatureImages = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.username = _data["username"] !== undefined ? _data["username"] : <any>null;
            this.personalCode = _data["personalCode"] !== undefined ? _data["personalCode"] : <any>null;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(RoleModel.fromJS(item));
            }
            else {
                this.roles = <any>null;
            }
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.contactEmail = _data["contactEmail"] !== undefined ? _data["contactEmail"] : <any>null;
            if (Array.isArray(_data["addedSignatureImages"])) {
                this.addedSignatureImages = [] as any;
                for (let item of _data["addedSignatureImages"])
                    this.addedSignatureImages!.push(TempFileModel.fromJS(item));
            }
            else {
                this.addedSignatureImages = <any>null;
            }
        }
    }

    static fromJS(data: any): AddRepresentativeModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddRepresentativeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["username"] = this.username !== undefined ? this.username : <any>null;
        data["personalCode"] = this.personalCode !== undefined ? this.personalCode : <any>null;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["contactEmail"] = this.contactEmail !== undefined ? this.contactEmail : <any>null;
        if (Array.isArray(this.addedSignatureImages)) {
            data["addedSignatureImages"] = [];
            for (let item of this.addedSignatureImages)
                data["addedSignatureImages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAddRepresentativeModel {
    firstName: string;
    lastName: string;
    username?: string | null;
    personalCode?: string | null;
    roles: RoleModel[];
    phone?: string | null;
    contactEmail?: string | null;
    addedSignatureImages: TempFileModel[];
}

export class UpdateRepresentativeModel implements IUpdateRepresentativeModel {
    firstName!: string;
    lastName!: string;
    username?: string | null;
    personalCode?: string | null;
    roles!: RoleModel[];
    phone?: string | null;
    contactEmail?: string | null;
    addedSignatureImages!: TempFileModel[];

    constructor(data?: IUpdateRepresentativeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.roles = [];
            this.addedSignatureImages = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.username = _data["username"] !== undefined ? _data["username"] : <any>null;
            this.personalCode = _data["personalCode"] !== undefined ? _data["personalCode"] : <any>null;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(RoleModel.fromJS(item));
            }
            else {
                this.roles = <any>null;
            }
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.contactEmail = _data["contactEmail"] !== undefined ? _data["contactEmail"] : <any>null;
            if (Array.isArray(_data["addedSignatureImages"])) {
                this.addedSignatureImages = [] as any;
                for (let item of _data["addedSignatureImages"])
                    this.addedSignatureImages!.push(TempFileModel.fromJS(item));
            }
            else {
                this.addedSignatureImages = <any>null;
            }
        }
    }

    static fromJS(data: any): UpdateRepresentativeModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRepresentativeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["username"] = this.username !== undefined ? this.username : <any>null;
        data["personalCode"] = this.personalCode !== undefined ? this.personalCode : <any>null;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["contactEmail"] = this.contactEmail !== undefined ? this.contactEmail : <any>null;
        if (Array.isArray(this.addedSignatureImages)) {
            data["addedSignatureImages"] = [];
            for (let item of this.addedSignatureImages)
                data["addedSignatureImages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpdateRepresentativeModel {
    firstName: string;
    lastName: string;
    username?: string | null;
    personalCode?: string | null;
    roles: RoleModel[];
    phone?: string | null;
    contactEmail?: string | null;
    addedSignatureImages: TempFileModel[];
}

export class OrganizationActions implements IOrganizationActions {
    canViewOrganization!: boolean;
    canManageRepresentatives!: boolean;
    currentRepresentativeId?: string | null;
    canUpdateContactInfo!: boolean;
    canAddSignatureImage!: boolean;
    canViewSignatureImage!: boolean;

    constructor(data?: IOrganizationActions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canViewOrganization = _data["canViewOrganization"] !== undefined ? _data["canViewOrganization"] : <any>null;
            this.canManageRepresentatives = _data["canManageRepresentatives"] !== undefined ? _data["canManageRepresentatives"] : <any>null;
            this.currentRepresentativeId = _data["currentRepresentativeId"] !== undefined ? _data["currentRepresentativeId"] : <any>null;
            this.canUpdateContactInfo = _data["canUpdateContactInfo"] !== undefined ? _data["canUpdateContactInfo"] : <any>null;
            this.canAddSignatureImage = _data["canAddSignatureImage"] !== undefined ? _data["canAddSignatureImage"] : <any>null;
            this.canViewSignatureImage = _data["canViewSignatureImage"] !== undefined ? _data["canViewSignatureImage"] : <any>null;
        }
    }

    static fromJS(data: any): OrganizationActions {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationActions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canViewOrganization"] = this.canViewOrganization !== undefined ? this.canViewOrganization : <any>null;
        data["canManageRepresentatives"] = this.canManageRepresentatives !== undefined ? this.canManageRepresentatives : <any>null;
        data["currentRepresentativeId"] = this.currentRepresentativeId !== undefined ? this.currentRepresentativeId : <any>null;
        data["canUpdateContactInfo"] = this.canUpdateContactInfo !== undefined ? this.canUpdateContactInfo : <any>null;
        data["canAddSignatureImage"] = this.canAddSignatureImage !== undefined ? this.canAddSignatureImage : <any>null;
        data["canViewSignatureImage"] = this.canViewSignatureImage !== undefined ? this.canViewSignatureImage : <any>null;
        return data;
    }
}

export interface IOrganizationActions {
    canViewOrganization: boolean;
    canManageRepresentatives: boolean;
    currentRepresentativeId?: string | null;
    canUpdateContactInfo: boolean;
    canAddSignatureImage: boolean;
    canViewSignatureImage: boolean;
}

export class Official implements IOfficial {
    id!: string;
    fullName!: string;

    constructor(data?: IOfficial) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
        }
    }

    static fromJS(data: any): Official {
        data = typeof data === 'object' ? data : {};
        let result = new Official();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        return data;
    }
}

export interface IOfficial {
    id: string;
    fullName: string;
}

export class PagedResultOfNotificationModel implements IPagedResultOfNotificationModel {
    pageNumber!: number;
    pageSize!: number;
    pageResult!: NotificationModel[];
    totalCount!: number;

    constructor(data?: IPagedResultOfNotificationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageResult = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"] !== undefined ? _data["pageNumber"] : <any>null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : <any>null;
            if (Array.isArray(_data["pageResult"])) {
                this.pageResult = [] as any;
                for (let item of _data["pageResult"])
                    this.pageResult!.push(NotificationModel.fromJS(item));
            }
            else {
                this.pageResult = <any>null;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): PagedResultOfNotificationModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfNotificationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber !== undefined ? this.pageNumber : <any>null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
        if (Array.isArray(this.pageResult)) {
            data["pageResult"] = [];
            for (let item of this.pageResult)
                data["pageResult"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data;
    }
}

export interface IPagedResultOfNotificationModel {
    pageNumber: number;
    pageSize: number;
    pageResult: NotificationModel[];
    totalCount: number;
}

export class NotificationModel implements INotificationModel {
    id!: string;
    createdOn!: Date;
    title!: string;
    htmlContent!: string;
    isUnread!: boolean;

    constructor(data?: INotificationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.htmlContent = _data["htmlContent"] !== undefined ? _data["htmlContent"] : <any>null;
            this.isUnread = _data["isUnread"] !== undefined ? _data["isUnread"] : <any>null;
        }
    }

    static fromJS(data: any): NotificationModel {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["htmlContent"] = this.htmlContent !== undefined ? this.htmlContent : <any>null;
        data["isUnread"] = this.isUnread !== undefined ? this.isUnread : <any>null;
        return data;
    }
}

export interface INotificationModel {
    id: string;
    createdOn: Date;
    title: string;
    htmlContent: string;
    isUnread: boolean;
}

export enum NotificationState {
    Unread = "unread",
    Read = "read",
    Archived = "archived",
}

export class NotificationsActions implements INotificationsActions {
    canReceive!: boolean;

    constructor(data?: INotificationsActions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canReceive = _data["canReceive"] !== undefined ? _data["canReceive"] : <any>null;
        }
    }

    static fromJS(data: any): NotificationsActions {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationsActions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canReceive"] = this.canReceive !== undefined ? this.canReceive : <any>null;
        return data;
    }
}

export interface INotificationsActions {
    canReceive: boolean;
}

export class ListMedicalCertificatesResponse implements IListMedicalCertificatesResponse {
    medicalCertificates!: MedicalCertificateListItem[];

    constructor(data?: IListMedicalCertificatesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.medicalCertificates = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["medicalCertificates"])) {
                this.medicalCertificates = [] as any;
                for (let item of _data["medicalCertificates"])
                    this.medicalCertificates!.push(MedicalCertificateListItem.fromJS(item));
            }
            else {
                this.medicalCertificates = <any>null;
            }
        }
    }

    static fromJS(data: any): ListMedicalCertificatesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListMedicalCertificatesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.medicalCertificates)) {
            data["medicalCertificates"] = [];
            for (let item of this.medicalCertificates)
                data["medicalCertificates"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListMedicalCertificatesResponse {
    medicalCertificates: MedicalCertificateListItem[];
}

export class MedicalCertificateListItem implements IMedicalCertificateListItem {
    id!: string;
    medicalInstitutionName!: string;
    medicalPractitionerFullName!: string;
    positionName!: string;
    issuedAt!: Date;
    validUntil!: Date;
    status!: ValidityStatus;
    restrictionNames!: string[];

    constructor(data?: IMedicalCertificateListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.restrictionNames = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.medicalInstitutionName = _data["medicalInstitutionName"] !== undefined ? _data["medicalInstitutionName"] : <any>null;
            this.medicalPractitionerFullName = _data["medicalPractitionerFullName"] !== undefined ? _data["medicalPractitionerFullName"] : <any>null;
            this.positionName = _data["positionName"] !== undefined ? _data["positionName"] : <any>null;
            this.issuedAt = _data["issuedAt"] ? new Date(_data["issuedAt"].toString()) : <any>null;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            if (Array.isArray(_data["restrictionNames"])) {
                this.restrictionNames = [] as any;
                for (let item of _data["restrictionNames"])
                    this.restrictionNames!.push(item);
            }
            else {
                this.restrictionNames = <any>null;
            }
        }
    }

    static fromJS(data: any): MedicalCertificateListItem {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalCertificateListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["medicalInstitutionName"] = this.medicalInstitutionName !== undefined ? this.medicalInstitutionName : <any>null;
        data["medicalPractitionerFullName"] = this.medicalPractitionerFullName !== undefined ? this.medicalPractitionerFullName : <any>null;
        data["positionName"] = this.positionName !== undefined ? this.positionName : <any>null;
        data["issuedAt"] = this.issuedAt ? this.issuedAt.toISOString() : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        if (Array.isArray(this.restrictionNames)) {
            data["restrictionNames"] = [];
            for (let item of this.restrictionNames)
                data["restrictionNames"].push(item);
        }
        return data;
    }
}

export interface IMedicalCertificateListItem {
    id: string;
    medicalInstitutionName: string;
    medicalPractitionerFullName: string;
    positionName: string;
    issuedAt: Date;
    validUntil: Date;
    status: ValidityStatus;
    restrictionNames: string[];
}

export class PagedResultOfOfficialMedicalCertificateLightViewModel implements IPagedResultOfOfficialMedicalCertificateLightViewModel {
    pageNumber!: number;
    pageSize!: number;
    pageResult!: OfficialMedicalCertificateLightViewModel[];
    totalCount!: number;

    constructor(data?: IPagedResultOfOfficialMedicalCertificateLightViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageResult = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"] !== undefined ? _data["pageNumber"] : <any>null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : <any>null;
            if (Array.isArray(_data["pageResult"])) {
                this.pageResult = [] as any;
                for (let item of _data["pageResult"])
                    this.pageResult!.push(OfficialMedicalCertificateLightViewModel.fromJS(item));
            }
            else {
                this.pageResult = <any>null;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): PagedResultOfOfficialMedicalCertificateLightViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfOfficialMedicalCertificateLightViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber !== undefined ? this.pageNumber : <any>null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
        if (Array.isArray(this.pageResult)) {
            data["pageResult"] = [];
            for (let item of this.pageResult)
                data["pageResult"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data;
    }
}

export interface IPagedResultOfOfficialMedicalCertificateLightViewModel {
    pageNumber: number;
    pageSize: number;
    pageResult: OfficialMedicalCertificateLightViewModel[];
    totalCount: number;
}

export class OfficialMedicalCertificateLightViewModel implements IOfficialMedicalCertificateLightViewModel {
    id!: string;
    name!: string;
    seafarerName!: string;
    seafarerId!: string;
    documentType!: string;
    birthDate!: Date;
    issuedAt!: Date;
    validUntil?: Date | null;
    createdAt?: Date | null;
    status!: ValidityStatus;
    documentNumber!: string;

    constructor(data?: IOfficialMedicalCertificateLightViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.seafarerName = _data["seafarerName"] !== undefined ? _data["seafarerName"] : <any>null;
            this.seafarerId = _data["seafarerId"] !== undefined ? _data["seafarerId"] : <any>null;
            this.documentType = _data["documentType"] !== undefined ? _data["documentType"] : <any>null;
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>null;
            this.issuedAt = _data["issuedAt"] ? new Date(_data["issuedAt"].toString()) : <any>null;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : <any>null;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.documentNumber = _data["documentNumber"] !== undefined ? _data["documentNumber"] : <any>null;
        }
    }

    static fromJS(data: any): OfficialMedicalCertificateLightViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OfficialMedicalCertificateLightViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["seafarerName"] = this.seafarerName !== undefined ? this.seafarerName : <any>null;
        data["seafarerId"] = this.seafarerId !== undefined ? this.seafarerId : <any>null;
        data["documentType"] = this.documentType !== undefined ? this.documentType : <any>null;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>null;
        data["issuedAt"] = this.issuedAt ? this.issuedAt.toISOString() : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["documentNumber"] = this.documentNumber !== undefined ? this.documentNumber : <any>null;
        return data;
    }
}

export interface IOfficialMedicalCertificateLightViewModel {
    id: string;
    name: string;
    seafarerName: string;
    seafarerId: string;
    documentType: string;
    birthDate: Date;
    issuedAt: Date;
    validUntil?: Date | null;
    createdAt?: Date | null;
    status: ValidityStatus;
    documentNumber: string;
}

export class MinimalDocumentModel implements IMinimalDocumentModel {
    id!: string;
    isValid!: boolean;
    documentNumber!: string;
    issuedOn?: Date | null;
    validUntil?: Date | null;

    protected _discriminator: string;

    constructor(data?: IMinimalDocumentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "MinimalDocumentModel";
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.isValid = _data["isValid"] !== undefined ? _data["isValid"] : <any>null;
            this.documentNumber = _data["documentNumber"] !== undefined ? _data["documentNumber"] : <any>null;
            this.issuedOn = _data["issuedOn"] ? new Date(_data["issuedOn"].toString()) : <any>null;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): MinimalDocumentModel {
        data = typeof data === 'object' ? data : {};
        if (data["type"] === "GetMedicalCertificateResponse") {
            let result = new GetMedicalCertificateResponse();
            result.init(data);
            return result;
        }
        if (data["type"] === "EndorsementDetailsModel") {
            let result = new EndorsementDetailsModel();
            result.init(data);
            return result;
        }
        if (data["type"] === "DocumentDetailsModel") {
            throw new Error("The abstract class 'DocumentDetailsModel' cannot be instantiated.");
        }
        if (data["type"] === "CertificateDetailsModel") {
            let result = new CertificateDetailsModel();
            result.init(data);
            return result;
        }
        let result = new MinimalDocumentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this._discriminator;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["isValid"] = this.isValid !== undefined ? this.isValid : <any>null;
        data["documentNumber"] = this.documentNumber !== undefined ? this.documentNumber : <any>null;
        data["issuedOn"] = this.issuedOn ? this.issuedOn.toISOString() : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : <any>null;
        return data;
    }
}

export interface IMinimalDocumentModel {
    id: string;
    isValid: boolean;
    documentNumber: string;
    issuedOn?: Date | null;
    validUntil?: Date | null;
}

export class GetMedicalCertificateResponse extends MinimalDocumentModel implements IGetMedicalCertificateResponse {
    status!: ValidityStatus;
    seafarer!: SeafarerPersonalInfoModel;
    medicalInstitution!: OrganizationSnapshotModel;
    number?: string | null;
    medicalPractitionerId!: string;
    medicalInstitutionId!: string;
    creator!: NameAndOrganization;
    medicalPractitionerFirstName!: string;
    medicalPractitionerLastName!: string;
    currentMedicalPractitionerSignature?: string | null;
    currentSeafarerSignature?: string | null;
    createdAt!: Date;
    identificationDocumentsWereChecked!: boolean;
    restrictionNames!: MultiLanguageString[];
    vision!: VisionAttributes;
    hearing!: HearingAttributes;
    verdict!: VerdictAttributes;
    positionName?: MultiLanguageString | null;
    additionalNotes?: string | null;
    files!: FileModel[];
    rejectionDetails?: RejectionDetailsModel | null;
    printTemplateDownloadUrl!: DownloadUrl;
    accessToken!: string;
    accessTokenUrl!: string;
    usedInApplications!: string[];
    version?: number | null;
    comment!: string;
    updatedAt?: Date | null;
    recentProfileImageChange?: HistoryDetails | null;
    changeInfo?: HistoryDetails | null;
    realCreator?: HistoryDetails | null;

    constructor(data?: IGetMedicalCertificateResponse) {
        super(data);
        if (!data) {
            this.seafarer = new SeafarerPersonalInfoModel();
            this.medicalInstitution = new OrganizationSnapshotModel();
            this.creator = new NameAndOrganization();
            this.restrictionNames = [];
            this.vision = new VisionAttributes();
            this.hearing = new HearingAttributes();
            this.verdict = new VerdictAttributes();
            this.files = [];
            this.printTemplateDownloadUrl = new DownloadUrl();
            this.usedInApplications = [];
        }
        this._discriminator = "GetMedicalCertificateResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.seafarer = _data["seafarer"] ? SeafarerPersonalInfoModel.fromJS(_data["seafarer"]) : new SeafarerPersonalInfoModel();
            this.medicalInstitution = _data["medicalInstitution"] ? OrganizationSnapshotModel.fromJS(_data["medicalInstitution"]) : new OrganizationSnapshotModel();
            this.number = _data["number"] !== undefined ? _data["number"] : <any>null;
            this.medicalPractitionerId = _data["medicalPractitionerId"] !== undefined ? _data["medicalPractitionerId"] : <any>null;
            this.medicalInstitutionId = _data["medicalInstitutionId"] !== undefined ? _data["medicalInstitutionId"] : <any>null;
            this.creator = _data["creator"] ? NameAndOrganization.fromJS(_data["creator"]) : new NameAndOrganization();
            this.medicalPractitionerFirstName = _data["medicalPractitionerFirstName"] !== undefined ? _data["medicalPractitionerFirstName"] : <any>null;
            this.medicalPractitionerLastName = _data["medicalPractitionerLastName"] !== undefined ? _data["medicalPractitionerLastName"] : <any>null;
            this.currentMedicalPractitionerSignature = _data["currentMedicalPractitionerSignature"] !== undefined ? _data["currentMedicalPractitionerSignature"] : <any>null;
            this.currentSeafarerSignature = _data["currentSeafarerSignature"] !== undefined ? _data["currentSeafarerSignature"] : <any>null;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>null;
            this.identificationDocumentsWereChecked = _data["identificationDocumentsWereChecked"] !== undefined ? _data["identificationDocumentsWereChecked"] : <any>null;
            if (Array.isArray(_data["restrictionNames"])) {
                this.restrictionNames = [] as any;
                for (let item of _data["restrictionNames"])
                    this.restrictionNames!.push(MultiLanguageString.fromJS(item));
            }
            else {
                this.restrictionNames = <any>null;
            }
            this.vision = _data["vision"] ? VisionAttributes.fromJS(_data["vision"]) : new VisionAttributes();
            this.hearing = _data["hearing"] ? HearingAttributes.fromJS(_data["hearing"]) : new HearingAttributes();
            this.verdict = _data["verdict"] ? VerdictAttributes.fromJS(_data["verdict"]) : new VerdictAttributes();
            this.positionName = _data["positionName"] ? MultiLanguageString.fromJS(_data["positionName"]) : <any>null;
            this.additionalNotes = _data["additionalNotes"] !== undefined ? _data["additionalNotes"] : <any>null;
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(FileModel.fromJS(item));
            }
            else {
                this.files = <any>null;
            }
            this.rejectionDetails = _data["rejectionDetails"] ? RejectionDetailsModel.fromJS(_data["rejectionDetails"]) : <any>null;
            this.printTemplateDownloadUrl = _data["printTemplateDownloadUrl"] ? DownloadUrl.fromJS(_data["printTemplateDownloadUrl"]) : new DownloadUrl();
            this.accessToken = _data["accessToken"] !== undefined ? _data["accessToken"] : <any>null;
            this.accessTokenUrl = _data["accessTokenUrl"] !== undefined ? _data["accessTokenUrl"] : <any>null;
            if (Array.isArray(_data["usedInApplications"])) {
                this.usedInApplications = [] as any;
                for (let item of _data["usedInApplications"])
                    this.usedInApplications!.push(item);
            }
            else {
                this.usedInApplications = <any>null;
            }
            this.version = _data["version"] !== undefined ? _data["version"] : <any>null;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>null;
            this.recentProfileImageChange = _data["recentProfileImageChange"] ? HistoryDetails.fromJS(_data["recentProfileImageChange"]) : <any>null;
            this.changeInfo = _data["changeInfo"] ? HistoryDetails.fromJS(_data["changeInfo"]) : <any>null;
            this.realCreator = _data["realCreator"] ? HistoryDetails.fromJS(_data["realCreator"]) : <any>null;
        }
    }

    static fromJS(data: any): GetMedicalCertificateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMedicalCertificateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["seafarer"] = this.seafarer ? this.seafarer.toJSON() : <any>null;
        data["medicalInstitution"] = this.medicalInstitution ? this.medicalInstitution.toJSON() : <any>null;
        data["number"] = this.number !== undefined ? this.number : <any>null;
        data["medicalPractitionerId"] = this.medicalPractitionerId !== undefined ? this.medicalPractitionerId : <any>null;
        data["medicalInstitutionId"] = this.medicalInstitutionId !== undefined ? this.medicalInstitutionId : <any>null;
        data["creator"] = this.creator ? this.creator.toJSON() : <any>null;
        data["medicalPractitionerFirstName"] = this.medicalPractitionerFirstName !== undefined ? this.medicalPractitionerFirstName : <any>null;
        data["medicalPractitionerLastName"] = this.medicalPractitionerLastName !== undefined ? this.medicalPractitionerLastName : <any>null;
        data["currentMedicalPractitionerSignature"] = this.currentMedicalPractitionerSignature !== undefined ? this.currentMedicalPractitionerSignature : <any>null;
        data["currentSeafarerSignature"] = this.currentSeafarerSignature !== undefined ? this.currentSeafarerSignature : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        data["identificationDocumentsWereChecked"] = this.identificationDocumentsWereChecked !== undefined ? this.identificationDocumentsWereChecked : <any>null;
        if (Array.isArray(this.restrictionNames)) {
            data["restrictionNames"] = [];
            for (let item of this.restrictionNames)
                data["restrictionNames"].push(item.toJSON());
        }
        data["vision"] = this.vision ? this.vision.toJSON() : <any>null;
        data["hearing"] = this.hearing ? this.hearing.toJSON() : <any>null;
        data["verdict"] = this.verdict ? this.verdict.toJSON() : <any>null;
        data["positionName"] = this.positionName ? this.positionName.toJSON() : <any>null;
        data["additionalNotes"] = this.additionalNotes !== undefined ? this.additionalNotes : <any>null;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        data["rejectionDetails"] = this.rejectionDetails ? this.rejectionDetails.toJSON() : <any>null;
        data["printTemplateDownloadUrl"] = this.printTemplateDownloadUrl ? this.printTemplateDownloadUrl.toJSON() : <any>null;
        data["accessToken"] = this.accessToken !== undefined ? this.accessToken : <any>null;
        data["accessTokenUrl"] = this.accessTokenUrl !== undefined ? this.accessTokenUrl : <any>null;
        if (Array.isArray(this.usedInApplications)) {
            data["usedInApplications"] = [];
            for (let item of this.usedInApplications)
                data["usedInApplications"].push(item);
        }
        data["version"] = this.version !== undefined ? this.version : <any>null;
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>null;
        data["recentProfileImageChange"] = this.recentProfileImageChange ? this.recentProfileImageChange.toJSON() : <any>null;
        data["changeInfo"] = this.changeInfo ? this.changeInfo.toJSON() : <any>null;
        data["realCreator"] = this.realCreator ? this.realCreator.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IGetMedicalCertificateResponse extends IMinimalDocumentModel {
    status: ValidityStatus;
    seafarer: SeafarerPersonalInfoModel;
    medicalInstitution: OrganizationSnapshotModel;
    number?: string | null;
    medicalPractitionerId: string;
    medicalInstitutionId: string;
    creator: NameAndOrganization;
    medicalPractitionerFirstName: string;
    medicalPractitionerLastName: string;
    currentMedicalPractitionerSignature?: string | null;
    currentSeafarerSignature?: string | null;
    createdAt: Date;
    identificationDocumentsWereChecked: boolean;
    restrictionNames: MultiLanguageString[];
    vision: VisionAttributes;
    hearing: HearingAttributes;
    verdict: VerdictAttributes;
    positionName?: MultiLanguageString | null;
    additionalNotes?: string | null;
    files: FileModel[];
    rejectionDetails?: RejectionDetailsModel | null;
    printTemplateDownloadUrl: DownloadUrl;
    accessToken: string;
    accessTokenUrl: string;
    usedInApplications: string[];
    version?: number | null;
    comment: string;
    updatedAt?: Date | null;
    recentProfileImageChange?: HistoryDetails | null;
    changeInfo?: HistoryDetails | null;
    realCreator?: HistoryDetails | null;
}

export class SeafarerPersonalInfoModel implements ISeafarerPersonalInfoModel {
    id!: string;
    firstName!: string;
    lastName!: string;
    birthdate!: Date;
    nationality?: MultiLanguageString | null;
    gender!: Gender;

    constructor(data?: ISeafarerPersonalInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.birthdate = _data["birthdate"] ? new Date(_data["birthdate"].toString()) : <any>null;
            this.nationality = _data["nationality"] ? MultiLanguageString.fromJS(_data["nationality"]) : <any>null;
            this.gender = _data["gender"] !== undefined ? _data["gender"] : <any>null;
        }
    }

    static fromJS(data: any): SeafarerPersonalInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new SeafarerPersonalInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["birthdate"] = this.birthdate ? this.birthdate.toISOString() : <any>null;
        data["nationality"] = this.nationality ? this.nationality.toJSON() : <any>null;
        data["gender"] = this.gender !== undefined ? this.gender : <any>null;
        return data;
    }
}

export interface ISeafarerPersonalInfoModel {
    id: string;
    firstName: string;
    lastName: string;
    birthdate: Date;
    nationality?: MultiLanguageString | null;
    gender: Gender;
}

export class OrganizationSnapshotModel implements IOrganizationSnapshotModel {
    name!: MultiLanguageString;
    registerCode!: string;
    address!: string;
    email!: string;
    phoneNumber!: string;

    constructor(data?: IOrganizationSnapshotModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.name = new MultiLanguageString();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] ? MultiLanguageString.fromJS(_data["name"]) : new MultiLanguageString();
            this.registerCode = _data["registerCode"] !== undefined ? _data["registerCode"] : <any>null;
            this.address = _data["address"] !== undefined ? _data["address"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : <any>null;
        }
    }

    static fromJS(data: any): OrganizationSnapshotModel {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationSnapshotModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name ? this.name.toJSON() : <any>null;
        data["registerCode"] = this.registerCode !== undefined ? this.registerCode : <any>null;
        data["address"] = this.address !== undefined ? this.address : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : <any>null;
        return data;
    }
}

export interface IOrganizationSnapshotModel {
    name: MultiLanguageString;
    registerCode: string;
    address: string;
    email: string;
    phoneNumber: string;
}

export class VisionAttributes implements IVisionAttributes {
    /** In estonian: Värvusnägemise viimase kontrolli kuupäev */
    dateOfLastColorVisionTest?: Date | null;
    /** In estonian: Nägemisteravus vastab jaotise A-I/9 nõuetele */
    visualAcuityMeetsStandardsInSectionAi9!: boolean;
    /** In estonian: Värvusnägemine vastab jaotise A-I/9 nõuetele */
    colorVisionMeetsStandardsInSectionAi9!: boolean;
    spectaclesOrContactLensesRequired!: boolean;

    constructor(data?: IVisionAttributes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.visualAcuityMeetsStandardsInSectionAi9 = true;
            this.colorVisionMeetsStandardsInSectionAi9 = true;
            this.spectaclesOrContactLensesRequired = false;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateOfLastColorVisionTest = _data["dateOfLastColorVisionTest"] ? new Date(_data["dateOfLastColorVisionTest"].toString()) : <any>null;
            this.visualAcuityMeetsStandardsInSectionAi9 = _data["visualAcuityMeetsStandardsInSectionAi9"] !== undefined ? _data["visualAcuityMeetsStandardsInSectionAi9"] : true;
            this.colorVisionMeetsStandardsInSectionAi9 = _data["colorVisionMeetsStandardsInSectionAi9"] !== undefined ? _data["colorVisionMeetsStandardsInSectionAi9"] : true;
            this.spectaclesOrContactLensesRequired = _data["spectaclesOrContactLensesRequired"] !== undefined ? _data["spectaclesOrContactLensesRequired"] : false;
        }
    }

    static fromJS(data: any): VisionAttributes {
        data = typeof data === 'object' ? data : {};
        let result = new VisionAttributes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateOfLastColorVisionTest"] = this.dateOfLastColorVisionTest ? this.dateOfLastColorVisionTest.toISOString() : <any>null;
        data["visualAcuityMeetsStandardsInSectionAi9"] = this.visualAcuityMeetsStandardsInSectionAi9 !== undefined ? this.visualAcuityMeetsStandardsInSectionAi9 : <any>null;
        data["colorVisionMeetsStandardsInSectionAi9"] = this.colorVisionMeetsStandardsInSectionAi9 !== undefined ? this.colorVisionMeetsStandardsInSectionAi9 : <any>null;
        data["spectaclesOrContactLensesRequired"] = this.spectaclesOrContactLensesRequired !== undefined ? this.spectaclesOrContactLensesRequired : <any>null;
        return data;
    }
}

export interface IVisionAttributes {
    /** In estonian: Värvusnägemise viimase kontrolli kuupäev */
    dateOfLastColorVisionTest?: Date | null;
    /** In estonian: Nägemisteravus vastab jaotise A-I/9 nõuetele */
    visualAcuityMeetsStandardsInSectionAi9: boolean;
    /** In estonian: Värvusnägemine vastab jaotise A-I/9 nõuetele */
    colorVisionMeetsStandardsInSectionAi9: boolean;
    spectaclesOrContactLensesRequired: boolean;
}

export class HearingAttributes implements IHearingAttributes {
    /** In estonian: Abivahenditeta kuulmine rahuldav */
    unaidedHearingIsSatisfactory!: boolean;
    /** In estonian: Kuulmine vastab jaotise A-I/9 nõuetele */
    meetsStandardsInSectionAi9!: boolean;

    constructor(data?: IHearingAttributes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.unaidedHearingIsSatisfactory = true;
            this.meetsStandardsInSectionAi9 = true;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unaidedHearingIsSatisfactory = _data["unaidedHearingIsSatisfactory"] !== undefined ? _data["unaidedHearingIsSatisfactory"] : true;
            this.meetsStandardsInSectionAi9 = _data["meetsStandardsInSectionAi9"] !== undefined ? _data["meetsStandardsInSectionAi9"] : true;
        }
    }

    static fromJS(data: any): HearingAttributes {
        data = typeof data === 'object' ? data : {};
        let result = new HearingAttributes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unaidedHearingIsSatisfactory"] = this.unaidedHearingIsSatisfactory !== undefined ? this.unaidedHearingIsSatisfactory : <any>null;
        data["meetsStandardsInSectionAi9"] = this.meetsStandardsInSectionAi9 !== undefined ? this.meetsStandardsInSectionAi9 : <any>null;
        return data;
    }
}

export interface IHearingAttributes {
    /** In estonian: Abivahenditeta kuulmine rahuldav */
    unaidedHearingIsSatisfactory: boolean;
    /** In estonian: Kuulmine vastab jaotise A-I/9 nõuetele */
    meetsStandardsInSectionAi9: boolean;
}

export class VerdictAttributes implements IVerdictAttributes {
    /** In estonian: Isik sobib töötama laeval */
    isFitForServiceAtSea!: boolean;
    /** In estonian: Amet */
    positionId?: string | null;
    /** In estonian: Isiku terviseseisund on sobiv laeval töötamiseks ega ohusta teisi pardal olevaid inimesi */
    healthConditionIsFitForServiceAtSea!: boolean;
    /** In estonian: Isik on sobiv navigatsioonivahis osalejaks ja vaatlejaks */
    isFitForNavigationalWatch!: boolean;
    hasRestrictions!: boolean;
    restrictions!: string[];

    constructor(data?: IVerdictAttributes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.isFitForServiceAtSea = true;
            this.healthConditionIsFitForServiceAtSea = true;
            this.isFitForNavigationalWatch = true;
            this.restrictions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isFitForServiceAtSea = _data["isFitForServiceAtSea"] !== undefined ? _data["isFitForServiceAtSea"] : true;
            this.positionId = _data["positionId"] !== undefined ? _data["positionId"] : <any>null;
            this.healthConditionIsFitForServiceAtSea = _data["healthConditionIsFitForServiceAtSea"] !== undefined ? _data["healthConditionIsFitForServiceAtSea"] : true;
            this.isFitForNavigationalWatch = _data["isFitForNavigationalWatch"] !== undefined ? _data["isFitForNavigationalWatch"] : true;
            this.hasRestrictions = _data["hasRestrictions"] !== undefined ? _data["hasRestrictions"] : <any>null;
            if (Array.isArray(_data["restrictions"])) {
                this.restrictions = [] as any;
                for (let item of _data["restrictions"])
                    this.restrictions!.push(item);
            }
            else {
                this.restrictions = <any>null;
            }
        }
    }

    static fromJS(data: any): VerdictAttributes {
        data = typeof data === 'object' ? data : {};
        let result = new VerdictAttributes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isFitForServiceAtSea"] = this.isFitForServiceAtSea !== undefined ? this.isFitForServiceAtSea : <any>null;
        data["positionId"] = this.positionId !== undefined ? this.positionId : <any>null;
        data["healthConditionIsFitForServiceAtSea"] = this.healthConditionIsFitForServiceAtSea !== undefined ? this.healthConditionIsFitForServiceAtSea : <any>null;
        data["isFitForNavigationalWatch"] = this.isFitForNavigationalWatch !== undefined ? this.isFitForNavigationalWatch : <any>null;
        data["hasRestrictions"] = this.hasRestrictions !== undefined ? this.hasRestrictions : <any>null;
        if (Array.isArray(this.restrictions)) {
            data["restrictions"] = [];
            for (let item of this.restrictions)
                data["restrictions"].push(item);
        }
        return data;
    }
}

export interface IVerdictAttributes {
    /** In estonian: Isik sobib töötama laeval */
    isFitForServiceAtSea: boolean;
    /** In estonian: Amet */
    positionId?: string | null;
    /** In estonian: Isiku terviseseisund on sobiv laeval töötamiseks ega ohusta teisi pardal olevaid inimesi */
    healthConditionIsFitForServiceAtSea: boolean;
    /** In estonian: Isik on sobiv navigatsioonivahis osalejaks ja vaatlejaks */
    isFitForNavigationalWatch: boolean;
    hasRestrictions: boolean;
    restrictions: string[];
}

export abstract class DocumentDetailsModel extends MinimalDocumentModel implements IDocumentDetailsModel {
    seafarerId!: string;
    code!: string;
    name!: string;
    documentType!: string;
    firstName!: string;
    lastName!: string;
    birthDate!: Date;
    photoUrl?: string | null;
    signatureUrl?: string | null;
    personalCode?: string | null;
    officialSignature?: OfficialSignatureApiModel | null;
    rejectionDetails?: RejectionDetailsModel | null;
    accessToken?: string | null;
    accessTokenUrl?: string | null;
    duplicationDetails?: DuplicationDetailsModel | null;
    hasDigitalRepresentation!: boolean;

    protected _discriminator: string;

    constructor(data?: IDocumentDetailsModel) {
        super(data);
        this._discriminator = "DocumentDetailsModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.seafarerId = _data["seafarerId"] !== undefined ? _data["seafarerId"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.documentType = _data["documentType"] !== undefined ? _data["documentType"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>null;
            this.photoUrl = _data["photoUrl"] !== undefined ? _data["photoUrl"] : <any>null;
            this.signatureUrl = _data["signatureUrl"] !== undefined ? _data["signatureUrl"] : <any>null;
            this.personalCode = _data["personalCode"] !== undefined ? _data["personalCode"] : <any>null;
            this.officialSignature = _data["officialSignature"] ? OfficialSignatureApiModel.fromJS(_data["officialSignature"]) : <any>null;
            this.rejectionDetails = _data["rejectionDetails"] ? RejectionDetailsModel.fromJS(_data["rejectionDetails"]) : <any>null;
            this.accessToken = _data["accessToken"] !== undefined ? _data["accessToken"] : <any>null;
            this.accessTokenUrl = _data["accessTokenUrl"] !== undefined ? _data["accessTokenUrl"] : <any>null;
            this.duplicationDetails = _data["duplicationDetails"] ? DuplicationDetailsModel.fromJS(_data["duplicationDetails"]) : <any>null;
            this.hasDigitalRepresentation = _data["hasDigitalRepresentation"] !== undefined ? _data["hasDigitalRepresentation"] : <any>null;
        }
    }

    static fromJS(data: any): DocumentDetailsModel {
        data = typeof data === 'object' ? data : {};
        if (data["type"] === "EndorsementDetailsModel") {
            let result = new EndorsementDetailsModel();
            result.init(data);
            return result;
        }
        if (data["type"] === "CertificateDetailsModel") {
            let result = new CertificateDetailsModel();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'DocumentDetailsModel' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this._discriminator;
        data["seafarerId"] = this.seafarerId !== undefined ? this.seafarerId : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["documentType"] = this.documentType !== undefined ? this.documentType : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>null;
        data["photoUrl"] = this.photoUrl !== undefined ? this.photoUrl : <any>null;
        data["signatureUrl"] = this.signatureUrl !== undefined ? this.signatureUrl : <any>null;
        data["personalCode"] = this.personalCode !== undefined ? this.personalCode : <any>null;
        data["officialSignature"] = this.officialSignature ? this.officialSignature.toJSON() : <any>null;
        data["rejectionDetails"] = this.rejectionDetails ? this.rejectionDetails.toJSON() : <any>null;
        data["accessToken"] = this.accessToken !== undefined ? this.accessToken : <any>null;
        data["accessTokenUrl"] = this.accessTokenUrl !== undefined ? this.accessTokenUrl : <any>null;
        data["duplicationDetails"] = this.duplicationDetails ? this.duplicationDetails.toJSON() : <any>null;
        data["hasDigitalRepresentation"] = this.hasDigitalRepresentation !== undefined ? this.hasDigitalRepresentation : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDocumentDetailsModel extends IMinimalDocumentModel {
    seafarerId: string;
    code: string;
    name: string;
    documentType: string;
    firstName: string;
    lastName: string;
    birthDate: Date;
    photoUrl?: string | null;
    signatureUrl?: string | null;
    personalCode?: string | null;
    officialSignature?: OfficialSignatureApiModel | null;
    rejectionDetails?: RejectionDetailsModel | null;
    accessToken?: string | null;
    accessTokenUrl?: string | null;
    duplicationDetails?: DuplicationDetailsModel | null;
    hasDigitalRepresentation: boolean;
}

export class EndorsementDetailsModel extends DocumentDetailsModel implements IEndorsementDetailsModel {
    certificateId!: string;
    certificateTypeName!: string;
    certificateNumber!: string;
    certificateCountryNamePossessiveEst?: string | null;
    certificateCountryNamePossessiveEng?: string | null;
    certificateCountryName!: MultiLanguageString;
    issuerName!: string;
    status!: EndorsementStatus;
    suspensionDetails?: SuspensionDetailsModel | null;
    replacementDetails?: ReplacementDetailsModel | null;
    positions!: EndorsementMultiLanguagePositionViewModel[];
    stcwRuleCodes!: string[];
    shipNames!: string[];
    shippingLineNames!: string[];
    trainingDate?: Date | null;
    languageOnPrint!: LanguageOnPrintedEndorsement;
    recentProfileImageChange?: HistoryDetails | null;
    changeInfo?: HistoryDetails | null;

    constructor(data?: IEndorsementDetailsModel) {
        super(data);
        if (!data) {
            this.certificateCountryName = new MultiLanguageString();
            this.positions = [];
            this.stcwRuleCodes = [];
            this.shipNames = [];
            this.shippingLineNames = [];
        }
        this._discriminator = "EndorsementDetailsModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.certificateId = _data["certificateId"] !== undefined ? _data["certificateId"] : <any>null;
            this.certificateTypeName = _data["certificateTypeName"] !== undefined ? _data["certificateTypeName"] : <any>null;
            this.certificateNumber = _data["certificateNumber"] !== undefined ? _data["certificateNumber"] : <any>null;
            this.certificateCountryNamePossessiveEst = _data["certificateCountryNamePossessiveEst"] !== undefined ? _data["certificateCountryNamePossessiveEst"] : <any>null;
            this.certificateCountryNamePossessiveEng = _data["certificateCountryNamePossessiveEng"] !== undefined ? _data["certificateCountryNamePossessiveEng"] : <any>null;
            this.certificateCountryName = _data["certificateCountryName"] ? MultiLanguageString.fromJS(_data["certificateCountryName"]) : new MultiLanguageString();
            this.issuerName = _data["issuerName"] !== undefined ? _data["issuerName"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.suspensionDetails = _data["suspensionDetails"] ? SuspensionDetailsModel.fromJS(_data["suspensionDetails"]) : <any>null;
            this.replacementDetails = _data["replacementDetails"] ? ReplacementDetailsModel.fromJS(_data["replacementDetails"]) : <any>null;
            if (Array.isArray(_data["positions"])) {
                this.positions = [] as any;
                for (let item of _data["positions"])
                    this.positions!.push(EndorsementMultiLanguagePositionViewModel.fromJS(item));
            }
            else {
                this.positions = <any>null;
            }
            if (Array.isArray(_data["stcwRuleCodes"])) {
                this.stcwRuleCodes = [] as any;
                for (let item of _data["stcwRuleCodes"])
                    this.stcwRuleCodes!.push(item);
            }
            else {
                this.stcwRuleCodes = <any>null;
            }
            if (Array.isArray(_data["shipNames"])) {
                this.shipNames = [] as any;
                for (let item of _data["shipNames"])
                    this.shipNames!.push(item);
            }
            else {
                this.shipNames = <any>null;
            }
            if (Array.isArray(_data["shippingLineNames"])) {
                this.shippingLineNames = [] as any;
                for (let item of _data["shippingLineNames"])
                    this.shippingLineNames!.push(item);
            }
            else {
                this.shippingLineNames = <any>null;
            }
            this.trainingDate = _data["trainingDate"] ? new Date(_data["trainingDate"].toString()) : <any>null;
            this.languageOnPrint = _data["languageOnPrint"] !== undefined ? _data["languageOnPrint"] : <any>null;
            this.recentProfileImageChange = _data["recentProfileImageChange"] ? HistoryDetails.fromJS(_data["recentProfileImageChange"]) : <any>null;
            this.changeInfo = _data["changeInfo"] ? HistoryDetails.fromJS(_data["changeInfo"]) : <any>null;
        }
    }

    static fromJS(data: any): EndorsementDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new EndorsementDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["certificateId"] = this.certificateId !== undefined ? this.certificateId : <any>null;
        data["certificateTypeName"] = this.certificateTypeName !== undefined ? this.certificateTypeName : <any>null;
        data["certificateNumber"] = this.certificateNumber !== undefined ? this.certificateNumber : <any>null;
        data["certificateCountryNamePossessiveEst"] = this.certificateCountryNamePossessiveEst !== undefined ? this.certificateCountryNamePossessiveEst : <any>null;
        data["certificateCountryNamePossessiveEng"] = this.certificateCountryNamePossessiveEng !== undefined ? this.certificateCountryNamePossessiveEng : <any>null;
        data["certificateCountryName"] = this.certificateCountryName ? this.certificateCountryName.toJSON() : <any>null;
        data["issuerName"] = this.issuerName !== undefined ? this.issuerName : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["suspensionDetails"] = this.suspensionDetails ? this.suspensionDetails.toJSON() : <any>null;
        data["replacementDetails"] = this.replacementDetails ? this.replacementDetails.toJSON() : <any>null;
        if (Array.isArray(this.positions)) {
            data["positions"] = [];
            for (let item of this.positions)
                data["positions"].push(item.toJSON());
        }
        if (Array.isArray(this.stcwRuleCodes)) {
            data["stcwRuleCodes"] = [];
            for (let item of this.stcwRuleCodes)
                data["stcwRuleCodes"].push(item);
        }
        if (Array.isArray(this.shipNames)) {
            data["shipNames"] = [];
            for (let item of this.shipNames)
                data["shipNames"].push(item);
        }
        if (Array.isArray(this.shippingLineNames)) {
            data["shippingLineNames"] = [];
            for (let item of this.shippingLineNames)
                data["shippingLineNames"].push(item);
        }
        data["trainingDate"] = this.trainingDate ? this.trainingDate.toISOString() : <any>null;
        data["languageOnPrint"] = this.languageOnPrint !== undefined ? this.languageOnPrint : <any>null;
        data["recentProfileImageChange"] = this.recentProfileImageChange ? this.recentProfileImageChange.toJSON() : <any>null;
        data["changeInfo"] = this.changeInfo ? this.changeInfo.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IEndorsementDetailsModel extends IDocumentDetailsModel {
    certificateId: string;
    certificateTypeName: string;
    certificateNumber: string;
    certificateCountryNamePossessiveEst?: string | null;
    certificateCountryNamePossessiveEng?: string | null;
    certificateCountryName: MultiLanguageString;
    issuerName: string;
    status: EndorsementStatus;
    suspensionDetails?: SuspensionDetailsModel | null;
    replacementDetails?: ReplacementDetailsModel | null;
    positions: EndorsementMultiLanguagePositionViewModel[];
    stcwRuleCodes: string[];
    shipNames: string[];
    shippingLineNames: string[];
    trainingDate?: Date | null;
    languageOnPrint: LanguageOnPrintedEndorsement;
    recentProfileImageChange?: HistoryDetails | null;
    changeInfo?: HistoryDetails | null;
}

export enum EndorsementStatus {
    Valid = "valid",
    Suspended = "suspended",
    Invalid = "invalid",
}

export class SuspensionDetailsModel implements ISuspensionDetailsModel {
    name!: string;
    comment!: string;
    time!: Date;
    startedOn!: Date;
    validUntil?: Date | null;
    isExpired!: boolean;
    reason?: SuspensionReasonModel | null;

    constructor(data?: ISuspensionDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
            this.time = _data["time"] ? new Date(_data["time"].toString()) : <any>null;
            this.startedOn = _data["startedOn"] ? new Date(_data["startedOn"].toString()) : <any>null;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : <any>null;
            this.isExpired = _data["isExpired"] !== undefined ? _data["isExpired"] : <any>null;
            this.reason = _data["reason"] ? SuspensionReasonModel.fromJS(_data["reason"]) : <any>null;
        }
    }

    static fromJS(data: any): SuspensionDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new SuspensionDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        data["time"] = this.time ? this.time.toISOString() : <any>null;
        data["startedOn"] = this.startedOn ? this.startedOn.toISOString() : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : <any>null;
        data["isExpired"] = this.isExpired !== undefined ? this.isExpired : <any>null;
        data["reason"] = this.reason ? this.reason.toJSON() : <any>null;
        return data;
    }
}

export interface ISuspensionDetailsModel {
    name: string;
    comment: string;
    time: Date;
    startedOn: Date;
    validUntil?: Date | null;
    isExpired: boolean;
    reason?: SuspensionReasonModel | null;
}

export class SuspensionReasonModel implements ISuspensionReasonModel {
    code!: SuspensionReason;
    description!: string;

    constructor(data?: ISuspensionReasonModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.code = new SuspensionReason();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] ? SuspensionReason.fromJS(_data["code"]) : new SuspensionReason();
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
        }
    }

    static fromJS(data: any): SuspensionReasonModel {
        data = typeof data === 'object' ? data : {};
        let result = new SuspensionReasonModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code ? this.code.toJSON() : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        return data;
    }
}

export interface ISuspensionReasonModel {
    code: SuspensionReason;
    description: string;
}

export class SuspensionReason extends SingleValueObjectOfString implements ISuspensionReason {

    constructor(data?: ISuspensionReason) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SuspensionReason {
        data = typeof data === 'object' ? data : {};
        let result = new SuspensionReason();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISuspensionReason extends ISingleValueObjectOfString {
}

export class ReplacementDetailsModel implements IReplacementDetailsModel {
    issuedOn!: Date;
    reason!: string;
    additionalInfo?: string | null;
    newEndorsementNumber!: string;

    constructor(data?: IReplacementDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issuedOn = _data["issuedOn"] ? new Date(_data["issuedOn"].toString()) : <any>null;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : <any>null;
            this.additionalInfo = _data["additionalInfo"] !== undefined ? _data["additionalInfo"] : <any>null;
            this.newEndorsementNumber = _data["newEndorsementNumber"] !== undefined ? _data["newEndorsementNumber"] : <any>null;
        }
    }

    static fromJS(data: any): ReplacementDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReplacementDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issuedOn"] = this.issuedOn ? this.issuedOn.toISOString() : <any>null;
        data["reason"] = this.reason !== undefined ? this.reason : <any>null;
        data["additionalInfo"] = this.additionalInfo !== undefined ? this.additionalInfo : <any>null;
        data["newEndorsementNumber"] = this.newEndorsementNumber !== undefined ? this.newEndorsementNumber : <any>null;
        return data;
    }
}

export interface IReplacementDetailsModel {
    issuedOn: Date;
    reason: string;
    additionalInfo?: string | null;
    newEndorsementNumber: string;
}

export class EndorsementMultiLanguagePositionViewModel implements IEndorsementMultiLanguagePositionViewModel {
    positionName!: MultiLanguageString;
    restrictions!: MultiLanguageString[];
    positionLevelName!: MultiLanguageString;
    responsibilities?: MultiLanguageString | null;

    constructor(data?: IEndorsementMultiLanguagePositionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.positionName = new MultiLanguageString();
            this.restrictions = [];
            this.positionLevelName = new MultiLanguageString();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.positionName = _data["positionName"] ? MultiLanguageString.fromJS(_data["positionName"]) : new MultiLanguageString();
            if (Array.isArray(_data["restrictions"])) {
                this.restrictions = [] as any;
                for (let item of _data["restrictions"])
                    this.restrictions!.push(MultiLanguageString.fromJS(item));
            }
            else {
                this.restrictions = <any>null;
            }
            this.positionLevelName = _data["positionLevelName"] ? MultiLanguageString.fromJS(_data["positionLevelName"]) : new MultiLanguageString();
            this.responsibilities = _data["responsibilities"] ? MultiLanguageString.fromJS(_data["responsibilities"]) : <any>null;
        }
    }

    static fromJS(data: any): EndorsementMultiLanguagePositionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EndorsementMultiLanguagePositionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["positionName"] = this.positionName ? this.positionName.toJSON() : <any>null;
        if (Array.isArray(this.restrictions)) {
            data["restrictions"] = [];
            for (let item of this.restrictions)
                data["restrictions"].push(item.toJSON());
        }
        data["positionLevelName"] = this.positionLevelName ? this.positionLevelName.toJSON() : <any>null;
        data["responsibilities"] = this.responsibilities ? this.responsibilities.toJSON() : <any>null;
        return data;
    }
}

export interface IEndorsementMultiLanguagePositionViewModel {
    positionName: MultiLanguageString;
    restrictions: MultiLanguageString[];
    positionLevelName: MultiLanguageString;
    responsibilities?: MultiLanguageString | null;
}

export enum LanguageOnPrintedEndorsement {
    Estonian = "estonian",
    EstonianAndEnglish = "estonianAndEnglish",
}

export class OfficialSignatureApiModel implements IOfficialSignatureApiModel {
    signerFullName!: string;
    signedAt!: Date;
    url!: string;

    constructor(data?: IOfficialSignatureApiModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.signerFullName = _data["signerFullName"] !== undefined ? _data["signerFullName"] : <any>null;
            this.signedAt = _data["signedAt"] ? new Date(_data["signedAt"].toString()) : <any>null;
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
        }
    }

    static fromJS(data: any): OfficialSignatureApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new OfficialSignatureApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["signerFullName"] = this.signerFullName !== undefined ? this.signerFullName : <any>null;
        data["signedAt"] = this.signedAt ? this.signedAt.toISOString() : <any>null;
        data["url"] = this.url !== undefined ? this.url : <any>null;
        return data;
    }
}

export interface IOfficialSignatureApiModel {
    signerFullName: string;
    signedAt: Date;
    url: string;
}

export class DuplicationDetailsModel implements IDuplicationDetailsModel {
    issuedOn!: Date;
    reason!: string;
    additionalInfo?: string | null;
    duplicateNumber!: string;

    constructor(data?: IDuplicationDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issuedOn = _data["issuedOn"] ? new Date(_data["issuedOn"].toString()) : <any>null;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : <any>null;
            this.additionalInfo = _data["additionalInfo"] !== undefined ? _data["additionalInfo"] : <any>null;
            this.duplicateNumber = _data["duplicateNumber"] !== undefined ? _data["duplicateNumber"] : <any>null;
        }
    }

    static fromJS(data: any): DuplicationDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new DuplicationDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issuedOn"] = this.issuedOn ? this.issuedOn.toISOString() : <any>null;
        data["reason"] = this.reason !== undefined ? this.reason : <any>null;
        data["additionalInfo"] = this.additionalInfo !== undefined ? this.additionalInfo : <any>null;
        data["duplicateNumber"] = this.duplicateNumber !== undefined ? this.duplicateNumber : <any>null;
        return data;
    }
}

export interface IDuplicationDetailsModel {
    issuedOn: Date;
    reason: string;
    additionalInfo?: string | null;
    duplicateNumber: string;
}

export class CertificateDetailsModel extends DocumentDetailsModel implements ICertificateDetailsModel {
    certificateTypeLegalName!: string;
    issuerCountry!: string;
    status!: CertificateStatus;
    isForeign!: boolean;
    hasPrintTemplate!: boolean;
    files!: FileModel[];
    recentProfileImageChange?: HistoryDetails | null;
    changeInfo?: HistoryDetails | null;
    harbourName?: string | null;
    shipGrossTonnage?: number | null;
    tankerGrossTonnage?: number | null;
    hasGTSupport!: boolean;
    pilotageAreaNames!: string[];
    pilotageAreaNamesEng!: string[];
    shipNames!: string[];
    shipGrossTonnages!: number[];
    shippingLineNames!: string[];
    positionNames!: string[];
    positionNamesEng!: string[];
    educationalInstitutionName?: string | null;
    educationalInstitutionNameEng?: string | null;
    trainingDate?: Date | null;
    textLiterals?: string | null;
    endorsementDocumentNumber?: string | null;
    endorsementTypeLegalNameEst?: string | null;
    endorsementTypeLegalNameEng?: string | null;
    stcwRuleCodes!: string[];

    constructor(data?: ICertificateDetailsModel) {
        super(data);
        if (!data) {
            this.files = [];
            this.pilotageAreaNames = [];
            this.pilotageAreaNamesEng = [];
            this.shipNames = [];
            this.shipGrossTonnages = [];
            this.shippingLineNames = [];
            this.positionNames = [];
            this.positionNamesEng = [];
            this.stcwRuleCodes = [];
        }
        this._discriminator = "CertificateDetailsModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.certificateTypeLegalName = _data["certificateTypeLegalName"] !== undefined ? _data["certificateTypeLegalName"] : <any>null;
            this.issuerCountry = _data["issuerCountry"] !== undefined ? _data["issuerCountry"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.isForeign = _data["isForeign"] !== undefined ? _data["isForeign"] : <any>null;
            this.hasPrintTemplate = _data["hasPrintTemplate"] !== undefined ? _data["hasPrintTemplate"] : <any>null;
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(FileModel.fromJS(item));
            }
            else {
                this.files = <any>null;
            }
            this.recentProfileImageChange = _data["recentProfileImageChange"] ? HistoryDetails.fromJS(_data["recentProfileImageChange"]) : <any>null;
            this.changeInfo = _data["changeInfo"] ? HistoryDetails.fromJS(_data["changeInfo"]) : <any>null;
            this.harbourName = _data["harbourName"] !== undefined ? _data["harbourName"] : <any>null;
            this.shipGrossTonnage = _data["shipGrossTonnage"] !== undefined ? _data["shipGrossTonnage"] : <any>null;
            this.tankerGrossTonnage = _data["tankerGrossTonnage"] !== undefined ? _data["tankerGrossTonnage"] : <any>null;
            this.hasGTSupport = _data["hasGTSupport"] !== undefined ? _data["hasGTSupport"] : <any>null;
            if (Array.isArray(_data["pilotageAreaNames"])) {
                this.pilotageAreaNames = [] as any;
                for (let item of _data["pilotageAreaNames"])
                    this.pilotageAreaNames!.push(item);
            }
            else {
                this.pilotageAreaNames = <any>null;
            }
            if (Array.isArray(_data["pilotageAreaNamesEng"])) {
                this.pilotageAreaNamesEng = [] as any;
                for (let item of _data["pilotageAreaNamesEng"])
                    this.pilotageAreaNamesEng!.push(item);
            }
            else {
                this.pilotageAreaNamesEng = <any>null;
            }
            if (Array.isArray(_data["shipNames"])) {
                this.shipNames = [] as any;
                for (let item of _data["shipNames"])
                    this.shipNames!.push(item);
            }
            else {
                this.shipNames = <any>null;
            }
            if (Array.isArray(_data["shipGrossTonnages"])) {
                this.shipGrossTonnages = [] as any;
                for (let item of _data["shipGrossTonnages"])
                    this.shipGrossTonnages!.push(item);
            }
            else {
                this.shipGrossTonnages = <any>null;
            }
            if (Array.isArray(_data["shippingLineNames"])) {
                this.shippingLineNames = [] as any;
                for (let item of _data["shippingLineNames"])
                    this.shippingLineNames!.push(item);
            }
            else {
                this.shippingLineNames = <any>null;
            }
            if (Array.isArray(_data["positionNames"])) {
                this.positionNames = [] as any;
                for (let item of _data["positionNames"])
                    this.positionNames!.push(item);
            }
            else {
                this.positionNames = <any>null;
            }
            if (Array.isArray(_data["positionNamesEng"])) {
                this.positionNamesEng = [] as any;
                for (let item of _data["positionNamesEng"])
                    this.positionNamesEng!.push(item);
            }
            else {
                this.positionNamesEng = <any>null;
            }
            this.educationalInstitutionName = _data["educationalInstitutionName"] !== undefined ? _data["educationalInstitutionName"] : <any>null;
            this.educationalInstitutionNameEng = _data["educationalInstitutionNameEng"] !== undefined ? _data["educationalInstitutionNameEng"] : <any>null;
            this.trainingDate = _data["trainingDate"] ? new Date(_data["trainingDate"].toString()) : <any>null;
            this.textLiterals = _data["textLiterals"] !== undefined ? _data["textLiterals"] : <any>null;
            this.endorsementDocumentNumber = _data["endorsementDocumentNumber"] !== undefined ? _data["endorsementDocumentNumber"] : <any>null;
            this.endorsementTypeLegalNameEst = _data["endorsementTypeLegalNameEst"] !== undefined ? _data["endorsementTypeLegalNameEst"] : <any>null;
            this.endorsementTypeLegalNameEng = _data["endorsementTypeLegalNameEng"] !== undefined ? _data["endorsementTypeLegalNameEng"] : <any>null;
            if (Array.isArray(_data["stcwRuleCodes"])) {
                this.stcwRuleCodes = [] as any;
                for (let item of _data["stcwRuleCodes"])
                    this.stcwRuleCodes!.push(item);
            }
            else {
                this.stcwRuleCodes = <any>null;
            }
        }
    }

    static fromJS(data: any): CertificateDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new CertificateDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["certificateTypeLegalName"] = this.certificateTypeLegalName !== undefined ? this.certificateTypeLegalName : <any>null;
        data["issuerCountry"] = this.issuerCountry !== undefined ? this.issuerCountry : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["isForeign"] = this.isForeign !== undefined ? this.isForeign : <any>null;
        data["hasPrintTemplate"] = this.hasPrintTemplate !== undefined ? this.hasPrintTemplate : <any>null;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        data["recentProfileImageChange"] = this.recentProfileImageChange ? this.recentProfileImageChange.toJSON() : <any>null;
        data["changeInfo"] = this.changeInfo ? this.changeInfo.toJSON() : <any>null;
        data["harbourName"] = this.harbourName !== undefined ? this.harbourName : <any>null;
        data["shipGrossTonnage"] = this.shipGrossTonnage !== undefined ? this.shipGrossTonnage : <any>null;
        data["tankerGrossTonnage"] = this.tankerGrossTonnage !== undefined ? this.tankerGrossTonnage : <any>null;
        data["hasGTSupport"] = this.hasGTSupport !== undefined ? this.hasGTSupport : <any>null;
        if (Array.isArray(this.pilotageAreaNames)) {
            data["pilotageAreaNames"] = [];
            for (let item of this.pilotageAreaNames)
                data["pilotageAreaNames"].push(item);
        }
        if (Array.isArray(this.pilotageAreaNamesEng)) {
            data["pilotageAreaNamesEng"] = [];
            for (let item of this.pilotageAreaNamesEng)
                data["pilotageAreaNamesEng"].push(item);
        }
        if (Array.isArray(this.shipNames)) {
            data["shipNames"] = [];
            for (let item of this.shipNames)
                data["shipNames"].push(item);
        }
        if (Array.isArray(this.shipGrossTonnages)) {
            data["shipGrossTonnages"] = [];
            for (let item of this.shipGrossTonnages)
                data["shipGrossTonnages"].push(item);
        }
        if (Array.isArray(this.shippingLineNames)) {
            data["shippingLineNames"] = [];
            for (let item of this.shippingLineNames)
                data["shippingLineNames"].push(item);
        }
        if (Array.isArray(this.positionNames)) {
            data["positionNames"] = [];
            for (let item of this.positionNames)
                data["positionNames"].push(item);
        }
        if (Array.isArray(this.positionNamesEng)) {
            data["positionNamesEng"] = [];
            for (let item of this.positionNamesEng)
                data["positionNamesEng"].push(item);
        }
        data["educationalInstitutionName"] = this.educationalInstitutionName !== undefined ? this.educationalInstitutionName : <any>null;
        data["educationalInstitutionNameEng"] = this.educationalInstitutionNameEng !== undefined ? this.educationalInstitutionNameEng : <any>null;
        data["trainingDate"] = this.trainingDate ? this.trainingDate.toISOString() : <any>null;
        data["textLiterals"] = this.textLiterals !== undefined ? this.textLiterals : <any>null;
        data["endorsementDocumentNumber"] = this.endorsementDocumentNumber !== undefined ? this.endorsementDocumentNumber : <any>null;
        data["endorsementTypeLegalNameEst"] = this.endorsementTypeLegalNameEst !== undefined ? this.endorsementTypeLegalNameEst : <any>null;
        data["endorsementTypeLegalNameEng"] = this.endorsementTypeLegalNameEng !== undefined ? this.endorsementTypeLegalNameEng : <any>null;
        if (Array.isArray(this.stcwRuleCodes)) {
            data["stcwRuleCodes"] = [];
            for (let item of this.stcwRuleCodes)
                data["stcwRuleCodes"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICertificateDetailsModel extends IDocumentDetailsModel {
    certificateTypeLegalName: string;
    issuerCountry: string;
    status: CertificateStatus;
    isForeign: boolean;
    hasPrintTemplate: boolean;
    files: FileModel[];
    recentProfileImageChange?: HistoryDetails | null;
    changeInfo?: HistoryDetails | null;
    harbourName?: string | null;
    shipGrossTonnage?: number | null;
    tankerGrossTonnage?: number | null;
    hasGTSupport: boolean;
    pilotageAreaNames: string[];
    pilotageAreaNamesEng: string[];
    shipNames: string[];
    shipGrossTonnages: number[];
    shippingLineNames: string[];
    positionNames: string[];
    positionNamesEng: string[];
    educationalInstitutionName?: string | null;
    educationalInstitutionNameEng?: string | null;
    trainingDate?: Date | null;
    textLiterals?: string | null;
    endorsementDocumentNumber?: string | null;
    endorsementTypeLegalNameEst?: string | null;
    endorsementTypeLegalNameEng?: string | null;
    stcwRuleCodes: string[];
}

export enum CertificateStatus {
    Valid = "valid",
    Invalid = "invalid",
}

export class AddMedicalCertificateResponse implements IAddMedicalCertificateResponse {
    id!: string;

    constructor(data?: IAddMedicalCertificateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): AddMedicalCertificateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddMedicalCertificateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }
}

export interface IAddMedicalCertificateResponse {
    id: string;
}

export class AddMedicalCertificateRequest implements IAddMedicalCertificateRequest {
    number?: string | null;
    medicalPractitionerId!: string;
    medicalInstitutionId!: string;
    issuedOn?: Date | null;
    validUntil?: Date | null;
    addedFiles!: TempFileModel[];
    existingFiles!: FileModel[];
    removedFiles!: FileModel[];
    /** In estonian: Isikut tõendavat dokumenti kontrolliti tervisekontrolli käigus */
    identificationDocumentsWereChecked!: boolean;
    vision!: VisionAttributes;
    hearing!: HearingAttributes;
    verdict!: VerdictAttributes;
    additionalNotes?: string | null;
    version?: number | null;
    comment?: string | null;
    updatedAt?: Date | null;

    constructor(data?: IAddMedicalCertificateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.addedFiles = [];
            this.existingFiles = [];
            this.removedFiles = [];
            this.identificationDocumentsWereChecked = true;
            this.vision = new VisionAttributes();
            this.hearing = new HearingAttributes();
            this.verdict = new VerdictAttributes();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.number = _data["number"] !== undefined ? _data["number"] : <any>null;
            this.medicalPractitionerId = _data["medicalPractitionerId"] !== undefined ? _data["medicalPractitionerId"] : <any>null;
            this.medicalInstitutionId = _data["medicalInstitutionId"] !== undefined ? _data["medicalInstitutionId"] : <any>null;
            this.issuedOn = _data["issuedOn"] ? new Date(_data["issuedOn"].toString()) : <any>null;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : <any>null;
            if (Array.isArray(_data["addedFiles"])) {
                this.addedFiles = [] as any;
                for (let item of _data["addedFiles"])
                    this.addedFiles!.push(TempFileModel.fromJS(item));
            }
            else {
                this.addedFiles = <any>null;
            }
            if (Array.isArray(_data["existingFiles"])) {
                this.existingFiles = [] as any;
                for (let item of _data["existingFiles"])
                    this.existingFiles!.push(FileModel.fromJS(item));
            }
            else {
                this.existingFiles = <any>null;
            }
            if (Array.isArray(_data["removedFiles"])) {
                this.removedFiles = [] as any;
                for (let item of _data["removedFiles"])
                    this.removedFiles!.push(FileModel.fromJS(item));
            }
            else {
                this.removedFiles = <any>null;
            }
            this.identificationDocumentsWereChecked = _data["identificationDocumentsWereChecked"] !== undefined ? _data["identificationDocumentsWereChecked"] : true;
            this.vision = _data["vision"] ? VisionAttributes.fromJS(_data["vision"]) : new VisionAttributes();
            this.hearing = _data["hearing"] ? HearingAttributes.fromJS(_data["hearing"]) : new HearingAttributes();
            this.verdict = _data["verdict"] ? VerdictAttributes.fromJS(_data["verdict"]) : new VerdictAttributes();
            this.additionalNotes = _data["additionalNotes"] !== undefined ? _data["additionalNotes"] : <any>null;
            this.version = _data["version"] !== undefined ? _data["version"] : <any>null;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): AddMedicalCertificateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddMedicalCertificateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number !== undefined ? this.number : <any>null;
        data["medicalPractitionerId"] = this.medicalPractitionerId !== undefined ? this.medicalPractitionerId : <any>null;
        data["medicalInstitutionId"] = this.medicalInstitutionId !== undefined ? this.medicalInstitutionId : <any>null;
        data["issuedOn"] = this.issuedOn ? this.issuedOn.toISOString() : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : <any>null;
        if (Array.isArray(this.addedFiles)) {
            data["addedFiles"] = [];
            for (let item of this.addedFiles)
                data["addedFiles"].push(item.toJSON());
        }
        if (Array.isArray(this.existingFiles)) {
            data["existingFiles"] = [];
            for (let item of this.existingFiles)
                data["existingFiles"].push(item.toJSON());
        }
        if (Array.isArray(this.removedFiles)) {
            data["removedFiles"] = [];
            for (let item of this.removedFiles)
                data["removedFiles"].push(item.toJSON());
        }
        data["identificationDocumentsWereChecked"] = this.identificationDocumentsWereChecked !== undefined ? this.identificationDocumentsWereChecked : <any>null;
        data["vision"] = this.vision ? this.vision.toJSON() : <any>null;
        data["hearing"] = this.hearing ? this.hearing.toJSON() : <any>null;
        data["verdict"] = this.verdict ? this.verdict.toJSON() : <any>null;
        data["additionalNotes"] = this.additionalNotes !== undefined ? this.additionalNotes : <any>null;
        data["version"] = this.version !== undefined ? this.version : <any>null;
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>null;
        return data;
    }
}

export interface IAddMedicalCertificateRequest {
    number?: string | null;
    medicalPractitionerId: string;
    medicalInstitutionId: string;
    issuedOn?: Date | null;
    validUntil?: Date | null;
    addedFiles: TempFileModel[];
    existingFiles: FileModel[];
    removedFiles: FileModel[];
    /** In estonian: Isikut tõendavat dokumenti kontrolliti tervisekontrolli käigus */
    identificationDocumentsWereChecked: boolean;
    vision: VisionAttributes;
    hearing: HearingAttributes;
    verdict: VerdictAttributes;
    additionalNotes?: string | null;
    version?: number | null;
    comment?: string | null;
    updatedAt?: Date | null;
}

export class MedicalInstitutionOption implements IMedicalInstitutionOption {
    value!: string;
    text!: string;
    medicalPractitionerOptions!: MedicalPractitionerOption[];
    active!: boolean;

    constructor(data?: IMedicalInstitutionOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.medicalPractitionerOptions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.text = _data["text"] !== undefined ? _data["text"] : <any>null;
            if (Array.isArray(_data["medicalPractitionerOptions"])) {
                this.medicalPractitionerOptions = [] as any;
                for (let item of _data["medicalPractitionerOptions"])
                    this.medicalPractitionerOptions!.push(MedicalPractitionerOption.fromJS(item));
            }
            else {
                this.medicalPractitionerOptions = <any>null;
            }
            this.active = _data["active"] !== undefined ? _data["active"] : <any>null;
        }
    }

    static fromJS(data: any): MedicalInstitutionOption {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalInstitutionOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["text"] = this.text !== undefined ? this.text : <any>null;
        if (Array.isArray(this.medicalPractitionerOptions)) {
            data["medicalPractitionerOptions"] = [];
            for (let item of this.medicalPractitionerOptions)
                data["medicalPractitionerOptions"].push(item.toJSON());
        }
        data["active"] = this.active !== undefined ? this.active : <any>null;
        return data;
    }
}

export interface IMedicalInstitutionOption {
    value: string;
    text: string;
    medicalPractitionerOptions: MedicalPractitionerOption[];
    active: boolean;
}

export class MedicalPractitionerOption implements IMedicalPractitionerOption {
    value!: string;
    text!: string;

    constructor(data?: IMedicalPractitionerOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.text = _data["text"] !== undefined ? _data["text"] : <any>null;
        }
    }

    static fromJS(data: any): MedicalPractitionerOption {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalPractitionerOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["text"] = this.text !== undefined ? this.text : <any>null;
        return data;
    }
}

export interface IMedicalPractitionerOption {
    value: string;
    text: string;
}

export class MedicalCertificateActions implements IMedicalCertificateActions {
    canChooseInstitutionAndPractitioner!: boolean;
    canApprove!: boolean;
    canDisapprove!: boolean;
    canComment!: boolean;
    canSuspend!: boolean;
    canPrintOut!: boolean;
    canModify!: boolean;
    canViewSeafarerApplications!: boolean;
    canOmitFile!: boolean;
    isOfficial!: boolean;

    constructor(data?: IMedicalCertificateActions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canChooseInstitutionAndPractitioner = _data["canChooseInstitutionAndPractitioner"] !== undefined ? _data["canChooseInstitutionAndPractitioner"] : <any>null;
            this.canApprove = _data["canApprove"] !== undefined ? _data["canApprove"] : <any>null;
            this.canDisapprove = _data["canDisapprove"] !== undefined ? _data["canDisapprove"] : <any>null;
            this.canComment = _data["canComment"] !== undefined ? _data["canComment"] : <any>null;
            this.canSuspend = _data["canSuspend"] !== undefined ? _data["canSuspend"] : <any>null;
            this.canPrintOut = _data["canPrintOut"] !== undefined ? _data["canPrintOut"] : <any>null;
            this.canModify = _data["canModify"] !== undefined ? _data["canModify"] : <any>null;
            this.canViewSeafarerApplications = _data["canViewSeafarerApplications"] !== undefined ? _data["canViewSeafarerApplications"] : <any>null;
            this.canOmitFile = _data["canOmitFile"] !== undefined ? _data["canOmitFile"] : <any>null;
            this.isOfficial = _data["isOfficial"] !== undefined ? _data["isOfficial"] : <any>null;
        }
    }

    static fromJS(data: any): MedicalCertificateActions {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalCertificateActions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canChooseInstitutionAndPractitioner"] = this.canChooseInstitutionAndPractitioner !== undefined ? this.canChooseInstitutionAndPractitioner : <any>null;
        data["canApprove"] = this.canApprove !== undefined ? this.canApprove : <any>null;
        data["canDisapprove"] = this.canDisapprove !== undefined ? this.canDisapprove : <any>null;
        data["canComment"] = this.canComment !== undefined ? this.canComment : <any>null;
        data["canSuspend"] = this.canSuspend !== undefined ? this.canSuspend : <any>null;
        data["canPrintOut"] = this.canPrintOut !== undefined ? this.canPrintOut : <any>null;
        data["canModify"] = this.canModify !== undefined ? this.canModify : <any>null;
        data["canViewSeafarerApplications"] = this.canViewSeafarerApplications !== undefined ? this.canViewSeafarerApplications : <any>null;
        data["canOmitFile"] = this.canOmitFile !== undefined ? this.canOmitFile : <any>null;
        data["isOfficial"] = this.isOfficial !== undefined ? this.isOfficial : <any>null;
        return data;
    }
}

export interface IMedicalCertificateActions {
    canChooseInstitutionAndPractitioner: boolean;
    canApprove: boolean;
    canDisapprove: boolean;
    canComment: boolean;
    canSuspend: boolean;
    canPrintOut: boolean;
    canModify: boolean;
    canViewSeafarerApplications: boolean;
    canOmitFile: boolean;
    isOfficial: boolean;
}

export class MedicalCertificateListActions implements IMedicalCertificateListActions {
    canAdd!: boolean;
    canChooseInstitutionAndPractitioner!: boolean;
    canOmitFile!: boolean;

    constructor(data?: IMedicalCertificateListActions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canAdd = _data["canAdd"] !== undefined ? _data["canAdd"] : <any>null;
            this.canChooseInstitutionAndPractitioner = _data["canChooseInstitutionAndPractitioner"] !== undefined ? _data["canChooseInstitutionAndPractitioner"] : <any>null;
            this.canOmitFile = _data["canOmitFile"] !== undefined ? _data["canOmitFile"] : <any>null;
        }
    }

    static fromJS(data: any): MedicalCertificateListActions {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalCertificateListActions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canAdd"] = this.canAdd !== undefined ? this.canAdd : <any>null;
        data["canChooseInstitutionAndPractitioner"] = this.canChooseInstitutionAndPractitioner !== undefined ? this.canChooseInstitutionAndPractitioner : <any>null;
        data["canOmitFile"] = this.canOmitFile !== undefined ? this.canOmitFile : <any>null;
        return data;
    }
}

export interface IMedicalCertificateListActions {
    canAdd: boolean;
    canChooseInstitutionAndPractitioner: boolean;
    canOmitFile: boolean;
}

export class HeaderNotification implements IHeaderNotification {
    id!: string;
    title!: string;
    message!: string;
    titleEn!: string;
    messageEn!: string;
    isActive!: boolean;

    constructor(data?: IHeaderNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.message = _data["message"] !== undefined ? _data["message"] : <any>null;
            this.titleEn = _data["titleEn"] !== undefined ? _data["titleEn"] : <any>null;
            this.messageEn = _data["messageEn"] !== undefined ? _data["messageEn"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): HeaderNotification {
        data = typeof data === 'object' ? data : {};
        let result = new HeaderNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["message"] = this.message !== undefined ? this.message : <any>null;
        data["titleEn"] = this.titleEn !== undefined ? this.titleEn : <any>null;
        data["messageEn"] = this.messageEn !== undefined ? this.messageEn : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data;
    }
}

export interface IHeaderNotification {
    id: string;
    title: string;
    message: string;
    titleEn: string;
    messageEn: string;
    isActive: boolean;
}

export class HarbourOptionsResponse implements IHarbourOptionsResponse {
    harbourOptions!: HarbourOption[];

    constructor(data?: IHarbourOptionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.harbourOptions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["harbourOptions"])) {
                this.harbourOptions = [] as any;
                for (let item of _data["harbourOptions"])
                    this.harbourOptions!.push(HarbourOption.fromJS(item));
            }
            else {
                this.harbourOptions = <any>null;
            }
        }
    }

    static fromJS(data: any): HarbourOptionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HarbourOptionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.harbourOptions)) {
            data["harbourOptions"] = [];
            for (let item of this.harbourOptions)
                data["harbourOptions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IHarbourOptionsResponse {
    harbourOptions: HarbourOption[];
}

export class TempFileUploadDestinationModel implements ITempFileUploadDestinationModel {
    fileId!: string;
    uploadUrl!: string;

    constructor(data?: ITempFileUploadDestinationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileId = _data["fileId"] !== undefined ? _data["fileId"] : <any>null;
            this.uploadUrl = _data["uploadUrl"] !== undefined ? _data["uploadUrl"] : <any>null;
        }
    }

    static fromJS(data: any): TempFileUploadDestinationModel {
        data = typeof data === 'object' ? data : {};
        let result = new TempFileUploadDestinationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileId"] = this.fileId !== undefined ? this.fileId : <any>null;
        data["uploadUrl"] = this.uploadUrl !== undefined ? this.uploadUrl : <any>null;
        return data;
    }
}

export interface ITempFileUploadDestinationModel {
    fileId: string;
    uploadUrl: string;
}

export class EndorsementLightViewModel implements IEndorsementLightViewModel {
    id!: string;
    number!: string;
    certificateTypeName!: string;
    issuerName!: string;
    issuedOn!: Date;
    validUntil!: Date;
    status!: EndorsementStatus;

    constructor(data?: IEndorsementLightViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.number = _data["number"] !== undefined ? _data["number"] : <any>null;
            this.certificateTypeName = _data["certificateTypeName"] !== undefined ? _data["certificateTypeName"] : <any>null;
            this.issuerName = _data["issuerName"] !== undefined ? _data["issuerName"] : <any>null;
            this.issuedOn = _data["issuedOn"] ? new Date(_data["issuedOn"].toString()) : <any>null;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
        }
    }

    static fromJS(data: any): EndorsementLightViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EndorsementLightViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["number"] = this.number !== undefined ? this.number : <any>null;
        data["certificateTypeName"] = this.certificateTypeName !== undefined ? this.certificateTypeName : <any>null;
        data["issuerName"] = this.issuerName !== undefined ? this.issuerName : <any>null;
        data["issuedOn"] = this.issuedOn ? this.issuedOn.toISOString() : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        return data;
    }
}

export interface IEndorsementLightViewModel {
    id: string;
    number: string;
    certificateTypeName: string;
    issuerName: string;
    issuedOn: Date;
    validUntil: Date;
    status: EndorsementStatus;
}

export class PagedResultOfOfficialEndorsementLightViewModel implements IPagedResultOfOfficialEndorsementLightViewModel {
    pageNumber!: number;
    pageSize!: number;
    pageResult!: OfficialEndorsementLightViewModel[];
    totalCount!: number;

    constructor(data?: IPagedResultOfOfficialEndorsementLightViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageResult = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"] !== undefined ? _data["pageNumber"] : <any>null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : <any>null;
            if (Array.isArray(_data["pageResult"])) {
                this.pageResult = [] as any;
                for (let item of _data["pageResult"])
                    this.pageResult!.push(OfficialEndorsementLightViewModel.fromJS(item));
            }
            else {
                this.pageResult = <any>null;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): PagedResultOfOfficialEndorsementLightViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfOfficialEndorsementLightViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber !== undefined ? this.pageNumber : <any>null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
        if (Array.isArray(this.pageResult)) {
            data["pageResult"] = [];
            for (let item of this.pageResult)
                data["pageResult"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data;
    }
}

export interface IPagedResultOfOfficialEndorsementLightViewModel {
    pageNumber: number;
    pageSize: number;
    pageResult: OfficialEndorsementLightViewModel[];
    totalCount: number;
}

export class OfficialEndorsementLightViewModel implements IOfficialEndorsementLightViewModel {
    id!: string;
    name!: string;
    seafarerName!: string;
    seafarerId!: string;
    birthDate?: Date | null;
    issuedAt!: Date;
    validUntil?: Date | null;
    status!: EndorsementStatus;
    documentNumber!: string;

    constructor(data?: IOfficialEndorsementLightViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.seafarerName = _data["seafarerName"] !== undefined ? _data["seafarerName"] : <any>null;
            this.seafarerId = _data["seafarerId"] !== undefined ? _data["seafarerId"] : <any>null;
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>null;
            this.issuedAt = _data["issuedAt"] ? new Date(_data["issuedAt"].toString()) : <any>null;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.documentNumber = _data["documentNumber"] !== undefined ? _data["documentNumber"] : <any>null;
        }
    }

    static fromJS(data: any): OfficialEndorsementLightViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OfficialEndorsementLightViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["seafarerName"] = this.seafarerName !== undefined ? this.seafarerName : <any>null;
        data["seafarerId"] = this.seafarerId !== undefined ? this.seafarerId : <any>null;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>null;
        data["issuedAt"] = this.issuedAt ? this.issuedAt.toISOString() : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["documentNumber"] = this.documentNumber !== undefined ? this.documentNumber : <any>null;
        return data;
    }
}

export interface IOfficialEndorsementLightViewModel {
    id: string;
    name: string;
    seafarerName: string;
    seafarerId: string;
    birthDate?: Date | null;
    issuedAt: Date;
    validUntil?: Date | null;
    status: EndorsementStatus;
    documentNumber: string;
}

export class SuspendRequest implements ISuspendRequest {
    reason!: SuspensionReason;
    comment!: string;
    startedOn!: Date;
    validUntil?: Date | null;

    constructor(data?: ISuspendRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.reason = new SuspensionReason();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"] ? SuspensionReason.fromJS(_data["reason"]) : new SuspensionReason();
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
            this.startedOn = _data["startedOn"] ? new Date(_data["startedOn"].toString()) : <any>null;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): SuspendRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SuspendRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason ? this.reason.toJSON() : <any>null;
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        data["startedOn"] = this.startedOn ? this.startedOn.toISOString() : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : <any>null;
        return data;
    }
}

export interface ISuspendRequest {
    reason: SuspensionReason;
    comment: string;
    startedOn: Date;
    validUntil?: Date | null;
}

export class InvalidationRequest implements IInvalidationRequest {
    reason!: ManualInvalidationReason;
    comment!: string;

    constructor(data?: IInvalidationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.reason = new ManualInvalidationReason();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"] ? ManualInvalidationReason.fromJS(_data["reason"]) : new ManualInvalidationReason();
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
        }
    }

    static fromJS(data: any): InvalidationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new InvalidationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason ? this.reason.toJSON() : <any>null;
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        return data;
    }
}

export interface IInvalidationRequest {
    reason: ManualInvalidationReason;
    comment: string;
}

export class EndorsementActions implements IEndorsementActions {
    canViewAdditionalInfo!: boolean;
    canSetAdditionalInfo!: boolean;
    canCancelSuspension!: boolean;
    canInvalidate!: boolean;
    canSuspend!: boolean;
    canPrintOut!: boolean;
    canViewDigitalRepresentation!: boolean;
    isOfficial!: boolean;

    constructor(data?: IEndorsementActions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canViewAdditionalInfo = _data["canViewAdditionalInfo"] !== undefined ? _data["canViewAdditionalInfo"] : <any>null;
            this.canSetAdditionalInfo = _data["canSetAdditionalInfo"] !== undefined ? _data["canSetAdditionalInfo"] : <any>null;
            this.canCancelSuspension = _data["canCancelSuspension"] !== undefined ? _data["canCancelSuspension"] : <any>null;
            this.canInvalidate = _data["canInvalidate"] !== undefined ? _data["canInvalidate"] : <any>null;
            this.canSuspend = _data["canSuspend"] !== undefined ? _data["canSuspend"] : <any>null;
            this.canPrintOut = _data["canPrintOut"] !== undefined ? _data["canPrintOut"] : <any>null;
            this.canViewDigitalRepresentation = _data["canViewDigitalRepresentation"] !== undefined ? _data["canViewDigitalRepresentation"] : <any>null;
            this.isOfficial = _data["isOfficial"] !== undefined ? _data["isOfficial"] : <any>null;
        }
    }

    static fromJS(data: any): EndorsementActions {
        data = typeof data === 'object' ? data : {};
        let result = new EndorsementActions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canViewAdditionalInfo"] = this.canViewAdditionalInfo !== undefined ? this.canViewAdditionalInfo : <any>null;
        data["canSetAdditionalInfo"] = this.canSetAdditionalInfo !== undefined ? this.canSetAdditionalInfo : <any>null;
        data["canCancelSuspension"] = this.canCancelSuspension !== undefined ? this.canCancelSuspension : <any>null;
        data["canInvalidate"] = this.canInvalidate !== undefined ? this.canInvalidate : <any>null;
        data["canSuspend"] = this.canSuspend !== undefined ? this.canSuspend : <any>null;
        data["canPrintOut"] = this.canPrintOut !== undefined ? this.canPrintOut : <any>null;
        data["canViewDigitalRepresentation"] = this.canViewDigitalRepresentation !== undefined ? this.canViewDigitalRepresentation : <any>null;
        data["isOfficial"] = this.isOfficial !== undefined ? this.isOfficial : <any>null;
        return data;
    }
}

export interface IEndorsementActions {
    canViewAdditionalInfo: boolean;
    canSetAdditionalInfo: boolean;
    canCancelSuspension: boolean;
    canInvalidate: boolean;
    canSuspend: boolean;
    canPrintOut: boolean;
    canViewDigitalRepresentation: boolean;
    isOfficial: boolean;
}

export class PrintTemplate implements IPrintTemplate {
    name!: string;
    url!: string;
    frontUrl?: string | null;
    backUrl?: string | null;
    transparentSignatureUrl?: string | null;
    transparentOfficialSignatureUrl?: string | null;

    constructor(data?: IPrintTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
            this.frontUrl = _data["frontUrl"] !== undefined ? _data["frontUrl"] : <any>null;
            this.backUrl = _data["backUrl"] !== undefined ? _data["backUrl"] : <any>null;
            this.transparentSignatureUrl = _data["transparentSignatureUrl"] !== undefined ? _data["transparentSignatureUrl"] : <any>null;
            this.transparentOfficialSignatureUrl = _data["transparentOfficialSignatureUrl"] !== undefined ? _data["transparentOfficialSignatureUrl"] : <any>null;
        }
    }

    static fromJS(data: any): PrintTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new PrintTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["url"] = this.url !== undefined ? this.url : <any>null;
        data["frontUrl"] = this.frontUrl !== undefined ? this.frontUrl : <any>null;
        data["backUrl"] = this.backUrl !== undefined ? this.backUrl : <any>null;
        data["transparentSignatureUrl"] = this.transparentSignatureUrl !== undefined ? this.transparentSignatureUrl : <any>null;
        data["transparentOfficialSignatureUrl"] = this.transparentOfficialSignatureUrl !== undefined ? this.transparentOfficialSignatureUrl : <any>null;
        return data;
    }
}

export interface IPrintTemplate {
    name: string;
    url: string;
    frontUrl?: string | null;
    backUrl?: string | null;
    transparentSignatureUrl?: string | null;
    transparentOfficialSignatureUrl?: string | null;
}

export class CertificateTypeApiModel implements ICertificateTypeApiModel {
    id!: string;
    name!: string;
    documentType!: CertificateDocumentTypeApiModel;

    constructor(data?: ICertificateTypeApiModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.documentType = new CertificateDocumentTypeApiModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.documentType = _data["documentType"] ? CertificateDocumentTypeApiModel.fromJS(_data["documentType"]) : new CertificateDocumentTypeApiModel();
        }
    }

    static fromJS(data: any): CertificateTypeApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new CertificateTypeApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["documentType"] = this.documentType ? this.documentType.toJSON() : <any>null;
        return data;
    }
}

export interface ICertificateTypeApiModel {
    id: string;
    name: string;
    documentType: CertificateDocumentTypeApiModel;
}

export class DocumentValidityModel implements IDocumentValidityModel {
    isValid!: boolean;
    documentNumber!: string;
    validUntil?: Date | null;
    issuedOn?: Date | null;
    organization!: string;

    constructor(data?: IDocumentValidityModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isValid = _data["isValid"] !== undefined ? _data["isValid"] : <any>null;
            this.documentNumber = _data["documentNumber"] !== undefined ? _data["documentNumber"] : <any>null;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : <any>null;
            this.issuedOn = _data["issuedOn"] ? new Date(_data["issuedOn"].toString()) : <any>null;
            this.organization = _data["organization"] !== undefined ? _data["organization"] : <any>null;
        }
    }

    static fromJS(data: any): DocumentValidityModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentValidityModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isValid"] = this.isValid !== undefined ? this.isValid : <any>null;
        data["documentNumber"] = this.documentNumber !== undefined ? this.documentNumber : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : <any>null;
        data["issuedOn"] = this.issuedOn ? this.issuedOn.toISOString() : <any>null;
        data["organization"] = this.organization !== undefined ? this.organization : <any>null;
        return data;
    }
}

export interface IDocumentValidityModel {
    isValid: boolean;
    documentNumber: string;
    validUntil?: Date | null;
    issuedOn?: Date | null;
    organization: string;
}

export class PagedResultOfQualificationRecordListItem implements IPagedResultOfQualificationRecordListItem {
    pageNumber!: number;
    pageSize!: number;
    pageResult!: QualificationRecordListItem[];
    totalCount!: number;

    constructor(data?: IPagedResultOfQualificationRecordListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageResult = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"] !== undefined ? _data["pageNumber"] : <any>null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : <any>null;
            if (Array.isArray(_data["pageResult"])) {
                this.pageResult = [] as any;
                for (let item of _data["pageResult"])
                    this.pageResult!.push(QualificationRecordListItem.fromJS(item));
            }
            else {
                this.pageResult = <any>null;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): PagedResultOfQualificationRecordListItem {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfQualificationRecordListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber !== undefined ? this.pageNumber : <any>null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
        if (Array.isArray(this.pageResult)) {
            data["pageResult"] = [];
            for (let item of this.pageResult)
                data["pageResult"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data;
    }
}

export interface IPagedResultOfQualificationRecordListItem {
    pageNumber: number;
    pageSize: number;
    pageResult: QualificationRecordListItem[];
    totalCount: number;
}

export class QualificationRecordListItem implements IQualificationRecordListItem {
    id!: string;
    name!: string;
    educationalInstitutionName!: string;
    issuedOn!: Date;
    specialityType!: SpecialityType;
    submittedOn?: Date | null;
    recordNumber!: string;

    constructor(data?: IQualificationRecordListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.educationalInstitutionName = _data["educationalInstitutionName"] !== undefined ? _data["educationalInstitutionName"] : <any>null;
            this.issuedOn = _data["issuedOn"] ? new Date(_data["issuedOn"].toString()) : <any>null;
            this.specialityType = _data["specialityType"] !== undefined ? _data["specialityType"] : <any>null;
            this.submittedOn = _data["submittedOn"] ? new Date(_data["submittedOn"].toString()) : <any>null;
            this.recordNumber = _data["recordNumber"] !== undefined ? _data["recordNumber"] : <any>null;
        }
    }

    static fromJS(data: any): QualificationRecordListItem {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationRecordListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["educationalInstitutionName"] = this.educationalInstitutionName !== undefined ? this.educationalInstitutionName : <any>null;
        data["issuedOn"] = this.issuedOn ? this.issuedOn.toISOString() : <any>null;
        data["specialityType"] = this.specialityType !== undefined ? this.specialityType : <any>null;
        data["submittedOn"] = this.submittedOn ? this.submittedOn.toISOString() : <any>null;
        data["recordNumber"] = this.recordNumber !== undefined ? this.recordNumber : <any>null;
        return data;
    }
}

export interface IQualificationRecordListItem {
    id: string;
    name: string;
    educationalInstitutionName: string;
    issuedOn: Date;
    specialityType: SpecialityType;
    submittedOn?: Date | null;
    recordNumber: string;
}

export enum QualificationRecordsSortField {
    SpecialityNameAsc = "specialityNameAsc",
    SpecialityNameDesc = "specialityNameDesc",
    IssuedOnAsc = "issuedOnAsc",
    IssuedOnDesc = "issuedOnDesc",
    EducationalInstitutionNameAsc = "educationalInstitutionNameAsc",
    EducationalInstitutionNameDesc = "educationalInstitutionNameDesc",
    SubmittedOnAsc = "submittedOnAsc",
    SubmittedOnDesc = "submittedOnDesc",
}

export abstract class QualificationRecordModel implements IQualificationRecordModel {
    id?: string | null;
    speciality?: string | null;
    recordNumber!: string;
    issuedOn?: Date | null;
    validUntil?: Date | null;
    additionalInformation!: string;
    qualificationResults!: QualificationRecordResultModel[];
    submittedOn?: Date | null;
    educationalInstitutionId?: string | null;
    addedFiles!: TempFileModel[];
    removedFiles!: FileModel[];
    existingFiles!: FileModel[];
    comment?: string | null;
    updatedAt?: Date | null;
    duplicateWarning?: boolean | null;

    protected _discriminator: string;

    constructor(data?: IQualificationRecordModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.recordNumber = "";
            this.additionalInformation = "";
            this.qualificationResults = [];
            this.addedFiles = [];
            this.removedFiles = [];
            this.existingFiles = [];
        }
        this._discriminator = "QualificationRecordModel";
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.speciality = _data["speciality"] !== undefined ? _data["speciality"] : <any>null;
            this.recordNumber = _data["recordNumber"] !== undefined ? _data["recordNumber"] : "";
            this.issuedOn = _data["issuedOn"] ? new Date(_data["issuedOn"].toString()) : <any>null;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : <any>null;
            this.additionalInformation = _data["additionalInformation"] !== undefined ? _data["additionalInformation"] : "";
            if (Array.isArray(_data["qualificationResults"])) {
                this.qualificationResults = [] as any;
                for (let item of _data["qualificationResults"])
                    this.qualificationResults!.push(QualificationRecordResultModel.fromJS(item));
            }
            else {
                this.qualificationResults = <any>null;
            }
            this.submittedOn = _data["submittedOn"] ? new Date(_data["submittedOn"].toString()) : <any>null;
            this.educationalInstitutionId = _data["educationalInstitutionId"] !== undefined ? _data["educationalInstitutionId"] : <any>null;
            if (Array.isArray(_data["addedFiles"])) {
                this.addedFiles = [] as any;
                for (let item of _data["addedFiles"])
                    this.addedFiles!.push(TempFileModel.fromJS(item));
            }
            else {
                this.addedFiles = <any>null;
            }
            if (Array.isArray(_data["removedFiles"])) {
                this.removedFiles = [] as any;
                for (let item of _data["removedFiles"])
                    this.removedFiles!.push(FileModel.fromJS(item));
            }
            else {
                this.removedFiles = <any>null;
            }
            if (Array.isArray(_data["existingFiles"])) {
                this.existingFiles = [] as any;
                for (let item of _data["existingFiles"])
                    this.existingFiles!.push(FileModel.fromJS(item));
            }
            else {
                this.existingFiles = <any>null;
            }
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>null;
            this.duplicateWarning = _data["duplicateWarning"] !== undefined ? _data["duplicateWarning"] : <any>null;
        }
    }

    static fromJS(data: any): QualificationRecordModel {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "TrainingQualificationRecordModel") {
            let result = new TrainingQualificationRecordModel();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "EducationalQualificationRecordModel") {
            let result = new EducationalQualificationRecordModel();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'QualificationRecordModel' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["speciality"] = this.speciality !== undefined ? this.speciality : <any>null;
        data["recordNumber"] = this.recordNumber !== undefined ? this.recordNumber : <any>null;
        data["issuedOn"] = this.issuedOn ? this.issuedOn.toISOString() : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : <any>null;
        data["additionalInformation"] = this.additionalInformation !== undefined ? this.additionalInformation : <any>null;
        if (Array.isArray(this.qualificationResults)) {
            data["qualificationResults"] = [];
            for (let item of this.qualificationResults)
                data["qualificationResults"].push(item.toJSON());
        }
        data["submittedOn"] = this.submittedOn ? this.submittedOn.toISOString() : <any>null;
        data["educationalInstitutionId"] = this.educationalInstitutionId !== undefined ? this.educationalInstitutionId : <any>null;
        if (Array.isArray(this.addedFiles)) {
            data["addedFiles"] = [];
            for (let item of this.addedFiles)
                data["addedFiles"].push(item.toJSON());
        }
        if (Array.isArray(this.removedFiles)) {
            data["removedFiles"] = [];
            for (let item of this.removedFiles)
                data["removedFiles"].push(item.toJSON());
        }
        if (Array.isArray(this.existingFiles)) {
            data["existingFiles"] = [];
            for (let item of this.existingFiles)
                data["existingFiles"].push(item.toJSON());
        }
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>null;
        data["duplicateWarning"] = this.duplicateWarning !== undefined ? this.duplicateWarning : <any>null;
        return data;
    }
}

export interface IQualificationRecordModel {
    id?: string | null;
    speciality?: string | null;
    recordNumber: string;
    issuedOn?: Date | null;
    validUntil?: Date | null;
    additionalInformation: string;
    qualificationResults: QualificationRecordResultModel[];
    submittedOn?: Date | null;
    educationalInstitutionId?: string | null;
    addedFiles: TempFileModel[];
    removedFiles: FileModel[];
    existingFiles: FileModel[];
    comment?: string | null;
    updatedAt?: Date | null;
    duplicateWarning?: boolean | null;
}

export class TrainingQualificationRecordModel extends QualificationRecordModel implements ITrainingQualificationRecordModel {
    fulfillmentDate?: Date | null;
    trainingType!: TrainingType;
    commissionMembers?: string | null;

    constructor(data?: ITrainingQualificationRecordModel) {
        super(data);
        if (!data) {
            this.trainingType = TrainingType.Undefined;
        }
        this._discriminator = "TrainingQualificationRecordModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fulfillmentDate = _data["fulfillmentDate"] ? new Date(_data["fulfillmentDate"].toString()) : <any>null;
            this.trainingType = _data["trainingType"] !== undefined ? _data["trainingType"] : TrainingType.Undefined;
            this.commissionMembers = _data["commissionMembers"] !== undefined ? _data["commissionMembers"] : <any>null;
        }
    }

    static fromJS(data: any): TrainingQualificationRecordModel {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingQualificationRecordModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fulfillmentDate"] = this.fulfillmentDate ? this.fulfillmentDate.toISOString() : <any>null;
        data["trainingType"] = this.trainingType !== undefined ? this.trainingType : <any>null;
        data["commissionMembers"] = this.commissionMembers !== undefined ? this.commissionMembers : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITrainingQualificationRecordModel extends IQualificationRecordModel {
    fulfillmentDate?: Date | null;
    trainingType: TrainingType;
    commissionMembers?: string | null;
}

export enum TrainingType {
    Undefined = "undefined",
    Online = "online",
    Contact = "contact",
}

export class QualificationRecordResultModel implements IQualificationRecordResultModel {
    seafarer?: SeafarerModel | null;
    certificateNumber!: string;
    passed!: boolean;
    comment!: string;
    updatedAt?: Date | null;

    constructor(data?: IQualificationRecordResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.certificateNumber = "";
            this.comment = "";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seafarer = _data["seafarer"] ? SeafarerModel.fromJS(_data["seafarer"]) : <any>null;
            this.certificateNumber = _data["certificateNumber"] !== undefined ? _data["certificateNumber"] : "";
            this.passed = _data["passed"] !== undefined ? _data["passed"] : <any>null;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : "";
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): QualificationRecordResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationRecordResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seafarer"] = this.seafarer ? this.seafarer.toJSON() : <any>null;
        data["certificateNumber"] = this.certificateNumber !== undefined ? this.certificateNumber : <any>null;
        data["passed"] = this.passed !== undefined ? this.passed : <any>null;
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>null;
        return data;
    }
}

export interface IQualificationRecordResultModel {
    seafarer?: SeafarerModel | null;
    certificateNumber: string;
    passed: boolean;
    comment: string;
    updatedAt?: Date | null;
}

export class SeafarerModel implements ISeafarerModel {
    id!: string;
    personalCode?: string | null;
    firstName!: string;
    lastName!: string;

    constructor(data?: ISeafarerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.personalCode = _data["personalCode"] !== undefined ? _data["personalCode"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
        }
    }

    static fromJS(data: any): SeafarerModel {
        data = typeof data === 'object' ? data : {};
        let result = new SeafarerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["personalCode"] = this.personalCode !== undefined ? this.personalCode : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        return data;
    }
}

export interface ISeafarerModel {
    id: string;
    personalCode?: string | null;
    firstName: string;
    lastName: string;
}

export class EducationalQualificationRecordModel extends QualificationRecordModel implements IEducationalQualificationRecordModel {

    constructor(data?: IEducationalQualificationRecordModel) {
        super(data);
        this._discriminator = "EducationalQualificationRecordModel";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): EducationalQualificationRecordModel {
        data = typeof data === 'object' ? data : {};
        let result = new EducationalQualificationRecordModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IEducationalQualificationRecordModel extends IQualificationRecordModel {
}

export abstract class QualificationRecordDetailsModel implements IQualificationRecordDetailsModel {
    educationalInstituteName?: string | null;
    specialityName?: string | null;
    creator?: NameAndOrganization | null;
    createdOn!: Date;
    id?: string | null;
    speciality?: string | null;
    recordNumber!: string;
    issuedOn?: Date | null;
    validUntil?: Date | null;
    additionalInformation!: string;
    qualificationResults!: QualificationRecordResultModel[];
    submittedOn?: Date | null;
    files!: FileModel[];
    version!: number;
    comment!: string;
    updatedAt?: Date | null;
    duplicateWarning?: boolean | null;
    changeInfo?: HistoryDetails | null;

    constructor(data?: IQualificationRecordDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.recordNumber = "";
            this.additionalInformation = "";
            this.qualificationResults = [];
            this.files = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.educationalInstituteName = _data["educationalInstituteName"] !== undefined ? _data["educationalInstituteName"] : <any>null;
            this.specialityName = _data["specialityName"] !== undefined ? _data["specialityName"] : <any>null;
            this.creator = _data["creator"] ? NameAndOrganization.fromJS(_data["creator"]) : <any>null;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.speciality = _data["speciality"] !== undefined ? _data["speciality"] : <any>null;
            this.recordNumber = _data["recordNumber"] !== undefined ? _data["recordNumber"] : "";
            this.issuedOn = _data["issuedOn"] ? new Date(_data["issuedOn"].toString()) : <any>null;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : <any>null;
            this.additionalInformation = _data["additionalInformation"] !== undefined ? _data["additionalInformation"] : "";
            if (Array.isArray(_data["qualificationResults"])) {
                this.qualificationResults = [] as any;
                for (let item of _data["qualificationResults"])
                    this.qualificationResults!.push(QualificationRecordResultModel.fromJS(item));
            }
            else {
                this.qualificationResults = <any>null;
            }
            this.submittedOn = _data["submittedOn"] ? new Date(_data["submittedOn"].toString()) : <any>null;
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(FileModel.fromJS(item));
            }
            else {
                this.files = <any>null;
            }
            this.version = _data["version"] !== undefined ? _data["version"] : <any>null;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>null;
            this.duplicateWarning = _data["duplicateWarning"] !== undefined ? _data["duplicateWarning"] : <any>null;
            this.changeInfo = _data["changeInfo"] ? HistoryDetails.fromJS(_data["changeInfo"]) : <any>null;
        }
    }

    static fromJS(data: any): QualificationRecordDetailsModel {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'QualificationRecordDetailsModel' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["educationalInstituteName"] = this.educationalInstituteName !== undefined ? this.educationalInstituteName : <any>null;
        data["specialityName"] = this.specialityName !== undefined ? this.specialityName : <any>null;
        data["creator"] = this.creator ? this.creator.toJSON() : <any>null;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["speciality"] = this.speciality !== undefined ? this.speciality : <any>null;
        data["recordNumber"] = this.recordNumber !== undefined ? this.recordNumber : <any>null;
        data["issuedOn"] = this.issuedOn ? this.issuedOn.toISOString() : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : <any>null;
        data["additionalInformation"] = this.additionalInformation !== undefined ? this.additionalInformation : <any>null;
        if (Array.isArray(this.qualificationResults)) {
            data["qualificationResults"] = [];
            for (let item of this.qualificationResults)
                data["qualificationResults"].push(item.toJSON());
        }
        data["submittedOn"] = this.submittedOn ? this.submittedOn.toISOString() : <any>null;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        data["version"] = this.version !== undefined ? this.version : <any>null;
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>null;
        data["duplicateWarning"] = this.duplicateWarning !== undefined ? this.duplicateWarning : <any>null;
        data["changeInfo"] = this.changeInfo ? this.changeInfo.toJSON() : <any>null;
        return data;
    }
}

export interface IQualificationRecordDetailsModel {
    educationalInstituteName?: string | null;
    specialityName?: string | null;
    creator?: NameAndOrganization | null;
    createdOn: Date;
    id?: string | null;
    speciality?: string | null;
    recordNumber: string;
    issuedOn?: Date | null;
    validUntil?: Date | null;
    additionalInformation: string;
    qualificationResults: QualificationRecordResultModel[];
    submittedOn?: Date | null;
    files: FileModel[];
    version: number;
    comment: string;
    updatedAt?: Date | null;
    duplicateWarning?: boolean | null;
    changeInfo?: HistoryDetails | null;
}

export class TrainingQualificationRecordDetailsModel extends QualificationRecordDetailsModel implements ITrainingQualificationRecordDetailsModel {
    fulfillmentDate?: Date | null;
    trainingType!: TrainingType;
    commissionMembers?: string | null;

    constructor(data?: ITrainingQualificationRecordDetailsModel) {
        super(data);
        if (!data) {
            this.trainingType = TrainingType.Undefined;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fulfillmentDate = _data["fulfillmentDate"] ? new Date(_data["fulfillmentDate"].toString()) : <any>null;
            this.trainingType = _data["trainingType"] !== undefined ? _data["trainingType"] : TrainingType.Undefined;
            this.commissionMembers = _data["commissionMembers"] !== undefined ? _data["commissionMembers"] : <any>null;
        }
    }

    static fromJS(data: any): TrainingQualificationRecordDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingQualificationRecordDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fulfillmentDate"] = this.fulfillmentDate ? this.fulfillmentDate.toISOString() : <any>null;
        data["trainingType"] = this.trainingType !== undefined ? this.trainingType : <any>null;
        data["commissionMembers"] = this.commissionMembers !== undefined ? this.commissionMembers : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITrainingQualificationRecordDetailsModel extends IQualificationRecordDetailsModel {
    fulfillmentDate?: Date | null;
    trainingType: TrainingType;
    commissionMembers?: string | null;
}

export class EducationalQualificationRecordDetailsModel extends QualificationRecordDetailsModel implements IEducationalQualificationRecordDetailsModel {
    educationName!: string;

    constructor(data?: IEducationalQualificationRecordDetailsModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.educationName = _data["educationName"] !== undefined ? _data["educationName"] : <any>null;
        }
    }

    static fromJS(data: any): EducationalQualificationRecordDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new EducationalQualificationRecordDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["educationName"] = this.educationName !== undefined ? this.educationName : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IEducationalQualificationRecordDetailsModel extends IQualificationRecordDetailsModel {
    educationName: string;
}

export class QualificationRecordResultsModelBase implements IQualificationRecordResultsModelBase {

    constructor(data?: IQualificationRecordResultsModelBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): QualificationRecordResultsModelBase {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationRecordResultsModelBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IQualificationRecordResultsModelBase {
}

export abstract class UpdateQualificationRecordResultsModel extends QualificationRecordResultsModelBase implements IUpdateQualificationRecordResultsModel {
    recordId!: string;
    qualificationResults!: UpdateQualificationResultModel[];

    protected _discriminator: string;

    constructor(data?: IUpdateQualificationRecordResultsModel) {
        super(data);
        if (!data) {
            this.qualificationResults = [];
        }
        this._discriminator = "UpdateQualificationRecordResultsModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.recordId = _data["recordId"] !== undefined ? _data["recordId"] : <any>null;
            if (Array.isArray(_data["qualificationResults"])) {
                this.qualificationResults = [] as any;
                for (let item of _data["qualificationResults"])
                    this.qualificationResults!.push(UpdateQualificationResultModel.fromJS(item));
            }
            else {
                this.qualificationResults = <any>null;
            }
        }
    }

    static fromJS(data: any): UpdateQualificationRecordResultsModel {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "UpdateEducationalQualificationRecordResultsModel") {
            let result = new UpdateEducationalQualificationRecordResultsModel();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "UpdateTrainingQualificationRecordResultsModel") {
            let result = new UpdateTrainingQualificationRecordResultsModel();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'UpdateQualificationRecordResultsModel' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        data["recordId"] = this.recordId !== undefined ? this.recordId : <any>null;
        if (Array.isArray(this.qualificationResults)) {
            data["qualificationResults"] = [];
            for (let item of this.qualificationResults)
                data["qualificationResults"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateQualificationRecordResultsModel extends IQualificationRecordResultsModelBase {
    recordId: string;
    qualificationResults: UpdateQualificationResultModel[];
}

export class UpdateQualificationResultModel implements IUpdateQualificationResultModel {
    recordId?: string | null;
    seafarerId?: string | null;
    certificateNumber!: string;
    passed?: boolean | null;
    comment!: string;

    constructor(data?: IUpdateQualificationResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.certificateNumber = "";
            this.comment = "";
        }
    }

    init(_data?: any) {
        if (_data) {
            this.recordId = _data["recordId"] !== undefined ? _data["recordId"] : <any>null;
            this.seafarerId = _data["seafarerId"] !== undefined ? _data["seafarerId"] : <any>null;
            this.certificateNumber = _data["certificateNumber"] !== undefined ? _data["certificateNumber"] : "";
            this.passed = _data["passed"] !== undefined ? _data["passed"] : <any>null;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : "";
        }
    }

    static fromJS(data: any): UpdateQualificationResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateQualificationResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordId"] = this.recordId !== undefined ? this.recordId : <any>null;
        data["seafarerId"] = this.seafarerId !== undefined ? this.seafarerId : <any>null;
        data["certificateNumber"] = this.certificateNumber !== undefined ? this.certificateNumber : <any>null;
        data["passed"] = this.passed !== undefined ? this.passed : <any>null;
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        return data;
    }
}

export interface IUpdateQualificationResultModel {
    recordId?: string | null;
    seafarerId?: string | null;
    certificateNumber: string;
    passed?: boolean | null;
    comment: string;
}

export class UpdateEducationalQualificationRecordResultsModel extends UpdateQualificationRecordResultsModel implements IUpdateEducationalQualificationRecordResultsModel {

    constructor(data?: IUpdateEducationalQualificationRecordResultsModel) {
        super(data);
        this._discriminator = "UpdateEducationalQualificationRecordResultsModel";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpdateEducationalQualificationRecordResultsModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateEducationalQualificationRecordResultsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateEducationalQualificationRecordResultsModel extends IUpdateQualificationRecordResultsModel {
}

export class UpdateTrainingQualificationRecordResultsModel extends UpdateQualificationRecordResultsModel implements IUpdateTrainingQualificationRecordResultsModel {

    constructor(data?: IUpdateTrainingQualificationRecordResultsModel) {
        super(data);
        this._discriminator = "UpdateTrainingQualificationRecordResultsModel";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): UpdateTrainingQualificationRecordResultsModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTrainingQualificationRecordResultsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateTrainingQualificationRecordResultsModel extends IUpdateQualificationRecordResultsModel {
}

export abstract class AddQualificationRecordResultModel extends QualificationRecordResultsModelBase implements IAddQualificationRecordResultModel {
    recordId!: string;
    qualificationResult!: UpdateQualificationResultModel;
    comment?: string | null;

    protected _discriminator: string;

    constructor(data?: IAddQualificationRecordResultModel) {
        super(data);
        if (!data) {
            this.qualificationResult = new UpdateQualificationResultModel();
        }
        this._discriminator = "AddQualificationRecordResultModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.recordId = _data["recordId"] !== undefined ? _data["recordId"] : <any>null;
            this.qualificationResult = _data["qualificationResult"] ? UpdateQualificationResultModel.fromJS(_data["qualificationResult"]) : new UpdateQualificationResultModel();
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
        }
    }

    static fromJS(data: any): AddQualificationRecordResultModel {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "AddEducationalQualificationRecordResultModel") {
            let result = new AddEducationalQualificationRecordResultModel();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "AddTrainingQualificationRecordResultModel") {
            let result = new AddTrainingQualificationRecordResultModel();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'AddQualificationRecordResultModel' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        data["recordId"] = this.recordId !== undefined ? this.recordId : <any>null;
        data["qualificationResult"] = this.qualificationResult ? this.qualificationResult.toJSON() : <any>null;
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAddQualificationRecordResultModel extends IQualificationRecordResultsModelBase {
    recordId: string;
    qualificationResult: UpdateQualificationResultModel;
    comment?: string | null;
}

export class AddEducationalQualificationRecordResultModel extends AddQualificationRecordResultModel implements IAddEducationalQualificationRecordResultModel {

    constructor(data?: IAddEducationalQualificationRecordResultModel) {
        super(data);
        this._discriminator = "AddEducationalQualificationRecordResultModel";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): AddEducationalQualificationRecordResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddEducationalQualificationRecordResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IAddEducationalQualificationRecordResultModel extends IAddQualificationRecordResultModel {
}

export class AddTrainingQualificationRecordResultModel extends AddQualificationRecordResultModel implements IAddTrainingQualificationRecordResultModel {

    constructor(data?: IAddTrainingQualificationRecordResultModel) {
        super(data);
        this._discriminator = "AddTrainingQualificationRecordResultModel";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): AddTrainingQualificationRecordResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddTrainingQualificationRecordResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IAddTrainingQualificationRecordResultModel extends IAddQualificationRecordResultModel {
}

export abstract class RemoveQualificationRecordResultModel implements IRemoveQualificationRecordResultModel {
    recordId!: string;
    seafarerId!: string;
    comment?: string | null;

    protected _discriminator: string;

    constructor(data?: IRemoveQualificationRecordResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "RemoveQualificationRecordResultModel";
    }

    init(_data?: any) {
        if (_data) {
            this.recordId = _data["recordId"] !== undefined ? _data["recordId"] : <any>null;
            this.seafarerId = _data["seafarerId"] !== undefined ? _data["seafarerId"] : <any>null;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
        }
    }

    static fromJS(data: any): RemoveQualificationRecordResultModel {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "RemoveEducationalQualificationRecordResultModel") {
            let result = new RemoveEducationalQualificationRecordResultModel();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "RemoveTrainingQualificationRecordResultModel") {
            let result = new RemoveTrainingQualificationRecordResultModel();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'RemoveQualificationRecordResultModel' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        data["recordId"] = this.recordId !== undefined ? this.recordId : <any>null;
        data["seafarerId"] = this.seafarerId !== undefined ? this.seafarerId : <any>null;
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        return data;
    }
}

export interface IRemoveQualificationRecordResultModel {
    recordId: string;
    seafarerId: string;
    comment?: string | null;
}

export class RemoveEducationalQualificationRecordResultModel extends RemoveQualificationRecordResultModel implements IRemoveEducationalQualificationRecordResultModel {

    constructor(data?: IRemoveEducationalQualificationRecordResultModel) {
        super(data);
        this._discriminator = "RemoveEducationalQualificationRecordResultModel";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): RemoveEducationalQualificationRecordResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveEducationalQualificationRecordResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IRemoveEducationalQualificationRecordResultModel extends IRemoveQualificationRecordResultModel {
}

export class RemoveTrainingQualificationRecordResultModel extends RemoveQualificationRecordResultModel implements IRemoveTrainingQualificationRecordResultModel {

    constructor(data?: IRemoveTrainingQualificationRecordResultModel) {
        super(data);
        this._discriminator = "RemoveTrainingQualificationRecordResultModel";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): RemoveTrainingQualificationRecordResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new RemoveTrainingQualificationRecordResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IRemoveTrainingQualificationRecordResultModel extends IRemoveQualificationRecordResultModel {
}

export class SubmitQualificationRecordResult implements ISubmitQualificationRecordResult {
    submittedOn!: Date;

    constructor(data?: ISubmitQualificationRecordResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.submittedOn = _data["submittedOn"] ? new Date(_data["submittedOn"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): SubmitQualificationRecordResult {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitQualificationRecordResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["submittedOn"] = this.submittedOn ? this.submittedOn.toISOString() : <any>null;
        return data;
    }
}

export interface ISubmitQualificationRecordResult {
    submittedOn: Date;
}

export abstract class SubmitQualificationRecordRequest implements ISubmitQualificationRecordRequest {
    recordId!: string;
    version!: number;

    protected _discriminator: string;

    constructor(data?: ISubmitQualificationRecordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "SubmitQualificationRecordRequest";
    }

    init(_data?: any) {
        if (_data) {
            this.recordId = _data["recordId"] !== undefined ? _data["recordId"] : <any>null;
            this.version = _data["version"] !== undefined ? _data["version"] : <any>null;
        }
    }

    static fromJS(data: any): SubmitQualificationRecordRequest {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "SubmitTrainingQualificationRecordRequest") {
            let result = new SubmitTrainingQualificationRecordRequest();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "SubmitEducationalQualificationRecordRequest") {
            let result = new SubmitEducationalQualificationRecordRequest();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'SubmitQualificationRecordRequest' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        data["recordId"] = this.recordId !== undefined ? this.recordId : <any>null;
        data["version"] = this.version !== undefined ? this.version : <any>null;
        return data;
    }
}

export interface ISubmitQualificationRecordRequest {
    recordId: string;
    version: number;
}

export class SubmitTrainingQualificationRecordRequest extends SubmitQualificationRecordRequest implements ISubmitTrainingQualificationRecordRequest {

    constructor(data?: ISubmitTrainingQualificationRecordRequest) {
        super(data);
        this._discriminator = "SubmitTrainingQualificationRecordRequest";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SubmitTrainingQualificationRecordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitTrainingQualificationRecordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISubmitTrainingQualificationRecordRequest extends ISubmitQualificationRecordRequest {
}

export class SubmitEducationalQualificationRecordRequest extends SubmitQualificationRecordRequest implements ISubmitEducationalQualificationRecordRequest {

    constructor(data?: ISubmitEducationalQualificationRecordRequest) {
        super(data);
        this._discriminator = "SubmitEducationalQualificationRecordRequest";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SubmitEducationalQualificationRecordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitEducationalQualificationRecordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISubmitEducationalQualificationRecordRequest extends ISubmitQualificationRecordRequest {
}

export abstract class SetResultAsFailedModel implements ISetResultAsFailedModel {
    recordId!: string;
    seafarerId!: string;
    comment!: string;

    protected _discriminator: string;

    constructor(data?: ISetResultAsFailedModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "SetResultAsFailedModel";
    }

    init(_data?: any) {
        if (_data) {
            this.recordId = _data["recordId"] !== undefined ? _data["recordId"] : <any>null;
            this.seafarerId = _data["seafarerId"] !== undefined ? _data["seafarerId"] : <any>null;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
        }
    }

    static fromJS(data: any): SetResultAsFailedModel {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "SetResultAsFailedForTrainingRecordModel") {
            let result = new SetResultAsFailedForTrainingRecordModel();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "SetResultAsFailedForEducationalRecordModel") {
            let result = new SetResultAsFailedForEducationalRecordModel();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'SetResultAsFailedModel' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        data["recordId"] = this.recordId !== undefined ? this.recordId : <any>null;
        data["seafarerId"] = this.seafarerId !== undefined ? this.seafarerId : <any>null;
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        return data;
    }
}

export interface ISetResultAsFailedModel {
    recordId: string;
    seafarerId: string;
    comment: string;
}

export class SetResultAsFailedForTrainingRecordModel extends SetResultAsFailedModel implements ISetResultAsFailedForTrainingRecordModel {

    constructor(data?: ISetResultAsFailedForTrainingRecordModel) {
        super(data);
        this._discriminator = "SetResultAsFailedForTrainingRecordModel";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SetResultAsFailedForTrainingRecordModel {
        data = typeof data === 'object' ? data : {};
        let result = new SetResultAsFailedForTrainingRecordModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISetResultAsFailedForTrainingRecordModel extends ISetResultAsFailedModel {
}

export class SetResultAsFailedForEducationalRecordModel extends SetResultAsFailedModel implements ISetResultAsFailedForEducationalRecordModel {

    constructor(data?: ISetResultAsFailedForEducationalRecordModel) {
        super(data);
        this._discriminator = "SetResultAsFailedForEducationalRecordModel";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SetResultAsFailedForEducationalRecordModel {
        data = typeof data === 'object' ? data : {};
        let result = new SetResultAsFailedForEducationalRecordModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISetResultAsFailedForEducationalRecordModel extends ISetResultAsFailedModel {
}

export abstract class SetResultAsPassedModel implements ISetResultAsPassedModel {
    recordId!: string;
    seafarerId!: string;
    certificateNumber!: string;

    protected _discriminator: string;

    constructor(data?: ISetResultAsPassedModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "SetResultAsPassedModel";
    }

    init(_data?: any) {
        if (_data) {
            this.recordId = _data["recordId"] !== undefined ? _data["recordId"] : <any>null;
            this.seafarerId = _data["seafarerId"] !== undefined ? _data["seafarerId"] : <any>null;
            this.certificateNumber = _data["certificateNumber"] !== undefined ? _data["certificateNumber"] : <any>null;
        }
    }

    static fromJS(data: any): SetResultAsPassedModel {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "SetResultAsPassedForTrainingRecordModel") {
            let result = new SetResultAsPassedForTrainingRecordModel();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "SetResultAsPassedForEducationalRecordModel") {
            let result = new SetResultAsPassedForEducationalRecordModel();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'SetResultAsPassedModel' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        data["recordId"] = this.recordId !== undefined ? this.recordId : <any>null;
        data["seafarerId"] = this.seafarerId !== undefined ? this.seafarerId : <any>null;
        data["certificateNumber"] = this.certificateNumber !== undefined ? this.certificateNumber : <any>null;
        return data;
    }
}

export interface ISetResultAsPassedModel {
    recordId: string;
    seafarerId: string;
    certificateNumber: string;
}

export class SetResultAsPassedForTrainingRecordModel extends SetResultAsPassedModel implements ISetResultAsPassedForTrainingRecordModel {

    constructor(data?: ISetResultAsPassedForTrainingRecordModel) {
        super(data);
        this._discriminator = "SetResultAsPassedForTrainingRecordModel";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SetResultAsPassedForTrainingRecordModel {
        data = typeof data === 'object' ? data : {};
        let result = new SetResultAsPassedForTrainingRecordModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISetResultAsPassedForTrainingRecordModel extends ISetResultAsPassedModel {
}

export class SetResultAsPassedForEducationalRecordModel extends SetResultAsPassedModel implements ISetResultAsPassedForEducationalRecordModel {

    constructor(data?: ISetResultAsPassedForEducationalRecordModel) {
        super(data);
        this._discriminator = "SetResultAsPassedForEducationalRecordModel";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SetResultAsPassedForEducationalRecordModel {
        data = typeof data === 'object' ? data : {};
        let result = new SetResultAsPassedForEducationalRecordModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ISetResultAsPassedForEducationalRecordModel extends ISetResultAsPassedModel {
}

export class AvailableActions implements IAvailableActions {
    canViewAllQualificationRecords!: boolean;
    canComment!: boolean;
    canManage!: boolean;

    constructor(data?: IAvailableActions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canViewAllQualificationRecords = _data["canViewAllQualificationRecords"] !== undefined ? _data["canViewAllQualificationRecords"] : <any>null;
            this.canComment = _data["canComment"] !== undefined ? _data["canComment"] : <any>null;
            this.canManage = _data["canManage"] !== undefined ? _data["canManage"] : <any>null;
        }
    }

    static fromJS(data: any): AvailableActions {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableActions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canViewAllQualificationRecords"] = this.canViewAllQualificationRecords !== undefined ? this.canViewAllQualificationRecords : <any>null;
        data["canComment"] = this.canComment !== undefined ? this.canComment : <any>null;
        data["canManage"] = this.canManage !== undefined ? this.canManage : <any>null;
        return data;
    }
}

export interface IAvailableActions {
    canViewAllQualificationRecords: boolean;
    canComment: boolean;
    canManage: boolean;
}

export class EducationalInstitutionModel implements IEducationalInstitutionModel {
    id!: string;
    name!: string;

    constructor(data?: IEducationalInstitutionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): EducationalInstitutionModel {
        data = typeof data === 'object' ? data : {};
        let result = new EducationalInstitutionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface IEducationalInstitutionModel {
    id: string;
    name: string;
}

export class QualificationViewModel implements IQualificationViewModel {
    id!: string;
    specialityType!: SpecialityType;
    issuedOn?: Date | null;
    validUntil?: Date | null;
    approval!: ApprovalStatus;
    additionalInformation!: string;
    speciality!: string;
    specialityTypeName!: string;
    validity!: ValidityStatus;
    educationalInstitutionId?: string | null;
    educationalInstitutionName!: string;
    isDeleted!: boolean;

    constructor(data?: IQualificationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.specialityType = _data["specialityType"] !== undefined ? _data["specialityType"] : <any>null;
            this.issuedOn = _data["issuedOn"] ? new Date(_data["issuedOn"].toString()) : <any>null;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : <any>null;
            this.approval = _data["approval"] !== undefined ? _data["approval"] : <any>null;
            this.additionalInformation = _data["additionalInformation"] !== undefined ? _data["additionalInformation"] : <any>null;
            this.speciality = _data["speciality"] !== undefined ? _data["speciality"] : <any>null;
            this.specialityTypeName = _data["specialityTypeName"] !== undefined ? _data["specialityTypeName"] : <any>null;
            this.validity = _data["validity"] !== undefined ? _data["validity"] : <any>null;
            this.educationalInstitutionId = _data["educationalInstitutionId"] !== undefined ? _data["educationalInstitutionId"] : <any>null;
            this.educationalInstitutionName = _data["educationalInstitutionName"] !== undefined ? _data["educationalInstitutionName"] : <any>null;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : <any>null;
        }
    }

    static fromJS(data: any): QualificationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["specialityType"] = this.specialityType !== undefined ? this.specialityType : <any>null;
        data["issuedOn"] = this.issuedOn ? this.issuedOn.toISOString() : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : <any>null;
        data["approval"] = this.approval !== undefined ? this.approval : <any>null;
        data["additionalInformation"] = this.additionalInformation !== undefined ? this.additionalInformation : <any>null;
        data["speciality"] = this.speciality !== undefined ? this.speciality : <any>null;
        data["specialityTypeName"] = this.specialityTypeName !== undefined ? this.specialityTypeName : <any>null;
        data["validity"] = this.validity !== undefined ? this.validity : <any>null;
        data["educationalInstitutionId"] = this.educationalInstitutionId !== undefined ? this.educationalInstitutionId : <any>null;
        data["educationalInstitutionName"] = this.educationalInstitutionName !== undefined ? this.educationalInstitutionName : <any>null;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : <any>null;
        return data;
    }
}

export interface IQualificationViewModel {
    id: string;
    specialityType: SpecialityType;
    issuedOn?: Date | null;
    validUntil?: Date | null;
    approval: ApprovalStatus;
    additionalInformation: string;
    speciality: string;
    specialityTypeName: string;
    validity: ValidityStatus;
    educationalInstitutionId?: string | null;
    educationalInstitutionName: string;
    isDeleted: boolean;
}

export class PagedResultOfOfficialQualificationLightViewModel implements IPagedResultOfOfficialQualificationLightViewModel {
    pageNumber!: number;
    pageSize!: number;
    pageResult!: OfficialQualificationLightViewModel[];
    totalCount!: number;

    constructor(data?: IPagedResultOfOfficialQualificationLightViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageResult = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"] !== undefined ? _data["pageNumber"] : <any>null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : <any>null;
            if (Array.isArray(_data["pageResult"])) {
                this.pageResult = [] as any;
                for (let item of _data["pageResult"])
                    this.pageResult!.push(OfficialQualificationLightViewModel.fromJS(item));
            }
            else {
                this.pageResult = <any>null;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): PagedResultOfOfficialQualificationLightViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfOfficialQualificationLightViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber !== undefined ? this.pageNumber : <any>null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
        if (Array.isArray(this.pageResult)) {
            data["pageResult"] = [];
            for (let item of this.pageResult)
                data["pageResult"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data;
    }
}

export interface IPagedResultOfOfficialQualificationLightViewModel {
    pageNumber: number;
    pageSize: number;
    pageResult: OfficialQualificationLightViewModel[];
    totalCount: number;
}

export class OfficialQualificationLightViewModel implements IOfficialQualificationLightViewModel {
    id!: string;
    name!: string;
    seafarerName!: string;
    seafarerId!: string;
    specialityType!: SpecialityType;
    specialityTypeName!: string;
    birthDate?: Date | null;
    issuedAt!: Date;
    validUntil?: Date | null;
    educationalInstitutionId?: string | null;
    educationalInstitutionName?: string | null;
    isDeleted!: boolean;
    approval!: ApprovalStatus;
    documentNumber!: string;
    additionalInformation!: string;
    validity!: ValidityStatus;

    constructor(data?: IOfficialQualificationLightViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.seafarerName = _data["seafarerName"] !== undefined ? _data["seafarerName"] : <any>null;
            this.seafarerId = _data["seafarerId"] !== undefined ? _data["seafarerId"] : <any>null;
            this.specialityType = _data["specialityType"] !== undefined ? _data["specialityType"] : <any>null;
            this.specialityTypeName = _data["specialityTypeName"] !== undefined ? _data["specialityTypeName"] : <any>null;
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>null;
            this.issuedAt = _data["issuedAt"] ? new Date(_data["issuedAt"].toString()) : <any>null;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : <any>null;
            this.educationalInstitutionId = _data["educationalInstitutionId"] !== undefined ? _data["educationalInstitutionId"] : <any>null;
            this.educationalInstitutionName = _data["educationalInstitutionName"] !== undefined ? _data["educationalInstitutionName"] : <any>null;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : <any>null;
            this.approval = _data["approval"] !== undefined ? _data["approval"] : <any>null;
            this.documentNumber = _data["documentNumber"] !== undefined ? _data["documentNumber"] : <any>null;
            this.additionalInformation = _data["additionalInformation"] !== undefined ? _data["additionalInformation"] : <any>null;
            this.validity = _data["validity"] !== undefined ? _data["validity"] : <any>null;
        }
    }

    static fromJS(data: any): OfficialQualificationLightViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OfficialQualificationLightViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["seafarerName"] = this.seafarerName !== undefined ? this.seafarerName : <any>null;
        data["seafarerId"] = this.seafarerId !== undefined ? this.seafarerId : <any>null;
        data["specialityType"] = this.specialityType !== undefined ? this.specialityType : <any>null;
        data["specialityTypeName"] = this.specialityTypeName !== undefined ? this.specialityTypeName : <any>null;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>null;
        data["issuedAt"] = this.issuedAt ? this.issuedAt.toISOString() : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : <any>null;
        data["educationalInstitutionId"] = this.educationalInstitutionId !== undefined ? this.educationalInstitutionId : <any>null;
        data["educationalInstitutionName"] = this.educationalInstitutionName !== undefined ? this.educationalInstitutionName : <any>null;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : <any>null;
        data["approval"] = this.approval !== undefined ? this.approval : <any>null;
        data["documentNumber"] = this.documentNumber !== undefined ? this.documentNumber : <any>null;
        data["additionalInformation"] = this.additionalInformation !== undefined ? this.additionalInformation : <any>null;
        data["validity"] = this.validity !== undefined ? this.validity : <any>null;
        return data;
    }
}

export interface IOfficialQualificationLightViewModel {
    id: string;
    name: string;
    seafarerName: string;
    seafarerId: string;
    specialityType: SpecialityType;
    specialityTypeName: string;
    birthDate?: Date | null;
    issuedAt: Date;
    validUntil?: Date | null;
    educationalInstitutionId?: string | null;
    educationalInstitutionName?: string | null;
    isDeleted: boolean;
    approval: ApprovalStatus;
    documentNumber: string;
    additionalInformation: string;
    validity: ValidityStatus;
}

export abstract class QualificationDetailsModel implements IQualificationDetailsModel {
    id!: string;
    seafarerId!: string;
    createdOn!: Date;
    specialityId!: string;
    certificateNumber!: string;
    recordNumber!: string;
    issuedOn?: Date | null;
    additionalInformation!: string;
    validUntil?: Date | null;
    specialityName!: string;
    recordResult?: QualificationRecordResultModel | null;
    creator?: NameAndOrganization | null;
    rejectionDetails?: RejectionDetailsModel | null;
    validity!: ValidityStatus;
    files!: FileModel[];
    educationalInstitutionId?: string | null;
    educationalInstitutionName?: string | null;
    approval?: ApprovalStatus | null;
    usedInApplications!: string[];
    version?: number | null;
    comment!: string;
    updatedAt?: Date | null;
    isDeleted!: boolean;
    recentProfileImageChange?: HistoryDetails | null;
    dublicateWarning!: boolean;
    changeInfo?: HistoryDetails | null;
    realCreator?: HistoryDetails | null;

    protected _discriminator: string;

    constructor(data?: IQualificationDetailsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.certificateNumber = "";
            this.recordNumber = "";
            this.additionalInformation = "";
            this.files = [];
            this.usedInApplications = [];
        }
        this._discriminator = "QualificationDetailsModel";
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.seafarerId = _data["seafarerId"] !== undefined ? _data["seafarerId"] : <any>null;
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>null;
            this.specialityId = _data["specialityId"] !== undefined ? _data["specialityId"] : <any>null;
            this.certificateNumber = _data["certificateNumber"] !== undefined ? _data["certificateNumber"] : "";
            this.recordNumber = _data["recordNumber"] !== undefined ? _data["recordNumber"] : "";
            this.issuedOn = _data["issuedOn"] ? new Date(_data["issuedOn"].toString()) : <any>null;
            this.additionalInformation = _data["additionalInformation"] !== undefined ? _data["additionalInformation"] : "";
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : <any>null;
            this.specialityName = _data["specialityName"] !== undefined ? _data["specialityName"] : <any>null;
            this.recordResult = _data["recordResult"] ? QualificationRecordResultModel.fromJS(_data["recordResult"]) : <any>null;
            this.creator = _data["creator"] ? NameAndOrganization.fromJS(_data["creator"]) : <any>null;
            this.rejectionDetails = _data["rejectionDetails"] ? RejectionDetailsModel.fromJS(_data["rejectionDetails"]) : <any>null;
            this.validity = _data["validity"] !== undefined ? _data["validity"] : <any>null;
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(FileModel.fromJS(item));
            }
            else {
                this.files = <any>null;
            }
            this.educationalInstitutionId = _data["educationalInstitutionId"] !== undefined ? _data["educationalInstitutionId"] : <any>null;
            this.educationalInstitutionName = _data["educationalInstitutionName"] !== undefined ? _data["educationalInstitutionName"] : <any>null;
            this.approval = _data["approval"] !== undefined ? _data["approval"] : <any>null;
            if (Array.isArray(_data["usedInApplications"])) {
                this.usedInApplications = [] as any;
                for (let item of _data["usedInApplications"])
                    this.usedInApplications!.push(item);
            }
            else {
                this.usedInApplications = <any>null;
            }
            this.version = _data["version"] !== undefined ? _data["version"] : <any>null;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>null;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : <any>null;
            this.recentProfileImageChange = _data["recentProfileImageChange"] ? HistoryDetails.fromJS(_data["recentProfileImageChange"]) : <any>null;
            this.dublicateWarning = _data["dublicateWarning"] !== undefined ? _data["dublicateWarning"] : <any>null;
            this.changeInfo = _data["changeInfo"] ? HistoryDetails.fromJS(_data["changeInfo"]) : <any>null;
            this.realCreator = _data["realCreator"] ? HistoryDetails.fromJS(_data["realCreator"]) : <any>null;
        }
    }

    static fromJS(data: any): QualificationDetailsModel {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "TrainingQualificationDetailsModel") {
            let result = new TrainingQualificationDetailsModel();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "EducationalQualificationDetailsModel") {
            let result = new EducationalQualificationDetailsModel();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'QualificationDetailsModel' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["seafarerId"] = this.seafarerId !== undefined ? this.seafarerId : <any>null;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>null;
        data["specialityId"] = this.specialityId !== undefined ? this.specialityId : <any>null;
        data["certificateNumber"] = this.certificateNumber !== undefined ? this.certificateNumber : <any>null;
        data["recordNumber"] = this.recordNumber !== undefined ? this.recordNumber : <any>null;
        data["issuedOn"] = this.issuedOn ? this.issuedOn.toISOString() : <any>null;
        data["additionalInformation"] = this.additionalInformation !== undefined ? this.additionalInformation : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : <any>null;
        data["specialityName"] = this.specialityName !== undefined ? this.specialityName : <any>null;
        data["recordResult"] = this.recordResult ? this.recordResult.toJSON() : <any>null;
        data["creator"] = this.creator ? this.creator.toJSON() : <any>null;
        data["rejectionDetails"] = this.rejectionDetails ? this.rejectionDetails.toJSON() : <any>null;
        data["validity"] = this.validity !== undefined ? this.validity : <any>null;
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        data["educationalInstitutionId"] = this.educationalInstitutionId !== undefined ? this.educationalInstitutionId : <any>null;
        data["educationalInstitutionName"] = this.educationalInstitutionName !== undefined ? this.educationalInstitutionName : <any>null;
        data["approval"] = this.approval !== undefined ? this.approval : <any>null;
        if (Array.isArray(this.usedInApplications)) {
            data["usedInApplications"] = [];
            for (let item of this.usedInApplications)
                data["usedInApplications"].push(item);
        }
        data["version"] = this.version !== undefined ? this.version : <any>null;
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>null;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : <any>null;
        data["recentProfileImageChange"] = this.recentProfileImageChange ? this.recentProfileImageChange.toJSON() : <any>null;
        data["dublicateWarning"] = this.dublicateWarning !== undefined ? this.dublicateWarning : <any>null;
        data["changeInfo"] = this.changeInfo ? this.changeInfo.toJSON() : <any>null;
        data["realCreator"] = this.realCreator ? this.realCreator.toJSON() : <any>null;
        return data;
    }
}

export interface IQualificationDetailsModel {
    id: string;
    seafarerId: string;
    createdOn: Date;
    specialityId: string;
    certificateNumber: string;
    recordNumber: string;
    issuedOn?: Date | null;
    additionalInformation: string;
    validUntil?: Date | null;
    specialityName: string;
    recordResult?: QualificationRecordResultModel | null;
    creator?: NameAndOrganization | null;
    rejectionDetails?: RejectionDetailsModel | null;
    validity: ValidityStatus;
    files: FileModel[];
    educationalInstitutionId?: string | null;
    educationalInstitutionName?: string | null;
    approval?: ApprovalStatus | null;
    usedInApplications: string[];
    version?: number | null;
    comment: string;
    updatedAt?: Date | null;
    isDeleted: boolean;
    recentProfileImageChange?: HistoryDetails | null;
    dublicateWarning: boolean;
    changeInfo?: HistoryDetails | null;
    realCreator?: HistoryDetails | null;
}

export class TrainingQualificationDetailsModel extends QualificationDetailsModel implements ITrainingQualificationDetailsModel {
    commissionMembers?: string | null;
    fulfillmentDate?: Date | null;
    trainingType!: TrainingType;

    constructor(data?: ITrainingQualificationDetailsModel) {
        super(data);
        if (!data) {
            this.trainingType = TrainingType.Undefined;
        }
        this._discriminator = "TrainingQualificationDetailsModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.commissionMembers = _data["commissionMembers"] !== undefined ? _data["commissionMembers"] : <any>null;
            this.fulfillmentDate = _data["fulfillmentDate"] ? new Date(_data["fulfillmentDate"].toString()) : <any>null;
            this.trainingType = _data["trainingType"] !== undefined ? _data["trainingType"] : TrainingType.Undefined;
        }
    }

    static fromJS(data: any): TrainingQualificationDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingQualificationDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commissionMembers"] = this.commissionMembers !== undefined ? this.commissionMembers : <any>null;
        data["fulfillmentDate"] = this.fulfillmentDate ? this.fulfillmentDate.toISOString() : <any>null;
        data["trainingType"] = this.trainingType !== undefined ? this.trainingType : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITrainingQualificationDetailsModel extends IQualificationDetailsModel {
    commissionMembers?: string | null;
    fulfillmentDate?: Date | null;
    trainingType: TrainingType;
}

export class EducationalQualificationDetailsModel extends QualificationDetailsModel implements IEducationalQualificationDetailsModel {
    educationName!: string;

    constructor(data?: IEducationalQualificationDetailsModel) {
        super(data);
        this._discriminator = "EducationalQualificationDetailsModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.educationName = _data["educationName"] !== undefined ? _data["educationName"] : <any>null;
        }
    }

    static fromJS(data: any): EducationalQualificationDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new EducationalQualificationDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["educationName"] = this.educationName !== undefined ? this.educationName : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IEducationalQualificationDetailsModel extends IQualificationDetailsModel {
    educationName: string;
}

export abstract class QualificationModel implements IQualificationModel {
    seafarerId?: string | null;
    specialityId?: string | null;
    certificateNumber!: string;
    recordNumber!: string;
    issuedOn?: Date | null;
    additionalInformation!: string;
    createdOn?: Date | null;
    educationalInstitutionId?: string | null;
    educationalInstitutionName?: string | null;
    approval?: ApprovalStatus | null;
    addedFiles!: TempFileModel[];
    removedFiles!: FileModel[];
    existingFiles!: FileModel[];
    version?: number | null;
    comment?: string | null;
    updatedAt?: Date | null;
    validUntil?: Date | null;

    protected _discriminator: string;

    constructor(data?: IQualificationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.certificateNumber = "";
            this.recordNumber = "";
            this.additionalInformation = "";
            this.addedFiles = [];
            this.removedFiles = [];
            this.existingFiles = [];
        }
        this._discriminator = "QualificationModel";
    }

    init(_data?: any) {
        if (_data) {
            this.seafarerId = _data["seafarerId"] !== undefined ? _data["seafarerId"] : <any>null;
            this.specialityId = _data["specialityId"] !== undefined ? _data["specialityId"] : <any>null;
            this.certificateNumber = _data["certificateNumber"] !== undefined ? _data["certificateNumber"] : "";
            this.recordNumber = _data["recordNumber"] !== undefined ? _data["recordNumber"] : "";
            this.issuedOn = _data["issuedOn"] ? new Date(_data["issuedOn"].toString()) : <any>null;
            this.additionalInformation = _data["additionalInformation"] !== undefined ? _data["additionalInformation"] : "";
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>null;
            this.educationalInstitutionId = _data["educationalInstitutionId"] !== undefined ? _data["educationalInstitutionId"] : <any>null;
            this.educationalInstitutionName = _data["educationalInstitutionName"] !== undefined ? _data["educationalInstitutionName"] : <any>null;
            this.approval = _data["approval"] !== undefined ? _data["approval"] : <any>null;
            if (Array.isArray(_data["addedFiles"])) {
                this.addedFiles = [] as any;
                for (let item of _data["addedFiles"])
                    this.addedFiles!.push(TempFileModel.fromJS(item));
            }
            else {
                this.addedFiles = <any>null;
            }
            if (Array.isArray(_data["removedFiles"])) {
                this.removedFiles = [] as any;
                for (let item of _data["removedFiles"])
                    this.removedFiles!.push(FileModel.fromJS(item));
            }
            else {
                this.removedFiles = <any>null;
            }
            if (Array.isArray(_data["existingFiles"])) {
                this.existingFiles = [] as any;
                for (let item of _data["existingFiles"])
                    this.existingFiles!.push(FileModel.fromJS(item));
            }
            else {
                this.existingFiles = <any>null;
            }
            this.version = _data["version"] !== undefined ? _data["version"] : <any>null;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>null;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): QualificationModel {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "TrainingQualificationModel") {
            let result = new TrainingQualificationModel();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "EducationalQualificationModel") {
            let result = new EducationalQualificationModel();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'QualificationModel' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        data["seafarerId"] = this.seafarerId !== undefined ? this.seafarerId : <any>null;
        data["specialityId"] = this.specialityId !== undefined ? this.specialityId : <any>null;
        data["certificateNumber"] = this.certificateNumber !== undefined ? this.certificateNumber : <any>null;
        data["recordNumber"] = this.recordNumber !== undefined ? this.recordNumber : <any>null;
        data["issuedOn"] = this.issuedOn ? this.issuedOn.toISOString() : <any>null;
        data["additionalInformation"] = this.additionalInformation !== undefined ? this.additionalInformation : <any>null;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>null;
        data["educationalInstitutionId"] = this.educationalInstitutionId !== undefined ? this.educationalInstitutionId : <any>null;
        data["educationalInstitutionName"] = this.educationalInstitutionName !== undefined ? this.educationalInstitutionName : <any>null;
        data["approval"] = this.approval !== undefined ? this.approval : <any>null;
        if (Array.isArray(this.addedFiles)) {
            data["addedFiles"] = [];
            for (let item of this.addedFiles)
                data["addedFiles"].push(item.toJSON());
        }
        if (Array.isArray(this.removedFiles)) {
            data["removedFiles"] = [];
            for (let item of this.removedFiles)
                data["removedFiles"].push(item.toJSON());
        }
        if (Array.isArray(this.existingFiles)) {
            data["existingFiles"] = [];
            for (let item of this.existingFiles)
                data["existingFiles"].push(item.toJSON());
        }
        data["version"] = this.version !== undefined ? this.version : <any>null;
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : <any>null;
        return data;
    }
}

export interface IQualificationModel {
    seafarerId?: string | null;
    specialityId?: string | null;
    certificateNumber: string;
    recordNumber: string;
    issuedOn?: Date | null;
    additionalInformation: string;
    createdOn?: Date | null;
    educationalInstitutionId?: string | null;
    educationalInstitutionName?: string | null;
    approval?: ApprovalStatus | null;
    addedFiles: TempFileModel[];
    removedFiles: FileModel[];
    existingFiles: FileModel[];
    version?: number | null;
    comment?: string | null;
    updatedAt?: Date | null;
    validUntil?: Date | null;
}

export class TrainingQualificationModel extends QualificationModel implements ITrainingQualificationModel {
    fulfillmentDate?: Date | null;
    trainingType!: TrainingType;
    commissionMembers?: string | null;

    constructor(data?: ITrainingQualificationModel) {
        super(data);
        if (!data) {
            this.trainingType = TrainingType.Undefined;
        }
        this._discriminator = "TrainingQualificationModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fulfillmentDate = _data["fulfillmentDate"] ? new Date(_data["fulfillmentDate"].toString()) : <any>null;
            this.trainingType = _data["trainingType"] !== undefined ? _data["trainingType"] : TrainingType.Undefined;
            this.commissionMembers = _data["commissionMembers"] !== undefined ? _data["commissionMembers"] : <any>null;
        }
    }

    static fromJS(data: any): TrainingQualificationModel {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingQualificationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fulfillmentDate"] = this.fulfillmentDate ? this.fulfillmentDate.toISOString() : <any>null;
        data["trainingType"] = this.trainingType !== undefined ? this.trainingType : <any>null;
        data["commissionMembers"] = this.commissionMembers !== undefined ? this.commissionMembers : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ITrainingQualificationModel extends IQualificationModel {
    fulfillmentDate?: Date | null;
    trainingType: TrainingType;
    commissionMembers?: string | null;
}

export class EducationalQualificationModel extends QualificationModel implements IEducationalQualificationModel {

    constructor(data?: IEducationalQualificationModel) {
        super(data);
        this._discriminator = "EducationalQualificationModel";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): EducationalQualificationModel {
        data = typeof data === 'object' ? data : {};
        let result = new EducationalQualificationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IEducationalQualificationModel extends IQualificationModel {
}

export abstract class QualificationOptions implements IQualificationOptions {
    specialities!: Speciality[];
    educationalInstitutions!: EducationalInstitution[];

    constructor(data?: IQualificationOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.specialities = [];
            this.educationalInstitutions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["specialities"])) {
                this.specialities = [] as any;
                for (let item of _data["specialities"])
                    this.specialities!.push(Speciality.fromJS(item));
            }
            else {
                this.specialities = <any>null;
            }
            if (Array.isArray(_data["educationalInstitutions"])) {
                this.educationalInstitutions = [] as any;
                for (let item of _data["educationalInstitutions"])
                    this.educationalInstitutions!.push(EducationalInstitution.fromJS(item));
            }
            else {
                this.educationalInstitutions = <any>null;
            }
        }
    }

    static fromJS(data: any): QualificationOptions {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'QualificationOptions' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.specialities)) {
            data["specialities"] = [];
            for (let item of this.specialities)
                data["specialities"].push(item.toJSON());
        }
        if (Array.isArray(this.educationalInstitutions)) {
            data["educationalInstitutions"] = [];
            for (let item of this.educationalInstitutions)
                data["educationalInstitutions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQualificationOptions {
    specialities: Speciality[];
    educationalInstitutions: EducationalInstitution[];
}

export class TrainingQualificationOptions extends QualificationOptions implements ITrainingQualificationOptions {

    constructor(data?: ITrainingQualificationOptions) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): TrainingQualificationOptions {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingQualificationOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ITrainingQualificationOptions extends IQualificationOptions {
}

export class Speciality implements ISpeciality {
    id!: string;
    name!: string;
    education!: string;

    constructor(data?: ISpeciality) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.education = _data["education"] !== undefined ? _data["education"] : <any>null;
        }
    }

    static fromJS(data: any): Speciality {
        data = typeof data === 'object' ? data : {};
        let result = new Speciality();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["education"] = this.education !== undefined ? this.education : <any>null;
        return data;
    }
}

export interface ISpeciality {
    id: string;
    name: string;
    education: string;
}

export class EducationalInstitution implements IEducationalInstitution {
    id!: string;
    name!: string;
    educators!: Educator[];
    active!: boolean;
    specialities!: SpecialityId[];

    constructor(data?: IEducationalInstitution) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.educators = [];
            this.specialities = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            if (Array.isArray(_data["educators"])) {
                this.educators = [] as any;
                for (let item of _data["educators"])
                    this.educators!.push(Educator.fromJS(item));
            }
            else {
                this.educators = <any>null;
            }
            this.active = _data["active"] !== undefined ? _data["active"] : <any>null;
            if (Array.isArray(_data["specialities"])) {
                this.specialities = [] as any;
                for (let item of _data["specialities"])
                    this.specialities!.push(SpecialityId.fromJS(item));
            }
            else {
                this.specialities = <any>null;
            }
        }
    }

    static fromJS(data: any): EducationalInstitution {
        data = typeof data === 'object' ? data : {};
        let result = new EducationalInstitution();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        if (Array.isArray(this.educators)) {
            data["educators"] = [];
            for (let item of this.educators)
                data["educators"].push(item.toJSON());
        }
        data["active"] = this.active !== undefined ? this.active : <any>null;
        if (Array.isArray(this.specialities)) {
            data["specialities"] = [];
            for (let item of this.specialities)
                data["specialities"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEducationalInstitution {
    id: string;
    name: string;
    educators: Educator[];
    active: boolean;
    specialities: SpecialityId[];
}

export class Educator implements IEducator {
    id!: string;
    fullName?: string | null;

    constructor(data?: IEducator) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : <any>null;
        }
    }

    static fromJS(data: any): Educator {
        data = typeof data === 'object' ? data : {};
        let result = new Educator();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["fullName"] = this.fullName !== undefined ? this.fullName : <any>null;
        return data;
    }
}

export interface IEducator {
    id: string;
    fullName?: string | null;
}

export class EducationalQualificationOptions extends QualificationOptions implements IEducationalQualificationOptions {

    constructor(data?: IEducationalQualificationOptions) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): EducationalQualificationOptions {
        data = typeof data === 'object' ? data : {};
        let result = new EducationalQualificationOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IEducationalQualificationOptions extends IQualificationOptions {
}

export class QualificationActions implements IQualificationActions {
    canApprove!: boolean;
    canDisapprove!: boolean;
    canSuspend!: boolean;
    canUpdateFromEHIS!: boolean;
    canAdd!: boolean;
    canAddQualificationsToSelf!: boolean;
    canComment!: boolean;
    canAddForAllInstitutions!: boolean;
    canModify!: boolean;
    canViewSeafarerApplications!: boolean;
    canOmitFile!: boolean;
    isOfficial!: boolean;

    constructor(data?: IQualificationActions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canApprove = _data["canApprove"] !== undefined ? _data["canApprove"] : <any>null;
            this.canDisapprove = _data["canDisapprove"] !== undefined ? _data["canDisapprove"] : <any>null;
            this.canSuspend = _data["canSuspend"] !== undefined ? _data["canSuspend"] : <any>null;
            this.canUpdateFromEHIS = _data["canUpdateFromEHIS"] !== undefined ? _data["canUpdateFromEHIS"] : <any>null;
            this.canAdd = _data["canAdd"] !== undefined ? _data["canAdd"] : <any>null;
            this.canAddQualificationsToSelf = _data["canAddQualificationsToSelf"] !== undefined ? _data["canAddQualificationsToSelf"] : <any>null;
            this.canComment = _data["canComment"] !== undefined ? _data["canComment"] : <any>null;
            this.canAddForAllInstitutions = _data["canAddForAllInstitutions"] !== undefined ? _data["canAddForAllInstitutions"] : <any>null;
            this.canModify = _data["canModify"] !== undefined ? _data["canModify"] : <any>null;
            this.canViewSeafarerApplications = _data["canViewSeafarerApplications"] !== undefined ? _data["canViewSeafarerApplications"] : <any>null;
            this.canOmitFile = _data["canOmitFile"] !== undefined ? _data["canOmitFile"] : <any>null;
            this.isOfficial = _data["isOfficial"] !== undefined ? _data["isOfficial"] : <any>null;
        }
    }

    static fromJS(data: any): QualificationActions {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationActions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canApprove"] = this.canApprove !== undefined ? this.canApprove : <any>null;
        data["canDisapprove"] = this.canDisapprove !== undefined ? this.canDisapprove : <any>null;
        data["canSuspend"] = this.canSuspend !== undefined ? this.canSuspend : <any>null;
        data["canUpdateFromEHIS"] = this.canUpdateFromEHIS !== undefined ? this.canUpdateFromEHIS : <any>null;
        data["canAdd"] = this.canAdd !== undefined ? this.canAdd : <any>null;
        data["canAddQualificationsToSelf"] = this.canAddQualificationsToSelf !== undefined ? this.canAddQualificationsToSelf : <any>null;
        data["canComment"] = this.canComment !== undefined ? this.canComment : <any>null;
        data["canAddForAllInstitutions"] = this.canAddForAllInstitutions !== undefined ? this.canAddForAllInstitutions : <any>null;
        data["canModify"] = this.canModify !== undefined ? this.canModify : <any>null;
        data["canViewSeafarerApplications"] = this.canViewSeafarerApplications !== undefined ? this.canViewSeafarerApplications : <any>null;
        data["canOmitFile"] = this.canOmitFile !== undefined ? this.canOmitFile : <any>null;
        data["isOfficial"] = this.isOfficial !== undefined ? this.isOfficial : <any>null;
        return data;
    }
}

export interface IQualificationActions {
    canApprove: boolean;
    canDisapprove: boolean;
    canSuspend: boolean;
    canUpdateFromEHIS: boolean;
    canAdd: boolean;
    canAddQualificationsToSelf: boolean;
    canComment: boolean;
    canAddForAllInstitutions: boolean;
    canModify: boolean;
    canViewSeafarerApplications: boolean;
    canOmitFile: boolean;
    isOfficial: boolean;
}

export class QualificationUpdateResult implements IQualificationUpdateResult {
    updated!: number;
    added!: number;

    constructor(data?: IQualificationUpdateResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.updated = _data["updated"] !== undefined ? _data["updated"] : <any>null;
            this.added = _data["added"] !== undefined ? _data["added"] : <any>null;
        }
    }

    static fromJS(data: any): QualificationUpdateResult {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationUpdateResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updated"] = this.updated !== undefined ? this.updated : <any>null;
        data["added"] = this.added !== undefined ? this.added : <any>null;
        return data;
    }
}

export interface IQualificationUpdateResult {
    updated: number;
    added: number;
}

export class RestrictionOption implements IRestrictionOption {
    value!: string;
    name!: LocalizedString;

    constructor(data?: IRestrictionOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.name = new LocalizedString();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.name = _data["name"] ? LocalizedString.fromJS(_data["name"]) : new LocalizedString();
        }
    }

    static fromJS(data: any): RestrictionOption {
        data = typeof data === 'object' ? data : {};
        let result = new RestrictionOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["name"] = this.name ? this.name.toJSON() : <any>null;
        return data;
    }
}

export interface IRestrictionOption {
    value: string;
    name: LocalizedString;
}

export class CertificatesResponse implements ICertificatesResponse {
    certificates!: Certificate[];

    constructor(data?: ICertificatesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.certificates = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["certificates"])) {
                this.certificates = [] as any;
                for (let item of _data["certificates"])
                    this.certificates!.push(Certificate.fromJS(item));
            }
            else {
                this.certificates = <any>null;
            }
        }
    }

    static fromJS(data: any): CertificatesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CertificatesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.certificates)) {
            data["certificates"] = [];
            for (let item of this.certificates)
                data["certificates"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICertificatesResponse {
    certificates: Certificate[];
}

export class Certificate implements ICertificate {
    id!: string;
    name!: string;
    documentType!: string;
    issuedAt!: Date;
    validUntil?: Date | null;
    status!: CertificateStatus;
    documentNumber!: string;

    constructor(data?: ICertificate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.documentType = _data["documentType"] !== undefined ? _data["documentType"] : <any>null;
            this.issuedAt = _data["issuedAt"] ? new Date(_data["issuedAt"].toString()) : <any>null;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.documentNumber = _data["documentNumber"] !== undefined ? _data["documentNumber"] : <any>null;
        }
    }

    static fromJS(data: any): Certificate {
        data = typeof data === 'object' ? data : {};
        let result = new Certificate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["documentType"] = this.documentType !== undefined ? this.documentType : <any>null;
        data["issuedAt"] = this.issuedAt ? this.issuedAt.toISOString() : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["documentNumber"] = this.documentNumber !== undefined ? this.documentNumber : <any>null;
        return data;
    }
}

export interface ICertificate {
    id: string;
    name: string;
    documentType: string;
    issuedAt: Date;
    validUntil?: Date | null;
    status: CertificateStatus;
    documentNumber: string;
}

export class PagedResultOfOfficialCertificateLightViewModel implements IPagedResultOfOfficialCertificateLightViewModel {
    pageNumber!: number;
    pageSize!: number;
    pageResult!: OfficialCertificateLightViewModel[];
    totalCount!: number;

    constructor(data?: IPagedResultOfOfficialCertificateLightViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageResult = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"] !== undefined ? _data["pageNumber"] : <any>null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : <any>null;
            if (Array.isArray(_data["pageResult"])) {
                this.pageResult = [] as any;
                for (let item of _data["pageResult"])
                    this.pageResult!.push(OfficialCertificateLightViewModel.fromJS(item));
            }
            else {
                this.pageResult = <any>null;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): PagedResultOfOfficialCertificateLightViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfOfficialCertificateLightViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber !== undefined ? this.pageNumber : <any>null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
        if (Array.isArray(this.pageResult)) {
            data["pageResult"] = [];
            for (let item of this.pageResult)
                data["pageResult"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data;
    }
}

export interface IPagedResultOfOfficialCertificateLightViewModel {
    pageNumber: number;
    pageSize: number;
    pageResult: OfficialCertificateLightViewModel[];
    totalCount: number;
}

export class OfficialCertificateLightViewModel implements IOfficialCertificateLightViewModel {
    id!: string;
    name!: string;
    seafarerName!: string;
    seafarerId!: string;
    documentType!: string;
    birthDate!: Date;
    issuedAt!: Date;
    validUntil?: Date | null;
    status!: CertificateStatus;
    documentNumber!: string;

    constructor(data?: IOfficialCertificateLightViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.seafarerName = _data["seafarerName"] !== undefined ? _data["seafarerName"] : <any>null;
            this.seafarerId = _data["seafarerId"] !== undefined ? _data["seafarerId"] : <any>null;
            this.documentType = _data["documentType"] !== undefined ? _data["documentType"] : <any>null;
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>null;
            this.issuedAt = _data["issuedAt"] ? new Date(_data["issuedAt"].toString()) : <any>null;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.documentNumber = _data["documentNumber"] !== undefined ? _data["documentNumber"] : <any>null;
        }
    }

    static fromJS(data: any): OfficialCertificateLightViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OfficialCertificateLightViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["seafarerName"] = this.seafarerName !== undefined ? this.seafarerName : <any>null;
        data["seafarerId"] = this.seafarerId !== undefined ? this.seafarerId : <any>null;
        data["documentType"] = this.documentType !== undefined ? this.documentType : <any>null;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>null;
        data["issuedAt"] = this.issuedAt ? this.issuedAt.toISOString() : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["documentNumber"] = this.documentNumber !== undefined ? this.documentNumber : <any>null;
        return data;
    }
}

export interface IOfficialCertificateLightViewModel {
    id: string;
    name: string;
    seafarerName: string;
    seafarerId: string;
    documentType: string;
    birthDate: Date;
    issuedAt: Date;
    validUntil?: Date | null;
    status: CertificateStatus;
    documentNumber: string;
}

export class CertificatesActions implements ICertificatesActions {
    canViewAdditionalInfo!: boolean;
    canSetAdditionalInfo!: boolean;
    canInvalidate!: boolean;
    canPrintOut!: boolean;
    canViewDigitalRepresentation!: boolean;
    isOfficial!: boolean;

    constructor(data?: ICertificatesActions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canViewAdditionalInfo = _data["canViewAdditionalInfo"] !== undefined ? _data["canViewAdditionalInfo"] : <any>null;
            this.canSetAdditionalInfo = _data["canSetAdditionalInfo"] !== undefined ? _data["canSetAdditionalInfo"] : <any>null;
            this.canInvalidate = _data["canInvalidate"] !== undefined ? _data["canInvalidate"] : <any>null;
            this.canPrintOut = _data["canPrintOut"] !== undefined ? _data["canPrintOut"] : <any>null;
            this.canViewDigitalRepresentation = _data["canViewDigitalRepresentation"] !== undefined ? _data["canViewDigitalRepresentation"] : <any>null;
            this.isOfficial = _data["isOfficial"] !== undefined ? _data["isOfficial"] : <any>null;
        }
    }

    static fromJS(data: any): CertificatesActions {
        data = typeof data === 'object' ? data : {};
        let result = new CertificatesActions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canViewAdditionalInfo"] = this.canViewAdditionalInfo !== undefined ? this.canViewAdditionalInfo : <any>null;
        data["canSetAdditionalInfo"] = this.canSetAdditionalInfo !== undefined ? this.canSetAdditionalInfo : <any>null;
        data["canInvalidate"] = this.canInvalidate !== undefined ? this.canInvalidate : <any>null;
        data["canPrintOut"] = this.canPrintOut !== undefined ? this.canPrintOut : <any>null;
        data["canViewDigitalRepresentation"] = this.canViewDigitalRepresentation !== undefined ? this.canViewDigitalRepresentation : <any>null;
        data["isOfficial"] = this.isOfficial !== undefined ? this.isOfficial : <any>null;
        return data;
    }
}

export interface ICertificatesActions {
    canViewAdditionalInfo: boolean;
    canSetAdditionalInfo: boolean;
    canInvalidate: boolean;
    canPrintOut: boolean;
    canViewDigitalRepresentation: boolean;
    isOfficial: boolean;
}

export class StcwIsListModel implements IStcwIsListModel {
    value!: string;
    name!: string;

    constructor(data?: IStcwIsListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): StcwIsListModel {
        data = typeof data === 'object' ? data : {};
        let result = new StcwIsListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface IStcwIsListModel {
    value: string;
    name: string;
}

export class AreaOptionsResponse implements IAreaOptionsResponse {
    areas!: AreaOption[];

    constructor(data?: IAreaOptionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.areas = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["areas"])) {
                this.areas = [] as any;
                for (let item of _data["areas"])
                    this.areas!.push(AreaOption.fromJS(item));
            }
            else {
                this.areas = <any>null;
            }
        }
    }

    static fromJS(data: any): AreaOptionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AreaOptionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.areas)) {
            data["areas"] = [];
            for (let item of this.areas)
                data["areas"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAreaOptionsResponse {
    areas: AreaOption[];
}

export class AreaOption implements IAreaOption {
    value!: string;
    text!: string;

    constructor(data?: IAreaOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.text = _data["text"] !== undefined ? _data["text"] : <any>null;
        }
    }

    static fromJS(data: any): AreaOption {
        data = typeof data === 'object' ? data : {};
        let result = new AreaOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["text"] = this.text !== undefined ? this.text : <any>null;
        return data;
    }
}

export interface IAreaOption {
    value: string;
    text: string;
}

export class AreaTypeModel implements IAreaTypeModel {
    key!: string;
    name!: string;

    constructor(data?: IAreaTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): AreaTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new AreaTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface IAreaTypeModel {
    key: string;
    name: string;
}

export class ApplicableCertificate implements IApplicableCertificate {
    templateId!: string;
    name!: string;
    legalName!: string;
    certificateKindId!: string;

    constructor(data?: IApplicableCertificate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateId = _data["templateId"] !== undefined ? _data["templateId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.legalName = _data["legalName"] !== undefined ? _data["legalName"] : <any>null;
            this.certificateKindId = _data["certificateKindId"] !== undefined ? _data["certificateKindId"] : <any>null;
        }
    }

    static fromJS(data: any): ApplicableCertificate {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicableCertificate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateId"] = this.templateId !== undefined ? this.templateId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["legalName"] = this.legalName !== undefined ? this.legalName : <any>null;
        data["certificateKindId"] = this.certificateKindId !== undefined ? this.certificateKindId : <any>null;
        return data;
    }
}

export interface IApplicableCertificate {
    templateId: string;
    name: string;
    legalName: string;
    certificateKindId: string;
}

export class StartApplyingOrChangeTypeResponse implements IStartApplyingOrChangeTypeResponse {
    applicationId!: string;

    constructor(data?: IStartApplyingOrChangeTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"] !== undefined ? _data["applicationId"] : <any>null;
        }
    }

    static fromJS(data: any): StartApplyingOrChangeTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StartApplyingOrChangeTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId !== undefined ? this.applicationId : <any>null;
        return data;
    }
}

export interface IStartApplyingOrChangeTypeResponse {
    applicationId: string;
}

export class StartApplyingForCertificateRequest implements IStartApplyingForCertificateRequest {
    templateId!: string;

    constructor(data?: IStartApplyingForCertificateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateId = _data["templateId"] !== undefined ? _data["templateId"] : <any>null;
        }
    }

    static fromJS(data: any): StartApplyingForCertificateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StartApplyingForCertificateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateId"] = this.templateId !== undefined ? this.templateId : <any>null;
        return data;
    }
}

export interface IStartApplyingForCertificateRequest {
    templateId: string;
}

export class ChangeTypeToCertificateRequest implements IChangeTypeToCertificateRequest {
    templateId!: string;
    appId!: string;

    constructor(data?: IChangeTypeToCertificateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateId = _data["templateId"] !== undefined ? _data["templateId"] : <any>null;
            this.appId = _data["appId"] !== undefined ? _data["appId"] : <any>null;
        }
    }

    static fromJS(data: any): ChangeTypeToCertificateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeTypeToCertificateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateId"] = this.templateId !== undefined ? this.templateId : <any>null;
        data["appId"] = this.appId !== undefined ? this.appId : <any>null;
        return data;
    }
}

export interface IChangeTypeToCertificateRequest {
    templateId: string;
    appId: string;
}

export class PossibleToApplyForEndorsement implements IPossibleToApplyForEndorsement {
    name!: string;
    legalName!: string;
    documentTypeCode!: string;
    certificateId!: string;
    templateId!: string;
    replaceableDocumentNumber?: string | null;

    constructor(data?: IPossibleToApplyForEndorsement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.legalName = _data["legalName"] !== undefined ? _data["legalName"] : <any>null;
            this.documentTypeCode = _data["documentTypeCode"] !== undefined ? _data["documentTypeCode"] : <any>null;
            this.certificateId = _data["certificateId"] !== undefined ? _data["certificateId"] : <any>null;
            this.templateId = _data["templateId"] !== undefined ? _data["templateId"] : <any>null;
            this.replaceableDocumentNumber = _data["replaceableDocumentNumber"] !== undefined ? _data["replaceableDocumentNumber"] : <any>null;
        }
    }

    static fromJS(data: any): PossibleToApplyForEndorsement {
        data = typeof data === 'object' ? data : {};
        let result = new PossibleToApplyForEndorsement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["legalName"] = this.legalName !== undefined ? this.legalName : <any>null;
        data["documentTypeCode"] = this.documentTypeCode !== undefined ? this.documentTypeCode : <any>null;
        data["certificateId"] = this.certificateId !== undefined ? this.certificateId : <any>null;
        data["templateId"] = this.templateId !== undefined ? this.templateId : <any>null;
        data["replaceableDocumentNumber"] = this.replaceableDocumentNumber !== undefined ? this.replaceableDocumentNumber : <any>null;
        return data;
    }
}

export interface IPossibleToApplyForEndorsement {
    name: string;
    legalName: string;
    documentTypeCode: string;
    certificateId: string;
    templateId: string;
    replaceableDocumentNumber?: string | null;
}

export class PossibleToApplyForConcessionPermit implements IPossibleToApplyForConcessionPermit {
    name!: string;
    legalName!: string;
    documentTypeCode!: string;
    endorsementId!: string;
    endorsementNumber!: string;
    templateId!: string;
    existingConcessionPermitNumber?: string | null;

    constructor(data?: IPossibleToApplyForConcessionPermit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.legalName = _data["legalName"] !== undefined ? _data["legalName"] : <any>null;
            this.documentTypeCode = _data["documentTypeCode"] !== undefined ? _data["documentTypeCode"] : <any>null;
            this.endorsementId = _data["endorsementId"] !== undefined ? _data["endorsementId"] : <any>null;
            this.endorsementNumber = _data["endorsementNumber"] !== undefined ? _data["endorsementNumber"] : <any>null;
            this.templateId = _data["templateId"] !== undefined ? _data["templateId"] : <any>null;
            this.existingConcessionPermitNumber = _data["existingConcessionPermitNumber"] !== undefined ? _data["existingConcessionPermitNumber"] : <any>null;
        }
    }

    static fromJS(data: any): PossibleToApplyForConcessionPermit {
        data = typeof data === 'object' ? data : {};
        let result = new PossibleToApplyForConcessionPermit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["legalName"] = this.legalName !== undefined ? this.legalName : <any>null;
        data["documentTypeCode"] = this.documentTypeCode !== undefined ? this.documentTypeCode : <any>null;
        data["endorsementId"] = this.endorsementId !== undefined ? this.endorsementId : <any>null;
        data["endorsementNumber"] = this.endorsementNumber !== undefined ? this.endorsementNumber : <any>null;
        data["templateId"] = this.templateId !== undefined ? this.templateId : <any>null;
        data["existingConcessionPermitNumber"] = this.existingConcessionPermitNumber !== undefined ? this.existingConcessionPermitNumber : <any>null;
        return data;
    }
}

export interface IPossibleToApplyForConcessionPermit {
    name: string;
    legalName: string;
    documentTypeCode: string;
    endorsementId: string;
    endorsementNumber: string;
    templateId: string;
    existingConcessionPermitNumber?: string | null;
}

export class StartApplyingForEndorsementRequest implements IStartApplyingForEndorsementRequest {
    templateId!: string;
    certificateId!: string;

    constructor(data?: IStartApplyingForEndorsementRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateId = _data["templateId"] !== undefined ? _data["templateId"] : <any>null;
            this.certificateId = _data["certificateId"] !== undefined ? _data["certificateId"] : <any>null;
        }
    }

    static fromJS(data: any): StartApplyingForEndorsementRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StartApplyingForEndorsementRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateId"] = this.templateId !== undefined ? this.templateId : <any>null;
        data["certificateId"] = this.certificateId !== undefined ? this.certificateId : <any>null;
        return data;
    }
}

export interface IStartApplyingForEndorsementRequest {
    templateId: string;
    certificateId: string;
}

export class StartApplyingForConcessionPermitRequest implements IStartApplyingForConcessionPermitRequest {
    templateId!: string;
    endorsementId!: string;

    constructor(data?: IStartApplyingForConcessionPermitRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateId = _data["templateId"] !== undefined ? _data["templateId"] : <any>null;
            this.endorsementId = _data["endorsementId"] !== undefined ? _data["endorsementId"] : <any>null;
        }
    }

    static fromJS(data: any): StartApplyingForConcessionPermitRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StartApplyingForConcessionPermitRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateId"] = this.templateId !== undefined ? this.templateId : <any>null;
        data["endorsementId"] = this.endorsementId !== undefined ? this.endorsementId : <any>null;
        return data;
    }
}

export interface IStartApplyingForConcessionPermitRequest {
    templateId: string;
    endorsementId: string;
}

export class ChangeTypeToEndorsementRequest implements IChangeTypeToEndorsementRequest {
    templateId!: string;
    certificateId!: string;
    appId!: string;

    constructor(data?: IChangeTypeToEndorsementRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templateId = _data["templateId"] !== undefined ? _data["templateId"] : <any>null;
            this.certificateId = _data["certificateId"] !== undefined ? _data["certificateId"] : <any>null;
            this.appId = _data["appId"] !== undefined ? _data["appId"] : <any>null;
        }
    }

    static fromJS(data: any): ChangeTypeToEndorsementRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeTypeToEndorsementRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templateId"] = this.templateId !== undefined ? this.templateId : <any>null;
        data["certificateId"] = this.certificateId !== undefined ? this.certificateId : <any>null;
        data["appId"] = this.appId !== undefined ? this.appId : <any>null;
        return data;
    }
}

export interface IChangeTypeToEndorsementRequest {
    templateId: string;
    certificateId: string;
    appId: string;
}

export class DuplicableDocumentModel implements IDuplicableDocumentModel {
    certificateOrEndorsementId!: string;
    name!: string;
    legalName!: string;
    documentNumber!: string;
    documentType!: DuplicableDocumentModelDocumentType;

    constructor(data?: IDuplicableDocumentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.certificateOrEndorsementId = _data["certificateOrEndorsementId"] !== undefined ? _data["certificateOrEndorsementId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.legalName = _data["legalName"] !== undefined ? _data["legalName"] : <any>null;
            this.documentNumber = _data["documentNumber"] !== undefined ? _data["documentNumber"] : <any>null;
            this.documentType = _data["documentType"] !== undefined ? _data["documentType"] : <any>null;
        }
    }

    static fromJS(data: any): DuplicableDocumentModel {
        data = typeof data === 'object' ? data : {};
        let result = new DuplicableDocumentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["certificateOrEndorsementId"] = this.certificateOrEndorsementId !== undefined ? this.certificateOrEndorsementId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["legalName"] = this.legalName !== undefined ? this.legalName : <any>null;
        data["documentNumber"] = this.documentNumber !== undefined ? this.documentNumber : <any>null;
        data["documentType"] = this.documentType !== undefined ? this.documentType : <any>null;
        return data;
    }
}

export interface IDuplicableDocumentModel {
    certificateOrEndorsementId: string;
    name: string;
    legalName: string;
    documentNumber: string;
    documentType: DuplicableDocumentModelDocumentType;
}

export enum DuplicableDocumentModelDocumentType {
    Certificate = "certificate",
    Endorsement = "endorsement",
}

export class StartApplyingForDuplicateRequest implements IStartApplyingForDuplicateRequest {
    certificateOrEndorsementId!: string;

    constructor(data?: IStartApplyingForDuplicateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.certificateOrEndorsementId = _data["certificateOrEndorsementId"] !== undefined ? _data["certificateOrEndorsementId"] : <any>null;
        }
    }

    static fromJS(data: any): StartApplyingForDuplicateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StartApplyingForDuplicateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["certificateOrEndorsementId"] = this.certificateOrEndorsementId !== undefined ? this.certificateOrEndorsementId : <any>null;
        return data;
    }
}

export interface IStartApplyingForDuplicateRequest {
    certificateOrEndorsementId: string;
}

export class ChangeTypeToDuplicateRequest implements IChangeTypeToDuplicateRequest {
    certificateOrEndorsementId!: string;
    appId!: string;

    constructor(data?: IChangeTypeToDuplicateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.certificateOrEndorsementId = _data["certificateOrEndorsementId"] !== undefined ? _data["certificateOrEndorsementId"] : <any>null;
            this.appId = _data["appId"] !== undefined ? _data["appId"] : <any>null;
        }
    }

    static fromJS(data: any): ChangeTypeToDuplicateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeTypeToDuplicateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["certificateOrEndorsementId"] = this.certificateOrEndorsementId !== undefined ? this.certificateOrEndorsementId : <any>null;
        data["appId"] = this.appId !== undefined ? this.appId : <any>null;
        return data;
    }
}

export interface IChangeTypeToDuplicateRequest {
    certificateOrEndorsementId: string;
    appId: string;
}

export class ApplicationViewModel implements IApplicationViewModel {
    id!: string;
    documentNumber!: string;
    seafarerId!: string;
    applicantName!: string;
    officialName?: string | null;
    templateName!: string;
    certificateTypeName!: string;
    certificateTypeLegalName!: string;
    requirementFulfillments!: RequirementFulfillmentViewModel[];
    areAllMandatoryRequirementsProcessed!: boolean;
    areAllMandatoryRequirementsAccepted!: boolean;
    state!: ApplicationState;
    submittedAt?: Date | null;
    firstSubmittedAt?: Date | null;
    processingStartedAt?: Date | null;
    processedAt?: Date | null;
    processingDecision?: ApplicationProcessingDecisionViewModel | null;
    documentType!: string;
    documentDeliveryMethod?: DocumentDeliveryMethodModel | null;
    documentDeliveryAddressConfirmed!: boolean;
    documentDeliveryConfirmedAt?: Date | null;
    hasDocumentBeenIssued!: boolean;
    isInEditMode!: boolean;
    hasBeenPrinted!: boolean;
    isForCertificate!: boolean;
    isForEndorsement!: boolean;
    issuedDocumentId?: string | null;
    requirementGroups!: RequirementGroupModel[];
    applicationType!: ApplicationType;
    seafarerContactInfoModel?: ContactInfoViewModel | null;
    replaceableDocumentNumber?: string | null;
    isDeleted!: boolean;
    additionalInfo?: string | null;

    constructor(data?: IApplicationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.requirementFulfillments = [];
            this.requirementGroups = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.documentNumber = _data["documentNumber"] !== undefined ? _data["documentNumber"] : <any>null;
            this.seafarerId = _data["seafarerId"] !== undefined ? _data["seafarerId"] : <any>null;
            this.applicantName = _data["applicantName"] !== undefined ? _data["applicantName"] : <any>null;
            this.officialName = _data["officialName"] !== undefined ? _data["officialName"] : <any>null;
            this.templateName = _data["templateName"] !== undefined ? _data["templateName"] : <any>null;
            this.certificateTypeName = _data["certificateTypeName"] !== undefined ? _data["certificateTypeName"] : <any>null;
            this.certificateTypeLegalName = _data["certificateTypeLegalName"] !== undefined ? _data["certificateTypeLegalName"] : <any>null;
            if (Array.isArray(_data["requirementFulfillments"])) {
                this.requirementFulfillments = [] as any;
                for (let item of _data["requirementFulfillments"])
                    this.requirementFulfillments!.push(RequirementFulfillmentViewModel.fromJS(item));
            }
            else {
                this.requirementFulfillments = <any>null;
            }
            this.areAllMandatoryRequirementsProcessed = _data["areAllMandatoryRequirementsProcessed"] !== undefined ? _data["areAllMandatoryRequirementsProcessed"] : <any>null;
            this.areAllMandatoryRequirementsAccepted = _data["areAllMandatoryRequirementsAccepted"] !== undefined ? _data["areAllMandatoryRequirementsAccepted"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.submittedAt = _data["submittedAt"] ? new Date(_data["submittedAt"].toString()) : <any>null;
            this.firstSubmittedAt = _data["firstSubmittedAt"] ? new Date(_data["firstSubmittedAt"].toString()) : <any>null;
            this.processingStartedAt = _data["processingStartedAt"] ? new Date(_data["processingStartedAt"].toString()) : <any>null;
            this.processedAt = _data["processedAt"] ? new Date(_data["processedAt"].toString()) : <any>null;
            this.processingDecision = _data["processingDecision"] ? ApplicationProcessingDecisionViewModel.fromJS(_data["processingDecision"]) : <any>null;
            this.documentType = _data["documentType"] !== undefined ? _data["documentType"] : <any>null;
            this.documentDeliveryMethod = _data["documentDeliveryMethod"] ? DocumentDeliveryMethodModel.fromJS(_data["documentDeliveryMethod"]) : <any>null;
            this.documentDeliveryAddressConfirmed = _data["documentDeliveryAddressConfirmed"] !== undefined ? _data["documentDeliveryAddressConfirmed"] : <any>null;
            this.documentDeliveryConfirmedAt = _data["documentDeliveryConfirmedAt"] ? new Date(_data["documentDeliveryConfirmedAt"].toString()) : <any>null;
            this.hasDocumentBeenIssued = _data["hasDocumentBeenIssued"] !== undefined ? _data["hasDocumentBeenIssued"] : <any>null;
            this.isInEditMode = _data["isInEditMode"] !== undefined ? _data["isInEditMode"] : <any>null;
            this.hasBeenPrinted = _data["hasBeenPrinted"] !== undefined ? _data["hasBeenPrinted"] : <any>null;
            this.isForCertificate = _data["isForCertificate"] !== undefined ? _data["isForCertificate"] : <any>null;
            this.isForEndorsement = _data["isForEndorsement"] !== undefined ? _data["isForEndorsement"] : <any>null;
            this.issuedDocumentId = _data["issuedDocumentId"] !== undefined ? _data["issuedDocumentId"] : <any>null;
            if (Array.isArray(_data["requirementGroups"])) {
                this.requirementGroups = [] as any;
                for (let item of _data["requirementGroups"])
                    this.requirementGroups!.push(RequirementGroupModel.fromJS(item));
            }
            else {
                this.requirementGroups = <any>null;
            }
            this.applicationType = _data["applicationType"] !== undefined ? _data["applicationType"] : <any>null;
            this.seafarerContactInfoModel = _data["seafarerContactInfoModel"] ? ContactInfoViewModel.fromJS(_data["seafarerContactInfoModel"]) : <any>null;
            this.replaceableDocumentNumber = _data["replaceableDocumentNumber"] !== undefined ? _data["replaceableDocumentNumber"] : <any>null;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : <any>null;
            this.additionalInfo = _data["additionalInfo"] !== undefined ? _data["additionalInfo"] : <any>null;
        }
    }

    static fromJS(data: any): ApplicationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["documentNumber"] = this.documentNumber !== undefined ? this.documentNumber : <any>null;
        data["seafarerId"] = this.seafarerId !== undefined ? this.seafarerId : <any>null;
        data["applicantName"] = this.applicantName !== undefined ? this.applicantName : <any>null;
        data["officialName"] = this.officialName !== undefined ? this.officialName : <any>null;
        data["templateName"] = this.templateName !== undefined ? this.templateName : <any>null;
        data["certificateTypeName"] = this.certificateTypeName !== undefined ? this.certificateTypeName : <any>null;
        data["certificateTypeLegalName"] = this.certificateTypeLegalName !== undefined ? this.certificateTypeLegalName : <any>null;
        if (Array.isArray(this.requirementFulfillments)) {
            data["requirementFulfillments"] = [];
            for (let item of this.requirementFulfillments)
                data["requirementFulfillments"].push(item.toJSON());
        }
        data["areAllMandatoryRequirementsProcessed"] = this.areAllMandatoryRequirementsProcessed !== undefined ? this.areAllMandatoryRequirementsProcessed : <any>null;
        data["areAllMandatoryRequirementsAccepted"] = this.areAllMandatoryRequirementsAccepted !== undefined ? this.areAllMandatoryRequirementsAccepted : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["submittedAt"] = this.submittedAt ? this.submittedAt.toISOString() : <any>null;
        data["firstSubmittedAt"] = this.firstSubmittedAt ? this.firstSubmittedAt.toISOString() : <any>null;
        data["processingStartedAt"] = this.processingStartedAt ? this.processingStartedAt.toISOString() : <any>null;
        data["processedAt"] = this.processedAt ? this.processedAt.toISOString() : <any>null;
        data["processingDecision"] = this.processingDecision ? this.processingDecision.toJSON() : <any>null;
        data["documentType"] = this.documentType !== undefined ? this.documentType : <any>null;
        data["documentDeliveryMethod"] = this.documentDeliveryMethod ? this.documentDeliveryMethod.toJSON() : <any>null;
        data["documentDeliveryAddressConfirmed"] = this.documentDeliveryAddressConfirmed !== undefined ? this.documentDeliveryAddressConfirmed : <any>null;
        data["documentDeliveryConfirmedAt"] = this.documentDeliveryConfirmedAt ? this.documentDeliveryConfirmedAt.toISOString() : <any>null;
        data["hasDocumentBeenIssued"] = this.hasDocumentBeenIssued !== undefined ? this.hasDocumentBeenIssued : <any>null;
        data["isInEditMode"] = this.isInEditMode !== undefined ? this.isInEditMode : <any>null;
        data["hasBeenPrinted"] = this.hasBeenPrinted !== undefined ? this.hasBeenPrinted : <any>null;
        data["isForCertificate"] = this.isForCertificate !== undefined ? this.isForCertificate : <any>null;
        data["isForEndorsement"] = this.isForEndorsement !== undefined ? this.isForEndorsement : <any>null;
        data["issuedDocumentId"] = this.issuedDocumentId !== undefined ? this.issuedDocumentId : <any>null;
        if (Array.isArray(this.requirementGroups)) {
            data["requirementGroups"] = [];
            for (let item of this.requirementGroups)
                data["requirementGroups"].push(item.toJSON());
        }
        data["applicationType"] = this.applicationType !== undefined ? this.applicationType : <any>null;
        data["seafarerContactInfoModel"] = this.seafarerContactInfoModel ? this.seafarerContactInfoModel.toJSON() : <any>null;
        data["replaceableDocumentNumber"] = this.replaceableDocumentNumber !== undefined ? this.replaceableDocumentNumber : <any>null;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : <any>null;
        data["additionalInfo"] = this.additionalInfo !== undefined ? this.additionalInfo : <any>null;
        return data;
    }
}

export interface IApplicationViewModel {
    id: string;
    documentNumber: string;
    seafarerId: string;
    applicantName: string;
    officialName?: string | null;
    templateName: string;
    certificateTypeName: string;
    certificateTypeLegalName: string;
    requirementFulfillments: RequirementFulfillmentViewModel[];
    areAllMandatoryRequirementsProcessed: boolean;
    areAllMandatoryRequirementsAccepted: boolean;
    state: ApplicationState;
    submittedAt?: Date | null;
    firstSubmittedAt?: Date | null;
    processingStartedAt?: Date | null;
    processedAt?: Date | null;
    processingDecision?: ApplicationProcessingDecisionViewModel | null;
    documentType: string;
    documentDeliveryMethod?: DocumentDeliveryMethodModel | null;
    documentDeliveryAddressConfirmed: boolean;
    documentDeliveryConfirmedAt?: Date | null;
    hasDocumentBeenIssued: boolean;
    isInEditMode: boolean;
    hasBeenPrinted: boolean;
    isForCertificate: boolean;
    isForEndorsement: boolean;
    issuedDocumentId?: string | null;
    requirementGroups: RequirementGroupModel[];
    applicationType: ApplicationType;
    seafarerContactInfoModel?: ContactInfoViewModel | null;
    replaceableDocumentNumber?: string | null;
    isDeleted: boolean;
    additionalInfo?: string | null;
}

export class RequirementFulfillmentViewModel implements IRequirementFulfillmentViewModel {
    requirementId!: string;
    requirement!: RequirementViewModel;
    requirementValue?: RequirementValueViewModel | null;
    requirementDecision?: RequirementDecisionViewModel | null;
    validationResult!: ResultError;
    status!: RequirementFulfillmentStatus;
    valueChangeComment?: OfficialCommentViewModel | null;
    demandValueChangeComment!: boolean;

    constructor(data?: IRequirementFulfillmentViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.validationResult = new ResultError();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requirementId = _data["requirementId"] !== undefined ? _data["requirementId"] : <any>null;
            this.requirement = _data["requirement"] ? RequirementViewModel.fromJS(_data["requirement"]) : <any>null;
            this.requirementValue = _data["requirementValue"] ? RequirementValueViewModel.fromJS(_data["requirementValue"]) : <any>null;
            this.requirementDecision = _data["requirementDecision"] ? RequirementDecisionViewModel.fromJS(_data["requirementDecision"]) : <any>null;
            this.validationResult = _data["validationResult"] ? ResultError.fromJS(_data["validationResult"]) : new ResultError();
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.valueChangeComment = _data["valueChangeComment"] ? OfficialCommentViewModel.fromJS(_data["valueChangeComment"]) : <any>null;
            this.demandValueChangeComment = _data["demandValueChangeComment"] !== undefined ? _data["demandValueChangeComment"] : <any>null;
        }
    }

    static fromJS(data: any): RequirementFulfillmentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RequirementFulfillmentViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requirementId"] = this.requirementId !== undefined ? this.requirementId : <any>null;
        data["requirement"] = this.requirement ? this.requirement.toJSON() : <any>null;
        data["requirementValue"] = this.requirementValue ? this.requirementValue.toJSON() : <any>null;
        data["requirementDecision"] = this.requirementDecision ? this.requirementDecision.toJSON() : <any>null;
        data["validationResult"] = this.validationResult ? this.validationResult.toJSON() : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["valueChangeComment"] = this.valueChangeComment ? this.valueChangeComment.toJSON() : <any>null;
        data["demandValueChangeComment"] = this.demandValueChangeComment !== undefined ? this.demandValueChangeComment : <any>null;
        return data;
    }
}

export interface IRequirementFulfillmentViewModel {
    requirementId: string;
    requirement: RequirementViewModel;
    requirementValue?: RequirementValueViewModel | null;
    requirementDecision?: RequirementDecisionViewModel | null;
    validationResult: ResultError;
    status: RequirementFulfillmentStatus;
    valueChangeComment?: OfficialCommentViewModel | null;
    demandValueChangeComment: boolean;
}

export abstract class RequirementViewModel implements IRequirementViewModel {
    id!: string;
    name!: string;
    description!: string[];
    groupId?: string | null;

    protected _discriminator: string;

    constructor(data?: IRequirementViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.description = [];
        }
        this._discriminator = "RequirementViewModel";
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            if (Array.isArray(_data["description"])) {
                this.description = [] as any;
                for (let item of _data["description"])
                    this.description!.push(item);
            }
            else {
                this.description = <any>null;
            }
            this.groupId = _data["groupId"] !== undefined ? _data["groupId"] : <any>null;
        }
    }

    static fromJS(data: any): RequirementViewModel {
        data = typeof data === 'object' ? data : {};
        if (data["type"] === "QualificationRequirementViewModel") {
            let result = new QualificationRequirementViewModel();
            result.init(data);
            return result;
        }
        if (data["type"] === "CertificateRequirementViewModel") {
            let result = new CertificateRequirementViewModel();
            result.init(data);
            return result;
        }
        if (data["type"] === "PersonalInfoRequirementViewModel") {
            let result = new PersonalInfoRequirementViewModel();
            result.init(data);
            return result;
        }
        if (data["type"] === "MedicalCertificateRequirementViewModel") {
            let result = new MedicalCertificateRequirementViewModel();
            result.init(data);
            return result;
        }
        if (data["type"] === "PositionsRequirementViewModel") {
            let result = new PositionsRequirementViewModel();
            result.init(data);
            return result;
        }
        if (data["type"] === "PracticesRequirementViewModel") {
            let result = new PracticesRequirementViewModel();
            result.init(data);
            return result;
        }
        if (data["type"] === "FilesRequirementViewModel") {
            let result = new FilesRequirementViewModel();
            result.init(data);
            return result;
        }
        if (data["type"] === "DuplicationReasonRequirementViewModel") {
            let result = new DuplicationReasonRequirementViewModel();
            result.init(data);
            return result;
        }
        if (data["type"] === "StateFeeRequirementViewModel") {
            let result = new StateFeeRequirementViewModel();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'RequirementViewModel' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this._discriminator;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        if (Array.isArray(this.description)) {
            data["description"] = [];
            for (let item of this.description)
                data["description"].push(item);
        }
        data["groupId"] = this.groupId !== undefined ? this.groupId : <any>null;
        return data;
    }
}

export interface IRequirementViewModel {
    id: string;
    name: string;
    description: string[];
    groupId?: string | null;
}

export class QualificationRequirementViewModel extends RequirementViewModel implements IQualificationRequirementViewModel {
    allowedTypes!: string[];
    maximumAge?: number | null;

    constructor(data?: IQualificationRequirementViewModel) {
        super(data);
        if (!data) {
            this.allowedTypes = [];
        }
        this._discriminator = "QualificationRequirementViewModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["allowedTypes"])) {
                this.allowedTypes = [] as any;
                for (let item of _data["allowedTypes"])
                    this.allowedTypes!.push(item);
            }
            else {
                this.allowedTypes = <any>null;
            }
            this.maximumAge = _data["maximumAge"] !== undefined ? _data["maximumAge"] : <any>null;
        }
    }

    static fromJS(data: any): QualificationRequirementViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationRequirementViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.allowedTypes)) {
            data["allowedTypes"] = [];
            for (let item of this.allowedTypes)
                data["allowedTypes"].push(item);
        }
        data["maximumAge"] = this.maximumAge !== undefined ? this.maximumAge : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IQualificationRequirementViewModel extends IRequirementViewModel {
    allowedTypes: string[];
    maximumAge?: number | null;
}

export abstract class RequirementValueViewModel implements IRequirementValueViewModel {

    protected _discriminator: string;

    constructor(data?: IRequirementValueViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "RequirementValueViewModel";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): RequirementValueViewModel {
        data = typeof data === 'object' ? data : {};
        if (data["type"] === "DuplicationReasonModel") {
            let result = new DuplicationReasonModel();
            result.init(data);
            return result;
        }
        if (data["type"] === "PaymentViewModel") {
            let result = new PaymentViewModel();
            result.init(data);
            return result;
        }
        if (data["type"] === "CertificateCollectionViewModel") {
            let result = new CertificateCollectionViewModel();
            result.init(data);
            return result;
        }
        if (data["type"] === "IdentityValueViewModel") {
            let result = new IdentityValueViewModel();
            result.init(data);
            return result;
        }
        if (data["type"] === "PositionsCollectionViewModel") {
            let result = new PositionsCollectionViewModel();
            result.init(data);
            return result;
        }
        if (data["type"] === "PracticesCollectionViewModel") {
            let result = new PracticesCollectionViewModel();
            result.init(data);
            return result;
        }
        if (data["type"] === "QualificationsCollectionViewModel") {
            let result = new QualificationsCollectionViewModel();
            result.init(data);
            return result;
        }
        if (data["type"] === "PersonalInfoRequirementValueViewModel") {
            let result = new PersonalInfoRequirementValueViewModel();
            result.init(data);
            return result;
        }
        if (data["type"] === "FilesRequirementValueViewModel") {
            let result = new FilesRequirementValueViewModel();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'RequirementValueViewModel' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this._discriminator;
        return data;
    }
}

export interface IRequirementValueViewModel {
}

export class CertificateCollectionViewModel extends RequirementValueViewModel implements ICertificateCollectionViewModel {
    certificateIds!: string[];

    constructor(data?: ICertificateCollectionViewModel) {
        super(data);
        if (!data) {
            this.certificateIds = [];
        }
        this._discriminator = "CertificateCollectionViewModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["certificateIds"])) {
                this.certificateIds = [] as any;
                for (let item of _data["certificateIds"])
                    this.certificateIds!.push(item);
            }
            else {
                this.certificateIds = <any>null;
            }
        }
    }

    static fromJS(data: any): CertificateCollectionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CertificateCollectionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.certificateIds)) {
            data["certificateIds"] = [];
            for (let item of this.certificateIds)
                data["certificateIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICertificateCollectionViewModel extends IRequirementValueViewModel {
    certificateIds: string[];
}

export class IdentityValueViewModel extends RequirementValueViewModel implements IIdentityValueViewModel {
    id!: string;

    constructor(data?: IIdentityValueViewModel) {
        super(data);
        this._discriminator = "IdentityValueViewModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data: any): IdentityValueViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityValueViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIdentityValueViewModel extends IRequirementValueViewModel {
    id: string;
}

export class PositionsCollectionViewModel extends RequirementValueViewModel implements IPositionsCollectionViewModel {
    positionIds!: string[];

    constructor(data?: IPositionsCollectionViewModel) {
        super(data);
        if (!data) {
            this.positionIds = [];
        }
        this._discriminator = "PositionsCollectionViewModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["positionIds"])) {
                this.positionIds = [] as any;
                for (let item of _data["positionIds"])
                    this.positionIds!.push(item);
            }
            else {
                this.positionIds = <any>null;
            }
        }
    }

    static fromJS(data: any): PositionsCollectionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PositionsCollectionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.positionIds)) {
            data["positionIds"] = [];
            for (let item of this.positionIds)
                data["positionIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPositionsCollectionViewModel extends IRequirementValueViewModel {
    positionIds: string[];
}

export class PracticesCollectionViewModel extends RequirementValueViewModel implements IPracticesCollectionViewModel {
    practiceIds!: string[];

    constructor(data?: IPracticesCollectionViewModel) {
        super(data);
        if (!data) {
            this.practiceIds = [];
        }
        this._discriminator = "PracticesCollectionViewModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["practiceIds"])) {
                this.practiceIds = [] as any;
                for (let item of _data["practiceIds"])
                    this.practiceIds!.push(item);
            }
            else {
                this.practiceIds = <any>null;
            }
        }
    }

    static fromJS(data: any): PracticesCollectionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PracticesCollectionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.practiceIds)) {
            data["practiceIds"] = [];
            for (let item of this.practiceIds)
                data["practiceIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IPracticesCollectionViewModel extends IRequirementValueViewModel {
    practiceIds: string[];
}

export class QualificationsCollectionViewModel extends RequirementValueViewModel implements IQualificationsCollectionViewModel {
    qualificationIds!: string[];

    constructor(data?: IQualificationsCollectionViewModel) {
        super(data);
        if (!data) {
            this.qualificationIds = [];
        }
        this._discriminator = "QualificationsCollectionViewModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["qualificationIds"])) {
                this.qualificationIds = [] as any;
                for (let item of _data["qualificationIds"])
                    this.qualificationIds!.push(item);
            }
            else {
                this.qualificationIds = <any>null;
            }
        }
    }

    static fromJS(data: any): QualificationsCollectionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QualificationsCollectionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.qualificationIds)) {
            data["qualificationIds"] = [];
            for (let item of this.qualificationIds)
                data["qualificationIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IQualificationsCollectionViewModel extends IRequirementValueViewModel {
    qualificationIds: string[];
}

export class PersonalInfoRequirementValueViewModel extends RequirementValueViewModel implements IPersonalInfoRequirementValueViewModel {
    approval!: ApprovalStatus;
    personalCode?: string | null;
    firstName!: string;
    lastName!: string;
    nationality?: string | null;
    birthdate!: Date;
    signatureImage?: FileModel | null;
    profileImage?: FileModel | null;
    recentProfileImageChange?: HistoryDetails | null;

    constructor(data?: IPersonalInfoRequirementValueViewModel) {
        super(data);
        if (!data) {
            this.personalCode = "";
            this.firstName = "";
            this.lastName = "";
        }
        this._discriminator = "PersonalInfoRequirementValueViewModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.approval = _data["approval"] !== undefined ? _data["approval"] : <any>null;
            this.personalCode = _data["personalCode"] !== undefined ? _data["personalCode"] : "";
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : "";
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : "";
            this.nationality = _data["nationality"] !== undefined ? _data["nationality"] : <any>null;
            this.birthdate = _data["birthdate"] ? new Date(_data["birthdate"].toString()) : <any>null;
            this.signatureImage = _data["signatureImage"] ? FileModel.fromJS(_data["signatureImage"]) : <any>null;
            this.profileImage = _data["profileImage"] ? FileModel.fromJS(_data["profileImage"]) : <any>null;
            this.recentProfileImageChange = _data["recentProfileImageChange"] ? HistoryDetails.fromJS(_data["recentProfileImageChange"]) : <any>null;
        }
    }

    static fromJS(data: any): PersonalInfoRequirementValueViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PersonalInfoRequirementValueViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approval"] = this.approval !== undefined ? this.approval : <any>null;
        data["personalCode"] = this.personalCode !== undefined ? this.personalCode : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["nationality"] = this.nationality !== undefined ? this.nationality : <any>null;
        data["birthdate"] = this.birthdate ? this.birthdate.toISOString() : <any>null;
        data["signatureImage"] = this.signatureImage ? this.signatureImage.toJSON() : <any>null;
        data["profileImage"] = this.profileImage ? this.profileImage.toJSON() : <any>null;
        data["recentProfileImageChange"] = this.recentProfileImageChange ? this.recentProfileImageChange.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPersonalInfoRequirementValueViewModel extends IRequirementValueViewModel {
    approval: ApprovalStatus;
    personalCode?: string | null;
    firstName: string;
    lastName: string;
    nationality?: string | null;
    birthdate: Date;
    signatureImage?: FileModel | null;
    profileImage?: FileModel | null;
    recentProfileImageChange?: HistoryDetails | null;
}

export class FilesRequirementValueViewModel extends RequirementValueViewModel implements IFilesRequirementValueViewModel {
    files!: FileModel[];

    constructor(data?: IFilesRequirementValueViewModel) {
        super(data);
        if (!data) {
            this.files = [];
        }
        this._discriminator = "FilesRequirementValueViewModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["files"])) {
                this.files = [] as any;
                for (let item of _data["files"])
                    this.files!.push(FileModel.fromJS(item));
            }
            else {
                this.files = <any>null;
            }
        }
    }

    static fromJS(data: any): FilesRequirementValueViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FilesRequirementValueViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.files)) {
            data["files"] = [];
            for (let item of this.files)
                data["files"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IFilesRequirementValueViewModel extends IRequirementValueViewModel {
    files: FileModel[];
}

export class DuplicationReasonModel extends RequirementValueViewModel implements IDuplicationReasonModel {
    reasonType!: DuplicationReasonTypeModel;
    additionalInfo?: string | null;

    constructor(data?: IDuplicationReasonModel) {
        super(data);
        if (!data) {
            this.reasonType = new DuplicationReasonTypeModel();
        }
        this._discriminator = "DuplicationReasonModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.reasonType = _data["reasonType"] ? DuplicationReasonTypeModel.fromJS(_data["reasonType"]) : new DuplicationReasonTypeModel();
            this.additionalInfo = _data["additionalInfo"] !== undefined ? _data["additionalInfo"] : <any>null;
        }
    }

    static fromJS(data: any): DuplicationReasonModel {
        data = typeof data === 'object' ? data : {};
        let result = new DuplicationReasonModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reasonType"] = this.reasonType ? this.reasonType.toJSON() : <any>null;
        data["additionalInfo"] = this.additionalInfo !== undefined ? this.additionalInfo : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDuplicationReasonModel extends IRequirementValueViewModel {
    reasonType: DuplicationReasonTypeModel;
    additionalInfo?: string | null;
}

export class DuplicationReasonTypeModel implements IDuplicationReasonTypeModel {
    key!: string;
    name!: string;

    constructor(data?: IDuplicationReasonTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): DuplicationReasonTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new DuplicationReasonTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface IDuplicationReasonTypeModel {
    key: string;
    name: string;
}

export class PaymentViewModel extends RequirementValueViewModel implements IPaymentViewModel {
    chosenMethod!: PaymentMethodWithDescription;
    submitter!: string;
    submittedAt?: Date | null;
    confirmedMethod?: PaymentMethodWithDescription | null;
    receivedAt?: Date | null;
    documentNumber!: string;
    payer!: string;
    refunder!: string;
    refundedAt?: Date | null;
    refundReason!: string;
    isConfirmed!: boolean;
    isRefunded!: boolean;

    constructor(data?: IPaymentViewModel) {
        super(data);
        if (!data) {
            this.chosenMethod = new PaymentMethodWithDescription();
        }
        this._discriminator = "PaymentViewModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.chosenMethod = _data["chosenMethod"] ? PaymentMethodWithDescription.fromJS(_data["chosenMethod"]) : new PaymentMethodWithDescription();
            this.submitter = _data["submitter"] !== undefined ? _data["submitter"] : <any>null;
            this.submittedAt = _data["submittedAt"] ? new Date(_data["submittedAt"].toString()) : <any>null;
            this.confirmedMethod = _data["confirmedMethod"] ? PaymentMethodWithDescription.fromJS(_data["confirmedMethod"]) : <any>null;
            this.receivedAt = _data["receivedAt"] ? new Date(_data["receivedAt"].toString()) : <any>null;
            this.documentNumber = _data["documentNumber"] !== undefined ? _data["documentNumber"] : <any>null;
            this.payer = _data["payer"] !== undefined ? _data["payer"] : <any>null;
            this.refunder = _data["refunder"] !== undefined ? _data["refunder"] : <any>null;
            this.refundedAt = _data["refundedAt"] ? new Date(_data["refundedAt"].toString()) : <any>null;
            this.refundReason = _data["refundReason"] !== undefined ? _data["refundReason"] : <any>null;
            this.isConfirmed = _data["isConfirmed"] !== undefined ? _data["isConfirmed"] : <any>null;
            this.isRefunded = _data["isRefunded"] !== undefined ? _data["isRefunded"] : <any>null;
        }
    }

    static fromJS(data: any): PaymentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chosenMethod"] = this.chosenMethod ? this.chosenMethod.toJSON() : <any>null;
        data["submitter"] = this.submitter !== undefined ? this.submitter : <any>null;
        data["submittedAt"] = this.submittedAt ? this.submittedAt.toISOString() : <any>null;
        data["confirmedMethod"] = this.confirmedMethod ? this.confirmedMethod.toJSON() : <any>null;
        data["receivedAt"] = this.receivedAt ? this.receivedAt.toISOString() : <any>null;
        data["documentNumber"] = this.documentNumber !== undefined ? this.documentNumber : <any>null;
        data["payer"] = this.payer !== undefined ? this.payer : <any>null;
        data["refunder"] = this.refunder !== undefined ? this.refunder : <any>null;
        data["refundedAt"] = this.refundedAt ? this.refundedAt.toISOString() : <any>null;
        data["refundReason"] = this.refundReason !== undefined ? this.refundReason : <any>null;
        data["isConfirmed"] = this.isConfirmed !== undefined ? this.isConfirmed : <any>null;
        data["isRefunded"] = this.isRefunded !== undefined ? this.isRefunded : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPaymentViewModel extends IRequirementValueViewModel {
    chosenMethod: PaymentMethodWithDescription;
    submitter: string;
    submittedAt?: Date | null;
    confirmedMethod?: PaymentMethodWithDescription | null;
    receivedAt?: Date | null;
    documentNumber: string;
    payer: string;
    refunder: string;
    refundedAt?: Date | null;
    refundReason: string;
    isConfirmed: boolean;
    isRefunded: boolean;
}

export class PaymentMethodWithDescription extends ValueObject implements IPaymentMethodWithDescription {
    paymentMethod!: string;
    description!: string;

    constructor(data?: IPaymentMethodWithDescription) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.paymentMethod = _data["paymentMethod"] !== undefined ? _data["paymentMethod"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
        }
    }

    static fromJS(data: any): PaymentMethodWithDescription {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentMethodWithDescription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentMethod"] = this.paymentMethod !== undefined ? this.paymentMethod : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPaymentMethodWithDescription extends IValueObject {
    paymentMethod: string;
    description: string;
}

export class CertificateRequirementViewModel extends RequirementViewModel implements ICertificateRequirementViewModel {
    allowedTypes!: string[];

    constructor(data?: ICertificateRequirementViewModel) {
        super(data);
        if (!data) {
            this.allowedTypes = [];
        }
        this._discriminator = "CertificateRequirementViewModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["allowedTypes"])) {
                this.allowedTypes = [] as any;
                for (let item of _data["allowedTypes"])
                    this.allowedTypes!.push(item);
            }
            else {
                this.allowedTypes = <any>null;
            }
        }
    }

    static fromJS(data: any): CertificateRequirementViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CertificateRequirementViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.allowedTypes)) {
            data["allowedTypes"] = [];
            for (let item of this.allowedTypes)
                data["allowedTypes"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICertificateRequirementViewModel extends IRequirementViewModel {
    allowedTypes: string[];
}

export class PersonalInfoRequirementViewModel extends RequirementViewModel implements IPersonalInfoRequirementViewModel {
    minimumAge?: number | null;
    requiredNationality?: string | null;
    requireProfileImage!: boolean;
    requireSignatureImage!: boolean;

    constructor(data?: IPersonalInfoRequirementViewModel) {
        super(data);
        this._discriminator = "PersonalInfoRequirementViewModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.minimumAge = _data["minimumAge"] !== undefined ? _data["minimumAge"] : <any>null;
            this.requiredNationality = _data["requiredNationality"] !== undefined ? _data["requiredNationality"] : <any>null;
            this.requireProfileImage = _data["requireProfileImage"] !== undefined ? _data["requireProfileImage"] : <any>null;
            this.requireSignatureImage = _data["requireSignatureImage"] !== undefined ? _data["requireSignatureImage"] : <any>null;
        }
    }

    static fromJS(data: any): PersonalInfoRequirementViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PersonalInfoRequirementViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["minimumAge"] = this.minimumAge !== undefined ? this.minimumAge : <any>null;
        data["requiredNationality"] = this.requiredNationality !== undefined ? this.requiredNationality : <any>null;
        data["requireProfileImage"] = this.requireProfileImage !== undefined ? this.requireProfileImage : <any>null;
        data["requireSignatureImage"] = this.requireSignatureImage !== undefined ? this.requireSignatureImage : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPersonalInfoRequirementViewModel extends IRequirementViewModel {
    minimumAge?: number | null;
    requiredNationality?: string | null;
    requireProfileImage: boolean;
    requireSignatureImage: boolean;
}

export class MedicalCertificateRequirementViewModel extends RequirementViewModel implements IMedicalCertificateRequirementViewModel {

    constructor(data?: IMedicalCertificateRequirementViewModel) {
        super(data);
        this._discriminator = "MedicalCertificateRequirementViewModel";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): MedicalCertificateRequirementViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalCertificateRequirementViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IMedicalCertificateRequirementViewModel extends IRequirementViewModel {
}

export class PositionsRequirementViewModel extends RequirementViewModel implements IPositionsRequirementViewModel {
    certificateTypeId!: string;

    constructor(data?: IPositionsRequirementViewModel) {
        super(data);
        this._discriminator = "PositionsRequirementViewModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.certificateTypeId = _data["certificateTypeId"] !== undefined ? _data["certificateTypeId"] : <any>null;
        }
    }

    static fromJS(data: any): PositionsRequirementViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PositionsRequirementViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["certificateTypeId"] = this.certificateTypeId !== undefined ? this.certificateTypeId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPositionsRequirementViewModel extends IRequirementViewModel {
    certificateTypeId: string;
}

export class PracticesRequirementViewModel extends RequirementViewModel implements IPracticesRequirementViewModel {
    practiceType!: PracticeType;
    isCountBased!: boolean;

    constructor(data?: IPracticesRequirementViewModel) {
        super(data);
        this._discriminator = "PracticesRequirementViewModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.practiceType = _data["practiceType"] !== undefined ? _data["practiceType"] : <any>null;
            this.isCountBased = _data["isCountBased"] !== undefined ? _data["isCountBased"] : <any>null;
        }
    }

    static fromJS(data: any): PracticesRequirementViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PracticesRequirementViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["practiceType"] = this.practiceType !== undefined ? this.practiceType : <any>null;
        data["isCountBased"] = this.isCountBased !== undefined ? this.isCountBased : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPracticesRequirementViewModel extends IRequirementViewModel {
    practiceType: PracticeType;
    isCountBased: boolean;
}

export class FilesRequirementViewModel extends RequirementViewModel implements IFilesRequirementViewModel {

    constructor(data?: IFilesRequirementViewModel) {
        super(data);
        this._discriminator = "FilesRequirementViewModel";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): FilesRequirementViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FilesRequirementViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IFilesRequirementViewModel extends IRequirementViewModel {
}

export class DuplicationReasonRequirementViewModel extends RequirementViewModel implements IDuplicationReasonRequirementViewModel {

    constructor(data?: IDuplicationReasonRequirementViewModel) {
        super(data);
        this._discriminator = "DuplicationReasonRequirementViewModel";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): DuplicationReasonRequirementViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DuplicationReasonRequirementViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDuplicationReasonRequirementViewModel extends IRequirementViewModel {
}

export class StateFeeRequirementViewModel extends RequirementViewModel implements IStateFeeRequirementViewModel {
    sum!: number;
    transferDetails!: TransferDetails;

    constructor(data?: IStateFeeRequirementViewModel) {
        super(data);
        if (!data) {
            this.transferDetails = new TransferDetails();
        }
        this._discriminator = "StateFeeRequirementViewModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sum = _data["sum"] !== undefined ? _data["sum"] : <any>null;
            this.transferDetails = _data["transferDetails"] ? TransferDetails.fromJS(_data["transferDetails"]) : new TransferDetails();
        }
    }

    static fromJS(data: any): StateFeeRequirementViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new StateFeeRequirementViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sum"] = this.sum !== undefined ? this.sum : <any>null;
        data["transferDetails"] = this.transferDetails ? this.transferDetails.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IStateFeeRequirementViewModel extends IRequirementViewModel {
    sum: number;
    transferDetails: TransferDetails;
}

export class TransferDetails implements ITransferDetails {
    accountHolder!: string;
    accounts!: BankAccountDetails[];
    referenceNumber!: string;

    constructor(data?: ITransferDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.accounts = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountHolder = _data["accountHolder"] !== undefined ? _data["accountHolder"] : <any>null;
            if (Array.isArray(_data["accounts"])) {
                this.accounts = [] as any;
                for (let item of _data["accounts"])
                    this.accounts!.push(BankAccountDetails.fromJS(item));
            }
            else {
                this.accounts = <any>null;
            }
            this.referenceNumber = _data["referenceNumber"] !== undefined ? _data["referenceNumber"] : <any>null;
        }
    }

    static fromJS(data: any): TransferDetails {
        data = typeof data === 'object' ? data : {};
        let result = new TransferDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountHolder"] = this.accountHolder !== undefined ? this.accountHolder : <any>null;
        if (Array.isArray(this.accounts)) {
            data["accounts"] = [];
            for (let item of this.accounts)
                data["accounts"].push(item.toJSON());
        }
        data["referenceNumber"] = this.referenceNumber !== undefined ? this.referenceNumber : <any>null;
        return data;
    }
}

export interface ITransferDetails {
    accountHolder: string;
    accounts: BankAccountDetails[];
    referenceNumber: string;
}

export class BankAccountDetails implements IBankAccountDetails {
    bank!: string;
    iban!: string;

    constructor(data?: IBankAccountDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bank = _data["bank"] !== undefined ? _data["bank"] : <any>null;
            this.iban = _data["iban"] !== undefined ? _data["iban"] : <any>null;
        }
    }

    static fromJS(data: any): BankAccountDetails {
        data = typeof data === 'object' ? data : {};
        let result = new BankAccountDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bank"] = this.bank !== undefined ? this.bank : <any>null;
        data["iban"] = this.iban !== undefined ? this.iban : <any>null;
        return data;
    }
}

export interface IBankAccountDetails {
    bank: string;
    iban: string;
}

export class RequirementDecisionViewModel implements IRequirementDecisionViewModel {
    comment!: string;
    type!: ProcessingDecisionType;

    constructor(data?: IRequirementDecisionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
        }
    }

    static fromJS(data: any): RequirementDecisionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RequirementDecisionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        return data;
    }
}

export interface IRequirementDecisionViewModel {
    comment: string;
    type: ProcessingDecisionType;
}

export enum ProcessingDecisionType {
    Accepted = "accepted",
    Rejected = "rejected",
}

export enum RequirementFulfillmentStatus {
    Unfulfilled = "unfulfilled",
    Fulfilled = "fulfilled",
    FulfilledAutomatically = "fulfilledAutomatically",
    Accepted = "accepted",
    Rejected = "rejected",
    Deleted = "deleted",
}

export class OfficialCommentViewModel implements IOfficialCommentViewModel {
    comment!: string;
    officialName!: string;

    constructor(data?: IOfficialCommentViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
            this.officialName = _data["officialName"] !== undefined ? _data["officialName"] : <any>null;
        }
    }

    static fromJS(data: any): OfficialCommentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OfficialCommentViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        data["officialName"] = this.officialName !== undefined ? this.officialName : <any>null;
        return data;
    }
}

export interface IOfficialCommentViewModel {
    comment: string;
    officialName: string;
}

export enum ApplicationState {
    ApplicationSubmitted = "applicationSubmitted",
    ApplicationNotSubmitted = "applicationNotSubmitted",
    PendingApplication = "pendingApplication",
    ApplicationRejected = "applicationRejected",
    DocumentIssued = "documentIssued",
}

export class ApplicationProcessingDecisionViewModel implements IApplicationProcessingDecisionViewModel {
    type!: ProcessingDecisionType;
    comment?: string | null;

    constructor(data?: IApplicationProcessingDecisionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
        }
    }

    static fromJS(data: any): ApplicationProcessingDecisionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationProcessingDecisionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        return data;
    }
}

export interface IApplicationProcessingDecisionViewModel {
    type: ProcessingDecisionType;
    comment?: string | null;
}

export abstract class DocumentDeliveryMethodModel implements IDocumentDeliveryMethodModel {

    protected _discriminator: string;

    constructor(data?: IDocumentDeliveryMethodModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "DocumentDeliveryMethodModel";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DocumentDeliveryMethodModel {
        data = typeof data === 'object' ? data : {};
        if (data["type"] === "PostalDeliveryMethodModel") {
            let result = new PostalDeliveryMethodModel();
            result.init(data);
            return result;
        }
        if (data["type"] === "PickUpDeliveryMethodModel") {
            let result = new PickUpDeliveryMethodModel();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'DocumentDeliveryMethodModel' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this._discriminator;
        return data;
    }
}

export interface IDocumentDeliveryMethodModel {
}

export class PostalDeliveryMethodModel extends DocumentDeliveryMethodModel implements IPostalDeliveryMethodModel {

    constructor(data?: IPostalDeliveryMethodModel) {
        super(data);
        this._discriminator = "PostalDeliveryMethodModel";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): PostalDeliveryMethodModel {
        data = typeof data === 'object' ? data : {};
        let result = new PostalDeliveryMethodModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IPostalDeliveryMethodModel extends IDocumentDeliveryMethodModel {
}

export class PickUpDeliveryMethodModel extends DocumentDeliveryMethodModel implements IPickUpDeliveryMethodModel {
    mandate?: MandateModel | null;

    constructor(data?: IPickUpDeliveryMethodModel) {
        super(data);
        this._discriminator = "PickUpDeliveryMethodModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.mandate = _data["mandate"] ? MandateModel.fromJS(_data["mandate"]) : <any>null;
        }
    }

    static fromJS(data: any): PickUpDeliveryMethodModel {
        data = typeof data === 'object' ? data : {};
        let result = new PickUpDeliveryMethodModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mandate"] = this.mandate ? this.mandate.toJSON() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPickUpDeliveryMethodModel extends IDocumentDeliveryMethodModel {
    mandate?: MandateModel | null;
}

export class MandateModel implements IMandateModel {
    firstName?: string | null;
    lastName?: string | null;
    personalCode?: string | null;
    birthDate?: Date | null;
    selectedThirdPersonIdentifier?: string | null;

    constructor(data?: IMandateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.personalCode = _data["personalCode"] !== undefined ? _data["personalCode"] : <any>null;
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>null;
            this.selectedThirdPersonIdentifier = _data["selectedThirdPersonIdentifier"] !== undefined ? _data["selectedThirdPersonIdentifier"] : <any>null;
        }
    }

    static fromJS(data: any): MandateModel {
        data = typeof data === 'object' ? data : {};
        let result = new MandateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["personalCode"] = this.personalCode !== undefined ? this.personalCode : <any>null;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>null;
        data["selectedThirdPersonIdentifier"] = this.selectedThirdPersonIdentifier !== undefined ? this.selectedThirdPersonIdentifier : <any>null;
        return data;
    }
}

export interface IMandateModel {
    firstName?: string | null;
    lastName?: string | null;
    personalCode?: string | null;
    birthDate?: Date | null;
    selectedThirdPersonIdentifier?: string | null;
}

export class RequirementGroupModel implements IRequirementGroupModel {
    id!: string;
    name!: string;

    constructor(data?: IRequirementGroupModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): RequirementGroupModel {
        data = typeof data === 'object' ? data : {};
        let result = new RequirementGroupModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface IRequirementGroupModel {
    id: string;
    name: string;
}

export enum ApplicationType {
    NewCertificate = "newCertificate",
    NewEndorsement = "newEndorsement",
    Duplicate = "duplicate",
}

export class RejectApplicationRequest implements IRejectApplicationRequest {
    comment!: string;

    constructor(data?: IRejectApplicationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
        }
    }

    static fromJS(data: any): RejectApplicationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RejectApplicationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        return data;
    }
}

export interface IRejectApplicationRequest {
    comment: string;
}

export class SetDocumentDeliveryMethodRequest implements ISetDocumentDeliveryMethodRequest {
    documentDeliveryMethod?: DocumentDeliveryMethodModel | null;

    constructor(data?: ISetDocumentDeliveryMethodRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.documentDeliveryMethod = _data["documentDeliveryMethod"] ? DocumentDeliveryMethodModel.fromJS(_data["documentDeliveryMethod"]) : <any>null;
        }
    }

    static fromJS(data: any): SetDocumentDeliveryMethodRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SetDocumentDeliveryMethodRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentDeliveryMethod"] = this.documentDeliveryMethod ? this.documentDeliveryMethod.toJSON() : <any>null;
        return data;
    }
}

export interface ISetDocumentDeliveryMethodRequest {
    documentDeliveryMethod?: DocumentDeliveryMethodModel | null;
}

export class ChangeDocumentRequest implements IChangeDocumentRequest {
    comment?: string | null;

    constructor(data?: IChangeDocumentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
        }
    }

    static fromJS(data: any): ChangeDocumentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeDocumentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        return data;
    }
}

export interface IChangeDocumentRequest {
    comment?: string | null;
}

export class ApplicationHistoryEventModel implements IApplicationHistoryEventModel {
    message!: string;
    actorName!: string;
    date!: Date;
    dateTime?: Date | null;
    comment?: string | null;
    requirementId?: string | null;
    key?: ApplicationEventKey | null;

    constructor(data?: IApplicationHistoryEventModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"] !== undefined ? _data["message"] : <any>null;
            this.actorName = _data["actorName"] !== undefined ? _data["actorName"] : <any>null;
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>null;
            this.dateTime = _data["dateTime"] ? new Date(_data["dateTime"].toString()) : <any>null;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
            this.requirementId = _data["requirementId"] !== undefined ? _data["requirementId"] : <any>null;
            this.key = _data["key"] !== undefined ? _data["key"] : <any>null;
        }
    }

    static fromJS(data: any): ApplicationHistoryEventModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationHistoryEventModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message !== undefined ? this.message : <any>null;
        data["actorName"] = this.actorName !== undefined ? this.actorName : <any>null;
        data["date"] = this.date ? this.date.toISOString() : <any>null;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : <any>null;
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        data["requirementId"] = this.requirementId !== undefined ? this.requirementId : <any>null;
        data["key"] = this.key !== undefined ? this.key : <any>null;
        return data;
    }
}

export interface IApplicationHistoryEventModel {
    message: string;
    actorName: string;
    date: Date;
    dateTime?: Date | null;
    comment?: string | null;
    requirementId?: string | null;
    key?: ApplicationEventKey | null;
}

export enum ApplicationEventKey {
    Started = "started",
    Submitted = "submitted",
    ProcessingStarted = "processingStarted",
    Rejected = "rejected",
    DocumentIssued = "documentIssued",
    Archived = "archived",
    Change = "change",
    Deleted = "deleted",
}

export class ApplicationActions implements IApplicationActions {
    canSetDocumentDeliveryMethod!: boolean;
    canConfirmDocumentDeliveryAddress!: boolean;
    canSubmit!: boolean;
    canStartProcessing!: boolean;
    canReject!: boolean;
    canChangeApplication!: boolean;
    canProcessRequirements!: boolean;
    canFillRequirements!: boolean;
    canAddQualifications!: boolean;
    canFillDocumentSeed!: boolean;
    canSignDocumentSeed!: boolean;
    canRemoveDocumentSeedSignature!: boolean;
    canIssueDocument!: boolean;
    canViewDocumentIssuing!: boolean;
    canConfirmDocumentDelivery!: boolean;
    canForwardToSigning!: boolean;
    canUndoForwardToSigning!: boolean;
    canTakeOverProcessing!: boolean;
    canChangeApplicationType!: boolean;
    canUpdateApplicationProfileImage!: boolean;
    canViewPrintPreview!: boolean;
    canDeleteApplication!: boolean;
    canViewIssuedApplicationPrintTemplate!: boolean;
    isOfficial!: boolean;

    constructor(data?: IApplicationActions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canSetDocumentDeliveryMethod = _data["canSetDocumentDeliveryMethod"] !== undefined ? _data["canSetDocumentDeliveryMethod"] : <any>null;
            this.canConfirmDocumentDeliveryAddress = _data["canConfirmDocumentDeliveryAddress"] !== undefined ? _data["canConfirmDocumentDeliveryAddress"] : <any>null;
            this.canSubmit = _data["canSubmit"] !== undefined ? _data["canSubmit"] : <any>null;
            this.canStartProcessing = _data["canStartProcessing"] !== undefined ? _data["canStartProcessing"] : <any>null;
            this.canReject = _data["canReject"] !== undefined ? _data["canReject"] : <any>null;
            this.canChangeApplication = _data["canChangeApplication"] !== undefined ? _data["canChangeApplication"] : <any>null;
            this.canProcessRequirements = _data["canProcessRequirements"] !== undefined ? _data["canProcessRequirements"] : <any>null;
            this.canFillRequirements = _data["canFillRequirements"] !== undefined ? _data["canFillRequirements"] : <any>null;
            this.canAddQualifications = _data["canAddQualifications"] !== undefined ? _data["canAddQualifications"] : <any>null;
            this.canFillDocumentSeed = _data["canFillDocumentSeed"] !== undefined ? _data["canFillDocumentSeed"] : <any>null;
            this.canSignDocumentSeed = _data["canSignDocumentSeed"] !== undefined ? _data["canSignDocumentSeed"] : <any>null;
            this.canRemoveDocumentSeedSignature = _data["canRemoveDocumentSeedSignature"] !== undefined ? _data["canRemoveDocumentSeedSignature"] : <any>null;
            this.canIssueDocument = _data["canIssueDocument"] !== undefined ? _data["canIssueDocument"] : <any>null;
            this.canViewDocumentIssuing = _data["canViewDocumentIssuing"] !== undefined ? _data["canViewDocumentIssuing"] : <any>null;
            this.canConfirmDocumentDelivery = _data["canConfirmDocumentDelivery"] !== undefined ? _data["canConfirmDocumentDelivery"] : <any>null;
            this.canForwardToSigning = _data["canForwardToSigning"] !== undefined ? _data["canForwardToSigning"] : <any>null;
            this.canUndoForwardToSigning = _data["canUndoForwardToSigning"] !== undefined ? _data["canUndoForwardToSigning"] : <any>null;
            this.canTakeOverProcessing = _data["canTakeOverProcessing"] !== undefined ? _data["canTakeOverProcessing"] : <any>null;
            this.canChangeApplicationType = _data["canChangeApplicationType"] !== undefined ? _data["canChangeApplicationType"] : <any>null;
            this.canUpdateApplicationProfileImage = _data["canUpdateApplicationProfileImage"] !== undefined ? _data["canUpdateApplicationProfileImage"] : <any>null;
            this.canViewPrintPreview = _data["canViewPrintPreview"] !== undefined ? _data["canViewPrintPreview"] : <any>null;
            this.canDeleteApplication = _data["canDeleteApplication"] !== undefined ? _data["canDeleteApplication"] : <any>null;
            this.canViewIssuedApplicationPrintTemplate = _data["canViewIssuedApplicationPrintTemplate"] !== undefined ? _data["canViewIssuedApplicationPrintTemplate"] : <any>null;
            this.isOfficial = _data["isOfficial"] !== undefined ? _data["isOfficial"] : <any>null;
        }
    }

    static fromJS(data: any): ApplicationActions {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationActions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canSetDocumentDeliveryMethod"] = this.canSetDocumentDeliveryMethod !== undefined ? this.canSetDocumentDeliveryMethod : <any>null;
        data["canConfirmDocumentDeliveryAddress"] = this.canConfirmDocumentDeliveryAddress !== undefined ? this.canConfirmDocumentDeliveryAddress : <any>null;
        data["canSubmit"] = this.canSubmit !== undefined ? this.canSubmit : <any>null;
        data["canStartProcessing"] = this.canStartProcessing !== undefined ? this.canStartProcessing : <any>null;
        data["canReject"] = this.canReject !== undefined ? this.canReject : <any>null;
        data["canChangeApplication"] = this.canChangeApplication !== undefined ? this.canChangeApplication : <any>null;
        data["canProcessRequirements"] = this.canProcessRequirements !== undefined ? this.canProcessRequirements : <any>null;
        data["canFillRequirements"] = this.canFillRequirements !== undefined ? this.canFillRequirements : <any>null;
        data["canAddQualifications"] = this.canAddQualifications !== undefined ? this.canAddQualifications : <any>null;
        data["canFillDocumentSeed"] = this.canFillDocumentSeed !== undefined ? this.canFillDocumentSeed : <any>null;
        data["canSignDocumentSeed"] = this.canSignDocumentSeed !== undefined ? this.canSignDocumentSeed : <any>null;
        data["canRemoveDocumentSeedSignature"] = this.canRemoveDocumentSeedSignature !== undefined ? this.canRemoveDocumentSeedSignature : <any>null;
        data["canIssueDocument"] = this.canIssueDocument !== undefined ? this.canIssueDocument : <any>null;
        data["canViewDocumentIssuing"] = this.canViewDocumentIssuing !== undefined ? this.canViewDocumentIssuing : <any>null;
        data["canConfirmDocumentDelivery"] = this.canConfirmDocumentDelivery !== undefined ? this.canConfirmDocumentDelivery : <any>null;
        data["canForwardToSigning"] = this.canForwardToSigning !== undefined ? this.canForwardToSigning : <any>null;
        data["canUndoForwardToSigning"] = this.canUndoForwardToSigning !== undefined ? this.canUndoForwardToSigning : <any>null;
        data["canTakeOverProcessing"] = this.canTakeOverProcessing !== undefined ? this.canTakeOverProcessing : <any>null;
        data["canChangeApplicationType"] = this.canChangeApplicationType !== undefined ? this.canChangeApplicationType : <any>null;
        data["canUpdateApplicationProfileImage"] = this.canUpdateApplicationProfileImage !== undefined ? this.canUpdateApplicationProfileImage : <any>null;
        data["canViewPrintPreview"] = this.canViewPrintPreview !== undefined ? this.canViewPrintPreview : <any>null;
        data["canDeleteApplication"] = this.canDeleteApplication !== undefined ? this.canDeleteApplication : <any>null;
        data["canViewIssuedApplicationPrintTemplate"] = this.canViewIssuedApplicationPrintTemplate !== undefined ? this.canViewIssuedApplicationPrintTemplate : <any>null;
        data["isOfficial"] = this.isOfficial !== undefined ? this.isOfficial : <any>null;
        return data;
    }
}

export interface IApplicationActions {
    canSetDocumentDeliveryMethod: boolean;
    canConfirmDocumentDeliveryAddress: boolean;
    canSubmit: boolean;
    canStartProcessing: boolean;
    canReject: boolean;
    canChangeApplication: boolean;
    canProcessRequirements: boolean;
    canFillRequirements: boolean;
    canAddQualifications: boolean;
    canFillDocumentSeed: boolean;
    canSignDocumentSeed: boolean;
    canRemoveDocumentSeedSignature: boolean;
    canIssueDocument: boolean;
    canViewDocumentIssuing: boolean;
    canConfirmDocumentDelivery: boolean;
    canForwardToSigning: boolean;
    canUndoForwardToSigning: boolean;
    canTakeOverProcessing: boolean;
    canChangeApplicationType: boolean;
    canUpdateApplicationProfileImage: boolean;
    canViewPrintPreview: boolean;
    canDeleteApplication: boolean;
    canViewIssuedApplicationPrintTemplate: boolean;
    isOfficial: boolean;
}

export class Provider implements IProvider {
    country!: string;
    bic!: string;
    name!: Name;
    longName!: LongName;
    url!: string;
    logo!: string;

    constructor(data?: IProvider) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.name = new Name();
            this.longName = new LongName();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.bic = _data["bic"] !== undefined ? _data["bic"] : <any>null;
            this.name = _data["name"] ? Name.fromJS(_data["name"]) : new Name();
            this.longName = _data["longName"] ? LongName.fromJS(_data["longName"]) : new LongName();
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
            this.logo = _data["logo"] !== undefined ? _data["logo"] : <any>null;
        }
    }

    static fromJS(data: any): Provider {
        data = typeof data === 'object' ? data : {};
        let result = new Provider();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["bic"] = this.bic !== undefined ? this.bic : <any>null;
        data["name"] = this.name ? this.name.toJSON() : <any>null;
        data["longName"] = this.longName ? this.longName.toJSON() : <any>null;
        data["url"] = this.url !== undefined ? this.url : <any>null;
        data["logo"] = this.logo !== undefined ? this.logo : <any>null;
        return data;
    }
}

export interface IProvider {
    country: string;
    bic: string;
    name: Name;
    longName: LongName;
    url: string;
    logo: string;
}

export class Name implements IName {
    ru!: string;
    lt!: string;
    en!: string;
    lv!: string;
    et!: string;

    constructor(data?: IName) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ru = _data["ru"] !== undefined ? _data["ru"] : <any>null;
            this.lt = _data["lt"] !== undefined ? _data["lt"] : <any>null;
            this.en = _data["en"] !== undefined ? _data["en"] : <any>null;
            this.lv = _data["lv"] !== undefined ? _data["lv"] : <any>null;
            this.et = _data["et"] !== undefined ? _data["et"] : <any>null;
        }
    }

    static fromJS(data: any): Name {
        data = typeof data === 'object' ? data : {};
        let result = new Name();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ru"] = this.ru !== undefined ? this.ru : <any>null;
        data["lt"] = this.lt !== undefined ? this.lt : <any>null;
        data["en"] = this.en !== undefined ? this.en : <any>null;
        data["lv"] = this.lv !== undefined ? this.lv : <any>null;
        data["et"] = this.et !== undefined ? this.et : <any>null;
        return data;
    }
}

export interface IName {
    ru: string;
    lt: string;
    en: string;
    lv: string;
    et: string;
}

export class LongName implements ILongName {
    ru!: string;
    lt!: string;
    en!: string;
    lv!: string;
    et!: string;

    constructor(data?: ILongName) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ru = _data["ru"] !== undefined ? _data["ru"] : <any>null;
            this.lt = _data["lt"] !== undefined ? _data["lt"] : <any>null;
            this.en = _data["en"] !== undefined ? _data["en"] : <any>null;
            this.lv = _data["lv"] !== undefined ? _data["lv"] : <any>null;
            this.et = _data["et"] !== undefined ? _data["et"] : <any>null;
        }
    }

    static fromJS(data: any): LongName {
        data = typeof data === 'object' ? data : {};
        let result = new LongName();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ru"] = this.ru !== undefined ? this.ru : <any>null;
        data["lt"] = this.lt !== undefined ? this.lt : <any>null;
        data["en"] = this.en !== undefined ? this.en : <any>null;
        data["lv"] = this.lv !== undefined ? this.lv : <any>null;
        data["et"] = this.et !== undefined ? this.et : <any>null;
        return data;
    }
}

export interface ILongName {
    ru: string;
    lt: string;
    en: string;
    lv: string;
    et: string;
}

export class Request implements IRequest {
    url!: string;
    requestBody!: Request1012;
    vK_MAC!: string;

    constructor(data?: IRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.requestBody = new Request1012();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"] !== undefined ? _data["url"] : <any>null;
            this.requestBody = _data["requestBody"] ? Request1012.fromJS(_data["requestBody"]) : new Request1012();
            this.vK_MAC = _data["vK_MAC"] !== undefined ? _data["vK_MAC"] : <any>null;
        }
    }

    static fromJS(data: any): Request {
        data = typeof data === 'object' ? data : {};
        let result = new Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url !== undefined ? this.url : <any>null;
        data["requestBody"] = this.requestBody ? this.requestBody.toJSON() : <any>null;
        data["vK_MAC"] = this.vK_MAC !== undefined ? this.vK_MAC : <any>null;
        return data;
    }
}

export interface IRequest {
    url: string;
    requestBody: Request1012;
    vK_MAC: string;
}

export class Request1012 implements IRequest1012 {
    vK_SERVICE!: string;
    vK_VERSION!: string;
    vK_SND_ID!: string;
    vK_STAMP!: string;
    vK_AMOUNT!: number;
    vK_CURR!: string;
    vK_REF!: string;
    vK_MSG!: string;
    vK_RETURN!: string;
    vK_CANCEL!: string;
    vK_DATETIME!: string;

    constructor(data?: IRequest1012) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vK_SERVICE = _data["vK_SERVICE"] !== undefined ? _data["vK_SERVICE"] : <any>null;
            this.vK_VERSION = _data["vK_VERSION"] !== undefined ? _data["vK_VERSION"] : <any>null;
            this.vK_SND_ID = _data["vK_SND_ID"] !== undefined ? _data["vK_SND_ID"] : <any>null;
            this.vK_STAMP = _data["vK_STAMP"] !== undefined ? _data["vK_STAMP"] : <any>null;
            this.vK_AMOUNT = _data["vK_AMOUNT"] !== undefined ? _data["vK_AMOUNT"] : <any>null;
            this.vK_CURR = _data["vK_CURR"] !== undefined ? _data["vK_CURR"] : <any>null;
            this.vK_REF = _data["vK_REF"] !== undefined ? _data["vK_REF"] : <any>null;
            this.vK_MSG = _data["vK_MSG"] !== undefined ? _data["vK_MSG"] : <any>null;
            this.vK_RETURN = _data["vK_RETURN"] !== undefined ? _data["vK_RETURN"] : <any>null;
            this.vK_CANCEL = _data["vK_CANCEL"] !== undefined ? _data["vK_CANCEL"] : <any>null;
            this.vK_DATETIME = _data["vK_DATETIME"] !== undefined ? _data["vK_DATETIME"] : <any>null;
        }
    }

    static fromJS(data: any): Request1012 {
        data = typeof data === 'object' ? data : {};
        let result = new Request1012();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vK_SERVICE"] = this.vK_SERVICE !== undefined ? this.vK_SERVICE : <any>null;
        data["vK_VERSION"] = this.vK_VERSION !== undefined ? this.vK_VERSION : <any>null;
        data["vK_SND_ID"] = this.vK_SND_ID !== undefined ? this.vK_SND_ID : <any>null;
        data["vK_STAMP"] = this.vK_STAMP !== undefined ? this.vK_STAMP : <any>null;
        data["vK_AMOUNT"] = this.vK_AMOUNT !== undefined ? this.vK_AMOUNT : <any>null;
        data["vK_CURR"] = this.vK_CURR !== undefined ? this.vK_CURR : <any>null;
        data["vK_REF"] = this.vK_REF !== undefined ? this.vK_REF : <any>null;
        data["vK_MSG"] = this.vK_MSG !== undefined ? this.vK_MSG : <any>null;
        data["vK_RETURN"] = this.vK_RETURN !== undefined ? this.vK_RETURN : <any>null;
        data["vK_CANCEL"] = this.vK_CANCEL !== undefined ? this.vK_CANCEL : <any>null;
        data["vK_DATETIME"] = this.vK_DATETIME !== undefined ? this.vK_DATETIME : <any>null;
        return data;
    }
}

export interface IRequest1012 {
    vK_SERVICE: string;
    vK_VERSION: string;
    vK_SND_ID: string;
    vK_STAMP: string;
    vK_AMOUNT: number;
    vK_CURR: string;
    vK_REF: string;
    vK_MSG: string;
    vK_RETURN: string;
    vK_CANCEL: string;
    vK_DATETIME: string;
}

export class CreateSwedbankBankLinkRequest implements ICreateSwedbankBankLinkRequest {
    bic?: string | null;
    cancelUrl?: string | null;
    returnUrl?: string | null;

    constructor(data?: ICreateSwedbankBankLinkRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bic = _data["bic"] !== undefined ? _data["bic"] : <any>null;
            this.cancelUrl = _data["cancelUrl"] !== undefined ? _data["cancelUrl"] : <any>null;
            this.returnUrl = _data["returnUrl"] !== undefined ? _data["returnUrl"] : <any>null;
        }
    }

    static fromJS(data: any): CreateSwedbankBankLinkRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSwedbankBankLinkRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bic"] = this.bic !== undefined ? this.bic : <any>null;
        data["cancelUrl"] = this.cancelUrl !== undefined ? this.cancelUrl : <any>null;
        data["returnUrl"] = this.returnUrl !== undefined ? this.returnUrl : <any>null;
        return data;
    }
}

export interface ICreateSwedbankBankLinkRequest {
    bic?: string | null;
    cancelUrl?: string | null;
    returnUrl?: string | null;
}

export class PaymentConfirmationRequest implements IPaymentConfirmationRequest {
    method?: string | null;
    receivedAt?: Date | null;
    documentNumber?: string | null;
    payer?: string | null;

    constructor(data?: IPaymentConfirmationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.method = _data["method"] !== undefined ? _data["method"] : <any>null;
            this.receivedAt = _data["receivedAt"] ? new Date(_data["receivedAt"].toString()) : <any>null;
            this.documentNumber = _data["documentNumber"] !== undefined ? _data["documentNumber"] : <any>null;
            this.payer = _data["payer"] !== undefined ? _data["payer"] : <any>null;
        }
    }

    static fromJS(data: any): PaymentConfirmationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentConfirmationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["method"] = this.method !== undefined ? this.method : <any>null;
        data["receivedAt"] = this.receivedAt ? this.receivedAt.toISOString() : <any>null;
        data["documentNumber"] = this.documentNumber !== undefined ? this.documentNumber : <any>null;
        data["payer"] = this.payer !== undefined ? this.payer : <any>null;
        return data;
    }
}

export interface IPaymentConfirmationRequest {
    method?: string | null;
    receivedAt?: Date | null;
    documentNumber?: string | null;
    payer?: string | null;
}

export class PaymentRefundRequest implements IPaymentRefundRequest {
    refundedAt?: Date | null;
    comment?: string | null;

    constructor(data?: IPaymentRefundRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.refundedAt = _data["refundedAt"] ? new Date(_data["refundedAt"].toString()) : <any>null;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
        }
    }

    static fromJS(data: any): PaymentRefundRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentRefundRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["refundedAt"] = this.refundedAt ? this.refundedAt.toISOString() : <any>null;
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        return data;
    }
}

export interface IPaymentRefundRequest {
    refundedAt?: Date | null;
    comment?: string | null;
}

export class PracticeRequirementCandidateModel implements IPracticeRequirementCandidateModel {
    id!: string;
    organizationName?: string | null;
    type!: PracticeType;
    pilotageType?: PilotageType | null;
    kind!: PracticeKind;
    hasCargoOperationsOrHarbourVisits!: boolean;
    startedOn!: Date;
    endedOn!: Date;
    issuedOn!: Date;
    status!: ValidityStatus;
    maxSuitablePeriodDays!: number;
    positionName?: string | null;
    practicePeriods!: PracticePeriod[];
    seafaringDetails?: SeafaringProperties | null;
    positionId?: PositionId | null;
    isDeleted!: boolean;

    constructor(data?: IPracticeRequirementCandidateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.practicePeriods = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.organizationName = _data["organizationName"] !== undefined ? _data["organizationName"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.pilotageType = _data["pilotageType"] !== undefined ? _data["pilotageType"] : <any>null;
            this.kind = _data["kind"] !== undefined ? _data["kind"] : <any>null;
            this.hasCargoOperationsOrHarbourVisits = _data["hasCargoOperationsOrHarbourVisits"] !== undefined ? _data["hasCargoOperationsOrHarbourVisits"] : <any>null;
            this.startedOn = _data["startedOn"] ? new Date(_data["startedOn"].toString()) : <any>null;
            this.endedOn = _data["endedOn"] ? new Date(_data["endedOn"].toString()) : <any>null;
            this.issuedOn = _data["issuedOn"] ? new Date(_data["issuedOn"].toString()) : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.maxSuitablePeriodDays = _data["maxSuitablePeriodDays"] !== undefined ? _data["maxSuitablePeriodDays"] : <any>null;
            this.positionName = _data["positionName"] !== undefined ? _data["positionName"] : <any>null;
            if (Array.isArray(_data["practicePeriods"])) {
                this.practicePeriods = [] as any;
                for (let item of _data["practicePeriods"])
                    this.practicePeriods!.push(PracticePeriod.fromJS(item));
            }
            else {
                this.practicePeriods = <any>null;
            }
            this.seafaringDetails = _data["seafaringDetails"] ? SeafaringProperties.fromJS(_data["seafaringDetails"]) : <any>null;
            this.positionId = _data["positionId"] ? PositionId.fromJS(_data["positionId"]) : <any>null;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : <any>null;
        }
    }

    static fromJS(data: any): PracticeRequirementCandidateModel {
        data = typeof data === 'object' ? data : {};
        let result = new PracticeRequirementCandidateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["organizationName"] = this.organizationName !== undefined ? this.organizationName : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["pilotageType"] = this.pilotageType !== undefined ? this.pilotageType : <any>null;
        data["kind"] = this.kind !== undefined ? this.kind : <any>null;
        data["hasCargoOperationsOrHarbourVisits"] = this.hasCargoOperationsOrHarbourVisits !== undefined ? this.hasCargoOperationsOrHarbourVisits : <any>null;
        data["startedOn"] = this.startedOn ? this.startedOn.toISOString() : <any>null;
        data["endedOn"] = this.endedOn ? this.endedOn.toISOString() : <any>null;
        data["issuedOn"] = this.issuedOn ? this.issuedOn.toISOString() : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["maxSuitablePeriodDays"] = this.maxSuitablePeriodDays !== undefined ? this.maxSuitablePeriodDays : <any>null;
        data["positionName"] = this.positionName !== undefined ? this.positionName : <any>null;
        if (Array.isArray(this.practicePeriods)) {
            data["practicePeriods"] = [];
            for (let item of this.practicePeriods)
                data["practicePeriods"].push(item.toJSON());
        }
        data["seafaringDetails"] = this.seafaringDetails ? this.seafaringDetails.toJSON() : <any>null;
        data["positionId"] = this.positionId ? this.positionId.toJSON() : <any>null;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : <any>null;
        return data;
    }
}

export interface IPracticeRequirementCandidateModel {
    id: string;
    organizationName?: string | null;
    type: PracticeType;
    pilotageType?: PilotageType | null;
    kind: PracticeKind;
    hasCargoOperationsOrHarbourVisits: boolean;
    startedOn: Date;
    endedOn: Date;
    issuedOn: Date;
    status: ValidityStatus;
    maxSuitablePeriodDays: number;
    positionName?: string | null;
    practicePeriods: PracticePeriod[];
    seafaringDetails?: SeafaringProperties | null;
    positionId?: PositionId | null;
    isDeleted: boolean;
}

export class ChosenPractices implements IChosenPractices {
    practices!: PracticeRequirementCandidateModel[];
    error!: ResultError;
    suitableEducationalPracticePeriodDays!: number;
    suitableWorkPracticePeriodDays!: number;
    totalSuitablePracticePeriodDays!: number;
    educationalPracticePeriodDays!: number;
    workPracticePeriodDays!: number;
    totalPracticePeriodDays!: number;
    educationalPracticePeriodCount!: number;
    workPracticePeriodCount!: number;
    totalPracticePeriodCount!: number;
    suitableEducationalPracticePeriodCount!: number;
    suitableWorkPracticePeriodCount!: number;
    totalSuitablePracticePeriodCount!: number;
    totalSuitableEducationalNavigationalWatchDays!: number;
    totalSuitableEducationalEngineWatchDays!: number;
    totalSuitableWorkNavigationalWatchDays!: number;
    totalSuitableWorkEngineWatchDays!: number;
    totalEducationalNavigationalWatchDays!: number;
    totalEducationalEngineWatchDays!: number;
    totalWorkNavigationalWatchDays!: number;
    totalWorkEngineWatchDays!: number;

    constructor(data?: IChosenPractices) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.practices = [];
            this.error = new ResultError();
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["practices"])) {
                this.practices = [] as any;
                for (let item of _data["practices"])
                    this.practices!.push(PracticeRequirementCandidateModel.fromJS(item));
            }
            else {
                this.practices = <any>null;
            }
            this.error = _data["error"] ? ResultError.fromJS(_data["error"]) : new ResultError();
            this.suitableEducationalPracticePeriodDays = _data["suitableEducationalPracticePeriodDays"] !== undefined ? _data["suitableEducationalPracticePeriodDays"] : <any>null;
            this.suitableWorkPracticePeriodDays = _data["suitableWorkPracticePeriodDays"] !== undefined ? _data["suitableWorkPracticePeriodDays"] : <any>null;
            this.totalSuitablePracticePeriodDays = _data["totalSuitablePracticePeriodDays"] !== undefined ? _data["totalSuitablePracticePeriodDays"] : <any>null;
            this.educationalPracticePeriodDays = _data["educationalPracticePeriodDays"] !== undefined ? _data["educationalPracticePeriodDays"] : <any>null;
            this.workPracticePeriodDays = _data["workPracticePeriodDays"] !== undefined ? _data["workPracticePeriodDays"] : <any>null;
            this.totalPracticePeriodDays = _data["totalPracticePeriodDays"] !== undefined ? _data["totalPracticePeriodDays"] : <any>null;
            this.educationalPracticePeriodCount = _data["educationalPracticePeriodCount"] !== undefined ? _data["educationalPracticePeriodCount"] : <any>null;
            this.workPracticePeriodCount = _data["workPracticePeriodCount"] !== undefined ? _data["workPracticePeriodCount"] : <any>null;
            this.totalPracticePeriodCount = _data["totalPracticePeriodCount"] !== undefined ? _data["totalPracticePeriodCount"] : <any>null;
            this.suitableEducationalPracticePeriodCount = _data["suitableEducationalPracticePeriodCount"] !== undefined ? _data["suitableEducationalPracticePeriodCount"] : <any>null;
            this.suitableWorkPracticePeriodCount = _data["suitableWorkPracticePeriodCount"] !== undefined ? _data["suitableWorkPracticePeriodCount"] : <any>null;
            this.totalSuitablePracticePeriodCount = _data["totalSuitablePracticePeriodCount"] !== undefined ? _data["totalSuitablePracticePeriodCount"] : <any>null;
            this.totalSuitableEducationalNavigationalWatchDays = _data["totalSuitableEducationalNavigationalWatchDays"] !== undefined ? _data["totalSuitableEducationalNavigationalWatchDays"] : <any>null;
            this.totalSuitableEducationalEngineWatchDays = _data["totalSuitableEducationalEngineWatchDays"] !== undefined ? _data["totalSuitableEducationalEngineWatchDays"] : <any>null;
            this.totalSuitableWorkNavigationalWatchDays = _data["totalSuitableWorkNavigationalWatchDays"] !== undefined ? _data["totalSuitableWorkNavigationalWatchDays"] : <any>null;
            this.totalSuitableWorkEngineWatchDays = _data["totalSuitableWorkEngineWatchDays"] !== undefined ? _data["totalSuitableWorkEngineWatchDays"] : <any>null;
            this.totalEducationalNavigationalWatchDays = _data["totalEducationalNavigationalWatchDays"] !== undefined ? _data["totalEducationalNavigationalWatchDays"] : <any>null;
            this.totalEducationalEngineWatchDays = _data["totalEducationalEngineWatchDays"] !== undefined ? _data["totalEducationalEngineWatchDays"] : <any>null;
            this.totalWorkNavigationalWatchDays = _data["totalWorkNavigationalWatchDays"] !== undefined ? _data["totalWorkNavigationalWatchDays"] : <any>null;
            this.totalWorkEngineWatchDays = _data["totalWorkEngineWatchDays"] !== undefined ? _data["totalWorkEngineWatchDays"] : <any>null;
        }
    }

    static fromJS(data: any): ChosenPractices {
        data = typeof data === 'object' ? data : {};
        let result = new ChosenPractices();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.practices)) {
            data["practices"] = [];
            for (let item of this.practices)
                data["practices"].push(item.toJSON());
        }
        data["error"] = this.error ? this.error.toJSON() : <any>null;
        data["suitableEducationalPracticePeriodDays"] = this.suitableEducationalPracticePeriodDays !== undefined ? this.suitableEducationalPracticePeriodDays : <any>null;
        data["suitableWorkPracticePeriodDays"] = this.suitableWorkPracticePeriodDays !== undefined ? this.suitableWorkPracticePeriodDays : <any>null;
        data["totalSuitablePracticePeriodDays"] = this.totalSuitablePracticePeriodDays !== undefined ? this.totalSuitablePracticePeriodDays : <any>null;
        data["educationalPracticePeriodDays"] = this.educationalPracticePeriodDays !== undefined ? this.educationalPracticePeriodDays : <any>null;
        data["workPracticePeriodDays"] = this.workPracticePeriodDays !== undefined ? this.workPracticePeriodDays : <any>null;
        data["totalPracticePeriodDays"] = this.totalPracticePeriodDays !== undefined ? this.totalPracticePeriodDays : <any>null;
        data["educationalPracticePeriodCount"] = this.educationalPracticePeriodCount !== undefined ? this.educationalPracticePeriodCount : <any>null;
        data["workPracticePeriodCount"] = this.workPracticePeriodCount !== undefined ? this.workPracticePeriodCount : <any>null;
        data["totalPracticePeriodCount"] = this.totalPracticePeriodCount !== undefined ? this.totalPracticePeriodCount : <any>null;
        data["suitableEducationalPracticePeriodCount"] = this.suitableEducationalPracticePeriodCount !== undefined ? this.suitableEducationalPracticePeriodCount : <any>null;
        data["suitableWorkPracticePeriodCount"] = this.suitableWorkPracticePeriodCount !== undefined ? this.suitableWorkPracticePeriodCount : <any>null;
        data["totalSuitablePracticePeriodCount"] = this.totalSuitablePracticePeriodCount !== undefined ? this.totalSuitablePracticePeriodCount : <any>null;
        data["totalSuitableEducationalNavigationalWatchDays"] = this.totalSuitableEducationalNavigationalWatchDays !== undefined ? this.totalSuitableEducationalNavigationalWatchDays : <any>null;
        data["totalSuitableEducationalEngineWatchDays"] = this.totalSuitableEducationalEngineWatchDays !== undefined ? this.totalSuitableEducationalEngineWatchDays : <any>null;
        data["totalSuitableWorkNavigationalWatchDays"] = this.totalSuitableWorkNavigationalWatchDays !== undefined ? this.totalSuitableWorkNavigationalWatchDays : <any>null;
        data["totalSuitableWorkEngineWatchDays"] = this.totalSuitableWorkEngineWatchDays !== undefined ? this.totalSuitableWorkEngineWatchDays : <any>null;
        data["totalEducationalNavigationalWatchDays"] = this.totalEducationalNavigationalWatchDays !== undefined ? this.totalEducationalNavigationalWatchDays : <any>null;
        data["totalEducationalEngineWatchDays"] = this.totalEducationalEngineWatchDays !== undefined ? this.totalEducationalEngineWatchDays : <any>null;
        data["totalWorkNavigationalWatchDays"] = this.totalWorkNavigationalWatchDays !== undefined ? this.totalWorkNavigationalWatchDays : <any>null;
        data["totalWorkEngineWatchDays"] = this.totalWorkEngineWatchDays !== undefined ? this.totalWorkEngineWatchDays : <any>null;
        return data;
    }
}

export interface IChosenPractices {
    practices: PracticeRequirementCandidateModel[];
    error: ResultError;
    suitableEducationalPracticePeriodDays: number;
    suitableWorkPracticePeriodDays: number;
    totalSuitablePracticePeriodDays: number;
    educationalPracticePeriodDays: number;
    workPracticePeriodDays: number;
    totalPracticePeriodDays: number;
    educationalPracticePeriodCount: number;
    workPracticePeriodCount: number;
    totalPracticePeriodCount: number;
    suitableEducationalPracticePeriodCount: number;
    suitableWorkPracticePeriodCount: number;
    totalSuitablePracticePeriodCount: number;
    totalSuitableEducationalNavigationalWatchDays: number;
    totalSuitableEducationalEngineWatchDays: number;
    totalSuitableWorkNavigationalWatchDays: number;
    totalSuitableWorkEngineWatchDays: number;
    totalEducationalNavigationalWatchDays: number;
    totalEducationalEngineWatchDays: number;
    totalWorkNavigationalWatchDays: number;
    totalWorkEngineWatchDays: number;
}

export class ChosenPayment implements IChosenPayment {
    payment!: PaymentViewModel;
    validationError!: ResultError;

    constructor(data?: IChosenPayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.payment = new PaymentViewModel();
            this.validationError = new ResultError();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.payment = _data["payment"] ? PaymentViewModel.fromJS(_data["payment"]) : new PaymentViewModel();
            this.validationError = _data["validationError"] ? ResultError.fromJS(_data["validationError"]) : new ResultError();
        }
    }

    static fromJS(data: any): ChosenPayment {
        data = typeof data === 'object' ? data : {};
        let result = new ChosenPayment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payment"] = this.payment ? this.payment.toJSON() : <any>null;
        data["validationError"] = this.validationError ? this.validationError.toJSON() : <any>null;
        return data;
    }
}

export interface IChosenPayment {
    payment: PaymentViewModel;
    validationError: ResultError;
}

export class MakeRequirementProcessingDecisionRequest implements IMakeRequirementProcessingDecisionRequest {
    comment!: string;
    requirementDecision!: ProcessingDecisionType;

    constructor(data?: IMakeRequirementProcessingDecisionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
            this.requirementDecision = _data["requirementDecision"] !== undefined ? _data["requirementDecision"] : <any>null;
        }
    }

    static fromJS(data: any): MakeRequirementProcessingDecisionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MakeRequirementProcessingDecisionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        data["requirementDecision"] = this.requirementDecision !== undefined ? this.requirementDecision : <any>null;
        return data;
    }
}

export interface IMakeRequirementProcessingDecisionRequest {
    comment: string;
    requirementDecision: ProcessingDecisionType;
}

export abstract class IssueDocumentDetailsApiModel implements IIssueDocumentDetailsApiModel {
    signature?: OfficialSignatureApiModel | null;
    seafarerId!: string;
    seafarerName!: string;
    /** Väljastamise kuupäev  */
    issueDate?: Date | null;
    /** Lisainfo */
    additionalInfo?: string | null;

    protected _discriminator: string;

    constructor(data?: IIssueDocumentDetailsApiModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "IssueDocumentDetailsApiModel";
    }

    init(_data?: any) {
        if (_data) {
            this.signature = _data["signature"] ? OfficialSignatureApiModel.fromJS(_data["signature"]) : <any>null;
            this.seafarerId = _data["seafarerId"] !== undefined ? _data["seafarerId"] : <any>null;
            this.seafarerName = _data["seafarerName"] !== undefined ? _data["seafarerName"] : <any>null;
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : <any>null;
            this.additionalInfo = _data["additionalInfo"] !== undefined ? _data["additionalInfo"] : <any>null;
        }
    }

    static fromJS(data: any): IssueDocumentDetailsApiModel {
        data = typeof data === 'object' ? data : {};
        if (data["type"] === "SeagoingShipDocumentApiModel") {
            let result = new SeagoingShipDocumentApiModel();
            result.init(data);
            return result;
        }
        if (data["type"] === "IssueCertificateDocumentDetailsApiModel") {
            throw new Error("The abstract class 'IssueCertificateDocumentDetailsApiModel' cannot be instantiated.");
        }
        if (data["type"] === "InlandVesselDocumentApiModel") {
            let result = new InlandVesselDocumentApiModel();
            result.init(data);
            return result;
        }
        if (data["type"] === "MaritimePilotCertificateDocumentApiModel") {
            let result = new MaritimePilotCertificateDocumentApiModel();
            result.init(data);
            return result;
        }
        if (data["type"] === "SeniorMaritimePilotCertificateDocumentApiModel") {
            let result = new SeniorMaritimePilotCertificateDocumentApiModel();
            result.init(data);
            return result;
        }
        if (data["type"] === "PortPilotCertificateDocumentApiModel") {
            let result = new PortPilotCertificateDocumentApiModel();
            result.init(data);
            return result;
        }
        if (data["type"] === "OpenSeaPilotCertificateDocumentApiModel") {
            let result = new OpenSeaPilotCertificateDocumentApiModel();
            result.init(data);
            return result;
        }
        if (data["type"] === "FastFerryMasterCertificateDocumentApiModel") {
            let result = new FastFerryMasterCertificateDocumentApiModel();
            result.init(data);
            return result;
        }
        if (data["type"] === "PilotCertificateDocumentApiModel") {
            let result = new PilotCertificateDocumentApiModel();
            result.init(data);
            return result;
        }
        if (data["type"] === "ConcessionPermitDocumentApiModel") {
            let result = new ConcessionPermitDocumentApiModel();
            result.init(data);
            return result;
        }
        if (data["type"] === "PilotlessSeafaringDocumentApiModel") {
            let result = new PilotlessSeafaringDocumentApiModel();
            result.init(data);
            return result;
        }
        if (data["type"] === "HarbourPilotExemptionCertificateDocumentApiModel") {
            let result = new HarbourPilotExemptionCertificateDocumentApiModel();
            result.init(data);
            return result;
        }
        if (data["type"] === "MaritimeCertificateDocumentApiModel") {
            let result = new MaritimeCertificateDocumentApiModel();
            result.init(data);
            return result;
        }
        if (data["type"] === "EndorsementDocumentApiModel") {
            let result = new EndorsementDocumentApiModel();
            result.init(data);
            return result;
        }
        if (data["type"] === "FastFerryEndorsementDocumentApiModel") {
            let result = new FastFerryEndorsementDocumentApiModel();
            result.init(data);
            return result;
        }
        if (data["type"] === "DocumentDuplicateDetailsModel") {
            let result = new DocumentDuplicateDetailsModel();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'IssueDocumentDetailsApiModel' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this._discriminator;
        data["signature"] = this.signature ? this.signature.toJSON() : <any>null;
        data["seafarerId"] = this.seafarerId !== undefined ? this.seafarerId : <any>null;
        data["seafarerName"] = this.seafarerName !== undefined ? this.seafarerName : <any>null;
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>null;
        data["additionalInfo"] = this.additionalInfo !== undefined ? this.additionalInfo : <any>null;
        return data;
    }
}

export interface IIssueDocumentDetailsApiModel {
    signature?: OfficialSignatureApiModel | null;
    seafarerId: string;
    seafarerName: string;
    /** Väljastamise kuupäev  */
    issueDate?: Date | null;
    /** Lisainfo */
    additionalInfo?: string | null;
}

export abstract class IssueCertificateDocumentDetailsApiModel extends IssueDocumentDetailsApiModel implements IIssueCertificateDocumentDetailsApiModel {
    certificateDocumentType!: string;
    certificateTypeName!: string;

    constructor(data?: IIssueCertificateDocumentDetailsApiModel) {
        super(data);
        this._discriminator = "IssueCertificateDocumentDetailsApiModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.certificateDocumentType = _data["certificateDocumentType"] !== undefined ? _data["certificateDocumentType"] : <any>null;
            this.certificateTypeName = _data["certificateTypeName"] !== undefined ? _data["certificateTypeName"] : <any>null;
        }
    }

    static fromJS(data: any): IssueCertificateDocumentDetailsApiModel {
        data = typeof data === 'object' ? data : {};
        if (data["type"] === "SeagoingShipDocumentApiModel") {
            let result = new SeagoingShipDocumentApiModel();
            result.init(data);
            return result;
        }
        if (data["type"] === "InlandVesselDocumentApiModel") {
            let result = new InlandVesselDocumentApiModel();
            result.init(data);
            return result;
        }
        if (data["type"] === "MaritimePilotCertificateDocumentApiModel") {
            let result = new MaritimePilotCertificateDocumentApiModel();
            result.init(data);
            return result;
        }
        if (data["type"] === "SeniorMaritimePilotCertificateDocumentApiModel") {
            let result = new SeniorMaritimePilotCertificateDocumentApiModel();
            result.init(data);
            return result;
        }
        if (data["type"] === "PortPilotCertificateDocumentApiModel") {
            let result = new PortPilotCertificateDocumentApiModel();
            result.init(data);
            return result;
        }
        if (data["type"] === "OpenSeaPilotCertificateDocumentApiModel") {
            let result = new OpenSeaPilotCertificateDocumentApiModel();
            result.init(data);
            return result;
        }
        if (data["type"] === "FastFerryMasterCertificateDocumentApiModel") {
            let result = new FastFerryMasterCertificateDocumentApiModel();
            result.init(data);
            return result;
        }
        if (data["type"] === "PilotCertificateDocumentApiModel") {
            let result = new PilotCertificateDocumentApiModel();
            result.init(data);
            return result;
        }
        if (data["type"] === "ConcessionPermitDocumentApiModel") {
            let result = new ConcessionPermitDocumentApiModel();
            result.init(data);
            return result;
        }
        if (data["type"] === "PilotlessSeafaringDocumentApiModel") {
            let result = new PilotlessSeafaringDocumentApiModel();
            result.init(data);
            return result;
        }
        if (data["type"] === "HarbourPilotExemptionCertificateDocumentApiModel") {
            let result = new HarbourPilotExemptionCertificateDocumentApiModel();
            result.init(data);
            return result;
        }
        if (data["type"] === "MaritimeCertificateDocumentApiModel") {
            let result = new MaritimeCertificateDocumentApiModel();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'IssueCertificateDocumentDetailsApiModel' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["certificateDocumentType"] = this.certificateDocumentType !== undefined ? this.certificateDocumentType : <any>null;
        data["certificateTypeName"] = this.certificateTypeName !== undefined ? this.certificateTypeName : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIssueCertificateDocumentDetailsApiModel extends IIssueDocumentDetailsApiModel {
    certificateDocumentType: string;
    certificateTypeName: string;
}

export class SeagoingShipDocumentApiModel extends IssueCertificateDocumentDetailsApiModel implements ISeagoingShipDocumentApiModel {
    /** Väljastaja riik */
    issuerCountry?: string | null;
    /** Kehtiv kuni */
    validUntil?: Date | null;

    constructor(data?: ISeagoingShipDocumentApiModel) {
        super(data);
        this._discriminator = "SeagoingShipDocumentApiModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.issuerCountry = _data["issuerCountry"] !== undefined ? _data["issuerCountry"] : <any>null;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): SeagoingShipDocumentApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new SeagoingShipDocumentApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issuerCountry"] = this.issuerCountry !== undefined ? this.issuerCountry : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISeagoingShipDocumentApiModel extends IIssueCertificateDocumentDetailsApiModel {
    /** Väljastaja riik */
    issuerCountry?: string | null;
    /** Kehtiv kuni */
    validUntil?: Date | null;
}

export class InlandVesselDocumentApiModel extends IssueCertificateDocumentDetailsApiModel implements IInlandVesselDocumentApiModel {

    constructor(data?: IInlandVesselDocumentApiModel) {
        super(data);
        this._discriminator = "InlandVesselDocumentApiModel";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): InlandVesselDocumentApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new InlandVesselDocumentApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IInlandVesselDocumentApiModel extends IIssueCertificateDocumentDetailsApiModel {
}

/** Maritime Pilot Certificate document API model */
export class MaritimePilotCertificateDocumentApiModel extends IssueCertificateDocumentDetailsApiModel implements IMaritimePilotCertificateDocumentApiModel {
    /** Issuer country (Väljastaja riik) */
    issuerCountry?: string | null;
    /** Valid until date (Kehtiv kuni) */
    validUntil?: Date | null;
    /** Ship gross tonnage limit (Laeva GT) */
    shipGrossTonnage?: number | null;
    /** Tanker gross tonnage limit (Tankeri GT) */
    tankerGrossTonnage?: number | null;
    /** Selected pilotage area IDs (Lootsimispiirkonnad) */
    pilotageAreaIds!: string[];

    constructor(data?: IMaritimePilotCertificateDocumentApiModel) {
        super(data);
        if (!data) {
            this.pilotageAreaIds = [];
        }
        this._discriminator = "MaritimePilotCertificateDocumentApiModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.issuerCountry = _data["issuerCountry"] !== undefined ? _data["issuerCountry"] : <any>null;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : <any>null;
            this.shipGrossTonnage = _data["shipGrossTonnage"] !== undefined ? _data["shipGrossTonnage"] : <any>null;
            this.tankerGrossTonnage = _data["tankerGrossTonnage"] !== undefined ? _data["tankerGrossTonnage"] : <any>null;
            if (Array.isArray(_data["pilotageAreaIds"])) {
                this.pilotageAreaIds = [] as any;
                for (let item of _data["pilotageAreaIds"])
                    this.pilotageAreaIds!.push(item);
            }
            else {
                this.pilotageAreaIds = <any>null;
            }
        }
    }

    static fromJS(data: any): MaritimePilotCertificateDocumentApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new MaritimePilotCertificateDocumentApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issuerCountry"] = this.issuerCountry !== undefined ? this.issuerCountry : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : <any>null;
        data["shipGrossTonnage"] = this.shipGrossTonnage !== undefined ? this.shipGrossTonnage : <any>null;
        data["tankerGrossTonnage"] = this.tankerGrossTonnage !== undefined ? this.tankerGrossTonnage : <any>null;
        if (Array.isArray(this.pilotageAreaIds)) {
            data["pilotageAreaIds"] = [];
            for (let item of this.pilotageAreaIds)
                data["pilotageAreaIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

/** Maritime Pilot Certificate document API model */
export interface IMaritimePilotCertificateDocumentApiModel extends IIssueCertificateDocumentDetailsApiModel {
    /** Issuer country (Väljastaja riik) */
    issuerCountry?: string | null;
    /** Valid until date (Kehtiv kuni) */
    validUntil?: Date | null;
    /** Ship gross tonnage limit (Laeva GT) */
    shipGrossTonnage?: number | null;
    /** Tanker gross tonnage limit (Tankeri GT) */
    tankerGrossTonnage?: number | null;
    /** Selected pilotage area IDs (Lootsimispiirkonnad) */
    pilotageAreaIds: string[];
}

/** Senior Maritime Pilot Certificate document API model */
export class SeniorMaritimePilotCertificateDocumentApiModel extends IssueCertificateDocumentDetailsApiModel implements ISeniorMaritimePilotCertificateDocumentApiModel {
    /** Issuer country (Väljastaja riik) */
    issuerCountry?: string | null;
    /** Valid until date (Kehtiv kuni) */
    validUntil?: Date | null;
    /** Ship gross tonnage limit (Laeva GT) - No validation for Senior Pilot */
    shipGrossTonnage?: number | null;
    /** Tanker gross tonnage limit (Tankeri GT) - No validation for Senior Pilot */
    tankerGrossTonnage?: number | null;
    /** Selected pilotage area IDs (Lootsimispiirkonnad) */
    pilotageAreaIds!: string[];

    constructor(data?: ISeniorMaritimePilotCertificateDocumentApiModel) {
        super(data);
        if (!data) {
            this.pilotageAreaIds = [];
        }
        this._discriminator = "SeniorMaritimePilotCertificateDocumentApiModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.issuerCountry = _data["issuerCountry"] !== undefined ? _data["issuerCountry"] : <any>null;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : <any>null;
            this.shipGrossTonnage = _data["shipGrossTonnage"] !== undefined ? _data["shipGrossTonnage"] : <any>null;
            this.tankerGrossTonnage = _data["tankerGrossTonnage"] !== undefined ? _data["tankerGrossTonnage"] : <any>null;
            if (Array.isArray(_data["pilotageAreaIds"])) {
                this.pilotageAreaIds = [] as any;
                for (let item of _data["pilotageAreaIds"])
                    this.pilotageAreaIds!.push(item);
            }
            else {
                this.pilotageAreaIds = <any>null;
            }
        }
    }

    static fromJS(data: any): SeniorMaritimePilotCertificateDocumentApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new SeniorMaritimePilotCertificateDocumentApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issuerCountry"] = this.issuerCountry !== undefined ? this.issuerCountry : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : <any>null;
        data["shipGrossTonnage"] = this.shipGrossTonnage !== undefined ? this.shipGrossTonnage : <any>null;
        data["tankerGrossTonnage"] = this.tankerGrossTonnage !== undefined ? this.tankerGrossTonnage : <any>null;
        if (Array.isArray(this.pilotageAreaIds)) {
            data["pilotageAreaIds"] = [];
            for (let item of this.pilotageAreaIds)
                data["pilotageAreaIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

/** Senior Maritime Pilot Certificate document API model */
export interface ISeniorMaritimePilotCertificateDocumentApiModel extends IIssueCertificateDocumentDetailsApiModel {
    /** Issuer country (Väljastaja riik) */
    issuerCountry?: string | null;
    /** Valid until date (Kehtiv kuni) */
    validUntil?: Date | null;
    /** Ship gross tonnage limit (Laeva GT) - No validation for Senior Pilot */
    shipGrossTonnage?: number | null;
    /** Tanker gross tonnage limit (Tankeri GT) - No validation for Senior Pilot */
    tankerGrossTonnage?: number | null;
    /** Selected pilotage area IDs (Lootsimispiirkonnad) */
    pilotageAreaIds: string[];
}

/** Port Pilot Certificate document API model (Sadamalootsi kutsetunnistus) */
export class PortPilotCertificateDocumentApiModel extends IssueCertificateDocumentDetailsApiModel implements IPortPilotCertificateDocumentApiModel {
    /** Issuer country (Väljastaja riik) */
    issuerCountry?: string | null;
    /** Valid until date (Kehtiv kuni) */
    validUntil?: Date | null;
    /** Harbour ID (Sadam)
Certificate is for one specific harbour/port */
    harbourId?: string | null;

    constructor(data?: IPortPilotCertificateDocumentApiModel) {
        super(data);
        this._discriminator = "PortPilotCertificateDocumentApiModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.issuerCountry = _data["issuerCountry"] !== undefined ? _data["issuerCountry"] : <any>null;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : <any>null;
            this.harbourId = _data["harbourId"] !== undefined ? _data["harbourId"] : <any>null;
        }
    }

    static fromJS(data: any): PortPilotCertificateDocumentApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new PortPilotCertificateDocumentApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issuerCountry"] = this.issuerCountry !== undefined ? this.issuerCountry : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : <any>null;
        data["harbourId"] = this.harbourId !== undefined ? this.harbourId : <any>null;
        super.toJSON(data);
        return data;
    }
}

/** Port Pilot Certificate document API model (Sadamalootsi kutsetunnistus) */
export interface IPortPilotCertificateDocumentApiModel extends IIssueCertificateDocumentDetailsApiModel {
    /** Issuer country (Väljastaja riik) */
    issuerCountry?: string | null;
    /** Valid until date (Kehtiv kuni) */
    validUntil?: Date | null;
    /** Harbour ID (Sadam)
Certificate is for one specific harbour/port */
    harbourId?: string | null;
}

/** Open Sea Pilot Certificate document API model (Avamerelootsi kutsetunnistus) */
export class OpenSeaPilotCertificateDocumentApiModel extends IssueCertificateDocumentDetailsApiModel implements IOpenSeaPilotCertificateDocumentApiModel {
    /** Issuer country (Väljastaja riik) */
    issuerCountry?: string | null;
    /** Valid until date (Kehtiv kuni) */
    validUntil?: Date | null;
    /** Pilotage area IDs (Lootsimispiirkonnad)
Certificate is valid for multiple selected pilotage areas */
    pilotageAreaIds!: string[];

    constructor(data?: IOpenSeaPilotCertificateDocumentApiModel) {
        super(data);
        if (!data) {
            this.pilotageAreaIds = [];
        }
        this._discriminator = "OpenSeaPilotCertificateDocumentApiModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.issuerCountry = _data["issuerCountry"] !== undefined ? _data["issuerCountry"] : <any>null;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : <any>null;
            if (Array.isArray(_data["pilotageAreaIds"])) {
                this.pilotageAreaIds = [] as any;
                for (let item of _data["pilotageAreaIds"])
                    this.pilotageAreaIds!.push(item);
            }
            else {
                this.pilotageAreaIds = <any>null;
            }
        }
    }

    static fromJS(data: any): OpenSeaPilotCertificateDocumentApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new OpenSeaPilotCertificateDocumentApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issuerCountry"] = this.issuerCountry !== undefined ? this.issuerCountry : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : <any>null;
        if (Array.isArray(this.pilotageAreaIds)) {
            data["pilotageAreaIds"] = [];
            for (let item of this.pilotageAreaIds)
                data["pilotageAreaIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

/** Open Sea Pilot Certificate document API model (Avamerelootsi kutsetunnistus) */
export interface IOpenSeaPilotCertificateDocumentApiModel extends IIssueCertificateDocumentDetailsApiModel {
    /** Issuer country (Väljastaja riik) */
    issuerCountry?: string | null;
    /** Valid until date (Kehtiv kuni) */
    validUntil?: Date | null;
    /** Pilotage area IDs (Lootsimispiirkonnad)
Certificate is valid for multiple selected pilotage areas */
    pilotageAreaIds: string[];
}

/** Fast Ferry Master Certificate document API model (TR Kiirlaeva laevajuhi tunnistus) */
export class FastFerryMasterCertificateDocumentApiModel extends IssueCertificateDocumentDetailsApiModel implements IFastFerryMasterCertificateDocumentApiModel {
    /** Issuer country (Väljastaja riik) */
    issuerCountry?: string | null;
    /** Valid until date (Kehtiv kuni) */
    validUntil?: Date | null;
    /** Ship IDs (Laevad)
Multiple ships can be selected for which the certificate is valid */
    shipIds!: string[];
    /** Shipping line/route IDs (Sõiduliinid)
Navigation areas of type ShippingLine */
    shippingLineIds!: string[];

    constructor(data?: IFastFerryMasterCertificateDocumentApiModel) {
        super(data);
        if (!data) {
            this.shipIds = [];
            this.shippingLineIds = [];
        }
        this._discriminator = "FastFerryMasterCertificateDocumentApiModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.issuerCountry = _data["issuerCountry"] !== undefined ? _data["issuerCountry"] : <any>null;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : <any>null;
            if (Array.isArray(_data["shipIds"])) {
                this.shipIds = [] as any;
                for (let item of _data["shipIds"])
                    this.shipIds!.push(item);
            }
            else {
                this.shipIds = <any>null;
            }
            if (Array.isArray(_data["shippingLineIds"])) {
                this.shippingLineIds = [] as any;
                for (let item of _data["shippingLineIds"])
                    this.shippingLineIds!.push(item);
            }
            else {
                this.shippingLineIds = <any>null;
            }
        }
    }

    static fromJS(data: any): FastFerryMasterCertificateDocumentApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new FastFerryMasterCertificateDocumentApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issuerCountry"] = this.issuerCountry !== undefined ? this.issuerCountry : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : <any>null;
        if (Array.isArray(this.shipIds)) {
            data["shipIds"] = [];
            for (let item of this.shipIds)
                data["shipIds"].push(item);
        }
        if (Array.isArray(this.shippingLineIds)) {
            data["shippingLineIds"] = [];
            for (let item of this.shippingLineIds)
                data["shippingLineIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

/** Fast Ferry Master Certificate document API model (TR Kiirlaeva laevajuhi tunnistus) */
export interface IFastFerryMasterCertificateDocumentApiModel extends IIssueCertificateDocumentDetailsApiModel {
    /** Issuer country (Väljastaja riik) */
    issuerCountry?: string | null;
    /** Valid until date (Kehtiv kuni) */
    validUntil?: Date | null;
    /** Ship IDs (Laevad)
Multiple ships can be selected for which the certificate is valid */
    shipIds: string[];
    /** Shipping line/route IDs (Sõiduliinid)
Navigation areas of type ShippingLine */
    shippingLineIds: string[];
}

export class PilotCertificateDocumentApiModel extends IssueCertificateDocumentDetailsApiModel implements IPilotCertificateDocumentApiModel {
    /** Väljastaja riik */
    issuerCountry?: string | null;
    /** Kehtiv kuni */
    validUntil?: Date | null;

    constructor(data?: IPilotCertificateDocumentApiModel) {
        super(data);
        this._discriminator = "PilotCertificateDocumentApiModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.issuerCountry = _data["issuerCountry"] !== undefined ? _data["issuerCountry"] : <any>null;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): PilotCertificateDocumentApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new PilotCertificateDocumentApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issuerCountry"] = this.issuerCountry !== undefined ? this.issuerCountry : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPilotCertificateDocumentApiModel extends IIssueCertificateDocumentDetailsApiModel {
    /** Väljastaja riik */
    issuerCountry?: string | null;
    /** Kehtiv kuni */
    validUntil?: Date | null;
}

export class ConcessionPermitDocumentApiModel extends IssueCertificateDocumentDetailsApiModel implements IConcessionPermitDocumentApiModel {
    /** Väljastaja riik */
    issuerCountry?: string | null;
    /** Kehtiv kuni */
    validUntil?: Date | null;
    /** Laev */
    shipId?: string | null;
    /** Lubatud ametikohad */
    positionIds!: string[];
    /** Väljastatava soodustusloa keel trükisel */
    languageOnPrint?: LanguageOnPrintedEndorsement | null;
    /** STCW reeglid */
    stcwRules!: string[];
    /** Pädevustunnistuse nimi (millele soodustusluba taotletakse) */
    endorsementName?: string | null;
    /** Pädevustunnistuse number (millele soodustusluba taotletakse) */
    endorsementCertificateNumber?: string | null;

    constructor(data?: IConcessionPermitDocumentApiModel) {
        super(data);
        if (!data) {
            this.positionIds = [];
            this.stcwRules = [];
        }
        this._discriminator = "ConcessionPermitDocumentApiModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.issuerCountry = _data["issuerCountry"] !== undefined ? _data["issuerCountry"] : <any>null;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : <any>null;
            this.shipId = _data["shipId"] !== undefined ? _data["shipId"] : <any>null;
            if (Array.isArray(_data["positionIds"])) {
                this.positionIds = [] as any;
                for (let item of _data["positionIds"])
                    this.positionIds!.push(item);
            }
            else {
                this.positionIds = <any>null;
            }
            this.languageOnPrint = _data["languageOnPrint"] !== undefined ? _data["languageOnPrint"] : <any>null;
            if (Array.isArray(_data["stcwRules"])) {
                this.stcwRules = [] as any;
                for (let item of _data["stcwRules"])
                    this.stcwRules!.push(item);
            }
            else {
                this.stcwRules = <any>null;
            }
            this.endorsementName = _data["endorsementName"] !== undefined ? _data["endorsementName"] : <any>null;
            this.endorsementCertificateNumber = _data["endorsementCertificateNumber"] !== undefined ? _data["endorsementCertificateNumber"] : <any>null;
        }
    }

    static fromJS(data: any): ConcessionPermitDocumentApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new ConcessionPermitDocumentApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issuerCountry"] = this.issuerCountry !== undefined ? this.issuerCountry : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : <any>null;
        data["shipId"] = this.shipId !== undefined ? this.shipId : <any>null;
        if (Array.isArray(this.positionIds)) {
            data["positionIds"] = [];
            for (let item of this.positionIds)
                data["positionIds"].push(item);
        }
        data["languageOnPrint"] = this.languageOnPrint !== undefined ? this.languageOnPrint : <any>null;
        if (Array.isArray(this.stcwRules)) {
            data["stcwRules"] = [];
            for (let item of this.stcwRules)
                data["stcwRules"].push(item);
        }
        data["endorsementName"] = this.endorsementName !== undefined ? this.endorsementName : <any>null;
        data["endorsementCertificateNumber"] = this.endorsementCertificateNumber !== undefined ? this.endorsementCertificateNumber : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IConcessionPermitDocumentApiModel extends IIssueCertificateDocumentDetailsApiModel {
    /** Väljastaja riik */
    issuerCountry?: string | null;
    /** Kehtiv kuni */
    validUntil?: Date | null;
    /** Laev */
    shipId?: string | null;
    /** Lubatud ametikohad */
    positionIds: string[];
    /** Väljastatava soodustusloa keel trükisel */
    languageOnPrint?: LanguageOnPrintedEndorsement | null;
    /** STCW reeglid */
    stcwRules: string[];
    /** Pädevustunnistuse nimi (millele soodustusluba taotletakse) */
    endorsementName?: string | null;
    /** Pädevustunnistuse number (millele soodustusluba taotletakse) */
    endorsementCertificateNumber?: string | null;
}

export class PilotlessSeafaringDocumentApiModel extends IssueCertificateDocumentDetailsApiModel implements IPilotlessSeafaringDocumentApiModel {
    /** Väljastaja riik */
    issuerCountry?: string | null;
    /** Kehtiv kuni */
    validUntil?: Date | null;

    constructor(data?: IPilotlessSeafaringDocumentApiModel) {
        super(data);
        this._discriminator = "PilotlessSeafaringDocumentApiModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.issuerCountry = _data["issuerCountry"] !== undefined ? _data["issuerCountry"] : <any>null;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): PilotlessSeafaringDocumentApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new PilotlessSeafaringDocumentApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issuerCountry"] = this.issuerCountry !== undefined ? this.issuerCountry : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPilotlessSeafaringDocumentApiModel extends IIssueCertificateDocumentDetailsApiModel {
    /** Väljastaja riik */
    issuerCountry?: string | null;
    /** Kehtiv kuni */
    validUntil?: Date | null;
}

/** Harbour Pilot Exemption Certificate document API model (Lootsitasõiduluba) */
export class HarbourPilotExemptionCertificateDocumentApiModel extends IssueCertificateDocumentDetailsApiModel implements IHarbourPilotExemptionCertificateDocumentApiModel {
    /** Issuer country (Väljastaja riik) */
    issuerCountry?: string | null;
    /** Valid until date (Kehtiv kuni) */
    validUntil?: Date | null;
    /** Harbour ID (Sadam)
Certificate is for one specific harbour/port */
    harbourId?: string | null;

    constructor(data?: IHarbourPilotExemptionCertificateDocumentApiModel) {
        super(data);
        this._discriminator = "HarbourPilotExemptionCertificateDocumentApiModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.issuerCountry = _data["issuerCountry"] !== undefined ? _data["issuerCountry"] : <any>null;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : <any>null;
            this.harbourId = _data["harbourId"] !== undefined ? _data["harbourId"] : <any>null;
        }
    }

    static fromJS(data: any): HarbourPilotExemptionCertificateDocumentApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new HarbourPilotExemptionCertificateDocumentApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issuerCountry"] = this.issuerCountry !== undefined ? this.issuerCountry : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : <any>null;
        data["harbourId"] = this.harbourId !== undefined ? this.harbourId : <any>null;
        super.toJSON(data);
        return data;
    }
}

/** Harbour Pilot Exemption Certificate document API model (Lootsitasõiduluba) */
export interface IHarbourPilotExemptionCertificateDocumentApiModel extends IIssueCertificateDocumentDetailsApiModel {
    /** Issuer country (Väljastaja riik) */
    issuerCountry?: string | null;
    /** Valid until date (Kehtiv kuni) */
    validUntil?: Date | null;
    /** Harbour ID (Sadam)
Certificate is for one specific harbour/port */
    harbourId?: string | null;
}

export class MaritimeCertificateDocumentApiModel extends IssueCertificateDocumentDetailsApiModel implements IMaritimeCertificateDocumentApiModel {
    /** Väljastaja riik */
    issuerCountry?: string | null;
    /** Kehtiv kuni */
    validUntil?: Date | null;

    constructor(data?: IMaritimeCertificateDocumentApiModel) {
        super(data);
        this._discriminator = "MaritimeCertificateDocumentApiModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.issuerCountry = _data["issuerCountry"] !== undefined ? _data["issuerCountry"] : <any>null;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): MaritimeCertificateDocumentApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new MaritimeCertificateDocumentApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issuerCountry"] = this.issuerCountry !== undefined ? this.issuerCountry : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IMaritimeCertificateDocumentApiModel extends IIssueCertificateDocumentDetailsApiModel {
    /** Väljastaja riik */
    issuerCountry?: string | null;
    /** Kehtiv kuni */
    validUntil?: Date | null;
}

export class EndorsementDocumentApiModel extends IssueDocumentDetailsApiModel implements IEndorsementDocumentApiModel {
    certificateTypeName!: string;
    certificateNumber!: string;
    issuerCountry?: string | null;
    certificateCountryNamePossessiveEst?: string | null;
    certificateCountryNamePossessiveEng?: string | null;
    validUntil?: Date | null;
    languageOnPrint?: LanguageOnPrintedEndorsement | null;
    desiredPositions!: string[];
    positions!: EndorsementPositionModel[];
    overallRestrictions!: EndorsementRestrictionModel[];
    automaticRestrictions!: EndorsementRestrictionModel[];
    disabledAutomaticRestrictions!: string[];
    stcwRules!: string[];
    suggestedValidUntil?: Date | null;
    suggestedValidUntilBasedOnDocumentName?: string | null;

    constructor(data?: IEndorsementDocumentApiModel) {
        super(data);
        if (!data) {
            this.desiredPositions = [];
            this.positions = [];
            this.overallRestrictions = [];
            this.automaticRestrictions = [];
            this.disabledAutomaticRestrictions = [];
            this.stcwRules = [];
        }
        this._discriminator = "EndorsementDocumentApiModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.certificateTypeName = _data["certificateTypeName"] !== undefined ? _data["certificateTypeName"] : <any>null;
            this.certificateNumber = _data["certificateNumber"] !== undefined ? _data["certificateNumber"] : <any>null;
            this.issuerCountry = _data["issuerCountry"] !== undefined ? _data["issuerCountry"] : <any>null;
            this.certificateCountryNamePossessiveEst = _data["certificateCountryNamePossessiveEst"] !== undefined ? _data["certificateCountryNamePossessiveEst"] : <any>null;
            this.certificateCountryNamePossessiveEng = _data["certificateCountryNamePossessiveEng"] !== undefined ? _data["certificateCountryNamePossessiveEng"] : <any>null;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : <any>null;
            this.languageOnPrint = _data["languageOnPrint"] !== undefined ? _data["languageOnPrint"] : <any>null;
            if (Array.isArray(_data["desiredPositions"])) {
                this.desiredPositions = [] as any;
                for (let item of _data["desiredPositions"])
                    this.desiredPositions!.push(item);
            }
            else {
                this.desiredPositions = <any>null;
            }
            if (Array.isArray(_data["positions"])) {
                this.positions = [] as any;
                for (let item of _data["positions"])
                    this.positions!.push(EndorsementPositionModel.fromJS(item));
            }
            else {
                this.positions = <any>null;
            }
            if (Array.isArray(_data["overallRestrictions"])) {
                this.overallRestrictions = [] as any;
                for (let item of _data["overallRestrictions"])
                    this.overallRestrictions!.push(EndorsementRestrictionModel.fromJS(item));
            }
            else {
                this.overallRestrictions = <any>null;
            }
            if (Array.isArray(_data["automaticRestrictions"])) {
                this.automaticRestrictions = [] as any;
                for (let item of _data["automaticRestrictions"])
                    this.automaticRestrictions!.push(EndorsementRestrictionModel.fromJS(item));
            }
            else {
                this.automaticRestrictions = <any>null;
            }
            if (Array.isArray(_data["disabledAutomaticRestrictions"])) {
                this.disabledAutomaticRestrictions = [] as any;
                for (let item of _data["disabledAutomaticRestrictions"])
                    this.disabledAutomaticRestrictions!.push(item);
            }
            else {
                this.disabledAutomaticRestrictions = <any>null;
            }
            if (Array.isArray(_data["stcwRules"])) {
                this.stcwRules = [] as any;
                for (let item of _data["stcwRules"])
                    this.stcwRules!.push(item);
            }
            else {
                this.stcwRules = <any>null;
            }
            this.suggestedValidUntil = _data["suggestedValidUntil"] ? new Date(_data["suggestedValidUntil"].toString()) : <any>null;
            this.suggestedValidUntilBasedOnDocumentName = _data["suggestedValidUntilBasedOnDocumentName"] !== undefined ? _data["suggestedValidUntilBasedOnDocumentName"] : <any>null;
        }
    }

    static fromJS(data: any): EndorsementDocumentApiModel {
        data = typeof data === 'object' ? data : {};
        if (data["type"] === "FastFerryEndorsementDocumentApiModel") {
            let result = new FastFerryEndorsementDocumentApiModel();
            result.init(data);
            return result;
        }
        let result = new EndorsementDocumentApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["certificateTypeName"] = this.certificateTypeName !== undefined ? this.certificateTypeName : <any>null;
        data["certificateNumber"] = this.certificateNumber !== undefined ? this.certificateNumber : <any>null;
        data["issuerCountry"] = this.issuerCountry !== undefined ? this.issuerCountry : <any>null;
        data["certificateCountryNamePossessiveEst"] = this.certificateCountryNamePossessiveEst !== undefined ? this.certificateCountryNamePossessiveEst : <any>null;
        data["certificateCountryNamePossessiveEng"] = this.certificateCountryNamePossessiveEng !== undefined ? this.certificateCountryNamePossessiveEng : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : <any>null;
        data["languageOnPrint"] = this.languageOnPrint !== undefined ? this.languageOnPrint : <any>null;
        if (Array.isArray(this.desiredPositions)) {
            data["desiredPositions"] = [];
            for (let item of this.desiredPositions)
                data["desiredPositions"].push(item);
        }
        if (Array.isArray(this.positions)) {
            data["positions"] = [];
            for (let item of this.positions)
                data["positions"].push(item.toJSON());
        }
        if (Array.isArray(this.overallRestrictions)) {
            data["overallRestrictions"] = [];
            for (let item of this.overallRestrictions)
                data["overallRestrictions"].push(item.toJSON());
        }
        if (Array.isArray(this.automaticRestrictions)) {
            data["automaticRestrictions"] = [];
            for (let item of this.automaticRestrictions)
                data["automaticRestrictions"].push(item.toJSON());
        }
        if (Array.isArray(this.disabledAutomaticRestrictions)) {
            data["disabledAutomaticRestrictions"] = [];
            for (let item of this.disabledAutomaticRestrictions)
                data["disabledAutomaticRestrictions"].push(item);
        }
        if (Array.isArray(this.stcwRules)) {
            data["stcwRules"] = [];
            for (let item of this.stcwRules)
                data["stcwRules"].push(item);
        }
        data["suggestedValidUntil"] = this.suggestedValidUntil ? this.suggestedValidUntil.toISOString() : <any>null;
        data["suggestedValidUntilBasedOnDocumentName"] = this.suggestedValidUntilBasedOnDocumentName !== undefined ? this.suggestedValidUntilBasedOnDocumentName : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IEndorsementDocumentApiModel extends IIssueDocumentDetailsApiModel {
    certificateTypeName: string;
    certificateNumber: string;
    issuerCountry?: string | null;
    certificateCountryNamePossessiveEst?: string | null;
    certificateCountryNamePossessiveEng?: string | null;
    validUntil?: Date | null;
    languageOnPrint?: LanguageOnPrintedEndorsement | null;
    desiredPositions: string[];
    positions: EndorsementPositionModel[];
    overallRestrictions: EndorsementRestrictionModel[];
    automaticRestrictions: EndorsementRestrictionModel[];
    disabledAutomaticRestrictions: string[];
    stcwRules: string[];
    suggestedValidUntil?: Date | null;
    suggestedValidUntilBasedOnDocumentName?: string | null;
}

export class EndorsementPositionModel implements IEndorsementPositionModel {
    id!: string;
    restrictions!: EndorsementRestrictionModel[];

    constructor(data?: IEndorsementPositionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.restrictions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            if (Array.isArray(_data["restrictions"])) {
                this.restrictions = [] as any;
                for (let item of _data["restrictions"])
                    this.restrictions!.push(EndorsementRestrictionModel.fromJS(item));
            }
            else {
                this.restrictions = <any>null;
            }
        }
    }

    static fromJS(data: any): EndorsementPositionModel {
        data = typeof data === 'object' ? data : {};
        let result = new EndorsementPositionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        if (Array.isArray(this.restrictions)) {
            data["restrictions"] = [];
            for (let item of this.restrictions)
                data["restrictions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEndorsementPositionModel {
    id: string;
    restrictions: EndorsementRestrictionModel[];
}

export class EndorsementRestrictionModel implements IEndorsementRestrictionModel {
    id?: string | null;
    descriptionEst?: string | null;
    descriptionEng?: string | null;

    constructor(data?: IEndorsementRestrictionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.descriptionEst = _data["descriptionEst"] !== undefined ? _data["descriptionEst"] : <any>null;
            this.descriptionEng = _data["descriptionEng"] !== undefined ? _data["descriptionEng"] : <any>null;
        }
    }

    static fromJS(data: any): EndorsementRestrictionModel {
        data = typeof data === 'object' ? data : {};
        let result = new EndorsementRestrictionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["descriptionEst"] = this.descriptionEst !== undefined ? this.descriptionEst : <any>null;
        data["descriptionEng"] = this.descriptionEng !== undefined ? this.descriptionEng : <any>null;
        return data;
    }
}

export interface IEndorsementRestrictionModel {
    id?: string | null;
    descriptionEst?: string | null;
    descriptionEng?: string | null;
}

/** Fast Ferry Endorsement document API model (Kiirlaeva kinnitusleht) Endorsement with ships and shipping lines */
export class FastFerryEndorsementDocumentApiModel extends EndorsementDocumentApiModel implements IFastFerryEndorsementDocumentApiModel {
    /** Ship IDs (Laevad)
Multiple ships can be selected for which the endorsement is valid */
    shipIds!: string[];
    /** Shipping line/route IDs (Sõiduliinid)
Navigation areas of type ShippingLine */
    shippingLineIds!: string[];

    constructor(data?: IFastFerryEndorsementDocumentApiModel) {
        super(data);
        if (!data) {
            this.shipIds = [];
            this.shippingLineIds = [];
        }
        this._discriminator = "FastFerryEndorsementDocumentApiModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["shipIds"])) {
                this.shipIds = [] as any;
                for (let item of _data["shipIds"])
                    this.shipIds!.push(item);
            }
            else {
                this.shipIds = <any>null;
            }
            if (Array.isArray(_data["shippingLineIds"])) {
                this.shippingLineIds = [] as any;
                for (let item of _data["shippingLineIds"])
                    this.shippingLineIds!.push(item);
            }
            else {
                this.shippingLineIds = <any>null;
            }
        }
    }

    static fromJS(data: any): FastFerryEndorsementDocumentApiModel {
        data = typeof data === 'object' ? data : {};
        let result = new FastFerryEndorsementDocumentApiModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.shipIds)) {
            data["shipIds"] = [];
            for (let item of this.shipIds)
                data["shipIds"].push(item);
        }
        if (Array.isArray(this.shippingLineIds)) {
            data["shippingLineIds"] = [];
            for (let item of this.shippingLineIds)
                data["shippingLineIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

/** Fast Ferry Endorsement document API model (Kiirlaeva kinnitusleht) Endorsement with ships and shipping lines */
export interface IFastFerryEndorsementDocumentApiModel extends IEndorsementDocumentApiModel {
    /** Ship IDs (Laevad)
Multiple ships can be selected for which the endorsement is valid */
    shipIds: string[];
    /** Shipping line/route IDs (Sõiduliinid)
Navigation areas of type ShippingLine */
    shippingLineIds: string[];
}

export class DocumentDuplicateDetailsModel extends IssueDocumentDetailsApiModel implements IDocumentDuplicateDetailsModel {
    documentId!: string;
    documentName!: string;
    documentNumber!: string;

    constructor(data?: IDocumentDuplicateDetailsModel) {
        super(data);
        this._discriminator = "DocumentDuplicateDetailsModel";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documentId = _data["documentId"] !== undefined ? _data["documentId"] : <any>null;
            this.documentName = _data["documentName"] !== undefined ? _data["documentName"] : <any>null;
            this.documentNumber = _data["documentNumber"] !== undefined ? _data["documentNumber"] : <any>null;
        }
    }

    static fromJS(data: any): DocumentDuplicateDetailsModel {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentDuplicateDetailsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentId"] = this.documentId !== undefined ? this.documentId : <any>null;
        data["documentName"] = this.documentName !== undefined ? this.documentName : <any>null;
        data["documentNumber"] = this.documentNumber !== undefined ? this.documentNumber : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDocumentDuplicateDetailsModel extends IIssueDocumentDetailsApiModel {
    documentId: string;
    documentName: string;
    documentNumber: string;
}

export abstract class EditDocumentSeedRequest implements IEditDocumentSeedRequest {
    additionalInfo?: string | null;

    protected _discriminator: string;

    constructor(data?: IEditDocumentSeedRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "EditDocumentSeedRequest";
    }

    init(_data?: any) {
        if (_data) {
            this.additionalInfo = _data["additionalInfo"] !== undefined ? _data["additionalInfo"] : <any>null;
        }
    }

    static fromJS(data: any): EditDocumentSeedRequest {
        data = typeof data === 'object' ? data : {};
        if (data["type"] === "EditSeagoingShipCertificateSeedRequest") {
            let result = new EditSeagoingShipCertificateSeedRequest();
            result.init(data);
            return result;
        }
        if (data["type"] === "EditInlandVesselCertificateSeedRequest") {
            let result = new EditInlandVesselCertificateSeedRequest();
            result.init(data);
            return result;
        }
        if (data["type"] === "EditPilotCertificateSeedRequest") {
            let result = new EditPilotCertificateSeedRequest();
            result.init(data);
            return result;
        }
        if (data["type"] === "EditConcessionPermitSeedRequest") {
            let result = new EditConcessionPermitSeedRequest();
            result.init(data);
            return result;
        }
        if (data["type"] === "EditPilotlessSeafaringSeedRequest") {
            let result = new EditPilotlessSeafaringSeedRequest();
            result.init(data);
            return result;
        }
        if (data["type"] === "EditHarbourPilotExemptionCertificateSeedRequest") {
            let result = new EditHarbourPilotExemptionCertificateSeedRequest();
            result.init(data);
            return result;
        }
        if (data["type"] === "EditMaritimeCertificateSeedRequest") {
            let result = new EditMaritimeCertificateSeedRequest();
            result.init(data);
            return result;
        }
        if (data["type"] === "EditMaritimePilotCertificateSeedRequest") {
            let result = new EditMaritimePilotCertificateSeedRequest();
            result.init(data);
            return result;
        }
        if (data["type"] === "EditSeniorMaritimePilotCertificateSeedRequest") {
            let result = new EditSeniorMaritimePilotCertificateSeedRequest();
            result.init(data);
            return result;
        }
        if (data["type"] === "EditPortPilotCertificateSeedRequest") {
            let result = new EditPortPilotCertificateSeedRequest();
            result.init(data);
            return result;
        }
        if (data["type"] === "EditOpenSeaPilotCertificateSeedRequest") {
            let result = new EditOpenSeaPilotCertificateSeedRequest();
            result.init(data);
            return result;
        }
        if (data["type"] === "EditFastFerryMasterCertificateSeedRequest") {
            let result = new EditFastFerryMasterCertificateSeedRequest();
            result.init(data);
            return result;
        }
        if (data["type"] === "EditEndorsementSeedRequest") {
            let result = new EditEndorsementSeedRequest();
            result.init(data);
            return result;
        }
        if (data["type"] === "EditFastFerryEndorsementSeedRequest") {
            let result = new EditFastFerryEndorsementSeedRequest();
            result.init(data);
            return result;
        }
        if (data["type"] === "EditDocumentDuplicateSeedRequest") {
            let result = new EditDocumentDuplicateSeedRequest();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'EditDocumentSeedRequest' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this._discriminator;
        data["additionalInfo"] = this.additionalInfo !== undefined ? this.additionalInfo : <any>null;
        return data;
    }
}

export interface IEditDocumentSeedRequest {
    additionalInfo?: string | null;
}

export class EditSeagoingShipCertificateSeedRequest extends EditDocumentSeedRequest implements IEditSeagoingShipCertificateSeedRequest {
    issueDate?: Date | null;
    validUntil?: Date | null;

    constructor(data?: IEditSeagoingShipCertificateSeedRequest) {
        super(data);
        this._discriminator = "EditSeagoingShipCertificateSeedRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : <any>null;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): EditSeagoingShipCertificateSeedRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditSeagoingShipCertificateSeedRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IEditSeagoingShipCertificateSeedRequest extends IEditDocumentSeedRequest {
    issueDate?: Date | null;
    validUntil?: Date | null;
}

export class EditInlandVesselCertificateSeedRequest extends EditDocumentSeedRequest implements IEditInlandVesselCertificateSeedRequest {
    issueDate?: Date | null;

    constructor(data?: IEditInlandVesselCertificateSeedRequest) {
        super(data);
        this._discriminator = "EditInlandVesselCertificateSeedRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): EditInlandVesselCertificateSeedRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditInlandVesselCertificateSeedRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IEditInlandVesselCertificateSeedRequest extends IEditDocumentSeedRequest {
    issueDate?: Date | null;
}

export class EditPilotCertificateSeedRequest extends EditDocumentSeedRequest implements IEditPilotCertificateSeedRequest {
    issueDate?: Date | null;
    validUntil?: Date | null;

    constructor(data?: IEditPilotCertificateSeedRequest) {
        super(data);
        this._discriminator = "EditPilotCertificateSeedRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : <any>null;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): EditPilotCertificateSeedRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditPilotCertificateSeedRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IEditPilotCertificateSeedRequest extends IEditDocumentSeedRequest {
    issueDate?: Date | null;
    validUntil?: Date | null;
}

export class EditConcessionPermitSeedRequest extends EditDocumentSeedRequest implements IEditConcessionPermitSeedRequest {
    issueDate?: Date | null;
    validUntil?: Date | null;
    shipId?: string | null;
    positionIds?: string[] | null;
    languageOnPrint?: LanguageOnPrintedEndorsement | null;
    stcwRules!: string[];

    constructor(data?: IEditConcessionPermitSeedRequest) {
        super(data);
        if (!data) {
            this.stcwRules = [];
        }
        this._discriminator = "EditConcessionPermitSeedRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : <any>null;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : <any>null;
            this.shipId = _data["shipId"] !== undefined ? _data["shipId"] : <any>null;
            if (Array.isArray(_data["positionIds"])) {
                this.positionIds = [] as any;
                for (let item of _data["positionIds"])
                    this.positionIds!.push(item);
            }
            else {
                this.positionIds = <any>null;
            }
            this.languageOnPrint = _data["languageOnPrint"] !== undefined ? _data["languageOnPrint"] : <any>null;
            if (Array.isArray(_data["stcwRules"])) {
                this.stcwRules = [] as any;
                for (let item of _data["stcwRules"])
                    this.stcwRules!.push(item);
            }
            else {
                this.stcwRules = <any>null;
            }
        }
    }

    static fromJS(data: any): EditConcessionPermitSeedRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditConcessionPermitSeedRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : <any>null;
        data["shipId"] = this.shipId !== undefined ? this.shipId : <any>null;
        if (Array.isArray(this.positionIds)) {
            data["positionIds"] = [];
            for (let item of this.positionIds)
                data["positionIds"].push(item);
        }
        data["languageOnPrint"] = this.languageOnPrint !== undefined ? this.languageOnPrint : <any>null;
        if (Array.isArray(this.stcwRules)) {
            data["stcwRules"] = [];
            for (let item of this.stcwRules)
                data["stcwRules"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IEditConcessionPermitSeedRequest extends IEditDocumentSeedRequest {
    issueDate?: Date | null;
    validUntil?: Date | null;
    shipId?: string | null;
    positionIds?: string[] | null;
    languageOnPrint?: LanguageOnPrintedEndorsement | null;
    stcwRules: string[];
}

export class EditPilotlessSeafaringSeedRequest extends EditDocumentSeedRequest implements IEditPilotlessSeafaringSeedRequest {
    issueDate?: Date | null;
    validUntil?: Date | null;

    constructor(data?: IEditPilotlessSeafaringSeedRequest) {
        super(data);
        this._discriminator = "EditPilotlessSeafaringSeedRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : <any>null;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): EditPilotlessSeafaringSeedRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditPilotlessSeafaringSeedRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IEditPilotlessSeafaringSeedRequest extends IEditDocumentSeedRequest {
    issueDate?: Date | null;
    validUntil?: Date | null;
}

/** Request model for editing a Harbour Pilot Exemption Certificate seed (Lootsitasõiduluba) */
export class EditHarbourPilotExemptionCertificateSeedRequest extends EditDocumentSeedRequest implements IEditHarbourPilotExemptionCertificateSeedRequest {
    /** Issue date (Väljastamise kuupäev) */
    issueDate?: Date | null;
    /** Valid until date (Kehtiv kuni) */
    validUntil?: Date | null;
    /** Harbour ID (Sadam)
Certificate is for one specific harbour/port */
    harbourId?: string | null;

    constructor(data?: IEditHarbourPilotExemptionCertificateSeedRequest) {
        super(data);
        this._discriminator = "EditHarbourPilotExemptionCertificateSeedRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : <any>null;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : <any>null;
            this.harbourId = _data["harbourId"] !== undefined ? _data["harbourId"] : <any>null;
        }
    }

    static fromJS(data: any): EditHarbourPilotExemptionCertificateSeedRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditHarbourPilotExemptionCertificateSeedRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : <any>null;
        data["harbourId"] = this.harbourId !== undefined ? this.harbourId : <any>null;
        super.toJSON(data);
        return data;
    }
}

/** Request model for editing a Harbour Pilot Exemption Certificate seed (Lootsitasõiduluba) */
export interface IEditHarbourPilotExemptionCertificateSeedRequest extends IEditDocumentSeedRequest {
    /** Issue date (Väljastamise kuupäev) */
    issueDate?: Date | null;
    /** Valid until date (Kehtiv kuni) */
    validUntil?: Date | null;
    /** Harbour ID (Sadam)
Certificate is for one specific harbour/port */
    harbourId?: string | null;
}

export class EditMaritimeCertificateSeedRequest extends EditDocumentSeedRequest implements IEditMaritimeCertificateSeedRequest {
    issueDate?: Date | null;
    validUntil?: Date | null;

    constructor(data?: IEditMaritimeCertificateSeedRequest) {
        super(data);
        this._discriminator = "EditMaritimeCertificateSeedRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : <any>null;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): EditMaritimeCertificateSeedRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditMaritimeCertificateSeedRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IEditMaritimeCertificateSeedRequest extends IEditDocumentSeedRequest {
    issueDate?: Date | null;
    validUntil?: Date | null;
}

/** Request model for editing a Maritime Pilot Certificate seed */
export class EditMaritimePilotCertificateSeedRequest extends EditDocumentSeedRequest implements IEditMaritimePilotCertificateSeedRequest {
    /** Issue date (Väljastamise kuupäev) */
    issueDate?: Date | null;
    /** Valid until date (Kehtiv kuni) */
    validUntil?: Date | null;
    /** Ship gross tonnage limit (Laeva GT) */
    shipGrossTonnage?: number | null;
    /** Tanker gross tonnage limit (Tankeri GT) */
    tankerGrossTonnage?: number | null;
    /** Selected pilotage area IDs (Lootsimispiirkonnad) */
    pilotageAreaIds!: string[];

    constructor(data?: IEditMaritimePilotCertificateSeedRequest) {
        super(data);
        if (!data) {
            this.pilotageAreaIds = [];
        }
        this._discriminator = "EditMaritimePilotCertificateSeedRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : <any>null;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : <any>null;
            this.shipGrossTonnage = _data["shipGrossTonnage"] !== undefined ? _data["shipGrossTonnage"] : <any>null;
            this.tankerGrossTonnage = _data["tankerGrossTonnage"] !== undefined ? _data["tankerGrossTonnage"] : <any>null;
            if (Array.isArray(_data["pilotageAreaIds"])) {
                this.pilotageAreaIds = [] as any;
                for (let item of _data["pilotageAreaIds"])
                    this.pilotageAreaIds!.push(item);
            }
            else {
                this.pilotageAreaIds = <any>null;
            }
        }
    }

    static fromJS(data: any): EditMaritimePilotCertificateSeedRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditMaritimePilotCertificateSeedRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : <any>null;
        data["shipGrossTonnage"] = this.shipGrossTonnage !== undefined ? this.shipGrossTonnage : <any>null;
        data["tankerGrossTonnage"] = this.tankerGrossTonnage !== undefined ? this.tankerGrossTonnage : <any>null;
        if (Array.isArray(this.pilotageAreaIds)) {
            data["pilotageAreaIds"] = [];
            for (let item of this.pilotageAreaIds)
                data["pilotageAreaIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

/** Request model for editing a Maritime Pilot Certificate seed */
export interface IEditMaritimePilotCertificateSeedRequest extends IEditDocumentSeedRequest {
    /** Issue date (Väljastamise kuupäev) */
    issueDate?: Date | null;
    /** Valid until date (Kehtiv kuni) */
    validUntil?: Date | null;
    /** Ship gross tonnage limit (Laeva GT) */
    shipGrossTonnage?: number | null;
    /** Tanker gross tonnage limit (Tankeri GT) */
    tankerGrossTonnage?: number | null;
    /** Selected pilotage area IDs (Lootsimispiirkonnad) */
    pilotageAreaIds: string[];
}

/** Request model for editing a Senior Maritime Pilot Certificate seed */
export class EditSeniorMaritimePilotCertificateSeedRequest extends EditDocumentSeedRequest implements IEditSeniorMaritimePilotCertificateSeedRequest {
    /** Issue date (Väljastamise kuupäev) */
    issueDate?: Date | null;
    /** Valid until date (Kehtiv kuni) */
    validUntil?: Date | null;
    /** Ship gross tonnage limit (Laeva GT) - No validation for Senior Pilot */
    shipGrossTonnage?: number | null;
    /** Tanker gross tonnage limit (Tankeri GT) - No validation for Senior Pilot */
    tankerGrossTonnage?: number | null;
    /** Selected pilotage area IDs (Lootsimispiirkonnad) */
    pilotageAreaIds!: string[];

    constructor(data?: IEditSeniorMaritimePilotCertificateSeedRequest) {
        super(data);
        if (!data) {
            this.pilotageAreaIds = [];
        }
        this._discriminator = "EditSeniorMaritimePilotCertificateSeedRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : <any>null;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : <any>null;
            this.shipGrossTonnage = _data["shipGrossTonnage"] !== undefined ? _data["shipGrossTonnage"] : <any>null;
            this.tankerGrossTonnage = _data["tankerGrossTonnage"] !== undefined ? _data["tankerGrossTonnage"] : <any>null;
            if (Array.isArray(_data["pilotageAreaIds"])) {
                this.pilotageAreaIds = [] as any;
                for (let item of _data["pilotageAreaIds"])
                    this.pilotageAreaIds!.push(item);
            }
            else {
                this.pilotageAreaIds = <any>null;
            }
        }
    }

    static fromJS(data: any): EditSeniorMaritimePilotCertificateSeedRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditSeniorMaritimePilotCertificateSeedRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : <any>null;
        data["shipGrossTonnage"] = this.shipGrossTonnage !== undefined ? this.shipGrossTonnage : <any>null;
        data["tankerGrossTonnage"] = this.tankerGrossTonnage !== undefined ? this.tankerGrossTonnage : <any>null;
        if (Array.isArray(this.pilotageAreaIds)) {
            data["pilotageAreaIds"] = [];
            for (let item of this.pilotageAreaIds)
                data["pilotageAreaIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

/** Request model for editing a Senior Maritime Pilot Certificate seed */
export interface IEditSeniorMaritimePilotCertificateSeedRequest extends IEditDocumentSeedRequest {
    /** Issue date (Väljastamise kuupäev) */
    issueDate?: Date | null;
    /** Valid until date (Kehtiv kuni) */
    validUntil?: Date | null;
    /** Ship gross tonnage limit (Laeva GT) - No validation for Senior Pilot */
    shipGrossTonnage?: number | null;
    /** Tanker gross tonnage limit (Tankeri GT) - No validation for Senior Pilot */
    tankerGrossTonnage?: number | null;
    /** Selected pilotage area IDs (Lootsimispiirkonnad) */
    pilotageAreaIds: string[];
}

/** Request model for editing a Port Pilot Certificate seed (Sadamalootsi kutsetunnistus) */
export class EditPortPilotCertificateSeedRequest extends EditDocumentSeedRequest implements IEditPortPilotCertificateSeedRequest {
    /** Issue date (Väljastamise kuupäev) */
    issueDate?: Date | null;
    /** Valid until date (Kehtiv kuni) */
    validUntil?: Date | null;
    /** Harbour ID (Sadam)
Certificate is for one specific harbour/port */
    harbourId?: string | null;

    constructor(data?: IEditPortPilotCertificateSeedRequest) {
        super(data);
        this._discriminator = "EditPortPilotCertificateSeedRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : <any>null;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : <any>null;
            this.harbourId = _data["harbourId"] !== undefined ? _data["harbourId"] : <any>null;
        }
    }

    static fromJS(data: any): EditPortPilotCertificateSeedRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditPortPilotCertificateSeedRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : <any>null;
        data["harbourId"] = this.harbourId !== undefined ? this.harbourId : <any>null;
        super.toJSON(data);
        return data;
    }
}

/** Request model for editing a Port Pilot Certificate seed (Sadamalootsi kutsetunnistus) */
export interface IEditPortPilotCertificateSeedRequest extends IEditDocumentSeedRequest {
    /** Issue date (Väljastamise kuupäev) */
    issueDate?: Date | null;
    /** Valid until date (Kehtiv kuni) */
    validUntil?: Date | null;
    /** Harbour ID (Sadam)
Certificate is for one specific harbour/port */
    harbourId?: string | null;
}

/** Request model for editing an Open Sea Pilot Certificate seed (Avamerelootsi kutsetunnistus) */
export class EditOpenSeaPilotCertificateSeedRequest extends EditDocumentSeedRequest implements IEditOpenSeaPilotCertificateSeedRequest {
    /** Issue date (Väljastamise kuupäev) */
    issueDate?: Date | null;
    /** Valid until date (Kehtiv kuni) */
    validUntil?: Date | null;
    /** Pilotage area IDs (Lootsimispiirkonnad)
Certificate is valid for multiple selected pilotage areas */
    pilotageAreaIds!: string[];

    constructor(data?: IEditOpenSeaPilotCertificateSeedRequest) {
        super(data);
        if (!data) {
            this.pilotageAreaIds = [];
        }
        this._discriminator = "EditOpenSeaPilotCertificateSeedRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : <any>null;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : <any>null;
            if (Array.isArray(_data["pilotageAreaIds"])) {
                this.pilotageAreaIds = [] as any;
                for (let item of _data["pilotageAreaIds"])
                    this.pilotageAreaIds!.push(item);
            }
            else {
                this.pilotageAreaIds = <any>null;
            }
        }
    }

    static fromJS(data: any): EditOpenSeaPilotCertificateSeedRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditOpenSeaPilotCertificateSeedRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : <any>null;
        if (Array.isArray(this.pilotageAreaIds)) {
            data["pilotageAreaIds"] = [];
            for (let item of this.pilotageAreaIds)
                data["pilotageAreaIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

/** Request model for editing an Open Sea Pilot Certificate seed (Avamerelootsi kutsetunnistus) */
export interface IEditOpenSeaPilotCertificateSeedRequest extends IEditDocumentSeedRequest {
    /** Issue date (Väljastamise kuupäev) */
    issueDate?: Date | null;
    /** Valid until date (Kehtiv kuni) */
    validUntil?: Date | null;
    /** Pilotage area IDs (Lootsimispiirkonnad)
Certificate is valid for multiple selected pilotage areas */
    pilotageAreaIds: string[];
}

/** Request model for editing a Fast Ferry Master Certificate seed (TR Kiirlaeva laevajuhi tunnistus) */
export class EditFastFerryMasterCertificateSeedRequest extends EditDocumentSeedRequest implements IEditFastFerryMasterCertificateSeedRequest {
    /** Issue date (Väljastamise kuupäev) */
    issueDate?: Date | null;
    /** Valid until date (Kehtiv kuni) */
    validUntil?: Date | null;
    /** Ship IDs (Laevad)
Multiple ships can be selected for which the certificate is valid */
    shipIds!: string[];
    /** Shipping line/route IDs (Sõiduliinid)
Navigation areas of type ShippingLine */
    shippingLineIds!: string[];

    constructor(data?: IEditFastFerryMasterCertificateSeedRequest) {
        super(data);
        if (!data) {
            this.shipIds = [];
            this.shippingLineIds = [];
        }
        this._discriminator = "EditFastFerryMasterCertificateSeedRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : <any>null;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : <any>null;
            if (Array.isArray(_data["shipIds"])) {
                this.shipIds = [] as any;
                for (let item of _data["shipIds"])
                    this.shipIds!.push(item);
            }
            else {
                this.shipIds = <any>null;
            }
            if (Array.isArray(_data["shippingLineIds"])) {
                this.shippingLineIds = [] as any;
                for (let item of _data["shippingLineIds"])
                    this.shippingLineIds!.push(item);
            }
            else {
                this.shippingLineIds = <any>null;
            }
        }
    }

    static fromJS(data: any): EditFastFerryMasterCertificateSeedRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditFastFerryMasterCertificateSeedRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : <any>null;
        if (Array.isArray(this.shipIds)) {
            data["shipIds"] = [];
            for (let item of this.shipIds)
                data["shipIds"].push(item);
        }
        if (Array.isArray(this.shippingLineIds)) {
            data["shippingLineIds"] = [];
            for (let item of this.shippingLineIds)
                data["shippingLineIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

/** Request model for editing a Fast Ferry Master Certificate seed (TR Kiirlaeva laevajuhi tunnistus) */
export interface IEditFastFerryMasterCertificateSeedRequest extends IEditDocumentSeedRequest {
    /** Issue date (Väljastamise kuupäev) */
    issueDate?: Date | null;
    /** Valid until date (Kehtiv kuni) */
    validUntil?: Date | null;
    /** Ship IDs (Laevad)
Multiple ships can be selected for which the certificate is valid */
    shipIds: string[];
    /** Shipping line/route IDs (Sõiduliinid)
Navigation areas of type ShippingLine */
    shippingLineIds: string[];
}

export class EditEndorsementSeedRequest extends EditDocumentSeedRequest implements IEditEndorsementSeedRequest {
    issueDate?: Date | null;
    validUntil?: Date | null;
    languageOnPrint?: LanguageOnPrintedEndorsement | null;
    positions!: EndorsementPositionModel[];
    overallRestrictions!: EndorsementRestrictionModel[];
    disabledAutomaticRestrictions!: string[];
    stcwRules!: string[];

    constructor(data?: IEditEndorsementSeedRequest) {
        super(data);
        if (!data) {
            this.positions = [];
            this.overallRestrictions = [];
            this.disabledAutomaticRestrictions = [];
            this.stcwRules = [];
        }
        this._discriminator = "EditEndorsementSeedRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : <any>null;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : <any>null;
            this.languageOnPrint = _data["languageOnPrint"] !== undefined ? _data["languageOnPrint"] : <any>null;
            if (Array.isArray(_data["positions"])) {
                this.positions = [] as any;
                for (let item of _data["positions"])
                    this.positions!.push(EndorsementPositionModel.fromJS(item));
            }
            else {
                this.positions = <any>null;
            }
            if (Array.isArray(_data["overallRestrictions"])) {
                this.overallRestrictions = [] as any;
                for (let item of _data["overallRestrictions"])
                    this.overallRestrictions!.push(EndorsementRestrictionModel.fromJS(item));
            }
            else {
                this.overallRestrictions = <any>null;
            }
            if (Array.isArray(_data["disabledAutomaticRestrictions"])) {
                this.disabledAutomaticRestrictions = [] as any;
                for (let item of _data["disabledAutomaticRestrictions"])
                    this.disabledAutomaticRestrictions!.push(item);
            }
            else {
                this.disabledAutomaticRestrictions = <any>null;
            }
            if (Array.isArray(_data["stcwRules"])) {
                this.stcwRules = [] as any;
                for (let item of _data["stcwRules"])
                    this.stcwRules!.push(item);
            }
            else {
                this.stcwRules = <any>null;
            }
        }
    }

    static fromJS(data: any): EditEndorsementSeedRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditEndorsementSeedRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : <any>null;
        data["languageOnPrint"] = this.languageOnPrint !== undefined ? this.languageOnPrint : <any>null;
        if (Array.isArray(this.positions)) {
            data["positions"] = [];
            for (let item of this.positions)
                data["positions"].push(item.toJSON());
        }
        if (Array.isArray(this.overallRestrictions)) {
            data["overallRestrictions"] = [];
            for (let item of this.overallRestrictions)
                data["overallRestrictions"].push(item.toJSON());
        }
        if (Array.isArray(this.disabledAutomaticRestrictions)) {
            data["disabledAutomaticRestrictions"] = [];
            for (let item of this.disabledAutomaticRestrictions)
                data["disabledAutomaticRestrictions"].push(item);
        }
        if (Array.isArray(this.stcwRules)) {
            data["stcwRules"] = [];
            for (let item of this.stcwRules)
                data["stcwRules"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IEditEndorsementSeedRequest extends IEditDocumentSeedRequest {
    issueDate?: Date | null;
    validUntil?: Date | null;
    languageOnPrint?: LanguageOnPrintedEndorsement | null;
    positions: EndorsementPositionModel[];
    overallRestrictions: EndorsementRestrictionModel[];
    disabledAutomaticRestrictions: string[];
    stcwRules: string[];
}

/** Request model for editing a Fast Ferry Endorsement seed (Kiirlaeva kinnitusleht) */
export class EditFastFerryEndorsementSeedRequest extends EditDocumentSeedRequest implements IEditFastFerryEndorsementSeedRequest {
    /** Issue date (Väljastamise kuupäev) */
    issueDate?: Date | null;
    /** Valid until date (Kehtiv kuni) */
    validUntil?: Date | null;
    /** Language on printed endorsement */
    languageOnPrint?: LanguageOnPrintedEndorsement | null;
    /** Positions on the endorsement */
    positions!: EndorsementPositionModel[];
    /** Overall restrictions for all positions */
    overallRestrictions!: EndorsementRestrictionModel[];
    /** Disabled automatic restrictions from medical certificate */
    disabledAutomaticRestrictions!: string[];
    /** STCW rules associated with the endorsement */
    stcwRules!: string[];
    /** Ship IDs (Laevad)
Multiple ships can be selected for which the endorsement is valid */
    shipIds!: string[];
    /** Shipping line/route IDs (Sõiduliinid)
Navigation areas of type ShippingLine */
    shippingLineIds!: string[];

    constructor(data?: IEditFastFerryEndorsementSeedRequest) {
        super(data);
        if (!data) {
            this.positions = [];
            this.overallRestrictions = [];
            this.disabledAutomaticRestrictions = [];
            this.stcwRules = [];
            this.shipIds = [];
            this.shippingLineIds = [];
        }
        this._discriminator = "EditFastFerryEndorsementSeedRequest";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.issueDate = _data["issueDate"] ? new Date(_data["issueDate"].toString()) : <any>null;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : <any>null;
            this.languageOnPrint = _data["languageOnPrint"] !== undefined ? _data["languageOnPrint"] : <any>null;
            if (Array.isArray(_data["positions"])) {
                this.positions = [] as any;
                for (let item of _data["positions"])
                    this.positions!.push(EndorsementPositionModel.fromJS(item));
            }
            else {
                this.positions = <any>null;
            }
            if (Array.isArray(_data["overallRestrictions"])) {
                this.overallRestrictions = [] as any;
                for (let item of _data["overallRestrictions"])
                    this.overallRestrictions!.push(EndorsementRestrictionModel.fromJS(item));
            }
            else {
                this.overallRestrictions = <any>null;
            }
            if (Array.isArray(_data["disabledAutomaticRestrictions"])) {
                this.disabledAutomaticRestrictions = [] as any;
                for (let item of _data["disabledAutomaticRestrictions"])
                    this.disabledAutomaticRestrictions!.push(item);
            }
            else {
                this.disabledAutomaticRestrictions = <any>null;
            }
            if (Array.isArray(_data["stcwRules"])) {
                this.stcwRules = [] as any;
                for (let item of _data["stcwRules"])
                    this.stcwRules!.push(item);
            }
            else {
                this.stcwRules = <any>null;
            }
            if (Array.isArray(_data["shipIds"])) {
                this.shipIds = [] as any;
                for (let item of _data["shipIds"])
                    this.shipIds!.push(item);
            }
            else {
                this.shipIds = <any>null;
            }
            if (Array.isArray(_data["shippingLineIds"])) {
                this.shippingLineIds = [] as any;
                for (let item of _data["shippingLineIds"])
                    this.shippingLineIds!.push(item);
            }
            else {
                this.shippingLineIds = <any>null;
            }
        }
    }

    static fromJS(data: any): EditFastFerryEndorsementSeedRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditFastFerryEndorsementSeedRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issueDate"] = this.issueDate ? this.issueDate.toISOString() : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : <any>null;
        data["languageOnPrint"] = this.languageOnPrint !== undefined ? this.languageOnPrint : <any>null;
        if (Array.isArray(this.positions)) {
            data["positions"] = [];
            for (let item of this.positions)
                data["positions"].push(item.toJSON());
        }
        if (Array.isArray(this.overallRestrictions)) {
            data["overallRestrictions"] = [];
            for (let item of this.overallRestrictions)
                data["overallRestrictions"].push(item.toJSON());
        }
        if (Array.isArray(this.disabledAutomaticRestrictions)) {
            data["disabledAutomaticRestrictions"] = [];
            for (let item of this.disabledAutomaticRestrictions)
                data["disabledAutomaticRestrictions"].push(item);
        }
        if (Array.isArray(this.stcwRules)) {
            data["stcwRules"] = [];
            for (let item of this.stcwRules)
                data["stcwRules"].push(item);
        }
        if (Array.isArray(this.shipIds)) {
            data["shipIds"] = [];
            for (let item of this.shipIds)
                data["shipIds"].push(item);
        }
        if (Array.isArray(this.shippingLineIds)) {
            data["shippingLineIds"] = [];
            for (let item of this.shippingLineIds)
                data["shippingLineIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

/** Request model for editing a Fast Ferry Endorsement seed (Kiirlaeva kinnitusleht) */
export interface IEditFastFerryEndorsementSeedRequest extends IEditDocumentSeedRequest {
    /** Issue date (Väljastamise kuupäev) */
    issueDate?: Date | null;
    /** Valid until date (Kehtiv kuni) */
    validUntil?: Date | null;
    /** Language on printed endorsement */
    languageOnPrint?: LanguageOnPrintedEndorsement | null;
    /** Positions on the endorsement */
    positions: EndorsementPositionModel[];
    /** Overall restrictions for all positions */
    overallRestrictions: EndorsementRestrictionModel[];
    /** Disabled automatic restrictions from medical certificate */
    disabledAutomaticRestrictions: string[];
    /** STCW rules associated with the endorsement */
    stcwRules: string[];
    /** Ship IDs (Laevad)
Multiple ships can be selected for which the endorsement is valid */
    shipIds: string[];
    /** Shipping line/route IDs (Sõiduliinid)
Navigation areas of type ShippingLine */
    shippingLineIds: string[];
}

export class EditDocumentDuplicateSeedRequest extends EditDocumentSeedRequest implements IEditDocumentDuplicateSeedRequest {

    constructor(data?: IEditDocumentDuplicateSeedRequest) {
        super(data);
        this._discriminator = "EditDocumentDuplicateSeedRequest";
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): EditDocumentDuplicateSeedRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditDocumentDuplicateSeedRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IEditDocumentDuplicateSeedRequest extends IEditDocumentSeedRequest {
}

export class EditAdditionalInfoRequest implements IEditAdditionalInfoRequest {
    additionalInfo?: string | null;

    constructor(data?: IEditAdditionalInfoRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.additionalInfo = _data["additionalInfo"] !== undefined ? _data["additionalInfo"] : <any>null;
        }
    }

    static fromJS(data: any): EditAdditionalInfoRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditAdditionalInfoRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["additionalInfo"] = this.additionalInfo !== undefined ? this.additionalInfo : <any>null;
        return data;
    }
}

export interface IEditAdditionalInfoRequest {
    additionalInfo?: string | null;
}

export class IssueDocumentRequest implements IIssueDocumentRequest {
    comment?: string | null;

    constructor(data?: IIssueDocumentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
        }
    }

    static fromJS(data: any): IssueDocumentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IssueDocumentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        return data;
    }
}

export interface IIssueDocumentRequest {
    comment?: string | null;
}

export class SeafarerApplicationLightViewModel implements ISeafarerApplicationLightViewModel {
    id!: string;
    documentNumber!: string;
    seafarerName!: string;
    certificateName!: string;
    documentType!: string;
    dateSubmitted?: Date | null;
    state!: ApplicationState;
    hasDocumentDeliveryBeenConfirmed!: boolean;
    isDeleted!: boolean;
    rowVariant!: string;

    constructor(data?: ISeafarerApplicationLightViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.documentNumber = _data["documentNumber"] !== undefined ? _data["documentNumber"] : <any>null;
            this.seafarerName = _data["seafarerName"] !== undefined ? _data["seafarerName"] : <any>null;
            this.certificateName = _data["certificateName"] !== undefined ? _data["certificateName"] : <any>null;
            this.documentType = _data["documentType"] !== undefined ? _data["documentType"] : <any>null;
            this.dateSubmitted = _data["dateSubmitted"] ? new Date(_data["dateSubmitted"].toString()) : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.hasDocumentDeliveryBeenConfirmed = _data["hasDocumentDeliveryBeenConfirmed"] !== undefined ? _data["hasDocumentDeliveryBeenConfirmed"] : <any>null;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : <any>null;
            this.rowVariant = _data["rowVariant"] !== undefined ? _data["rowVariant"] : <any>null;
        }
    }

    static fromJS(data: any): SeafarerApplicationLightViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SeafarerApplicationLightViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["documentNumber"] = this.documentNumber !== undefined ? this.documentNumber : <any>null;
        data["seafarerName"] = this.seafarerName !== undefined ? this.seafarerName : <any>null;
        data["certificateName"] = this.certificateName !== undefined ? this.certificateName : <any>null;
        data["documentType"] = this.documentType !== undefined ? this.documentType : <any>null;
        data["dateSubmitted"] = this.dateSubmitted ? this.dateSubmitted.toISOString() : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["hasDocumentDeliveryBeenConfirmed"] = this.hasDocumentDeliveryBeenConfirmed !== undefined ? this.hasDocumentDeliveryBeenConfirmed : <any>null;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : <any>null;
        data["rowVariant"] = this.rowVariant !== undefined ? this.rowVariant : <any>null;
        return data;
    }
}

export interface ISeafarerApplicationLightViewModel {
    id: string;
    documentNumber: string;
    seafarerName: string;
    certificateName: string;
    documentType: string;
    dateSubmitted?: Date | null;
    state: ApplicationState;
    hasDocumentDeliveryBeenConfirmed: boolean;
    isDeleted: boolean;
    rowVariant: string;
}

export class PagedResultOfOfficialApplicationLightViewModel implements IPagedResultOfOfficialApplicationLightViewModel {
    pageNumber!: number;
    pageSize!: number;
    pageResult!: OfficialApplicationLightViewModel[];
    totalCount!: number;

    constructor(data?: IPagedResultOfOfficialApplicationLightViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.pageResult = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"] !== undefined ? _data["pageNumber"] : <any>null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : <any>null;
            if (Array.isArray(_data["pageResult"])) {
                this.pageResult = [] as any;
                for (let item of _data["pageResult"])
                    this.pageResult!.push(OfficialApplicationLightViewModel.fromJS(item));
            }
            else {
                this.pageResult = <any>null;
            }
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : <any>null;
        }
    }

    static fromJS(data: any): PagedResultOfOfficialApplicationLightViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfOfficialApplicationLightViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber !== undefined ? this.pageNumber : <any>null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
        if (Array.isArray(this.pageResult)) {
            data["pageResult"] = [];
            for (let item of this.pageResult)
                data["pageResult"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : <any>null;
        return data;
    }
}

export interface IPagedResultOfOfficialApplicationLightViewModel {
    pageNumber: number;
    pageSize: number;
    pageResult: OfficialApplicationLightViewModel[];
    totalCount: number;
}

export class OfficialApplicationLightViewModel implements IOfficialApplicationLightViewModel {
    id!: string;
    documentNumber!: string;
    seafarerName!: string;
    certificateName!: string;
    documentType!: string;
    dateSubmitted?: Date | null;
    signingState!: ApplicationSigningState;
    state!: ApplicationState;
    applicationType!: ApplicationType;
    isInEditMode!: boolean;
    hasDocumentDeliveryBeenConfirmed!: boolean;
    isDeleted!: boolean;
    _rowVariant!: string;

    constructor(data?: IOfficialApplicationLightViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.documentNumber = _data["documentNumber"] !== undefined ? _data["documentNumber"] : <any>null;
            this.seafarerName = _data["seafarerName"] !== undefined ? _data["seafarerName"] : <any>null;
            this.certificateName = _data["certificateName"] !== undefined ? _data["certificateName"] : <any>null;
            this.documentType = _data["documentType"] !== undefined ? _data["documentType"] : <any>null;
            this.dateSubmitted = _data["dateSubmitted"] ? new Date(_data["dateSubmitted"].toString()) : <any>null;
            this.signingState = _data["signingState"] !== undefined ? _data["signingState"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.applicationType = _data["applicationType"] !== undefined ? _data["applicationType"] : <any>null;
            this.isInEditMode = _data["isInEditMode"] !== undefined ? _data["isInEditMode"] : <any>null;
            this.hasDocumentDeliveryBeenConfirmed = _data["hasDocumentDeliveryBeenConfirmed"] !== undefined ? _data["hasDocumentDeliveryBeenConfirmed"] : <any>null;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : <any>null;
            this._rowVariant = _data["_rowVariant"] !== undefined ? _data["_rowVariant"] : <any>null;
        }
    }

    static fromJS(data: any): OfficialApplicationLightViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OfficialApplicationLightViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["documentNumber"] = this.documentNumber !== undefined ? this.documentNumber : <any>null;
        data["seafarerName"] = this.seafarerName !== undefined ? this.seafarerName : <any>null;
        data["certificateName"] = this.certificateName !== undefined ? this.certificateName : <any>null;
        data["documentType"] = this.documentType !== undefined ? this.documentType : <any>null;
        data["dateSubmitted"] = this.dateSubmitted ? this.dateSubmitted.toISOString() : <any>null;
        data["signingState"] = this.signingState !== undefined ? this.signingState : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["applicationType"] = this.applicationType !== undefined ? this.applicationType : <any>null;
        data["isInEditMode"] = this.isInEditMode !== undefined ? this.isInEditMode : <any>null;
        data["hasDocumentDeliveryBeenConfirmed"] = this.hasDocumentDeliveryBeenConfirmed !== undefined ? this.hasDocumentDeliveryBeenConfirmed : <any>null;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : <any>null;
        data["_rowVariant"] = this._rowVariant !== undefined ? this._rowVariant : <any>null;
        return data;
    }
}

export interface IOfficialApplicationLightViewModel {
    id: string;
    documentNumber: string;
    seafarerName: string;
    certificateName: string;
    documentType: string;
    dateSubmitted?: Date | null;
    signingState: ApplicationSigningState;
    state: ApplicationState;
    applicationType: ApplicationType;
    isInEditMode: boolean;
    hasDocumentDeliveryBeenConfirmed: boolean;
    isDeleted: boolean;
    _rowVariant: string;
}

export enum ApplicationSigningState {
    NotSigned = "notSigned",
    ForwardedToSigning = "forwardedToSigning",
    Signed = "signed",
}

export enum ApplicationSortField {
    DateSubmittedAsc = "dateSubmittedAsc",
    DateSubmittedDesc = "dateSubmittedDesc",
}

export class ApplicationsListActions implements IApplicationsListActions {
    canViewSeafarerApplications!: boolean;
    canViewProcessingApplications!: boolean;
    canStartApplications!: boolean;

    constructor(data?: IApplicationsListActions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canViewSeafarerApplications = _data["canViewSeafarerApplications"] !== undefined ? _data["canViewSeafarerApplications"] : <any>null;
            this.canViewProcessingApplications = _data["canViewProcessingApplications"] !== undefined ? _data["canViewProcessingApplications"] : <any>null;
            this.canStartApplications = _data["canStartApplications"] !== undefined ? _data["canStartApplications"] : <any>null;
        }
    }

    static fromJS(data: any): ApplicationsListActions {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationsListActions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canViewSeafarerApplications"] = this.canViewSeafarerApplications !== undefined ? this.canViewSeafarerApplications : <any>null;
        data["canViewProcessingApplications"] = this.canViewProcessingApplications !== undefined ? this.canViewProcessingApplications : <any>null;
        data["canStartApplications"] = this.canStartApplications !== undefined ? this.canStartApplications : <any>null;
        return data;
    }
}

export interface IApplicationsListActions {
    canViewSeafarerApplications: boolean;
    canViewProcessingApplications: boolean;
    canStartApplications: boolean;
}

export abstract class HarbormasterEligibilityResult implements IHarbormasterEligibilityResult {

    protected _discriminator: string;

    constructor(data?: IHarbormasterEligibilityResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "HarbormasterEligibilityResult";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): HarbormasterEligibilityResult {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "PersonIsQualified") {
            let result = new PersonIsQualified();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "PersonIsNotQualified") {
            let result = new PersonIsNotQualified();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "PersonNotFound") {
            let result = new PersonNotFound();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'HarbormasterEligibilityResult' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        return data;
    }
}

export interface IHarbormasterEligibilityResult {
}

export class PersonIsQualified extends HarbormasterEligibilityResult implements IPersonIsQualified {
    /** Isik kvalifitseerub sadamakapteniks */
    value!: string;

    constructor(data?: IPersonIsQualified) {
        super(data);
        if (!data) {
            this.value = "PersonIsQualified";
        }
        this._discriminator = "PersonIsQualified";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : "PersonIsQualified";
        }
    }

    static fromJS(data: any): PersonIsQualified {
        data = typeof data === 'object' ? data : {};
        let result = new PersonIsQualified();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPersonIsQualified extends IHarbormasterEligibilityResult {
    /** Isik kvalifitseerub sadamakapteniks */
    value: string;
}

export class PersonNotFound extends HarbormasterEligibilityResult implements IPersonNotFound {
    /** Isik puudub süsteemist */
    value!: string;

    constructor(data?: IPersonNotFound) {
        super(data);
        if (!data) {
            this.value = "PersonNotFound";
        }
        this._discriminator = "PersonNotFound";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : "PersonNotFound";
        }
    }

    static fromJS(data: any): PersonNotFound {
        data = typeof data === 'object' ? data : {};
        let result = new PersonNotFound();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPersonNotFound extends IHarbormasterEligibilityResult {
    /** Isik puudub süsteemist */
    value: string;
}

export class PersonIsNotQualified extends HarbormasterEligibilityResult implements IPersonIsNotQualified {
    /** Süsteemis puuduvad isikul vajalikud dokumendid */
    value!: string;

    constructor(data?: IPersonIsNotQualified) {
        super(data);
        if (!data) {
            this.value = "PersonIsNotQualified";
        }
        this._discriminator = "PersonIsNotQualified";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : "PersonIsNotQualified";
        }
    }

    static fromJS(data: any): PersonIsNotQualified {
        data = typeof data === 'object' ? data : {};
        let result = new PersonIsNotQualified();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPersonIsNotQualified extends IHarbormasterEligibilityResult {
    /** Süsteemis puuduvad isikul vajalikud dokumendid */
    value: string;
}

export abstract class SeafaringEligibilityResult implements ISeafaringEligibilityResult {

    constructor(data?: ISeafaringEligibilityResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): SeafaringEligibilityResult {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'SeafaringEligibilityResult' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ISeafaringEligibilityResult {
}

export class PersonIsQualifiedForSeafaring extends SeafaringEligibilityResult implements IPersonIsQualifiedForSeafaring {
    /** Isik kvalifitseerub merel töötamiseks */
    value!: string;

    constructor(data?: IPersonIsQualifiedForSeafaring) {
        super(data);
        if (!data) {
            this.value = "PersonIsQualifiedForSeafaring";
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : "PersonIsQualifiedForSeafaring";
        }
    }

    static fromJS(data: any): PersonIsQualifiedForSeafaring {
        data = typeof data === 'object' ? data : {};
        let result = new PersonIsQualifiedForSeafaring();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IPersonIsQualifiedForSeafaring extends ISeafaringEligibilityResult {
    /** Isik kvalifitseerub merel töötamiseks */
    value: string;
}

export class SeafarerNotFound extends SeafaringEligibilityResult implements ISeafarerNotFound {
    /** Isik puudub süsteemist */
    value!: string;

    constructor(data?: ISeafarerNotFound) {
        super(data);
        if (!data) {
            this.value = "SeafarerNotFound";
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : "SeafarerNotFound";
        }
    }

    static fromJS(data: any): SeafarerNotFound {
        data = typeof data === 'object' ? data : {};
        let result = new SeafarerNotFound();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ISeafarerNotFound extends ISeafaringEligibilityResult {
    /** Isik puudub süsteemist */
    value: string;
}

export class DocumentsNotFound extends SeafaringEligibilityResult implements IDocumentsNotFound {
    /** Süsteemis puuduvad isikul vajalikud dokumendid */
    value!: string;

    constructor(data?: IDocumentsNotFound) {
        super(data);
        if (!data) {
            this.value = "DocumentsNotFound";
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : "DocumentsNotFound";
        }
    }

    static fromJS(data: any): DocumentsNotFound {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentsNotFound();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IDocumentsNotFound extends ISeafaringEligibilityResult {
    /** Süsteemis puuduvad isikul vajalikud dokumendid */
    value: string;
}

export class SeafarerDocumentsModel implements ISeafarerDocumentsModel {
    /** Meremehe nimi */
    seafarerName!: string;
    /** Meremehe isikuandmete tuvastatuse staatus. TRUE kui meremees on tuvastatud. */
    isSeafarerIdentified!: boolean;
    /** Pädevustunnistused */
    certificates!: CertificateModel[];
    /** Kinnituslehed */
    endorsements!: EndorsementModel[];
    /** Tervisetõendid */
    medicalCertificates!: MedicalCertificateModel[];

    constructor(data?: ISeafarerDocumentsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.certificates = [];
            this.endorsements = [];
            this.medicalCertificates = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.seafarerName = _data["seafarerName"] !== undefined ? _data["seafarerName"] : <any>null;
            this.isSeafarerIdentified = _data["isSeafarerIdentified"] !== undefined ? _data["isSeafarerIdentified"] : <any>null;
            if (Array.isArray(_data["certificates"])) {
                this.certificates = [] as any;
                for (let item of _data["certificates"])
                    this.certificates!.push(CertificateModel.fromJS(item));
            }
            else {
                this.certificates = <any>null;
            }
            if (Array.isArray(_data["endorsements"])) {
                this.endorsements = [] as any;
                for (let item of _data["endorsements"])
                    this.endorsements!.push(EndorsementModel.fromJS(item));
            }
            else {
                this.endorsements = <any>null;
            }
            if (Array.isArray(_data["medicalCertificates"])) {
                this.medicalCertificates = [] as any;
                for (let item of _data["medicalCertificates"])
                    this.medicalCertificates!.push(MedicalCertificateModel.fromJS(item));
            }
            else {
                this.medicalCertificates = <any>null;
            }
        }
    }

    static fromJS(data: any): SeafarerDocumentsModel {
        data = typeof data === 'object' ? data : {};
        let result = new SeafarerDocumentsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["seafarerName"] = this.seafarerName !== undefined ? this.seafarerName : <any>null;
        data["isSeafarerIdentified"] = this.isSeafarerIdentified !== undefined ? this.isSeafarerIdentified : <any>null;
        if (Array.isArray(this.certificates)) {
            data["certificates"] = [];
            for (let item of this.certificates)
                data["certificates"].push(item.toJSON());
        }
        if (Array.isArray(this.endorsements)) {
            data["endorsements"] = [];
            for (let item of this.endorsements)
                data["endorsements"].push(item.toJSON());
        }
        if (Array.isArray(this.medicalCertificates)) {
            data["medicalCertificates"] = [];
            for (let item of this.medicalCertificates)
                data["medicalCertificates"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISeafarerDocumentsModel {
    /** Meremehe nimi */
    seafarerName: string;
    /** Meremehe isikuandmete tuvastatuse staatus. TRUE kui meremees on tuvastatud. */
    isSeafarerIdentified: boolean;
    /** Pädevustunnistused */
    certificates: CertificateModel[];
    /** Kinnituslehed */
    endorsements: EndorsementModel[];
    /** Tervisetõendid */
    medicalCertificates: MedicalCertificateModel[];
}

export abstract class SeafarerDocumentModel implements ISeafarerDocumentModel {
    /** Dokumendi väljastamise kuupäev */
    issuedOn!: Date;
    /** Dokumendi kehtivuse lõpukuupäev */
    validUntil?: Date | null;

    constructor(data?: ISeafarerDocumentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.issuedOn = _data["issuedOn"] ? new Date(_data["issuedOn"].toString()) : <any>null;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): SeafarerDocumentModel {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'SeafarerDocumentModel' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["issuedOn"] = this.issuedOn ? this.issuedOn.toISOString() : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : <any>null;
        return data;
    }
}

export interface ISeafarerDocumentModel {
    /** Dokumendi väljastamise kuupäev */
    issuedOn: Date;
    /** Dokumendi kehtivuse lõpukuupäev */
    validUntil?: Date | null;
}

export class CertificateModel extends SeafarerDocumentModel implements ICertificateModel {
    /** Pädevustunnistuse dokumendi number */
    documentNumber!: string;
    /** Nimetus */
    name!: string;
    /** Väljastamise riik */
    issuerCountry!: string;
    /** Väljastamise riigi kood */
    issuerCountryCode!: string;

    constructor(data?: ICertificateModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documentNumber = _data["documentNumber"] !== undefined ? _data["documentNumber"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.issuerCountry = _data["issuerCountry"] !== undefined ? _data["issuerCountry"] : <any>null;
            this.issuerCountryCode = _data["issuerCountryCode"] !== undefined ? _data["issuerCountryCode"] : <any>null;
        }
    }

    static fromJS(data: any): CertificateModel {
        data = typeof data === 'object' ? data : {};
        let result = new CertificateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentNumber"] = this.documentNumber !== undefined ? this.documentNumber : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["issuerCountry"] = this.issuerCountry !== undefined ? this.issuerCountry : <any>null;
        data["issuerCountryCode"] = this.issuerCountryCode !== undefined ? this.issuerCountryCode : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICertificateModel extends ISeafarerDocumentModel {
    /** Pädevustunnistuse dokumendi number */
    documentNumber: string;
    /** Nimetus */
    name: string;
    /** Väljastamise riik */
    issuerCountry: string;
    /** Väljastamise riigi kood */
    issuerCountryCode: string;
}

export class EndorsementModel extends SeafarerDocumentModel implements IEndorsementModel {
    /** Kinnituslehe dokumendi number */
    documentNumber!: string;
    /** STCW reeglid */
    stcwRules!: string[];
    /** Ametid */
    positions!: PositionModel[];

    constructor(data?: IEndorsementModel) {
        super(data);
        if (!data) {
            this.stcwRules = [];
            this.positions = [];
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.documentNumber = _data["documentNumber"] !== undefined ? _data["documentNumber"] : <any>null;
            if (Array.isArray(_data["stcwRules"])) {
                this.stcwRules = [] as any;
                for (let item of _data["stcwRules"])
                    this.stcwRules!.push(item);
            }
            else {
                this.stcwRules = <any>null;
            }
            if (Array.isArray(_data["positions"])) {
                this.positions = [] as any;
                for (let item of _data["positions"])
                    this.positions!.push(PositionModel.fromJS(item));
            }
            else {
                this.positions = <any>null;
            }
        }
    }

    static fromJS(data: any): EndorsementModel {
        data = typeof data === 'object' ? data : {};
        let result = new EndorsementModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["documentNumber"] = this.documentNumber !== undefined ? this.documentNumber : <any>null;
        if (Array.isArray(this.stcwRules)) {
            data["stcwRules"] = [];
            for (let item of this.stcwRules)
                data["stcwRules"].push(item);
        }
        if (Array.isArray(this.positions)) {
            data["positions"] = [];
            for (let item of this.positions)
                data["positions"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IEndorsementModel extends ISeafarerDocumentModel {
    /** Kinnituslehe dokumendi number */
    documentNumber: string;
    /** STCW reeglid */
    stcwRules: string[];
    /** Ametid */
    positions: PositionModel[];
}

export class PositionModel implements IPositionModel {
    /** Ameti nimetus */
    name!: string;
    /** Piirangud */
    restrictions!: string[];

    constructor(data?: IPositionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.restrictions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            if (Array.isArray(_data["restrictions"])) {
                this.restrictions = [] as any;
                for (let item of _data["restrictions"])
                    this.restrictions!.push(item);
            }
            else {
                this.restrictions = <any>null;
            }
        }
    }

    static fromJS(data: any): PositionModel {
        data = typeof data === 'object' ? data : {};
        let result = new PositionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        if (Array.isArray(this.restrictions)) {
            data["restrictions"] = [];
            for (let item of this.restrictions)
                data["restrictions"].push(item);
        }
        return data;
    }
}

export interface IPositionModel {
    /** Ameti nimetus */
    name: string;
    /** Piirangud */
    restrictions: string[];
}

export class MedicalCertificateModel extends SeafarerDocumentModel implements IMedicalCertificateModel {

    constructor(data?: IMedicalCertificateModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): MedicalCertificateModel {
        data = typeof data === 'object' ? data : {};
        let result = new MedicalCertificateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IMedicalCertificateModel extends ISeafarerDocumentModel {
}

export class FindUsageResponse implements IFindUsageResponse {
    totalUsages!: number;
    usages!: PersonalDataUsageModel[];

    constructor(data?: IFindUsageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.usages = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalUsages = _data["totalUsages"] !== undefined ? _data["totalUsages"] : <any>null;
            if (Array.isArray(_data["usages"])) {
                this.usages = [] as any;
                for (let item of _data["usages"])
                    this.usages!.push(PersonalDataUsageModel.fromJS(item));
            }
            else {
                this.usages = <any>null;
            }
        }
    }

    static fromJS(data: any): FindUsageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FindUsageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalUsages"] = this.totalUsages !== undefined ? this.totalUsages : <any>null;
        if (Array.isArray(this.usages)) {
            data["usages"] = [];
            for (let item of this.usages)
                data["usages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFindUsageResponse {
    totalUsages: number;
    usages: PersonalDataUsageModel[];
}

export class PersonalDataUsageModel implements IPersonalDataUsageModel {
    /** Millal päriti (RFC 3339, UTC Z). */
    logtime!: string;
    /** Mida päriti */
    action!: string;
    /** Andmete saaja registrikood */
    receiverCode!: string;
    /** Andmete saaja nimi (mittekohustuslik vastavalt spec v1.6). */
    receiverName?: string | null;
    /** Andmete saaja infosüsteem */
    receiverSystem!: string;

    constructor(data?: IPersonalDataUsageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logtime = _data["logtime"] !== undefined ? _data["logtime"] : <any>null;
            this.action = _data["action"] !== undefined ? _data["action"] : <any>null;
            this.receiverCode = _data["receiverCode"] !== undefined ? _data["receiverCode"] : <any>null;
            this.receiverName = _data["receiverName"] !== undefined ? _data["receiverName"] : <any>null;
            this.receiverSystem = _data["receiverSystem"] !== undefined ? _data["receiverSystem"] : <any>null;
        }
    }

    static fromJS(data: any): PersonalDataUsageModel {
        data = typeof data === 'object' ? data : {};
        let result = new PersonalDataUsageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logtime"] = this.logtime !== undefined ? this.logtime : <any>null;
        data["action"] = this.action !== undefined ? this.action : <any>null;
        data["receiverCode"] = this.receiverCode !== undefined ? this.receiverCode : <any>null;
        data["receiverName"] = this.receiverName !== undefined ? this.receiverName : <any>null;
        data["receiverSystem"] = this.receiverSystem !== undefined ? this.receiverSystem : <any>null;
        return data;
    }
}

export interface IPersonalDataUsageModel {
    /** Millal päriti (RFC 3339, UTC Z). */
    logtime: string;
    /** Mida päriti */
    action: string;
    /** Andmete saaja registrikood */
    receiverCode: string;
    /** Andmete saaja nimi (mittekohustuslik vastavalt spec v1.6). */
    receiverName?: string | null;
    /** Andmete saaja infosüsteem */
    receiverSystem: string;
}

export class UsagePeriodResponse implements IUsagePeriodResponse {
    periodStart!: string;
    periodEnd!: string;

    constructor(data?: IUsagePeriodResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.periodStart = _data["periodStart"] !== undefined ? _data["periodStart"] : <any>null;
            this.periodEnd = _data["periodEnd"] !== undefined ? _data["periodEnd"] : <any>null;
        }
    }

    static fromJS(data: any): UsagePeriodResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UsagePeriodResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["periodStart"] = this.periodStart !== undefined ? this.periodStart : <any>null;
        data["periodEnd"] = this.periodEnd !== undefined ? this.periodEnd : <any>null;
        return data;
    }
}

export interface IUsagePeriodResponse {
    periodStart: string;
    periodEnd: string;
}

export class HeartbeatResponse implements IHeartbeatResponse {
    status!: string;
    message!: string;

    constructor(data?: IHeartbeatResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.message = _data["message"] !== undefined ? _data["message"] : <any>null;
        }
    }

    static fromJS(data: any): HeartbeatResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HeartbeatResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["message"] = this.message !== undefined ? this.message : <any>null;
        return data;
    }
}

export interface IHeartbeatResponse {
    status: string;
    message: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

/* eslint-disable */
// Don't know why it suddenly started complaining about this, but let's disable checking for now.
export namespace factory {
    export function create<T>(type: { new(): T }): T {
    const obj = new type() as any;
    obj.init({});
    return obj;
  }

   export function empty<T>(type: { new(): T }): T {
    const obj = new type() as any;
    return obj;
  }
}
/* eslint-enable */

// NOTE: When you want to extend classes, add the extended class name to api-client.nswag "extendedClasses" property.